
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7c9c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7c9c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hBaMZ", function(module, exports) {

var $8DdNe = parcelRequire("8DdNe");
var $ccfe42e488c0e860$require$Buffer = $8DdNe.Buffer;
//  Chance.js 1.1.12
//  https://chancejs.com
//  (c) 2013 Victor Quinn
//  Chance may be freely distributed or modified under the MIT license.
(function() {
    // Constants
    var MAX_INT = 9007199254740992;
    var MIN_INT = -MAX_INT;
    var NUMBERS = '0123456789';
    var CHARS_LOWER = 'abcdefghijklmnopqrstuvwxyz';
    var CHARS_UPPER = CHARS_LOWER.toUpperCase();
    var HEX_POOL = NUMBERS + "abcdef";
    // Errors
    function UnsupportedError(message) {
        this.name = 'UnsupportedError';
        this.message = message || 'This feature is not supported on this platform';
    }
    UnsupportedError.prototype = new Error();
    UnsupportedError.prototype.constructor = UnsupportedError;
    // Cached array helpers
    var slice = Array.prototype.slice;
    // Constructor
    function Chance(seed) {
        if (!(this instanceof Chance)) {
            if (!seed) seed = null;
             // handle other non-truthy seeds, as described in issue #322
            return seed === null ? new Chance() : new Chance(seed);
        }
        // if user has provided a function, use that as the generator
        if (typeof seed === 'function') {
            this.random = seed;
            return this;
        }
        if (arguments.length) // set a starting value of zero so we can add to it
        this.seed = 0;
        // otherwise, leave this.seed blank so that MT will receive a blank
        for(var i = 0; i < arguments.length; i++){
            var seedling = 0;
            if (Object.prototype.toString.call(arguments[i]) === '[object String]') for(var j = 0; j < arguments[i].length; j++){
                // create a numeric hash for each argument, add to seedling
                var hash = 0;
                for(var k = 0; k < arguments[i].length; k++)hash = arguments[i].charCodeAt(k) + (hash << 6) + (hash << 16) - hash;
                seedling += hash;
            }
            else seedling = arguments[i];
            this.seed += (arguments.length - i) * seedling;
        }
        // If no generator function was provided, use our MT
        this.mt = this.mersenne_twister(this.seed);
        this.bimd5 = this.blueimp_md5();
        this.random = function() {
            return this.mt.random(this.seed);
        };
        return this;
    }
    Chance.prototype.VERSION = "1.1.13";
    // Random helper functions
    function initOptions(options, defaults) {
        options = options || {};
        if (defaults) {
            for(var i in defaults)if (typeof options[i] === 'undefined') options[i] = defaults[i];
        }
        return options;
    }
    function range(size) {
        return Array.apply(null, Array(size)).map(function(_, i) {
            return i;
        });
    }
    function testRange(test, errorMessage) {
        if (test) throw new RangeError(errorMessage);
    }
    /**
     * Encode the input string with Base64.
     */ var base64 = function() {
        throw new Error('No Base64 encoder available.');
    };
    // Select proper Base64 encoder.
    (function determineBase64Encoder() {
        if (typeof btoa === 'function') base64 = btoa;
        else if (typeof $ccfe42e488c0e860$require$Buffer === 'function') base64 = function(input) {
            return new $ccfe42e488c0e860$require$Buffer(input).toString('base64');
        };
    })();
    // -- Basics --
    /**
     *  Return a random bool, either true or false
     *
     *  @param {Object} [options={ likelihood: 50 }] alter the likelihood of
     *    receiving a true or false value back.
     *  @throws {RangeError} if the likelihood is out of bounds
     *  @returns {Bool} either true or false
     */ Chance.prototype.bool = function(options) {
        // likelihood of success (true)
        options = initOptions(options, {
            likelihood: 50
        });
        // Note, we could get some minor perf optimizations by checking range
        // prior to initializing defaults, but that makes code a bit messier
        // and the check more complicated as we have to check existence of
        // the object then existence of the key before checking constraints.
        // Since the options initialization should be minor computationally,
        // decision made for code cleanliness intentionally. This is mentioned
        // here as it's the first occurrence, will not be mentioned again.
        testRange(options.likelihood < 0 || options.likelihood > 100, "Chance: Likelihood accepts values from 0 to 100.");
        return this.random() * 100 < options.likelihood;
    };
    Chance.prototype.falsy = function(options) {
        // return a random falsy value
        options = initOptions(options, {
            pool: [
                false,
                null,
                0,
                NaN,
                '',
                undefined
            ]
        });
        var pool = options.pool, index = this.integer({
            min: 0,
            max: pool.length - 1
        }), value = pool[index];
        return value;
    };
    Chance.prototype.animal = function(options) {
        //returns a random animal
        options = initOptions(options);
        if (typeof options.type !== 'undefined') {
            //if user does not put in a valid animal type, user will get an error
            testRange(!this.get("animals")[options.type.toLowerCase()], "Please pick from desert, ocean, grassland, forest, zoo, pets, farm.");
            //if user does put in valid animal type, will return a random animal of that type
            return this.pick(this.get("animals")[options.type.toLowerCase()]);
        }
        //if user does not put in any animal type, will return a random animal regardless
        var animalTypeArray = [
            "desert",
            "forest",
            "ocean",
            "zoo",
            "farm",
            "pet",
            "grassland"
        ];
        return this.pick(this.get("animals")[this.pick(animalTypeArray)]);
    };
    /**
     *  Return a random character.
     *
     *  @param {Object} [options={}] can specify a character pool or alpha,
     *    numeric, symbols and casing (lower or upper)
     *  @returns {String} a single random character
     */ Chance.prototype.character = function(options) {
        options = initOptions(options);
        var symbols = "!@#$%^&*()[]", letters, pool;
        if (options.casing === 'lower') letters = CHARS_LOWER;
        else if (options.casing === 'upper') letters = CHARS_UPPER;
        else letters = CHARS_LOWER + CHARS_UPPER;
        if (options.pool) pool = options.pool;
        else {
            pool = '';
            if (options.alpha) pool += letters;
            if (options.numeric) pool += NUMBERS;
            if (options.symbols) pool += symbols;
            if (!pool) pool = letters + NUMBERS + symbols;
        }
        return pool.charAt(this.natural({
            max: pool.length - 1
        }));
    };
    // Note, wanted to use "float" or "double" but those are both JS reserved words.
    // Note, fixed means N OR LESS digits after the decimal. This because
    // It could be 14.9000 but in JavaScript, when this is cast as a number,
    // the trailing zeroes are dropped. Left to the consumer if trailing zeroes are
    // needed
    /**
     *  Return a random floating point number
     *
     *  @param {Object} [options={}] can specify a fixed precision, min, max
     *  @returns {Number} a single floating point number
     *  @throws {RangeError} Can only specify fixed or precision, not both. Also
     *    min cannot be greater than max
     */ Chance.prototype.floating = function(options) {
        options = initOptions(options, {
            fixed: 4
        });
        testRange(options.fixed && options.precision, "Chance: Cannot specify both fixed and precision.");
        var num;
        var fixed = Math.pow(10, options.fixed);
        var max = MAX_INT / fixed;
        var min = -max;
        testRange(options.min && options.fixed && options.min < min, "Chance: Min specified is out of range with fixed. Min should be, at least, " + min);
        testRange(options.max && options.fixed && options.max > max, "Chance: Max specified is out of range with fixed. Max should be, at most, " + max);
        options = initOptions(options, {
            min: min,
            max: max
        });
        // Todo - Make this work!
        // options.precision = (typeof options.precision !== "undefined") ? options.precision : false;
        num = this.integer({
            min: options.min * fixed,
            max: options.max * fixed
        });
        var num_fixed = (num / fixed).toFixed(options.fixed);
        return parseFloat(num_fixed);
    };
    /**
     *  Return a random integer
     *
     *  NOTE the max and min are INCLUDED in the range. So:
     *  chance.integer({min: 1, max: 3});
     *  would return either 1, 2, or 3.
     *
     *  @param {Object} [options={}] can specify a min and/or max
     *  @returns {Number} a single random integer number
     *  @throws {RangeError} min cannot be greater than max
     */ Chance.prototype.integer = function(options) {
        // 9007199254740992 (2^53) is the max integer number in JavaScript
        // See: http://vq.io/132sa2j
        options = initOptions(options, {
            min: MIN_INT,
            max: MAX_INT
        });
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        return Math.floor(this.random() * (options.max - options.min + 1) + options.min);
    };
    /**
     *  Return a random natural
     *
     *  NOTE the max and min are INCLUDED in the range. So:
     *  chance.natural({min: 1, max: 3});
     *  would return either 1, 2, or 3.
     *
     *  @param {Object} [options={}] can specify a min and/or max or a numerals count.
     *  @returns {Number} a single random integer number
     *  @throws {RangeError} min cannot be greater than max
     */ Chance.prototype.natural = function(options) {
        options = initOptions(options, {
            min: 0,
            max: MAX_INT
        });
        if (typeof options.numerals === 'number') {
            testRange(options.numerals < 1, "Chance: Numerals cannot be less than one.");
            options.min = Math.pow(10, options.numerals - 1);
            options.max = Math.pow(10, options.numerals) - 1;
        }
        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
        if (options.exclude) {
            testRange(!Array.isArray(options.exclude), "Chance: exclude must be an array.");
            for(var exclusionIndex in options.exclude)testRange(!Number.isInteger(options.exclude[exclusionIndex]), "Chance: exclude must be numbers.");
            var random = options.min + this.natural({
                max: options.max - options.min - options.exclude.length
            });
            var sortedExclusions = options.exclude.sort((a, b)=>a - b);
            for(var sortedExclusionIndex in sortedExclusions){
                if (random < sortedExclusions[sortedExclusionIndex]) break;
                random++;
            }
            return random;
        }
        return this.integer(options);
    };
    /**
     *  Return a random prime number
     *
     *  NOTE the max and min are INCLUDED in the range.
     *
     *  @param {Object} [options={}] can specify a min and/or max
     *  @returns {Number} a single random prime number
     *  @throws {RangeError} min cannot be greater than max nor negative
     */ Chance.prototype.prime = function(options) {
        options = initOptions(options, {
            min: 0,
            max: 10000
        });
        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        var lastPrime = data.primes[data.primes.length - 1];
        if (options.max > lastPrime) {
            for(var i = lastPrime + 2; i <= options.max; ++i)if (this.is_prime(i)) data.primes.push(i);
        }
        var targetPrimes = data.primes.filter(function(prime) {
            return prime >= options.min && prime <= options.max;
        });
        return this.pick(targetPrimes);
    };
    /**
     * Determine whether a given number is prime or not.
     */ Chance.prototype.is_prime = function(n) {
        if (n % 1 || n < 2) return false;
        if (n % 2 === 0) return n === 2;
        if (n % 3 === 0) return n === 3;
        var m = Math.sqrt(n);
        for(var i = 5; i <= m; i += 6){
            if (n % i === 0 || n % (i + 2) === 0) return false;
        }
        return true;
    };
    /**
     *  Return a random hex number as string
     *
     *  NOTE the max and min are INCLUDED in the range. So:
     *  chance.hex({min: '9', max: 'B'});
     *  would return either '9', 'A' or 'B'.
     *
     *  @param {Object} [options={}] can specify a min and/or max and/or casing
     *  @returns {String} a single random string hex number
     *  @throws {RangeError} min cannot be greater than max
     */ Chance.prototype.hex = function(options) {
        options = initOptions(options, {
            min: 0,
            max: MAX_INT,
            casing: 'lower'
        });
        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
        var integer = this.natural({
            min: options.min,
            max: options.max
        });
        if (options.casing === 'upper') return integer.toString(16).toUpperCase();
        return integer.toString(16);
    };
    Chance.prototype.letter = function(options) {
        options = initOptions(options, {
            casing: 'lower'
        });
        var pool = "abcdefghijklmnopqrstuvwxyz";
        var letter = this.character({
            pool: pool
        });
        if (options.casing === 'upper') letter = letter.toUpperCase();
        return letter;
    };
    /**
     *  Return a random string
     *
     *  @param {Object} [options={}] can specify a length or min and max
     *  @returns {String} a string of random length
     *  @throws {RangeError} length cannot be less than zero
     */ Chance.prototype.string = function(options) {
        options = initOptions(options, {
            min: 5,
            max: 20
        });
        if (options.length !== 0 && !options.length) options.length = this.natural({
            min: options.min,
            max: options.max
        });
        testRange(options.length < 0, "Chance: Length cannot be less than zero.");
        var length = options.length, text = this.n(this.character, length, options);
        return text.join("");
    };
    function CopyToken(c) {
        this.c = c;
    }
    CopyToken.prototype = {
        substitute: function() {
            return this.c;
        }
    };
    function EscapeToken(c) {
        this.c = c;
    }
    EscapeToken.prototype = {
        substitute: function() {
            if (!/[{}\\]/.test(this.c)) throw new Error('Invalid escape sequence: "\\' + this.c + '".');
            return this.c;
        }
    };
    function ReplaceToken(c) {
        this.c = c;
    }
    ReplaceToken.prototype = {
        replacers: {
            '#': function(chance1) {
                return chance1.character({
                    pool: NUMBERS
                });
            },
            'A': function(chance1) {
                return chance1.character({
                    pool: CHARS_UPPER
                });
            },
            'a': function(chance1) {
                return chance1.character({
                    pool: CHARS_LOWER
                });
            }
        },
        substitute: function(chance1) {
            var replacer = this.replacers[this.c];
            if (!replacer) throw new Error('Invalid replacement character: "' + this.c + '".');
            return replacer(chance1);
        }
    };
    function parseTemplate(template) {
        var tokens = [];
        var mode = 'identity';
        for(var i = 0; i < template.length; i++){
            var c = template[i];
            switch(mode){
                case 'escape':
                    tokens.push(new EscapeToken(c));
                    mode = 'identity';
                    break;
                case 'identity':
                    if (c === '{') mode = 'replace';
                    else if (c === '\\') mode = 'escape';
                    else tokens.push(new CopyToken(c));
                    break;
                case 'replace':
                    if (c === '}') mode = 'identity';
                    else tokens.push(new ReplaceToken(c));
                    break;
            }
        }
        return tokens;
    }
    /**
     *  Return a random string matching the given template.
     *
     *  The template consists of any number of "character replacement" and
     *  "character literal" sequences. A "character replacement" sequence
     *  starts with a left brace, has any number of special replacement
     *  characters, and ends with a right brace. A character literal can be any
     *  character except a brace or a backslash. A literal brace or backslash
     *  character can be included in the output by escaping with a backslash.
     *
     *  The following replacement characters can be used in a replacement
     *  sequence:
     *
     *      "#": a random digit
     *      "a": a random lower case letter
     *      "A": a random upper case letter
     *
     *  Example: chance.template('{AA###}-{##}')
     *
     *  @param {String} template string.
     *  @returns {String} a random string matching the template.
     */ Chance.prototype.template = function(template) {
        if (!template) throw new Error('Template string is required');
        var self1 = this;
        return parseTemplate(template).map(function(token) {
            return token.substitute(self1);
        }).join('');
    };
    /**
     *  Return a random buffer
     *
     *  @param {Object} [options={}] can specify a length
     *  @returns {Buffer} a buffer of random length
     *  @throws {RangeError} length cannot be less than zero
     */ Chance.prototype.buffer = function(options) {
        if (typeof $ccfe42e488c0e860$require$Buffer === 'undefined') throw new UnsupportedError('Sorry, the buffer() function is not supported on your platform');
        options = initOptions(options, {
            length: this.natural({
                min: 5,
                max: 20
            })
        });
        testRange(options.length < 0, "Chance: Length cannot be less than zero.");
        var length = options.length;
        var content = this.n(this.character, length, options);
        return $ccfe42e488c0e860$require$Buffer.from(content);
    };
    // -- End Basics --
    // -- Helpers --
    Chance.prototype.capitalize = function(word) {
        return word.charAt(0).toUpperCase() + word.substr(1);
    };
    Chance.prototype.mixin = function(obj) {
        for(var func_name in obj)this[func_name] = obj[func_name];
        return this;
    };
    /**
     *  Given a function that generates something random and a number of items to generate,
     *    return an array of items where none repeat.
     *
     *  @param {Function} fn the function that generates something random
     *  @param {Number} num number of terms to generate
     *  @param {Object} options any options to pass on to the generator function
     *  @returns {Array} an array of length `num` with every item generated by `fn` and unique
     *
     *  There can be more parameters after these. All additional parameters are provided to the given function
     */ Chance.prototype.unique = function(fn, num, options) {
        testRange(typeof fn !== "function", "Chance: The first argument must be a function.");
        var comparator = function(arr, val) {
            return arr.indexOf(val) !== -1;
        };
        if (options) comparator = options.comparator || comparator;
        var arr = [], count = 0, result, MAX_DUPLICATES = num * 50, params = slice.call(arguments, 2);
        while(arr.length < num){
            var clonedParams = JSON.parse(JSON.stringify(params));
            result = fn.apply(this, clonedParams);
            if (!comparator(arr, result)) {
                arr.push(result);
                // reset count when unique found
                count = 0;
            }
            if (++count > MAX_DUPLICATES) throw new RangeError("Chance: num is likely too large for sample set");
        }
        return arr;
    };
    /**
     *  Gives an array of n random terms
     *
     *  @param {Function} fn the function that generates something random
     *  @param {Number} n number of terms to generate
     *  @returns {Array} an array of length `n` with items generated by `fn`
     *
     *  There can be more parameters after these. All additional parameters are provided to the given function
     */ Chance.prototype.n = function(fn, n) {
        testRange(typeof fn !== "function", "Chance: The first argument must be a function.");
        if (typeof n === 'undefined') n = 1;
        var i = n, arr = [], params = slice.call(arguments, 2);
        // Providing a negative count should result in a noop.
        i = Math.max(0, i);
        for(; i--;)arr.push(fn.apply(this, params));
        return arr;
    };
    // H/T to SO for this one: http://vq.io/OtUrZ5
    Chance.prototype.pad = function(number, width, pad) {
        // Default pad to 0 if none provided
        pad = pad || '0';
        // Convert number to a string
        number = number + '';
        return number.length >= width ? number : new Array(width - number.length + 1).join(pad) + number;
    };
    // DEPRECATED on 2015-10-01
    Chance.prototype.pick = function(arr, count) {
        if (arr.length === 0) throw new RangeError("Chance: Cannot pick() from an empty array");
        if (!count || count === 1) return arr[this.natural({
            max: arr.length - 1
        })];
        else return this.shuffle(arr).slice(0, count);
    };
    // Given an array, returns a single random element
    Chance.prototype.pickone = function(arr) {
        if (arr.length === 0) throw new RangeError("Chance: Cannot pickone() from an empty array");
        return arr[this.natural({
            max: arr.length - 1
        })];
    };
    // Given an array, returns a random set with 'count' elements
    Chance.prototype.pickset = function(arr, count) {
        if (count === 0) return [];
        if (arr.length === 0) throw new RangeError("Chance: Cannot pickset() from an empty array");
        if (count < 0) throw new RangeError("Chance: Count must be a positive number");
        if (!count || count === 1) return [
            this.pickone(arr)
        ];
        else {
            var array = arr.slice(0);
            var end = array.length;
            return this.n(function() {
                var index = this.natural({
                    max: --end
                });
                var value = array[index];
                array[index] = array[end];
                return value;
            }, Math.min(end, count));
        }
    };
    Chance.prototype.shuffle = function(arr) {
        var new_array = [], j = 0, length = Number(arr.length), source_indexes = range(length), last_source_index = length - 1, selected_source_index;
        for(var i = 0; i < length; i++){
            // Pick a random index from the array
            selected_source_index = this.natural({
                max: last_source_index
            });
            j = source_indexes[selected_source_index];
            // Add it to the new array
            new_array[i] = arr[j];
            // Mark the source index as used
            source_indexes[selected_source_index] = source_indexes[last_source_index];
            last_source_index -= 1;
        }
        return new_array;
    };
    // Returns a single item from an array with relative weighting of odds
    Chance.prototype.weighted = function(arr, weights, trim) {
        if (arr.length !== weights.length) throw new RangeError("Chance: Length of array and weights must match");
        // scan weights array and sum valid entries
        var sum = 0;
        var val;
        for(var weightIndex = 0; weightIndex < weights.length; ++weightIndex){
            val = weights[weightIndex];
            if (isNaN(val)) throw new RangeError("Chance: All weights must be numbers");
            if (val > 0) sum += val;
        }
        if (sum === 0) throw new RangeError("Chance: No valid entries in array weights");
        // select a value within range
        var selected = this.random() * sum;
        // find array entry corresponding to selected value
        var total = 0;
        var lastGoodIdx = -1;
        var chosenIdx;
        for(weightIndex = 0; weightIndex < weights.length; ++weightIndex){
            val = weights[weightIndex];
            total += val;
            if (val > 0) {
                if (selected <= total) {
                    chosenIdx = weightIndex;
                    break;
                }
                lastGoodIdx = weightIndex;
            }
            // handle any possible rounding error comparison to ensure something is picked
            if (weightIndex === weights.length - 1) chosenIdx = lastGoodIdx;
        }
        var chosen = arr[chosenIdx];
        trim = typeof trim === 'undefined' ? false : trim;
        if (trim) {
            arr.splice(chosenIdx, 1);
            weights.splice(chosenIdx, 1);
        }
        return chosen;
    };
    // -- End Helpers --
    // -- Text --
    Chance.prototype.paragraph = function(options) {
        options = initOptions(options);
        var sentences = options.sentences || this.natural({
            min: 3,
            max: 7
        }), sentence_array = this.n(this.sentence, sentences), separator = options.linebreak === true ? '\n' : ' ';
        return sentence_array.join(separator);
    };
    // Could get smarter about this than generating random words and
    // chaining them together. Such as: http://vq.io/1a5ceOh
    Chance.prototype.sentence = function(options) {
        options = initOptions(options);
        var words = options.words || this.natural({
            min: 12,
            max: 18
        }), punctuation = options.punctuation, text, word_array = this.n(this.word, words);
        text = word_array.join(' ');
        // Capitalize first letter of sentence
        text = this.capitalize(text);
        // Make sure punctuation has a usable value
        if (punctuation !== false && !/^[.?;!:]$/.test(punctuation)) punctuation = '.';
        // Add punctuation mark
        if (punctuation) text += punctuation;
        return text;
    };
    Chance.prototype.syllable = function(options) {
        options = initOptions(options);
        var length = options.length || this.natural({
            min: 2,
            max: 3
        }), consonants = 'bcdfghjklmnprstvwz', vowels = 'aeiou', all = consonants + vowels, text = '', chr;
        // I'm sure there's a more elegant way to do this, but this works
        // decently well.
        for(var i = 0; i < length; i++){
            if (i === 0) // First character can be anything
            chr = this.character({
                pool: all
            });
            else if (consonants.indexOf(chr) === -1) // Last character was a vowel, now we want a consonant
            chr = this.character({
                pool: consonants
            });
            else // Last character was a consonant, now we want a vowel
            chr = this.character({
                pool: vowels
            });
            text += chr;
        }
        if (options.capitalize) text = this.capitalize(text);
        return text;
    };
    Chance.prototype.word = function(options) {
        options = initOptions(options);
        testRange(options.syllables && options.length, "Chance: Cannot specify both syllables AND length.");
        var syllables = options.syllables || this.natural({
            min: 1,
            max: 3
        }), text = '';
        if (options.length) {
            // Either bound word by length
            do text += this.syllable();
            while (text.length < options.length);
            text = text.substring(0, options.length);
        } else // Or by number of syllables
        for(var i = 0; i < syllables; i++)text += this.syllable();
        if (options.capitalize) text = this.capitalize(text);
        return text;
    };
    Chance.prototype.emoji = function(options) {
        options = initOptions(options, {
            category: "all",
            length: 1
        });
        testRange(options.length < 1 || BigInt(options.length) > BigInt(MAX_INT), "Chance: length must be between 1 and " + String(MAX_INT));
        var emojis = this.get("emojis");
        if (options.category === "all") options.category = this.pickone(Object.keys(emojis));
        var emojisForCategory = emojis[options.category];
        testRange(emojisForCategory === undefined, "Chance: Unrecognised emoji category: [" + options.category + "].");
        return this.pickset(emojisForCategory, options.length).map(function(codePoint) {
            return String.fromCodePoint(codePoint);
        }).join("");
    };
    // -- End Text --
    // -- Person --
    Chance.prototype.age = function(options) {
        options = initOptions(options);
        var ageRange;
        switch(options.type){
            case 'child':
                ageRange = {
                    min: 0,
                    max: 12
                };
                break;
            case 'teen':
                ageRange = {
                    min: 13,
                    max: 19
                };
                break;
            case 'adult':
                ageRange = {
                    min: 18,
                    max: 65
                };
                break;
            case 'senior':
                ageRange = {
                    min: 65,
                    max: 100
                };
                break;
            case 'all':
                ageRange = {
                    min: 0,
                    max: 100
                };
                break;
            default:
                ageRange = {
                    min: 18,
                    max: 65
                };
                break;
        }
        return this.natural(ageRange);
    };
    Chance.prototype.birthday = function(options) {
        var age = this.age(options);
        var now = new Date();
        var currentYear = now.getFullYear();
        if (options && options.type) {
            var min = new Date();
            var max = new Date();
            min.setFullYear(currentYear - age - 1);
            max.setFullYear(currentYear - age);
            options = initOptions(options, {
                min: min,
                max: max
            });
        } else if (options && (options.minAge !== undefined || options.maxAge !== undefined)) {
            testRange(options.minAge < 0, "Chance: MinAge cannot be less than zero.");
            testRange(options.minAge > options.maxAge, "Chance: MinAge cannot be greater than MaxAge.");
            var minAge = options.minAge !== undefined ? options.minAge : 0;
            var maxAge = options.maxAge !== undefined ? options.maxAge : 100;
            var minDate = new Date(currentYear - maxAge - 1, now.getMonth(), now.getDate());
            var maxDate = new Date(currentYear - minAge, now.getMonth(), now.getDate());
            minDate.setDate(minDate.getDate() + 1);
            maxDate.setDate(maxDate.getDate() + 1);
            maxDate.setMilliseconds(maxDate.getMilliseconds() - 1);
            options = initOptions(options, {
                min: minDate,
                max: maxDate
            });
        } else options = initOptions(options, {
            year: currentYear - age
        });
        return this.date(options);
    };
    // CPF; ID to identify taxpayers in Brazil
    Chance.prototype.cpf = function(options) {
        options = initOptions(options, {
            formatted: true
        });
        var n = this.n(this.natural, 9, {
            max: 9
        });
        var d1 = n[8] * 2 + n[7] * 3 + n[6] * 4 + n[5] * 5 + n[4] * 6 + n[3] * 7 + n[2] * 8 + n[1] * 9 + n[0] * 10;
        d1 = 11 - d1 % 11;
        if (d1 >= 10) d1 = 0;
        var d2 = d1 * 2 + n[8] * 3 + n[7] * 4 + n[6] * 5 + n[5] * 6 + n[4] * 7 + n[3] * 8 + n[2] * 9 + n[1] * 10 + n[0] * 11;
        d2 = 11 - d2 % 11;
        if (d2 >= 10) d2 = 0;
        var cpf = '' + n[0] + n[1] + n[2] + '.' + n[3] + n[4] + n[5] + '.' + n[6] + n[7] + n[8] + '-' + d1 + d2;
        return options.formatted ? cpf : cpf.replace(/\D/g, '');
    };
    // CNPJ: ID to identify companies in Brazil
    Chance.prototype.cnpj = function(options) {
        options = initOptions(options, {
            formatted: true
        });
        var n = this.n(this.natural, 12, {
            max: 12
        });
        var d1 = n[11] * 2 + n[10] * 3 + n[9] * 4 + n[8] * 5 + n[7] * 6 + n[6] * 7 + n[5] * 8 + n[4] * 9 + n[3] * 2 + n[2] * 3 + n[1] * 4 + n[0] * 5;
        d1 = 11 - d1 % 11;
        if (d1 < 2) d1 = 0;
        var d2 = d1 * 2 + n[11] * 3 + n[10] * 4 + n[9] * 5 + n[8] * 6 + n[7] * 7 + n[6] * 8 + n[5] * 9 + n[4] * 2 + n[3] * 3 + n[2] * 4 + n[1] * 5 + n[0] * 6;
        d2 = 11 - d2 % 11;
        if (d2 < 2) d2 = 0;
        var cnpj = '' + n[0] + n[1] + '.' + n[2] + n[3] + n[4] + '.' + n[5] + n[6] + n[7] + '/' + n[8] + n[9] + n[10] + n[11] + '-' + d1 + d2;
        return options.formatted ? cnpj : cnpj.replace(/\D/g, '');
    };
    Chance.prototype.first = function(options) {
        options = initOptions(options, {
            gender: this.gender(),
            nationality: 'en'
        });
        return this.pick(this.get("firstNames")[options.gender.toLowerCase()][options.nationality.toLowerCase()]);
    };
    Chance.prototype.profession = function(options) {
        options = initOptions(options);
        if (options.rank) return this.pick([
            'Apprentice ',
            'Junior ',
            'Senior ',
            'Lead '
        ]) + this.pick(this.get("profession"));
        else return this.pick(this.get("profession"));
    };
    Chance.prototype.company = function() {
        return this.pick(this.get("company"));
    };
    Chance.prototype.gender = function(options) {
        options = initOptions(options, {
            extraGenders: []
        });
        return this.pick([
            'Male',
            'Female'
        ].concat(options.extraGenders));
    };
    Chance.prototype.last = function(options) {
        options = initOptions(options, {
            nationality: '*'
        });
        if (options.nationality === "*") {
            var allLastNames = [];
            var lastNames = this.get("lastNames");
            Object.keys(lastNames).forEach(function(key) {
                allLastNames = allLastNames.concat(lastNames[key]);
            });
            return this.pick(allLastNames);
        } else return this.pick(this.get("lastNames")[options.nationality.toLowerCase()]);
    };
    Chance.prototype.israelId = function() {
        var x = this.string({
            pool: '0123456789',
            length: 8
        });
        var y = 0;
        for(var i = 0; i < x.length; i++){
            var thisDigit = x[i] * (i / 2 === parseInt(i / 2) ? 1 : 2);
            thisDigit = this.pad(thisDigit, 2).toString();
            thisDigit = parseInt(thisDigit[0]) + parseInt(thisDigit[1]);
            y = y + thisDigit;
        }
        x = x + (10 - parseInt(y.toString().slice(-1))).toString().slice(-1);
        return x;
    };
    Chance.prototype.mrz = function(options) {
        var checkDigit = function(input) {
            var alpha = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(''), multipliers = [
                7,
                3,
                1
            ], runningTotal = 0;
            if (typeof input !== 'string') input = input.toString();
            input.split('').forEach(function(character, idx) {
                var pos = alpha.indexOf(character);
                if (pos !== -1) character = pos === 0 ? 0 : pos + 9;
                else character = parseInt(character, 10);
                character *= multipliers[idx % multipliers.length];
                runningTotal += character;
            });
            return runningTotal % 10;
        };
        var generate = function(opts) {
            var pad = function(length) {
                return new Array(length + 1).join('<');
            };
            var number = [
                'P<',
                opts.issuer,
                opts.last.toUpperCase(),
                '<<',
                opts.first.toUpperCase(),
                pad(39 - (opts.last.length + opts.first.length + 2)),
                opts.passportNumber,
                checkDigit(opts.passportNumber),
                opts.nationality,
                opts.dob,
                checkDigit(opts.dob),
                opts.gender,
                opts.expiry,
                checkDigit(opts.expiry),
                pad(14),
                checkDigit(pad(14))
            ].join('');
            return number + checkDigit(number.substr(44, 10) + number.substr(57, 7) + number.substr(65, 7));
        };
        var that = this;
        options = initOptions(options, {
            first: this.first(),
            last: this.last(),
            passportNumber: this.integer({
                min: 100000000,
                max: 999999999
            }),
            dob: function() {
                var date = that.birthday({
                    type: 'adult'
                });
                return [
                    date.getFullYear().toString().substr(2),
                    that.pad(date.getMonth() + 1, 2),
                    that.pad(date.getDate(), 2)
                ].join('');
            }(),
            expiry: function() {
                var date = new Date();
                return [
                    (date.getFullYear() + 5).toString().substr(2),
                    that.pad(date.getMonth() + 1, 2),
                    that.pad(date.getDate(), 2)
                ].join('');
            }(),
            gender: this.gender() === 'Female' ? 'F' : 'M',
            issuer: 'GBR',
            nationality: 'GBR'
        });
        return generate(options);
    };
    Chance.prototype.name = function(options) {
        options = initOptions(options);
        var first = this.first(options), last = this.last(options), name;
        if (options.middle) name = first + ' ' + this.first(options) + ' ' + last;
        else if (options.middle_initial) name = first + ' ' + this.character({
            alpha: true,
            casing: 'upper'
        }) + '. ' + last;
        else name = first + ' ' + last;
        if (options.prefix) name = this.prefix(options) + ' ' + name;
        if (options.suffix) name = name + ' ' + this.suffix(options);
        return name;
    };
    // Return the list of available name prefixes based on supplied gender.
    // @todo introduce internationalization
    Chance.prototype.name_prefixes = function(gender) {
        gender = gender || "all";
        gender = gender.toLowerCase();
        var prefixes = [
            {
                name: 'Doctor',
                abbreviation: 'Dr.'
            }
        ];
        if (gender === "male" || gender === "all") prefixes.push({
            name: 'Mister',
            abbreviation: 'Mr.'
        });
        if (gender === "female" || gender === "all") {
            prefixes.push({
                name: 'Miss',
                abbreviation: 'Miss'
            });
            prefixes.push({
                name: 'Misses',
                abbreviation: 'Mrs.'
            });
        }
        return prefixes;
    };
    // Alias for name_prefix
    Chance.prototype.prefix = function(options) {
        return this.name_prefix(options);
    };
    Chance.prototype.name_prefix = function(options) {
        options = initOptions(options, {
            gender: "all"
        });
        return options.full ? this.pick(this.name_prefixes(options.gender)).name : this.pick(this.name_prefixes(options.gender)).abbreviation;
    };
    //Hungarian ID number
    Chance.prototype.HIDN = function() {
        //Hungarian ID nuber structure: XXXXXXYY (X=number,Y=Capital Latin letter)
        var idn_pool = "0123456789";
        var idn_chrs = "ABCDEFGHIJKLMNOPQRSTUVWXYXZ";
        var idn = "";
        idn += this.string({
            pool: idn_pool,
            length: 6
        });
        idn += this.string({
            pool: idn_chrs,
            length: 2
        });
        return idn;
    };
    Chance.prototype.ssn = function(options) {
        options = initOptions(options, {
            ssnFour: false,
            dashes: true
        });
        var ssn_pool = "1234567890", ssn, dash = options.dashes ? '-' : '';
        if (!options.ssnFour) ssn = this.string({
            pool: ssn_pool,
            length: 3
        }) + dash + this.string({
            pool: ssn_pool,
            length: 2
        }) + dash + this.string({
            pool: ssn_pool,
            length: 4
        });
        else ssn = this.string({
            pool: ssn_pool,
            length: 4
        });
        return ssn;
    };
    // Aadhar is similar to ssn, used in India to uniquely identify a person
    Chance.prototype.aadhar = function(options) {
        options = initOptions(options, {
            onlyLastFour: false,
            separatedByWhiteSpace: true
        });
        var aadhar_pool = "1234567890", aadhar, whiteSpace = options.separatedByWhiteSpace ? ' ' : '';
        if (!options.onlyLastFour) aadhar = this.string({
            pool: aadhar_pool,
            length: 4
        }) + whiteSpace + this.string({
            pool: aadhar_pool,
            length: 4
        }) + whiteSpace + this.string({
            pool: aadhar_pool,
            length: 4
        });
        else aadhar = this.string({
            pool: aadhar_pool,
            length: 4
        });
        return aadhar;
    };
    // Return the list of available name suffixes
    // @todo introduce internationalization
    Chance.prototype.name_suffixes = function() {
        var suffixes = [
            {
                name: 'Doctor of Osteopathic Medicine',
                abbreviation: 'D.O.'
            },
            {
                name: 'Doctor of Philosophy',
                abbreviation: 'Ph.D.'
            },
            {
                name: 'Esquire',
                abbreviation: 'Esq.'
            },
            {
                name: 'Junior',
                abbreviation: 'Jr.'
            },
            {
                name: 'Juris Doctor',
                abbreviation: 'J.D.'
            },
            {
                name: 'Master of Arts',
                abbreviation: 'M.A.'
            },
            {
                name: 'Master of Business Administration',
                abbreviation: 'M.B.A.'
            },
            {
                name: 'Master of Science',
                abbreviation: 'M.S.'
            },
            {
                name: 'Medical Doctor',
                abbreviation: 'M.D.'
            },
            {
                name: 'Senior',
                abbreviation: 'Sr.'
            },
            {
                name: 'The Third',
                abbreviation: 'III'
            },
            {
                name: 'The Fourth',
                abbreviation: 'IV'
            },
            {
                name: 'Bachelor of Engineering',
                abbreviation: 'B.E'
            },
            {
                name: 'Bachelor of Technology',
                abbreviation: 'B.TECH'
            }
        ];
        return suffixes;
    };
    // Alias for name_suffix
    Chance.prototype.suffix = function(options) {
        return this.name_suffix(options);
    };
    Chance.prototype.name_suffix = function(options) {
        options = initOptions(options);
        return options.full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
    };
    Chance.prototype.nationalities = function() {
        return this.get("nationalities");
    };
    // Generate random nationality based on json list
    Chance.prototype.nationality = function() {
        var nationality = this.pick(this.nationalities());
        return nationality.name;
    };
    // Generate random zodiac sign
    Chance.prototype.zodiac = function() {
        const zodiacSymbols = [
            "Aries",
            "Taurus",
            "Gemini",
            "Cancer",
            "Leo",
            "Virgo",
            "Libra",
            "Scorpio",
            "Sagittarius",
            "Capricorn",
            "Aquarius",
            "Pisces"
        ];
        return this.pickone(zodiacSymbols);
    };
    // -- End Person --
    // -- Mobile --
    // Android GCM Registration ID
    Chance.prototype.android_id = function() {
        return "APA91" + this.string({
            pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_",
            length: 178
        });
    };
    // Apple Push Token
    Chance.prototype.apple_token = function() {
        return this.string({
            pool: "abcdef1234567890",
            length: 64
        });
    };
    // Windows Phone 8 ANID2
    Chance.prototype.wp8_anid2 = function() {
        return base64(this.hash({
            length: 32
        }));
    };
    // Windows Phone 7 ANID
    Chance.prototype.wp7_anid = function() {
        return 'A=' + this.guid().replace(/-/g, '').toUpperCase() + '&E=' + this.hash({
            length: 3
        }) + '&W=' + this.integer({
            min: 0,
            max: 9
        });
    };
    // BlackBerry Device PIN
    Chance.prototype.bb_pin = function() {
        return this.hash({
            length: 8
        });
    };
    // -- End Mobile --
    // -- Web --
    Chance.prototype.avatar = function(options) {
        var url = null;
        var URL_BASE = '//www.gravatar.com/avatar/';
        var PROTOCOLS = {
            http: 'http',
            https: 'https'
        };
        var FILE_TYPES = {
            bmp: 'bmp',
            gif: 'gif',
            jpg: 'jpg',
            png: 'png'
        };
        var FALLBACKS = {
            '404': '404',
            mm: 'mm',
            identicon: 'identicon',
            monsterid: 'monsterid',
            wavatar: 'wavatar',
            retro: 'retro',
            blank: 'blank' // A transparent png
        };
        var RATINGS = {
            g: 'g',
            pg: 'pg',
            r: 'r',
            x: 'x'
        };
        var opts = {
            protocol: null,
            email: null,
            fileExtension: null,
            size: null,
            fallback: null,
            rating: null
        };
        if (!options) {
            // Set to a random email
            opts.email = this.email();
            options = {};
        } else if (typeof options === 'string') {
            opts.email = options;
            options = {};
        } else if (typeof options !== 'object') return null;
        else if (options.constructor === 'Array') return null;
        opts = initOptions(options, opts);
        if (!opts.email) // Set to a random email
        opts.email = this.email();
        // Safe checking for params
        opts.protocol = PROTOCOLS[opts.protocol] ? opts.protocol + ':' : '';
        opts.size = parseInt(opts.size, 0) ? opts.size : '';
        opts.rating = RATINGS[opts.rating] ? opts.rating : '';
        opts.fallback = FALLBACKS[opts.fallback] ? opts.fallback : '';
        opts.fileExtension = FILE_TYPES[opts.fileExtension] ? opts.fileExtension : '';
        url = opts.protocol + URL_BASE + this.bimd5.md5(opts.email) + (opts.fileExtension ? '.' + opts.fileExtension : '') + (opts.size || opts.rating || opts.fallback ? '?' : '') + (opts.size ? '&s=' + opts.size.toString() : '') + (opts.rating ? '&r=' + opts.rating : '') + (opts.fallback ? '&d=' + opts.fallback : '');
        return url;
    };
    /**
     * #Description:
     * ===============================================
     * Generate random color value base on color type:
     * -> hex
     * -> rgb
     * -> rgba
     * -> 0x
     * -> named color
     *
     * #Examples:
     * ===============================================
     * * Geerate random hex color
     * chance.color() => '#79c157' / 'rgb(110,52,164)' / '0x67ae0b' / '#e2e2e2' / '#29CFA7'
     *
     * * Generate Hex based color value
     * chance.color({format: 'hex'})    => '#d67118'
     *
     * * Generate simple rgb value
     * chance.color({format: 'rgb'})    => 'rgb(110,52,164)'
     *
     * * Generate Ox based color value
     * chance.color({format: '0x'})     => '0x67ae0b'
     *
     * * Generate graiscale based value
     * chance.color({grayscale: true})  => '#e2e2e2'
     *
     * * Return valide color name
     * chance.color({format: 'name'})   => 'red'
     *
     * * Make color uppercase
     * chance.color({casing: 'upper'})  => '#29CFA7'
     *
     * * Min Max values for RGBA
     * var light_red = chance.color({format: 'hex', min_red: 200, max_red: 255, max_green: 0, max_blue: 0, min_alpha: .2, max_alpha: .3});
     *
     * @param  [object] options
     * @return [string] color value
     */ Chance.prototype.color = function(options) {
        function gray(value, delimiter) {
            return [
                value,
                value,
                value
            ].join(delimiter || '');
        }
        function rgb(hasAlpha) {
            var rgbValue = hasAlpha ? 'rgba' : 'rgb';
            var alphaChannel = hasAlpha ? ',' + this.floating({
                min: min_alpha,
                max: max_alpha
            }) : "";
            var colorValue = isGrayscale ? gray(this.natural({
                min: min_rgb,
                max: max_rgb
            }), ',') : this.natural({
                min: min_green,
                max: max_green
            }) + ',' + this.natural({
                min: min_blue,
                max: max_blue
            }) + ',' + this.natural({
                max: 255
            });
            return rgbValue + '(' + colorValue + alphaChannel + ')';
        }
        function hex(start, end, withHash) {
            var symbol = withHash ? "#" : "";
            var hexstring = "";
            if (isGrayscale) {
                hexstring = gray(this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2));
                if (options.format === "shorthex") hexstring = gray(this.hex({
                    min: 0,
                    max: 15
                }));
            } else {
                if (options.format === "shorthex") hexstring = this.pad(this.hex({
                    min: Math.floor(min_red / 16),
                    max: Math.floor(max_red / 16)
                }), 1) + this.pad(this.hex({
                    min: Math.floor(min_green / 16),
                    max: Math.floor(max_green / 16)
                }), 1) + this.pad(this.hex({
                    min: Math.floor(min_blue / 16),
                    max: Math.floor(max_blue / 16)
                }), 1);
                else if (min_red !== undefined || max_red !== undefined || min_green !== undefined || max_green !== undefined || min_blue !== undefined || max_blue !== undefined) hexstring = this.pad(this.hex({
                    min: min_red,
                    max: max_red
                }), 2) + this.pad(this.hex({
                    min: min_green,
                    max: max_green
                }), 2) + this.pad(this.hex({
                    min: min_blue,
                    max: max_blue
                }), 2);
                else hexstring = this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2) + this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2) + this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2);
            }
            return symbol + hexstring;
        }
        options = initOptions(options, {
            format: this.pick([
                'hex',
                'shorthex',
                'rgb',
                'rgba',
                '0x',
                'name'
            ]),
            grayscale: false,
            casing: 'lower',
            min: 0,
            max: 255,
            min_red: undefined,
            max_red: undefined,
            min_green: undefined,
            max_green: undefined,
            min_blue: undefined,
            max_blue: undefined,
            min_alpha: 0,
            max_alpha: 1
        });
        var isGrayscale = options.grayscale;
        var min_rgb = options.min;
        var max_rgb = options.max;
        var min_red = options.min_red;
        var max_red = options.max_red;
        var min_green = options.min_green;
        var max_green = options.max_green;
        var min_blue = options.min_blue;
        var max_blue = options.max_blue;
        var min_alpha = options.min_alpha;
        var max_alpha = options.max_alpha;
        if (options.min_red === undefined) min_red = min_rgb;
        if (options.max_red === undefined) max_red = max_rgb;
        if (options.min_green === undefined) min_green = min_rgb;
        if (options.max_green === undefined) max_green = max_rgb;
        if (options.min_blue === undefined) min_blue = min_rgb;
        if (options.max_blue === undefined) max_blue = max_rgb;
        if (options.min_alpha === undefined) min_alpha = 0;
        if (options.max_alpha === undefined) max_alpha = 1;
        if (isGrayscale && min_rgb === 0 && max_rgb === 255 && min_red !== undefined && max_red !== undefined) {
            min_rgb = (min_red + min_green + min_blue) / 3;
            max_rgb = (max_red + max_green + max_blue) / 3;
        }
        var colorValue;
        if (options.format === 'hex') colorValue = hex.call(this, 2, 6, true);
        else if (options.format === 'shorthex') colorValue = hex.call(this, 1, 3, true);
        else if (options.format === 'rgb') colorValue = rgb.call(this, false);
        else if (options.format === 'rgba') colorValue = rgb.call(this, true);
        else if (options.format === '0x') colorValue = '0x' + hex.call(this, 2, 6);
        else if (options.format === 'name') return this.pick(this.get("colorNames"));
        else throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        if (options.casing === 'upper') colorValue = colorValue.toUpperCase();
        return colorValue;
    };
    Chance.prototype.domain = function(options) {
        options = initOptions(options);
        return this.word() + '.' + (options.tld || this.tld());
    };
    Chance.prototype.email = function(options) {
        options = initOptions(options);
        return this.word({
            length: options.length
        }) + '@' + (options.domain || this.domain());
    };
    /**
     * #Description:
     * ===============================================
     * Generate a random Facebook id, aka fbid.
     *
     * NOTE: At the moment (Sep 2017), Facebook ids are
     * "numeric strings" of length 16.
     * However, Facebook Graph API documentation states that
     * "it is extremely likely to change over time".
     * @see https://developers.facebook.com/docs/graph-api/overview/
     *
     * #Examples:
     * ===============================================
     * chance.fbid() => '1000035231661304'
     *
     * @return [string] facebook id
     */ Chance.prototype.fbid = function() {
        return '10000' + this.string({
            pool: "1234567890",
            length: 11
        });
    };
    Chance.prototype.google_analytics = function() {
        var account = this.pad(this.natural({
            max: 999999
        }), 6);
        var property = this.pad(this.natural({
            max: 99
        }), 2);
        return 'UA-' + account + '-' + property;
    };
    Chance.prototype.hashtag = function() {
        return '#' + this.word();
    };
    Chance.prototype.ip = function() {
        // Todo: This could return some reserved IPs. See http://vq.io/137dgYy
        // this should probably be updated to account for that rare as it may be
        return this.natural({
            min: 1,
            max: 254
        }) + '.' + this.natural({
            max: 255
        }) + '.' + this.natural({
            max: 255
        }) + '.' + this.natural({
            min: 1,
            max: 254
        });
    };
    Chance.prototype.ipv6 = function() {
        var ip_addr = this.n(this.hash, 8, {
            length: 4
        });
        return ip_addr.join(":");
    };
    Chance.prototype.klout = function() {
        return this.natural({
            min: 1,
            max: 99
        });
    };
    Chance.prototype.mac = function(options) {
        // Todo: This could also be extended to EUI-64 based MACs
        // (https://www.iana.org/assignments/ethernet-numbers/ethernet-numbers.xhtml#ethernet-numbers-4)
        // Todo: This can return some reserved MACs (similar to IP function)
        // this should probably be updated to account for that rare as it may be
        options = initOptions(options, {
            delimiter: ':'
        });
        return this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2);
    };
    Chance.prototype.semver = function(options) {
        options = initOptions(options, {
            include_prerelease: true
        });
        var range = this.pickone([
            "^",
            "~",
            "<",
            ">",
            "<=",
            ">=",
            "="
        ]);
        if (options.range) range = options.range;
        var prerelease = "";
        if (options.include_prerelease) prerelease = this.weighted([
            "",
            "-dev",
            "-beta",
            "-alpha"
        ], [
            50,
            10,
            5,
            1
        ]);
        return range + this.rpg('3d10').join('.') + prerelease;
    };
    Chance.prototype.tlds = function() {
        return [
            'com',
            'org',
            'edu',
            'gov',
            'co.uk',
            'net',
            'io',
            'ac',
            'ad',
            'ae',
            'af',
            'ag',
            'ai',
            'al',
            'am',
            'ao',
            'aq',
            'ar',
            'as',
            'at',
            'au',
            'aw',
            'ax',
            'az',
            'ba',
            'bb',
            'bd',
            'be',
            'bf',
            'bg',
            'bh',
            'bi',
            'bj',
            'bm',
            'bn',
            'bo',
            'br',
            'bs',
            'bt',
            'bv',
            'bw',
            'by',
            'bz',
            'ca',
            'cc',
            'cd',
            'cf',
            'cg',
            'ch',
            'ci',
            'ck',
            'cl',
            'cm',
            'cn',
            'co',
            'cr',
            'cu',
            'cv',
            'cw',
            'cx',
            'cy',
            'cz',
            'de',
            'dj',
            'dk',
            'dm',
            'do',
            'dz',
            'ec',
            'ee',
            'eg',
            'eh',
            'er',
            'es',
            'et',
            'eu',
            'fi',
            'fj',
            'fk',
            'fm',
            'fo',
            'fr',
            'ga',
            'gb',
            'gd',
            'ge',
            'gf',
            'gg',
            'gh',
            'gi',
            'gl',
            'gm',
            'gn',
            'gp',
            'gq',
            'gr',
            'gs',
            'gt',
            'gu',
            'gw',
            'gy',
            'hk',
            'hm',
            'hn',
            'hr',
            'ht',
            'hu',
            'id',
            'ie',
            'il',
            'im',
            'in',
            'io',
            'iq',
            'ir',
            'is',
            'it',
            'je',
            'jm',
            'jo',
            'jp',
            'ke',
            'kg',
            'kh',
            'ki',
            'km',
            'kn',
            'kp',
            'kr',
            'kw',
            'ky',
            'kz',
            'la',
            'lb',
            'lc',
            'li',
            'lk',
            'lr',
            'ls',
            'lt',
            'lu',
            'lv',
            'ly',
            'ma',
            'mc',
            'md',
            'me',
            'mg',
            'mh',
            'mk',
            'ml',
            'mm',
            'mn',
            'mo',
            'mp',
            'mq',
            'mr',
            'ms',
            'mt',
            'mu',
            'mv',
            'mw',
            'mx',
            'my',
            'mz',
            'na',
            'nc',
            'ne',
            'nf',
            'ng',
            'ni',
            'nl',
            'no',
            'np',
            'nr',
            'nu',
            'nz',
            'om',
            'pa',
            'pe',
            'pf',
            'pg',
            'ph',
            'pk',
            'pl',
            'pm',
            'pn',
            'pr',
            'ps',
            'pt',
            'pw',
            'py',
            'qa',
            're',
            'ro',
            'rs',
            'ru',
            'rw',
            'sa',
            'sb',
            'sc',
            'sd',
            'se',
            'sg',
            'sh',
            'si',
            'sj',
            'sk',
            'sl',
            'sm',
            'sn',
            'so',
            'sr',
            'ss',
            'st',
            'su',
            'sv',
            'sx',
            'sy',
            'sz',
            'tc',
            'td',
            'tf',
            'tg',
            'th',
            'tj',
            'tk',
            'tl',
            'tm',
            'tn',
            'to',
            'tr',
            'tt',
            'tv',
            'tw',
            'tz',
            'ua',
            'ug',
            'uk',
            'us',
            'uy',
            'uz',
            'va',
            'vc',
            've',
            'vg',
            'vi',
            'vn',
            'vu',
            'wf',
            'ws',
            'ye',
            'yt',
            'za',
            'zm',
            'zw'
        ];
    };
    Chance.prototype.tld = function() {
        return this.pick(this.tlds());
    };
    Chance.prototype.twitter = function() {
        return '@' + this.word();
    };
    Chance.prototype.url = function(options) {
        options = initOptions(options, {
            protocol: "http",
            domain: this.domain(options),
            domain_prefix: "",
            path: this.word(),
            extensions: []
        });
        var extension = options.extensions.length > 0 ? "." + this.pick(options.extensions) : "";
        var domain = options.domain_prefix ? options.domain_prefix + "." + options.domain : options.domain;
        return options.protocol + "://" + domain + "/" + options.path + extension;
    };
    Chance.prototype.port = function() {
        return this.integer({
            min: 0,
            max: 65535
        });
    };
    Chance.prototype.locale = function(options) {
        options = initOptions(options);
        if (options.region) return this.pick(this.get("locale_regions"));
        else return this.pick(this.get("locale_languages"));
    };
    Chance.prototype.locales = function(options) {
        options = initOptions(options);
        if (options.region) return this.get("locale_regions");
        else return this.get("locale_languages");
    };
    Chance.prototype.loremPicsum = function(options) {
        options = initOptions(options, {
            width: 500,
            height: 500,
            greyscale: false,
            blurred: false
        });
        var greyscale = options.greyscale ? 'g/' : '';
        var query = options.blurred ? '/?blur' : '/?random';
        return 'https://picsum.photos/' + greyscale + options.width + '/' + options.height + query;
    };
    // -- End Web --
    // -- Location --
    Chance.prototype.address = function(options) {
        options = initOptions(options);
        return this.natural({
            min: 5,
            max: 2000
        }) + ' ' + this.street(options);
    };
    Chance.prototype.altitude = function(options) {
        options = initOptions(options, {
            fixed: 5,
            min: 0,
            max: 8848
        });
        return this.floating({
            min: options.min,
            max: options.max,
            fixed: options.fixed
        });
    };
    Chance.prototype.areacode = function(options) {
        options = initOptions(options, {
            parens: true
        });
        // Don't want area codes to start with 1, or have a 9 as the second digit
        var areacode = options.exampleNumber ? "555" : this.natural({
            min: 2,
            max: 9
        }).toString() + this.natural({
            min: 0,
            max: 8
        }).toString() + this.natural({
            min: 0,
            max: 9
        }).toString();
        return options.parens ? '(' + areacode + ')' : areacode;
    };
    Chance.prototype.city = function() {
        return this.capitalize(this.word({
            syllables: 3
        }));
    };
    Chance.prototype.coordinates = function(options) {
        return this.latitude(options) + ', ' + this.longitude(options);
    };
    Chance.prototype.countries = function() {
        return this.get("countries");
    };
    Chance.prototype.country = function(options) {
        options = initOptions(options);
        var country = this.pick(this.countries());
        return options.raw ? country : options.full ? country.name : country.abbreviation;
    };
    Chance.prototype.depth = function(options) {
        options = initOptions(options, {
            fixed: 5,
            min: -10994,
            max: 0
        });
        return this.floating({
            min: options.min,
            max: options.max,
            fixed: options.fixed
        });
    };
    Chance.prototype.geohash = function(options) {
        options = initOptions(options, {
            length: 7
        });
        return this.string({
            length: options.length,
            pool: '0123456789bcdefghjkmnpqrstuvwxyz'
        });
    };
    Chance.prototype.geojson = function(options) {
        return this.latitude(options) + ', ' + this.longitude(options) + ', ' + this.altitude(options);
    };
    Chance.prototype.latitude = function(options) {
        // Constants - Formats
        var [DDM, DMS, DD] = [
            'ddm',
            'dms',
            'dd'
        ];
        options = initOptions(options, options && options.format && [
            DDM,
            DMS
        ].includes(options.format.toLowerCase()) ? {
            min: 0,
            max: 89,
            fixed: 4
        } : {
            fixed: 5,
            min: -90,
            max: 90,
            format: DD
        });
        var format = options.format.toLowerCase();
        if (format === DDM || format === DMS) {
            testRange(options.min < 0 || options.min > 89, "Chance: Min specified is out of range. Should be between 0 - 89");
            testRange(options.max < 0 || options.max > 89, "Chance: Max specified is out of range. Should be between 0 - 89");
            testRange(options.fixed > 4, 'Chance: Fixed specified should be below or equal to 4');
        }
        switch(format){
            case DDM:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.floating({
                    min: 0,
                    max: 59,
                    fixed: options.fixed
                });
            case DMS:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.integer({
                    min: 0,
                    max: 59
                }) + "\u2019" + this.floating({
                    min: 0,
                    max: 59,
                    fixed: options.fixed
                }) + "\u201D";
            case DD:
            default:
                return this.floating({
                    min: options.min,
                    max: options.max,
                    fixed: options.fixed
                });
        }
    };
    Chance.prototype.longitude = function(options) {
        // Constants - Formats
        var [DDM, DMS, DD] = [
            'ddm',
            'dms',
            'dd'
        ];
        options = initOptions(options, options && options.format && [
            DDM,
            DMS
        ].includes(options.format.toLowerCase()) ? {
            min: 0,
            max: 179,
            fixed: 4
        } : {
            fixed: 5,
            min: -180,
            max: 180,
            format: DD
        });
        var format = options.format.toLowerCase();
        if (format === DDM || format === DMS) {
            testRange(options.min < 0 || options.min > 179, "Chance: Min specified is out of range. Should be between 0 - 179");
            testRange(options.max < 0 || options.max > 179, "Chance: Max specified is out of range. Should be between 0 - 179");
            testRange(options.fixed > 4, 'Chance: Fixed specified should be below or equal to 4');
        }
        switch(format){
            case DDM:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.floating({
                    min: 0,
                    max: 59.9999,
                    fixed: options.fixed
                });
            case DMS:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.integer({
                    min: 0,
                    max: 59
                }) + "\u2019" + this.floating({
                    min: 0,
                    max: 59.9999,
                    fixed: options.fixed
                }) + "\u201D";
            case DD:
            default:
                return this.floating({
                    min: options.min,
                    max: options.max,
                    fixed: options.fixed
                });
        }
    };
    Chance.prototype.phone = function(options) {
        var self1 = this, numPick, ukNum = function(parts) {
            var section = [];
            //fills the section part of the phone number with random numbers.
            parts.sections.forEach(function(n) {
                section.push(self1.string({
                    pool: '0123456789',
                    length: n
                }));
            });
            return parts.area + section.join(' ');
        };
        options = initOptions(options, {
            formatted: true,
            country: 'us',
            mobile: false,
            exampleNumber: false
        });
        if (!options.formatted) options.parens = false;
        var phone;
        switch(options.country){
            case 'fr':
                if (!options.mobile) {
                    numPick = this.pick([
                        // Valid zone and département codes.
                        '01' + this.pick([
                            '30',
                            '34',
                            '39',
                            '40',
                            '41',
                            '42',
                            '43',
                            '44',
                            '45',
                            '46',
                            '47',
                            '48',
                            '49',
                            '53',
                            '55',
                            '56',
                            '58',
                            '60',
                            '64',
                            '69',
                            '70',
                            '72',
                            '73',
                            '74',
                            '75',
                            '76',
                            '77',
                            '78',
                            '79',
                            '80',
                            '81',
                            '82',
                            '83'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '02' + this.pick([
                            '14',
                            '18',
                            '22',
                            '23',
                            '28',
                            '29',
                            '30',
                            '31',
                            '32',
                            '33',
                            '34',
                            '35',
                            '36',
                            '37',
                            '38',
                            '40',
                            '41',
                            '43',
                            '44',
                            '45',
                            '46',
                            '47',
                            '48',
                            '49',
                            '50',
                            '51',
                            '52',
                            '53',
                            '54',
                            '56',
                            '57',
                            '61',
                            '62',
                            '69',
                            '72',
                            '76',
                            '77',
                            '78',
                            '85',
                            '90',
                            '96',
                            '97',
                            '98',
                            '99'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '03' + this.pick([
                            '10',
                            '20',
                            '21',
                            '22',
                            '23',
                            '24',
                            '25',
                            '26',
                            '27',
                            '28',
                            '29',
                            '39',
                            '44',
                            '45',
                            '51',
                            '52',
                            '54',
                            '55',
                            '57',
                            '58',
                            '59',
                            '60',
                            '61',
                            '62',
                            '63',
                            '64',
                            '65',
                            '66',
                            '67',
                            '68',
                            '69',
                            '70',
                            '71',
                            '72',
                            '73',
                            '80',
                            '81',
                            '82',
                            '83',
                            '84',
                            '85',
                            '86',
                            '87',
                            '88',
                            '89',
                            '90'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '04' + this.pick([
                            '11',
                            '13',
                            '15',
                            '20',
                            '22',
                            '26',
                            '27',
                            '30',
                            '32',
                            '34',
                            '37',
                            '42',
                            '43',
                            '44',
                            '50',
                            '56',
                            '57',
                            '63',
                            '66',
                            '67',
                            '68',
                            '69',
                            '70',
                            '71',
                            '72',
                            '73',
                            '74',
                            '75',
                            '76',
                            '77',
                            '78',
                            '79',
                            '80',
                            '81',
                            '82',
                            '83',
                            '84',
                            '85',
                            '86',
                            '88',
                            '89',
                            '90',
                            '91',
                            '92',
                            '93',
                            '94',
                            '95',
                            '97',
                            '98'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '05' + this.pick([
                            '08',
                            '16',
                            '17',
                            '19',
                            '24',
                            '31',
                            '32',
                            '33',
                            '34',
                            '35',
                            '40',
                            '45',
                            '46',
                            '47',
                            '49',
                            '53',
                            '55',
                            '56',
                            '57',
                            '58',
                            '59',
                            '61',
                            '62',
                            '63',
                            '64',
                            '65',
                            '67',
                            '79',
                            '81',
                            '82',
                            '86',
                            '87',
                            '90',
                            '94'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '09' + self1.string({
                            pool: '0123456789',
                            length: 8
                        })
                    ]);
                    phone = options.formatted ? numPick.match(/../g).join(' ') : numPick;
                } else {
                    numPick = this.pick([
                        '06',
                        '07'
                    ]) + self1.string({
                        pool: '0123456789',
                        length: 8
                    });
                    phone = options.formatted ? numPick.match(/../g).join(' ') : numPick;
                }
                break;
            case 'uk':
                if (!options.mobile) {
                    numPick = this.pick([
                        //valid area codes of major cities/counties followed by random numbers in required format.
                        {
                            area: '01' + this.character({
                                pool: '234569'
                            }) + '1 ',
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '020 ' + this.character({
                                pool: '378'
                            }),
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '023 ' + this.character({
                                pool: '89'
                            }),
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '024 7',
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '028 ' + this.pick([
                                '25',
                                '28',
                                '37',
                                '71',
                                '82',
                                '90',
                                '92',
                                '95'
                            ]),
                            sections: [
                                2,
                                4
                            ]
                        },
                        {
                            area: '012' + this.pick([
                                '04',
                                '08',
                                '54',
                                '76',
                                '97',
                                '98'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '013' + this.pick([
                                '63',
                                '64',
                                '84',
                                '86'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '014' + this.pick([
                                '04',
                                '20',
                                '60',
                                '61',
                                '80',
                                '88'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '015' + this.pick([
                                '24',
                                '27',
                                '62',
                                '66'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '016' + this.pick([
                                '06',
                                '29',
                                '35',
                                '47',
                                '59',
                                '95'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '017' + this.pick([
                                '26',
                                '44',
                                '50',
                                '68'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '018' + this.pick([
                                '27',
                                '37',
                                '84',
                                '97'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '019' + this.pick([
                                '00',
                                '05',
                                '35',
                                '46',
                                '49',
                                '63',
                                '95'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        }
                    ]);
                    phone = options.formatted ? ukNum(numPick) : ukNum(numPick).replace(' ', '', 'g');
                } else {
                    numPick = this.pick([
                        {
                            area: '07' + this.pick([
                                '4',
                                '5',
                                '7',
                                '8',
                                '9'
                            ]),
                            sections: [
                                2,
                                6
                            ]
                        },
                        {
                            area: '07624 ',
                            sections: [
                                6
                            ]
                        }
                    ]);
                    phone = options.formatted ? ukNum(numPick) : ukNum(numPick).replace(' ', '');
                }
                break;
            case 'za':
                if (!options.mobile) {
                    numPick = this.pick([
                        '01' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '02' + this.pick([
                            '1',
                            '2',
                            '3',
                            '4',
                            '7',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '03' + this.pick([
                            '1',
                            '2',
                            '3',
                            '5',
                            '6',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '04' + this.pick([
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '05' + this.pick([
                            '1',
                            '3',
                            '4',
                            '6',
                            '7',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        })
                    ]);
                    phone = options.formatted || numPick;
                } else {
                    numPick = this.pick([
                        '060' + this.pick([
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '061' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '06' + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '071' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '07' + this.pick([
                            '2',
                            '3',
                            '4',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '08' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        })
                    ]);
                    phone = options.formatted || numPick;
                }
                break;
            case 'us':
                var areacode = this.areacode(options).toString();
                var exchange = this.natural({
                    min: 2,
                    max: 9
                }).toString() + this.natural({
                    min: 0,
                    max: 9
                }).toString() + this.natural({
                    min: 0,
                    max: 9
                }).toString();
                var subscriber = this.natural({
                    min: 1000,
                    max: 9999
                }).toString(); // this could be random [0-9]{4}
                phone = options.formatted ? areacode + ' ' + exchange + '-' + subscriber : areacode + exchange + subscriber;
                break;
            case 'br':
                var areaCode = this.pick([
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "21",
                    "22",
                    "24",
                    "27",
                    "28",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "37",
                    "38",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "51",
                    "53",
                    "54",
                    "55",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "71",
                    "73",
                    "74",
                    "75",
                    "77",
                    "79",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85",
                    "86",
                    "87",
                    "88",
                    "89",
                    "91",
                    "92",
                    "93",
                    "94",
                    "95",
                    "96",
                    "97",
                    "98",
                    "99"
                ]);
                var prefix;
                if (options.mobile) // Brasilian official reference (mobile): http://www.anatel.gov.br/setorregulado/plano-de-numeracao-brasileiro?id=330
                prefix = '9' + self1.string({
                    pool: '0123456789',
                    length: 4
                });
                else // Brasilian official reference: http://www.anatel.gov.br/setorregulado/plano-de-numeracao-brasileiro?id=331
                prefix = this.natural({
                    min: 2000,
                    max: 5999
                }).toString();
                var mcdu = self1.string({
                    pool: '0123456789',
                    length: 4
                });
                phone = options.formatted ? '(' + areaCode + ') ' + prefix + '-' + mcdu : areaCode + prefix + mcdu;
                break;
        }
        return phone;
    };
    Chance.prototype.postal = function() {
        // Postal District
        var pd = this.character({
            pool: "XVTSRPNKLMHJGECBA"
        });
        // Forward Sortation Area (FSA)
        var fsa = pd + this.natural({
            max: 9
        }) + this.character({
            alpha: true,
            casing: "upper"
        });
        // Local Delivery Unut (LDU)
        var ldu = this.natural({
            max: 9
        }) + this.character({
            alpha: true,
            casing: "upper"
        }) + this.natural({
            max: 9
        });
        return fsa + " " + ldu;
    };
    Chance.prototype.postcode = function() {
        // Area
        var area = this.pick(this.get("postcodeAreas")).code;
        // District
        var district = this.natural({
            max: 9
        });
        // Sub-District
        var subDistrict = this.bool() ? this.character({
            alpha: true,
            casing: "upper"
        }) : "";
        // Outward Code
        var outward = area + district + subDistrict;
        // Sector
        var sector = this.natural({
            max: 9
        });
        // Unit
        var unit = this.character({
            alpha: true,
            casing: "upper"
        }) + this.character({
            alpha: true,
            casing: "upper"
        });
        // Inward Code
        var inward = sector + unit;
        return outward + " " + inward;
    };
    Chance.prototype.counties = function(options) {
        options = initOptions(options, {
            country: 'uk'
        });
        return this.get("counties")[options.country.toLowerCase()];
    };
    Chance.prototype.county = function(options) {
        return this.pick(this.counties(options)).name;
    };
    Chance.prototype.provinces = function(options) {
        options = initOptions(options, {
            country: 'ca'
        });
        return this.get("provinces")[options.country.toLowerCase()];
    };
    Chance.prototype.province = function(options) {
        return options && options.full ? this.pick(this.provinces(options)).name : this.pick(this.provinces(options)).abbreviation;
    };
    Chance.prototype.state = function(options) {
        return options && options.full ? this.pick(this.states(options)).name : this.pick(this.states(options)).abbreviation;
    };
    Chance.prototype.states = function(options) {
        options = initOptions(options, {
            country: 'us',
            us_states_and_dc: true
        });
        var states;
        switch(options.country.toLowerCase()){
            case 'us':
                var us_states_and_dc = this.get("us_states_and_dc"), territories = this.get("territories"), armed_forces = this.get("armed_forces");
                states = [];
                if (options.us_states_and_dc) states = states.concat(us_states_and_dc);
                if (options.territories) states = states.concat(territories);
                if (options.armed_forces) states = states.concat(armed_forces);
                break;
            case 'it':
            case 'mx':
                states = this.get("country_regions")[options.country.toLowerCase()];
                break;
            case 'uk':
                states = this.get("counties")[options.country.toLowerCase()];
                break;
        }
        return states;
    };
    Chance.prototype.street = function(options) {
        options = initOptions(options, {
            country: 'us',
            syllables: 2
        });
        var street;
        switch(options.country.toLowerCase()){
            case 'us':
                street = this.word({
                    syllables: options.syllables
                });
                street = this.capitalize(street);
                street += ' ';
                street += options.short_suffix ? this.street_suffix(options).abbreviation : this.street_suffix(options).name;
                break;
            case 'it':
                street = this.word({
                    syllables: options.syllables
                });
                street = this.capitalize(street);
                street = (options.short_suffix ? this.street_suffix(options).abbreviation : this.street_suffix(options).name) + " " + street;
                break;
        }
        return street;
    };
    Chance.prototype.street_suffix = function(options) {
        options = initOptions(options, {
            country: 'us'
        });
        return this.pick(this.street_suffixes(options));
    };
    Chance.prototype.street_suffixes = function(options) {
        options = initOptions(options, {
            country: 'us'
        });
        // These are the most common suffixes.
        return this.get("street_suffixes")[options.country.toLowerCase()];
    };
    // Note: only returning US zip codes, internationalization will be a whole
    // other beast to tackle at some point.
    Chance.prototype.zip = function(options) {
        var zip = this.n(this.natural, 5, {
            max: 9
        });
        if (options && options.plusfour === true) {
            zip.push('-');
            zip = zip.concat(this.n(this.natural, 4, {
                max: 9
            }));
        }
        return zip.join("");
    };
    // -- End Location --
    // -- Time
    Chance.prototype.ampm = function() {
        return this.bool() ? 'am' : 'pm';
    };
    Chance.prototype.date = function(options) {
        var date_string, date;
        // If interval is specified we ignore preset
        if (options && (options.min || options.max)) {
            options = initOptions(options, {
                american: true,
                string: false
            });
            var min = typeof options.min !== "undefined" ? options.min.getTime() : 1;
            // 100,000,000 days measured relative to midnight at the beginning of 01 January, 1970 UTC. http://es5.github.io/#x15.9.1.1
            var max = typeof options.max !== "undefined" ? options.max.getTime() : 8640000000000000;
            date = new Date(this.integer({
                min: min,
                max: max
            }));
        } else {
            var m = this.month({
                raw: true
            });
            var daysInMonth = m.days;
            if (options && options.month) // Mod 12 to allow months outside range of 0-11 (not encouraged, but also not prevented).
            daysInMonth = this.get('months')[(options.month % 12 + 12) % 12].days;
            options = initOptions(options, {
                year: parseInt(this.year(), 10),
                // Necessary to subtract 1 because Date() 0-indexes month but not day or year
                // for some reason.
                month: m.numeric - 1,
                day: this.natural({
                    min: 1,
                    max: daysInMonth
                }),
                hour: this.hour({
                    twentyfour: true
                }),
                minute: this.minute(),
                second: this.second(),
                millisecond: this.millisecond(),
                american: true,
                string: false
            });
            date = new Date(options.year, options.month, options.day, options.hour, options.minute, options.second, options.millisecond);
        }
        if (options.american) // Adding 1 to the month is necessary because Date() 0-indexes
        // months but not day for some odd reason.
        date_string = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
        else date_string = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        return options.string ? date_string : date;
    };
    Chance.prototype.hammertime = function(options) {
        return this.date(options).getTime();
    };
    Chance.prototype.hour = function(options) {
        options = initOptions(options, {
            min: options && options.twentyfour ? 0 : 1,
            max: options && options.twentyfour ? 23 : 12
        });
        testRange(options.min < 0, "Chance: Min cannot be less than 0.");
        testRange(options.twentyfour && options.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option.");
        testRange(!options.twentyfour && options.max > 12, "Chance: Max cannot be greater than 12.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        return this.natural({
            min: options.min,
            max: options.max
        });
    };
    Chance.prototype.millisecond = function() {
        return this.natural({
            max: 999
        });
    };
    Chance.prototype.minute = Chance.prototype.second = function(options) {
        options = initOptions(options, {
            min: 0,
            max: 59
        });
        testRange(options.min < 0, "Chance: Min cannot be less than 0.");
        testRange(options.max > 59, "Chance: Max cannot be greater than 59.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        return this.natural({
            min: options.min,
            max: options.max
        });
    };
    Chance.prototype.month = function(options) {
        options = initOptions(options, {
            min: 1,
            max: 12
        });
        testRange(options.min < 1, "Chance: Min cannot be less than 1.");
        testRange(options.max > 12, "Chance: Max cannot be greater than 12.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        var month = this.pick(this.months().slice(options.min - 1, options.max));
        return options.raw ? month : month.name;
    };
    Chance.prototype.months = function() {
        return this.get("months");
    };
    Chance.prototype.second = function() {
        return this.natural({
            max: 59
        });
    };
    Chance.prototype.timestamp = function() {
        return this.natural({
            min: 1,
            max: parseInt(new Date().getTime() / 1000, 10)
        });
    };
    Chance.prototype.weekday = function(options) {
        options = initOptions(options, {
            weekday_only: false
        });
        var weekdays = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
        ];
        if (!options.weekday_only) {
            weekdays.push("Saturday");
            weekdays.push("Sunday");
        }
        return this.pickone(weekdays);
    };
    Chance.prototype.year = function(options) {
        // Default to current year as min if none specified
        options = initOptions(options, {
            min: new Date().getFullYear()
        });
        // Default to one century after current year as max if none specified
        options.max = typeof options.max !== "undefined" ? options.max : options.min + 100;
        return this.natural(options).toString();
    };
    // -- End Time
    // -- Finance --
    Chance.prototype.cc = function(options) {
        options = initOptions(options);
        var type, number, to_generate;
        type = options.type ? this.cc_type({
            name: options.type,
            raw: true
        }) : this.cc_type({
            raw: true
        });
        number = type.prefix.split("");
        to_generate = type.length - type.prefix.length - 1;
        // Generates n - 1 digits
        number = number.concat(this.n(this.integer, to_generate, {
            min: 0,
            max: 9
        }));
        // Generates the last digit according to Luhn algorithm
        number.push(this.luhn_calculate(number.join("")));
        return number.join("");
    };
    Chance.prototype.cc_types = function() {
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        return this.get("cc_types");
    };
    Chance.prototype.cc_type = function(options) {
        options = initOptions(options);
        var types = this.cc_types(), type = null;
        if (options.name) {
            for(var i = 0; i < types.length; i++)// Accept either name or short_name to specify card type
            if (types[i].name === options.name || types[i].short_name === options.name) {
                type = types[i];
                break;
            }
            if (type === null) throw new RangeError("Chance: Credit card type '" + options.name + "' is not supported");
        } else type = this.pick(types);
        return options.raw ? type : type.name;
    };
    // return all world currency by ISO 4217
    Chance.prototype.currency_types = function() {
        return this.get("currency_types");
    };
    // return random world currency by ISO 4217
    Chance.prototype.currency = function() {
        return this.pick(this.currency_types());
    };
    // return all timezones available
    Chance.prototype.timezones = function() {
        return this.get("timezones");
    };
    // return random timezone
    Chance.prototype.timezone = function() {
        return this.pick(this.timezones());
    };
    //Return random correct currency exchange pair (e.g. EUR/USD) or array of currency code
    Chance.prototype.currency_pair = function(returnAsString) {
        var currencies = this.unique(this.currency, 2, {
            comparator: function(arr, val) {
                return arr.reduce(function(acc, item) {
                    // If a match has been found, short circuit check and just return
                    return acc || item.code === val.code;
                }, false);
            }
        });
        if (returnAsString) return currencies[0].code + '/' + currencies[1].code;
        else return currencies;
    };
    Chance.prototype.dollar = function(options) {
        // By default, a somewhat more sane max for dollar than all available numbers
        options = initOptions(options, {
            max: 10000,
            min: 0
        });
        var dollar = this.floating({
            min: options.min,
            max: options.max,
            fixed: 2
        }).toString(), cents = dollar.split('.')[1];
        if (cents === undefined) dollar += '.00';
        else if (cents.length < 2) dollar = dollar + '0';
        if (dollar < 0) return '-$' + dollar.replace('-', '');
        else return '$' + dollar;
    };
    Chance.prototype.euro = function(options) {
        return Number(this.dollar(options).replace("$", "")).toLocaleString() + "\u20AC";
    };
    Chance.prototype.exp = function(options) {
        options = initOptions(options);
        var exp = {};
        exp.year = this.exp_year();
        // If the year is this year, need to ensure month is greater than the
        // current month or this expiration will not be valid
        if (exp.year === new Date().getFullYear().toString()) exp.month = this.exp_month({
            future: true
        });
        else exp.month = this.exp_month();
        return options.raw ? exp : exp.month + '/' + exp.year;
    };
    Chance.prototype.exp_month = function(options) {
        options = initOptions(options);
        var month, month_int, // Date object months are 0 indexed
        curMonth = new Date().getMonth() + 1;
        if (options.future && curMonth !== 12) do {
            month = this.month({
                raw: true
            }).numeric;
            month_int = parseInt(month, 10);
        }while (month_int <= curMonth);
        else month = this.month({
            raw: true
        }).numeric;
        return month;
    };
    Chance.prototype.exp_year = function() {
        var curMonth = new Date().getMonth() + 1, curYear = new Date().getFullYear();
        return this.year({
            min: curMonth === 12 ? curYear + 1 : curYear,
            max: curYear + 10
        });
    };
    Chance.prototype.vat = function(options) {
        options = initOptions(options, {
            country: 'it'
        });
        switch(options.country.toLowerCase()){
            case 'it':
                return this.it_vat();
        }
    };
    /**
     * Generate a string matching IBAN pattern (https://en.wikipedia.org/wiki/International_Bank_Account_Number).
     * No country-specific formats support (yet)
     */ Chance.prototype.iban = function() {
        var alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var alphanum = alpha + '0123456789';
        var iban = this.string({
            length: 2,
            pool: alpha
        }) + this.pad(this.integer({
            min: 0,
            max: 99
        }), 2) + this.string({
            length: 4,
            pool: alphanum
        }) + this.pad(this.natural(), this.natural({
            min: 6,
            max: 26
        }));
        return iban;
    };
    // -- End Finance
    // -- Regional
    Chance.prototype.it_vat = function() {
        var it_vat = this.natural({
            min: 1,
            max: 1800000
        });
        it_vat = this.pad(it_vat, 7) + this.pad(this.pick(this.provinces({
            country: 'it'
        })).code, 3);
        return it_vat + this.luhn_calculate(it_vat);
    };
    /*
     * this generator is written following the official algorithm
     * all data can be passed explicitely or randomized by calling chance.cf() without options
     * the code does not check that the input data is valid (it goes beyond the scope of the generator)
     *
     * @param  [Object] options = { first: first name,
     *                              last: last name,
     *                              gender: female|male,
                                    birthday: JavaScript date object,
                                    city: string(4), 1 letter + 3 numbers
                                   }
     * @return [string] codice fiscale
     *
    */ Chance.prototype.cf = function(options) {
        options = options || {};
        var gender = !!options.gender ? options.gender : this.gender(), first = !!options.first ? options.first : this.first({
            gender: gender,
            nationality: 'it'
        }), last = !!options.last ? options.last : this.last({
            nationality: 'it'
        }), birthday = !!options.birthday ? options.birthday : this.birthday(), city = !!options.city ? options.city : this.pickone([
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'L',
            'M',
            'Z'
        ]) + this.pad(this.natural({
            max: 999
        }), 3), cf = [], name_generator = function(name, isLast) {
            var temp, return_value = [];
            if (name.length < 3) return_value = name.split("").concat("XXX".split("")).splice(0, 3);
            else {
                temp = name.toUpperCase().split('').map(function(c) {
                    return "BCDFGHJKLMNPRSTVWZ".indexOf(c) !== -1 ? c : undefined;
                }).join('');
                if (temp.length > 3) {
                    if (isLast) temp = temp.substr(0, 3);
                    else temp = temp[0] + temp.substr(2, 2);
                }
                if (temp.length < 3) {
                    return_value = temp;
                    temp = name.toUpperCase().split('').map(function(c) {
                        return "AEIOU".indexOf(c) !== -1 ? c : undefined;
                    }).join('').substr(0, 3 - return_value.length);
                }
                return_value = return_value + temp;
            }
            return return_value;
        }, date_generator = function(birthday, gender, that) {
            var lettermonths = [
                'A',
                'B',
                'C',
                'D',
                'E',
                'H',
                'L',
                'M',
                'P',
                'R',
                'S',
                'T'
            ];
            return birthday.getFullYear().toString().substr(2) + lettermonths[birthday.getMonth()] + that.pad(birthday.getDate() + (gender.toLowerCase() === "female" ? 40 : 0), 2);
        }, checkdigit_generator = function(cf) {
            var range1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", range2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", evens = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", odds = "BAKPLCQDREVOSFTGUHMINJWZYX", digit = 0;
            for(var i = 0; i < 15; i++)if (i % 2 !== 0) digit += evens.indexOf(range2[range1.indexOf(cf[i])]);
            else digit += odds.indexOf(range2[range1.indexOf(cf[i])]);
            return evens[digit % 26];
        };
        cf = cf.concat(name_generator(last, true), name_generator(first), date_generator(birthday, gender, this), city.toUpperCase().split("")).join("");
        cf += checkdigit_generator(cf.toUpperCase(), this);
        return cf.toUpperCase();
    };
    Chance.prototype.pl_pesel = function() {
        var number = this.natural({
            min: 1,
            max: 9999999999
        });
        var arr = this.pad(number, 10).split('');
        for(var i = 0; i < arr.length; i++)arr[i] = parseInt(arr[i]);
        var controlNumber = (1 * arr[0] + 3 * arr[1] + 7 * arr[2] + 9 * arr[3] + 1 * arr[4] + 3 * arr[5] + 7 * arr[6] + 9 * arr[7] + 1 * arr[8] + 3 * arr[9]) % 10;
        if (controlNumber !== 0) controlNumber = 10 - controlNumber;
        return arr.join('') + controlNumber;
    };
    Chance.prototype.pl_nip = function() {
        var number = this.natural({
            min: 1,
            max: 999999999
        });
        var arr = this.pad(number, 9).split('');
        for(var i = 0; i < arr.length; i++)arr[i] = parseInt(arr[i]);
        var controlNumber = (6 * arr[0] + 5 * arr[1] + 7 * arr[2] + 2 * arr[3] + 3 * arr[4] + 4 * arr[5] + 5 * arr[6] + 6 * arr[7] + 7 * arr[8]) % 11;
        if (controlNumber === 10) return this.pl_nip();
        return arr.join('') + controlNumber;
    };
    Chance.prototype.pl_regon = function() {
        var number = this.natural({
            min: 1,
            max: 99999999
        });
        var arr = this.pad(number, 8).split('');
        for(var i = 0; i < arr.length; i++)arr[i] = parseInt(arr[i]);
        var controlNumber = (8 * arr[0] + 9 * arr[1] + 2 * arr[2] + 3 * arr[3] + 4 * arr[4] + 5 * arr[5] + 6 * arr[6] + 7 * arr[7]) % 11;
        if (controlNumber === 10) controlNumber = 0;
        return arr.join('') + controlNumber;
    };
    // -- End Regional
    // -- Music --
    // Genre choices:
    // Rock,Pop,Hip-Hop,Jazz,Classical,Electronic,Country,R&B,Reggae,
    // Blues,Metal,Folk,Alternative,Punk,Disco,Funk,Techno,
    // Indie,Gospel,Dance,Children's,World
    Chance.prototype.music_genre = function(genre = 'general') {
        if (!(genre.toLowerCase() in data.music_genres)) throw new Error(`Unsupported genre: ${genre}`);
        const genres = data.music_genres[genre.toLowerCase()];
        const randomIndex = this.integer({
            min: 0,
            max: genres.length - 1
        });
        return genres[randomIndex];
    };
    Chance.prototype.note = function(options) {
        // choices for 'notes' option:
        // flatKey - chromatic scale with flat notes (default)
        // sharpKey - chromatic scale with sharp notes
        // flats - just flat notes
        // sharps - just sharp notes
        // naturals - just natural notes
        // all - naturals, sharps and flats
        options = initOptions(options, {
            notes: 'flatKey'
        });
        var scales = {
            naturals: [
                'C',
                'D',
                'E',
                'F',
                'G',
                'A',
                'B'
            ],
            flats: [
                "D\u266D",
                "E\u266D",
                "G\u266D",
                "A\u266D",
                "B\u266D"
            ],
            sharps: [
                "C\u266F",
                "D\u266F",
                "F\u266F",
                "G\u266F",
                "A\u266F"
            ]
        };
        scales.all = scales.naturals.concat(scales.flats.concat(scales.sharps));
        scales.flatKey = scales.naturals.concat(scales.flats);
        scales.sharpKey = scales.naturals.concat(scales.sharps);
        return this.pickone(scales[options.notes]);
    };
    Chance.prototype.midi_note = function(options) {
        var min = 0;
        var max = 127;
        options = initOptions(options, {
            min: min,
            max: max
        });
        return this.integer({
            min: options.min,
            max: options.max
        });
    };
    Chance.prototype.chord_quality = function(options) {
        options = initOptions(options, {
            jazz: true
        });
        var chord_qualities = [
            'maj',
            'min',
            'aug',
            'dim'
        ];
        if (options.jazz) chord_qualities = [
            'maj7',
            'min7',
            '7',
            'sus',
            'dim',
            "\xf8"
        ];
        return this.pickone(chord_qualities);
    };
    Chance.prototype.chord = function(options) {
        options = initOptions(options);
        return this.note(options) + this.chord_quality(options);
    };
    Chance.prototype.tempo = function(options) {
        var min = 40;
        var max = 320;
        options = initOptions(options, {
            min: min,
            max: max
        });
        return this.integer({
            min: options.min,
            max: options.max
        });
    };
    // -- End Music
    // -- Miscellaneous --
    // Coin - Flip, flip, flipadelphia
    Chance.prototype.coin = function() {
        return this.bool() ? "heads" : "tails";
    };
    // Dice - For all the board game geeks out there, myself included ;)
    function diceFn(range) {
        return function() {
            return this.natural(range);
        };
    }
    Chance.prototype.d4 = diceFn({
        min: 1,
        max: 4
    });
    Chance.prototype.d6 = diceFn({
        min: 1,
        max: 6
    });
    Chance.prototype.d8 = diceFn({
        min: 1,
        max: 8
    });
    Chance.prototype.d10 = diceFn({
        min: 1,
        max: 10
    });
    Chance.prototype.d12 = diceFn({
        min: 1,
        max: 12
    });
    Chance.prototype.d20 = diceFn({
        min: 1,
        max: 20
    });
    Chance.prototype.d30 = diceFn({
        min: 1,
        max: 30
    });
    Chance.prototype.d100 = diceFn({
        min: 1,
        max: 100
    });
    Chance.prototype.rpg = function(thrown, options) {
        options = initOptions(options);
        if (!thrown) throw new RangeError("Chance: A type of die roll must be included");
        else {
            var bits = thrown.toLowerCase().split("d"), rolls = [];
            if (bits.length !== 2 || !parseInt(bits[0], 10) || !parseInt(bits[1], 10)) throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
            for(var i = bits[0]; i > 0; i--)rolls[i - 1] = this.natural({
                min: 1,
                max: bits[1]
            });
            return typeof options.sum !== 'undefined' && options.sum ? rolls.reduce(function(p, c) {
                return p + c;
            }) : rolls;
        }
    };
    // Guid
    Chance.prototype.guid = function(options) {
        options = initOptions(options, {
            version: 5
        });
        var guid_pool = "abcdef1234567890", variant_pool = "ab89", guid = this.string({
            pool: guid_pool,
            length: 8
        }) + '-' + this.string({
            pool: guid_pool,
            length: 4
        }) + '-' + // The Version
        options.version + this.string({
            pool: guid_pool,
            length: 3
        }) + '-' + // The Variant
        this.string({
            pool: variant_pool,
            length: 1
        }) + this.string({
            pool: guid_pool,
            length: 3
        }) + '-' + this.string({
            pool: guid_pool,
            length: 12
        });
        return guid;
    };
    // Hash
    Chance.prototype.hash = function(options) {
        options = initOptions(options, {
            length: 40,
            casing: 'lower'
        });
        var pool = options.casing === 'upper' ? HEX_POOL.toUpperCase() : HEX_POOL;
        return this.string({
            pool: pool,
            length: options.length
        });
    };
    Chance.prototype.luhn_check = function(num) {
        var str = num.toString();
        var checkDigit = +str.substring(str.length - 1);
        return checkDigit === this.luhn_calculate(+str.substring(0, str.length - 1));
    };
    Chance.prototype.luhn_calculate = function(num) {
        var digits = num.toString().split("").reverse();
        var sum = 0;
        var digit;
        for(var i = 0, l = digits.length; l > i; ++i){
            digit = +digits[i];
            if (i % 2 === 0) {
                digit *= 2;
                if (digit > 9) digit -= 9;
            }
            sum += digit;
        }
        return sum * 9 % 10;
    };
    // MD5 Hash
    Chance.prototype.md5 = function(options) {
        var opts = {
            str: '',
            key: null,
            raw: false
        };
        if (!options) {
            opts.str = this.string();
            options = {};
        } else if (typeof options === 'string') {
            opts.str = options;
            options = {};
        } else if (typeof options !== 'object') return null;
        else if (options.constructor === 'Array') return null;
        opts = initOptions(options, opts);
        if (!opts.str) throw new Error('A parameter is required to return an md5 hash.');
        return this.bimd5.md5(opts.str, opts.key, opts.raw);
    };
    /**
     * #Description:
     * =====================================================
     * Generate random file name with extension
     *
     * The argument provide extension type
     * -> raster
     * -> vector
     * -> 3d
     * -> document
     *
     * If nothing is provided the function return random file name with random
     * extension type of any kind
     *
     * The user can validate the file name length range
     * If nothing provided the generated file name is random
     *
     * #Extension Pool :
     * * Currently the supported extensions are
     *  -> some of the most popular raster image extensions
     *  -> some of the most popular vector image extensions
     *  -> some of the most popular 3d image extensions
     *  -> some of the most popular document extensions
     *
     * #Examples :
     * =====================================================
     *
     * Return random file name with random extension. The file extension
     * is provided by a predefined collection of extensions. More about the extension
     * pool can be found in #Extension Pool section
     *
     * chance.file()
     * => dsfsdhjf.xml
     *
     * In order to generate a file name with specific length, specify the
     * length property and integer value. The extension is going to be random
     *
     * chance.file({length : 10})
     * => asrtineqos.pdf
     *
     * In order to generate file with extension from some of the predefined groups
     * of the extension pool just specify the extension pool category in fileType property
     *
     * chance.file({fileType : 'raster'})
     * => dshgssds.psd
     *
     * You can provide specific extension for your files
     * chance.file({extension : 'html'})
     * => djfsd.html
     *
     * Or you could pass custom collection of extensions by array or by object
     * chance.file({extensions : [...]})
     * => dhgsdsd.psd
     *
     * chance.file({extensions : { key : [...], key : [...]}})
     * => djsfksdjsd.xml
     *
     * @param  [collection] options
     * @return [string]
     *
     */ Chance.prototype.file = function(options) {
        var fileOptions = options || {};
        var poolCollectionKey = "fileExtension";
        var typeRange = Object.keys(this.get("fileExtension")); //['raster', 'vector', '3d', 'document'];
        var fileName;
        var fileExtension;
        // Generate random file name
        fileName = this.word({
            length: fileOptions.length
        });
        // Generate file by specific extension provided by the user
        if (fileOptions.extension) {
            fileExtension = fileOptions.extension;
            return fileName + '.' + fileExtension;
        }
        // Generate file by specific extension collection
        if (fileOptions.extensions) {
            if (Array.isArray(fileOptions.extensions)) {
                fileExtension = this.pickone(fileOptions.extensions);
                return fileName + '.' + fileExtension;
            } else if (fileOptions.extensions.constructor === Object) {
                var extensionObjectCollection = fileOptions.extensions;
                var keys = Object.keys(extensionObjectCollection);
                fileExtension = this.pickone(extensionObjectCollection[this.pickone(keys)]);
                return fileName + '.' + fileExtension;
            }
            throw new Error("Chance: Extensions must be an Array or Object");
        }
        // Generate file extension based on specific file type
        if (fileOptions.fileType) {
            var fileType = fileOptions.fileType;
            if (typeRange.indexOf(fileType) !== -1) {
                fileExtension = this.pickone(this.get(poolCollectionKey)[fileType]);
                return fileName + '.' + fileExtension;
            }
            throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
        }
        // Generate random file name if no extension options are passed
        fileExtension = this.pickone(this.get(poolCollectionKey)[this.pickone(typeRange)]);
        return fileName + '.' + fileExtension;
    };
    /**
     * Generates file data of random bytes using the chance.file method for the file name
     *
     * @param {object}
     * fileName: String
     * fileExtention: String
     * fileSize: Number      <- in bytes
     * @returns {object} fileName: String, fileData: Buffer
     */ Chance.prototype.fileWithContent = function(options) {
        var fileOptions = options || {};
        var fileName = 'fileName' in fileOptions ? fileOptions.fileName : this.file().split(".")[0];
        fileName += "." + ('fileExtension' in fileOptions ? fileOptions.fileExtension : this.file().split(".")[1]);
        if (typeof fileOptions.fileSize !== "number") throw new Error('File size must be an integer');
        var file = {
            fileData: this.buffer({
                length: fileOptions.fileSize
            }),
            fileName: fileName
        };
        return file;
    };
    var data = {
        firstNames: {
            "male": {
                "en": [
                    "James",
                    "John",
                    "Robert",
                    "Michael",
                    "William",
                    "David",
                    "Richard",
                    "Joseph",
                    "Charles",
                    "Thomas",
                    "Christopher",
                    "Daniel",
                    "Matthew",
                    "George",
                    "Donald",
                    "Anthony",
                    "Paul",
                    "Mark",
                    "Edward",
                    "Steven",
                    "Kenneth",
                    "Andrew",
                    "Brian",
                    "Joshua",
                    "Kevin",
                    "Ronald",
                    "Timothy",
                    "Jason",
                    "Jeffrey",
                    "Frank",
                    "Gary",
                    "Ryan",
                    "Nicholas",
                    "Eric",
                    "Stephen",
                    "Jacob",
                    "Larry",
                    "Jonathan",
                    "Scott",
                    "Raymond",
                    "Justin",
                    "Brandon",
                    "Gregory",
                    "Samuel",
                    "Benjamin",
                    "Patrick",
                    "Jack",
                    "Henry",
                    "Walter",
                    "Dennis",
                    "Jerry",
                    "Alexander",
                    "Peter",
                    "Tyler",
                    "Douglas",
                    "Harold",
                    "Aaron",
                    "Jose",
                    "Adam",
                    "Arthur",
                    "Zachary",
                    "Carl",
                    "Nathan",
                    "Albert",
                    "Kyle",
                    "Lawrence",
                    "Joe",
                    "Willie",
                    "Gerald",
                    "Roger",
                    "Keith",
                    "Jeremy",
                    "Terry",
                    "Harry",
                    "Ralph",
                    "Sean",
                    "Jesse",
                    "Roy",
                    "Louis",
                    "Billy",
                    "Austin",
                    "Bruce",
                    "Eugene",
                    "Christian",
                    "Bryan",
                    "Wayne",
                    "Russell",
                    "Howard",
                    "Fred",
                    "Ethan",
                    "Jordan",
                    "Philip",
                    "Alan",
                    "Juan",
                    "Randy",
                    "Vincent",
                    "Bobby",
                    "Dylan",
                    "Johnny",
                    "Phillip",
                    "Victor",
                    "Clarence",
                    "Ernest",
                    "Martin",
                    "Craig",
                    "Stanley",
                    "Shawn",
                    "Travis",
                    "Bradley",
                    "Leonard",
                    "Earl",
                    "Gabriel",
                    "Jimmy",
                    "Francis",
                    "Todd",
                    "Noah",
                    "Danny",
                    "Dale",
                    "Cody",
                    "Carlos",
                    "Allen",
                    "Frederick",
                    "Logan",
                    "Curtis",
                    "Alex",
                    "Joel",
                    "Luis",
                    "Norman",
                    "Marvin",
                    "Glenn",
                    "Tony",
                    "Nathaniel",
                    "Rodney",
                    "Melvin",
                    "Alfred",
                    "Steve",
                    "Cameron",
                    "Chad",
                    "Edwin",
                    "Caleb",
                    "Evan",
                    "Antonio",
                    "Lee",
                    "Herbert",
                    "Jeffery",
                    "Isaac",
                    "Derek",
                    "Ricky",
                    "Marcus",
                    "Theodore",
                    "Elijah",
                    "Luke",
                    "Jesus",
                    "Eddie",
                    "Troy",
                    "Mike",
                    "Dustin",
                    "Ray",
                    "Adrian",
                    "Bernard",
                    "Leroy",
                    "Angel",
                    "Randall",
                    "Wesley",
                    "Ian",
                    "Jared",
                    "Mason",
                    "Hunter",
                    "Calvin",
                    "Oscar",
                    "Clifford",
                    "Jay",
                    "Shane",
                    "Ronnie",
                    "Barry",
                    "Lucas",
                    "Corey",
                    "Manuel",
                    "Leo",
                    "Tommy",
                    "Warren",
                    "Jackson",
                    "Isaiah",
                    "Connor",
                    "Don",
                    "Dean",
                    "Jon",
                    "Julian",
                    "Miguel",
                    "Bill",
                    "Lloyd",
                    "Charlie",
                    "Mitchell",
                    "Leon",
                    "Jerome",
                    "Darrell",
                    "Jeremiah",
                    "Alvin",
                    "Brett",
                    "Seth",
                    "Floyd",
                    "Jim",
                    "Blake",
                    "Micheal",
                    "Gordon",
                    "Trevor",
                    "Lewis",
                    "Erik",
                    "Edgar",
                    "Vernon",
                    "Devin",
                    "Gavin",
                    "Jayden",
                    "Chris",
                    "Clyde",
                    "Tom",
                    "Derrick",
                    "Mario",
                    "Brent",
                    "Marc",
                    "Herman",
                    "Chase",
                    "Dominic",
                    "Ricardo",
                    "Franklin",
                    "Maurice",
                    "Max",
                    "Aiden",
                    "Owen",
                    "Lester",
                    "Gilbert",
                    "Elmer",
                    "Gene",
                    "Francisco",
                    "Glen",
                    "Cory",
                    "Garrett",
                    "Clayton",
                    "Sam",
                    "Jorge",
                    "Chester",
                    "Alejandro",
                    "Jeff",
                    "Harvey",
                    "Milton",
                    "Cole",
                    "Ivan",
                    "Andre",
                    "Duane",
                    "Landon"
                ],
                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
                "it": [
                    "Adolfo",
                    "Alberto",
                    "Aldo",
                    "Alessandro",
                    "Alessio",
                    "Alfredo",
                    "Alvaro",
                    "Andrea",
                    "Angelo",
                    "Angiolo",
                    "Antonino",
                    "Antonio",
                    "Attilio",
                    "Benito",
                    "Bernardo",
                    "Bruno",
                    "Carlo",
                    "Cesare",
                    "Christian",
                    "Claudio",
                    "Corrado",
                    "Cosimo",
                    "Cristian",
                    "Cristiano",
                    "Daniele",
                    "Dario",
                    "David",
                    "Davide",
                    "Diego",
                    "Dino",
                    "Domenico",
                    "Duccio",
                    "Edoardo",
                    "Elia",
                    "Elio",
                    "Emanuele",
                    "Emiliano",
                    "Emilio",
                    "Enrico",
                    "Enzo",
                    "Ettore",
                    "Fabio",
                    "Fabrizio",
                    "Federico",
                    "Ferdinando",
                    "Fernando",
                    "Filippo",
                    "Francesco",
                    "Franco",
                    "Gabriele",
                    "Giacomo",
                    "Giampaolo",
                    "Giampiero",
                    "Giancarlo",
                    "Gianfranco",
                    "Gianluca",
                    "Gianmarco",
                    "Gianni",
                    "Gino",
                    "Giorgio",
                    "Giovanni",
                    "Giuliano",
                    "Giulio",
                    "Giuseppe",
                    "Graziano",
                    "Gregorio",
                    "Guido",
                    "Iacopo",
                    "Jacopo",
                    "Lapo",
                    "Leonardo",
                    "Lorenzo",
                    "Luca",
                    "Luciano",
                    "Luigi",
                    "Manuel",
                    "Marcello",
                    "Marco",
                    "Marino",
                    "Mario",
                    "Massimiliano",
                    "Massimo",
                    "Matteo",
                    "Mattia",
                    "Maurizio",
                    "Mauro",
                    "Michele",
                    "Mirko",
                    "Mohamed",
                    "Nello",
                    "Neri",
                    "Niccol\xf2",
                    "Nicola",
                    "Osvaldo",
                    "Otello",
                    "Paolo",
                    "Pier Luigi",
                    "Piero",
                    "Pietro",
                    "Raffaele",
                    "Remo",
                    "Renato",
                    "Renzo",
                    "Riccardo",
                    "Roberto",
                    "Rolando",
                    "Romano",
                    "Salvatore",
                    "Samuele",
                    "Sandro",
                    "Sergio",
                    "Silvano",
                    "Simone",
                    "Stefano",
                    "Thomas",
                    "Tommaso",
                    "Ubaldo",
                    "Ugo",
                    "Umberto",
                    "Valerio",
                    "Valter",
                    "Vasco",
                    "Vincenzo",
                    "Vittorio"
                ],
                // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
                "nl": [
                    "Aaron",
                    "Abel",
                    "Adam",
                    "Adriaan",
                    "Albert",
                    "Alexander",
                    "Ali",
                    "Arjen",
                    "Arno",
                    "Bart",
                    "Bas",
                    "Bastiaan",
                    "Benjamin",
                    "Bob",
                    "Boris",
                    "Bram",
                    "Brent",
                    "Cas",
                    "Casper",
                    "Chris",
                    "Christiaan",
                    "Cornelis",
                    "Daan",
                    "Daley",
                    "Damian",
                    "Dani",
                    "Daniel",
                    "Dani\xebl",
                    "David",
                    "Dean",
                    "Dirk",
                    "Dylan",
                    "Egbert",
                    "Elijah",
                    "Erik",
                    "Erwin",
                    "Evert",
                    "Ezra",
                    "Fabian",
                    "Fedde",
                    "Finn",
                    "Florian",
                    "Floris",
                    "Frank",
                    "Frans",
                    "Frederik",
                    "Freek",
                    "Geert",
                    "Gerard",
                    "Gerben",
                    "Gerrit",
                    "Gijs",
                    "Guus",
                    "Hans",
                    "Hendrik",
                    "Henk",
                    "Herman",
                    "Hidde",
                    "Hugo",
                    "Jaap",
                    "Jan Jaap",
                    "Jan-Willem",
                    "Jack",
                    "Jacob",
                    "Jan",
                    "Jason",
                    "Jasper",
                    "Jayden",
                    "Jelle",
                    "Jelte",
                    "Jens",
                    "Jeroen",
                    "Jesse",
                    "Jim",
                    "Job",
                    "Joep",
                    "Johannes",
                    "John",
                    "Jonathan",
                    "Joris",
                    "Joshua",
                    "Jo\xebl",
                    "Julian",
                    "Kees",
                    "Kevin",
                    "Koen",
                    "Lars",
                    "Laurens",
                    "Leendert",
                    "Lennard",
                    "Lodewijk",
                    "Luc",
                    "Luca",
                    "Lucas",
                    "Lukas",
                    "Luuk",
                    "Maarten",
                    "Marcus",
                    "Martijn",
                    "Martin",
                    "Matthijs",
                    "Maurits",
                    "Max",
                    "Mees",
                    "Melle",
                    "Mick",
                    "Mika",
                    "Milan",
                    "Mohamed",
                    "Mohammed",
                    "Morris",
                    "Muhammed",
                    "Nathan",
                    "Nick",
                    "Nico",
                    "Niek",
                    "Niels",
                    "Noah",
                    "Noud",
                    "Olivier",
                    "Oscar",
                    "Owen",
                    "Paul",
                    "Pepijn",
                    "Peter",
                    "Pieter",
                    "Pim",
                    "Quinten",
                    "Reinier",
                    "Rens",
                    "Robin",
                    "Ruben",
                    "Sam",
                    "Samuel",
                    "Sander",
                    "Sebastiaan",
                    "Sem",
                    "Sep",
                    "Sepp",
                    "Siem",
                    "Simon",
                    "Stan",
                    "Stef",
                    "Steven",
                    "Stijn",
                    "Sven",
                    "Teun",
                    "Thijmen",
                    "Thijs",
                    "Thomas",
                    "Tijn",
                    "Tim",
                    "Timo",
                    "Tobias",
                    "Tom",
                    "Victor",
                    "Vince",
                    "Willem",
                    "Wim",
                    "Wouter",
                    "Yusuf"
                ],
                // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
                "fr": [
                    "Aaron",
                    "Abdon",
                    "Abel",
                    "Ab\xe9lard",
                    "Abelin",
                    "Abondance",
                    "Abraham",
                    "Absalon",
                    "Acace",
                    "Achaire",
                    "Achille",
                    "Adalard",
                    "Adalbald",
                    "Adalb\xe9ron",
                    "Adalbert",
                    "Adalric",
                    "Adam",
                    "Adegrin",
                    "Adel",
                    "Adelin",
                    "Andelin",
                    "Adelphe",
                    "Adam",
                    "Ad\xe9odat",
                    "Adh\xe9mar",
                    "Adjutor",
                    "Adolphe",
                    "Adonis",
                    "Adon",
                    "Adrien",
                    "Agapet",
                    "Agathange",
                    "Agathon",
                    "Agilbert",
                    "Ag\xe9nor",
                    "Agnan",
                    "Aignan",
                    "Agrippin",
                    "Aimable",
                    "Aim\xe9",
                    "Alain",
                    "Alban",
                    "Albin",
                    "Aubin",
                    "Alb\xe9ric",
                    "Albert",
                    "Albertet",
                    "Alcibiade",
                    "Alcide",
                    "Alc\xe9e",
                    "Alcime",
                    "Aldonce",
                    "Aldric",
                    "Ald\xe9ric",
                    "Aleaume",
                    "Alexandre",
                    "Alexis",
                    "Alix",
                    "Alliaume",
                    "Aleaume",
                    "Almine",
                    "Almire",
                    "Alo\xefs",
                    "Alph\xe9e",
                    "Alphonse",
                    "Alpinien",
                    "Alver\xe8de",
                    "Amalric",
                    "Amaury",
                    "Amandin",
                    "Amant",
                    "Ambroise",
                    "Am\xe9d\xe9e",
                    "Am\xe9lien",
                    "Amiel",
                    "Amour",
                    "Ana\xebl",
                    "Anastase",
                    "Anatole",
                    "Ancelin",
                    "And\xe9ol",
                    "Andoche",
                    "Andr\xe9",
                    "Andoche",
                    "Ange",
                    "Angelin",
                    "Angilbe",
                    "Anglebert",
                    "Angoustan",
                    "Anicet",
                    "Anne",
                    "Annibal",
                    "Ansbert",
                    "Anselme",
                    "Anthelme",
                    "Antheaume",
                    "Anthime",
                    "Antide",
                    "Antoine",
                    "Antonius",
                    "Antonin",
                    "Apollinaire",
                    "Apollon",
                    "Aquilin",
                    "Arcade",
                    "Archambaud",
                    "Archambeau",
                    "Archange",
                    "Archibald",
                    "Arian",
                    "Ariel",
                    "Ariste",
                    "Aristide",
                    "Armand",
                    "Armel",
                    "Armin",
                    "Arnould",
                    "Arnaud",
                    "Arolde",
                    "Ars\xe8ne",
                    "Arsino\xe9",
                    "Arthaud",
                    "Arth\xe8me",
                    "Arthur",
                    "Ascelin",
                    "Athanase",
                    "Aubry",
                    "Audebert",
                    "Audouin",
                    "Audran",
                    "Audric",
                    "Auguste",
                    "Augustin",
                    "Aur\xe8le",
                    "Aur\xe9lien",
                    "Aurian",
                    "Auxence",
                    "Axel",
                    "Aymard",
                    "Aymeric",
                    "Aymon",
                    "Aymond",
                    "Balthazar",
                    "Baptiste",
                    "Barnab\xe9",
                    "Barth\xe9lemy",
                    "Bartim\xe9e",
                    "Basile",
                    "Bastien",
                    "Baudouin",
                    "B\xe9nigne",
                    "Benjamin",
                    "Beno\xeet",
                    "B\xe9renger",
                    "B\xe9rard",
                    "Bernard",
                    "Bertrand",
                    "Blaise",
                    "Bon",
                    "Boniface",
                    "Bouchard",
                    "Brice",
                    "Brieuc",
                    "Bruno",
                    "Brunon",
                    "Calixte",
                    "Calliste",
                    "Cam\xe9lien",
                    "Camille",
                    "Camillien",
                    "Candide",
                    "Caribert",
                    "Carloman",
                    "Cassandre",
                    "Cassien",
                    "C\xe9dric",
                    "C\xe9leste",
                    "C\xe9lestin",
                    "C\xe9lien",
                    "C\xe9saire",
                    "C\xe9sar",
                    "Charles",
                    "Charlemagne",
                    "Childebert",
                    "Chilp\xe9ric",
                    "Chr\xe9tien",
                    "Christian",
                    "Christodule",
                    "Christophe",
                    "Chrysostome",
                    "Clarence",
                    "Claude",
                    "Claudien",
                    "Cl\xe9andre",
                    "Cl\xe9ment",
                    "Clotaire",
                    "C\xf4me",
                    "Constance",
                    "Constant",
                    "Constantin",
                    "Corentin",
                    "Cyprien",
                    "Cyriaque",
                    "Cyrille",
                    "Cyril",
                    "Damien",
                    "Daniel",
                    "David",
                    "Delphin",
                    "Denis",
                    "D\xe9sir\xe9",
                    "Didier",
                    "Dieudonn\xe9",
                    "Dimitri",
                    "Dominique",
                    "Dorian",
                    "Doroth\xe9e",
                    "Edgard",
                    "Edmond",
                    "\xc9douard",
                    "\xc9leuth\xe8re",
                    "\xc9lie",
                    "\xc9lis\xe9e",
                    "\xc9meric",
                    "\xc9mile",
                    "\xc9milien",
                    "Emmanuel",
                    "Enguerrand",
                    "\xc9piphane",
                    "\xc9ric",
                    "Esprit",
                    "Ernest",
                    "\xc9tienne",
                    "Eubert",
                    "Eudes",
                    "Eudoxe",
                    "Eug\xe8ne",
                    "Eus\xe8be",
                    "Eustache",
                    "\xc9variste",
                    "\xc9vrard",
                    "Fabien",
                    "Fabrice",
                    "Falba",
                    "F\xe9licit\xe9",
                    "F\xe9lix",
                    "Ferdinand",
                    "Fiacre",
                    "Fid\xe8le",
                    "Firmin",
                    "Flavien",
                    "Flodoard",
                    "Florent",
                    "Florentin",
                    "Florestan",
                    "Florian",
                    "Fortun\xe9",
                    "Foulques",
                    "Francisque",
                    "Fran\xe7ois",
                    "Fran\xe7ais",
                    "Franciscus",
                    "Francs",
                    "Fr\xe9d\xe9ric",
                    "Fulbert",
                    "Fulcran",
                    "Fulgence",
                    "Gabin",
                    "Gabriel",
                    "Ga\xebl",
                    "Garnier",
                    "Gaston",
                    "Gaspard",
                    "Gatien",
                    "Gaud",
                    "Gautier",
                    "G\xe9d\xe9on",
                    "Geoffroy",
                    "Georges",
                    "G\xe9raud",
                    "G\xe9rard",
                    "Gerbert",
                    "Germain",
                    "Gervais",
                    "Ghislain",
                    "Gilbert",
                    "Gilles",
                    "Girart",
                    "Gislebert",
                    "Gondebaud",
                    "Gonthier",
                    "Gontran",
                    "Gonzague",
                    "Gr\xe9goire",
                    "Gu\xe9rin",
                    "Gui",
                    "Guillaume",
                    "Gustave",
                    "Guy",
                    "Guyot",
                    "Hardouin",
                    "Hector",
                    "H\xe9delin",
                    "H\xe9lier",
                    "Henri",
                    "Herbert",
                    "Herluin",
                    "Herv\xe9",
                    "Hilaire",
                    "Hildebert",
                    "Hincmar",
                    "Hippolyte",
                    "Honor\xe9",
                    "Hubert",
                    "Hugues",
                    "Innocent",
                    "Isabeau",
                    "Isidore",
                    "Jacques",
                    "Japhet",
                    "Jason",
                    "Jean",
                    "Jeannel",
                    "Jeannot",
                    "J\xe9r\xe9mie",
                    "J\xe9r\xf4me",
                    "Joachim",
                    "Joanny",
                    "Job",
                    "Jocelyn",
                    "Jo\xebl",
                    "Johan",
                    "Jonas",
                    "Jonathan",
                    "Joseph",
                    "Josse",
                    "Josselin",
                    "Jourdain",
                    "Jude",
                    "Judica\xebl",
                    "Jules",
                    "Julien",
                    "Juste",
                    "Justin",
                    "Lambert",
                    "Landry",
                    "Laurent",
                    "Lazare",
                    "L\xe9andre",
                    "L\xe9on",
                    "L\xe9onard",
                    "L\xe9opold",
                    "Leu",
                    "Loup",
                    "Leufroy",
                    "Lib\xe8re",
                    "Li\xe9tald",
                    "Lionel",
                    "Lo\xefc",
                    "Longin",
                    "Lorrain",
                    "Lorraine",
                    "Lothaire",
                    "Louis",
                    "Loup",
                    "Luc",
                    "Lucas",
                    "Lucien",
                    "Ludolphe",
                    "Ludovic",
                    "Macaire",
                    "Malo",
                    "Mamert",
                    "Manass\xe9",
                    "Marc",
                    "Marceau",
                    "Marcel",
                    "Marcelin",
                    "Marius",
                    "Marseille",
                    "Martial",
                    "Martin",
                    "Mathurin",
                    "Matthias",
                    "Mathias",
                    "Matthieu",
                    "Maugis",
                    "Maurice",
                    "Mauricet",
                    "Maxence",
                    "Maxime",
                    "Maximilien",
                    "Mayeul",
                    "M\xe9d\xe9ric",
                    "Melchior",
                    "Mence",
                    "Merlin",
                    "M\xe9rov\xe9e",
                    "Micha\xebl",
                    "Michel",
                    "Mo\xefse",
                    "Morgan",
                    "Nathan",
                    "Nathana\xebl",
                    "Narcisse",
                    "N\xe9h\xe9mie",
                    "Nestor",
                    "Nestor",
                    "Nic\xe9phore",
                    "Nicolas",
                    "No\xe9",
                    "No\xebl",
                    "Norbert",
                    "Normand",
                    "Normands",
                    "Octave",
                    "Odilon",
                    "Odon",
                    "Oger",
                    "Olivier",
                    "Oury",
                    "Pac\xf4me",
                    "Pal\xe9mon",
                    "Parfait",
                    "Pascal",
                    "Paterne",
                    "Patrice",
                    "Paul",
                    "P\xe9pin",
                    "Perceval",
                    "Phil\xe9mon",
                    "Philibert",
                    "Philippe",
                    "Philoth\xe9e",
                    "Pie",
                    "Pierre",
                    "Pierrick",
                    "Prosper",
                    "Quentin",
                    "Raoul",
                    "Rapha\xebl",
                    "Raymond",
                    "R\xe9gis",
                    "R\xe9jean",
                    "R\xe9mi",
                    "Renaud",
                    "Ren\xe9",
                    "Reybaud",
                    "Richard",
                    "Robert",
                    "Roch",
                    "Rodolphe",
                    "Rodrigue",
                    "Roger",
                    "Roland",
                    "Romain",
                    "Romuald",
                    "Rom\xe9o",
                    "Rome",
                    "Ronan",
                    "Roselin",
                    "Salomon",
                    "Samuel",
                    "Savin",
                    "Savinien",
                    "Scholastique",
                    "S\xe9bastien",
                    "S\xe9raphin",
                    "Serge",
                    "S\xe9verin",
                    "Sidoine",
                    "Sigebert",
                    "Sigismond",
                    "Silv\xe8re",
                    "Simon",
                    "Sim\xe9on",
                    "Sixte",
                    "Stanislas",
                    "St\xe9phane",
                    "Stephan",
                    "Sylvain",
                    "Sylvestre",
                    "Tancr\xe8de",
                    "Tanguy",
                    "Taurin",
                    "Th\xe9odore",
                    "Th\xe9odose",
                    "Th\xe9ophile",
                    "Th\xe9ophraste",
                    "Thibault",
                    "Thibert",
                    "Thierry",
                    "Thomas",
                    "Timol\xe9on",
                    "Timoth\xe9e",
                    "Titien",
                    "Tonnin",
                    "Toussaint",
                    "Trajan",
                    "Tristan",
                    "Turold",
                    "Tim",
                    "Ulysse",
                    "Urbain",
                    "Valentin",
                    "Val\xe8re",
                    "Val\xe9ry",
                    "Venance",
                    "Venant",
                    "Venceslas",
                    "Vianney",
                    "Victor",
                    "Victorien",
                    "Victorin",
                    "Vigile",
                    "Vincent",
                    "Vital",
                    "Vitalien",
                    "Vivien",
                    "Waleran",
                    "Wandrille",
                    "Xavier",
                    "X\xe9nophon",
                    "Yves",
                    "Zacharie",
                    "Zach\xe9",
                    "Z\xe9phirin"
                ]
            },
            "female": {
                "en": [
                    "Mary",
                    "Emma",
                    "Elizabeth",
                    "Minnie",
                    "Margaret",
                    "Ida",
                    "Alice",
                    "Bertha",
                    "Sarah",
                    "Annie",
                    "Clara",
                    "Ella",
                    "Florence",
                    "Cora",
                    "Martha",
                    "Laura",
                    "Nellie",
                    "Grace",
                    "Carrie",
                    "Maude",
                    "Mabel",
                    "Bessie",
                    "Jennie",
                    "Gertrude",
                    "Julia",
                    "Hattie",
                    "Edith",
                    "Mattie",
                    "Rose",
                    "Catherine",
                    "Lillian",
                    "Ada",
                    "Lillie",
                    "Helen",
                    "Jessie",
                    "Louise",
                    "Ethel",
                    "Lula",
                    "Myrtle",
                    "Eva",
                    "Frances",
                    "Lena",
                    "Lucy",
                    "Edna",
                    "Maggie",
                    "Pearl",
                    "Daisy",
                    "Fannie",
                    "Josephine",
                    "Dora",
                    "Rosa",
                    "Katherine",
                    "Agnes",
                    "Marie",
                    "Nora",
                    "May",
                    "Mamie",
                    "Blanche",
                    "Stella",
                    "Ellen",
                    "Nancy",
                    "Effie",
                    "Sallie",
                    "Nettie",
                    "Della",
                    "Lizzie",
                    "Flora",
                    "Susie",
                    "Maud",
                    "Mae",
                    "Etta",
                    "Harriet",
                    "Sadie",
                    "Caroline",
                    "Katie",
                    "Lydia",
                    "Elsie",
                    "Kate",
                    "Susan",
                    "Mollie",
                    "Alma",
                    "Addie",
                    "Georgia",
                    "Eliza",
                    "Lulu",
                    "Nannie",
                    "Lottie",
                    "Amanda",
                    "Belle",
                    "Charlotte",
                    "Rebecca",
                    "Ruth",
                    "Viola",
                    "Olive",
                    "Amelia",
                    "Hannah",
                    "Jane",
                    "Virginia",
                    "Emily",
                    "Matilda",
                    "Irene",
                    "Kathryn",
                    "Esther",
                    "Willie",
                    "Henrietta",
                    "Ollie",
                    "Amy",
                    "Rachel",
                    "Sara",
                    "Estella",
                    "Theresa",
                    "Augusta",
                    "Ora",
                    "Pauline",
                    "Josie",
                    "Lola",
                    "Sophia",
                    "Leona",
                    "Anne",
                    "Mildred",
                    "Ann",
                    "Beulah",
                    "Callie",
                    "Lou",
                    "Delia",
                    "Eleanor",
                    "Barbara",
                    "Iva",
                    "Louisa",
                    "Maria",
                    "Mayme",
                    "Evelyn",
                    "Estelle",
                    "Nina",
                    "Betty",
                    "Marion",
                    "Bettie",
                    "Dorothy",
                    "Luella",
                    "Inez",
                    "Lela",
                    "Rosie",
                    "Allie",
                    "Millie",
                    "Janie",
                    "Cornelia",
                    "Victoria",
                    "Ruby",
                    "Winifred",
                    "Alta",
                    "Celia",
                    "Christine",
                    "Beatrice",
                    "Birdie",
                    "Harriett",
                    "Mable",
                    "Myra",
                    "Sophie",
                    "Tillie",
                    "Isabel",
                    "Sylvia",
                    "Carolyn",
                    "Isabelle",
                    "Leila",
                    "Sally",
                    "Ina",
                    "Essie",
                    "Bertie",
                    "Nell",
                    "Alberta",
                    "Katharine",
                    "Lora",
                    "Rena",
                    "Mina",
                    "Rhoda",
                    "Mathilda",
                    "Abbie",
                    "Eula",
                    "Dollie",
                    "Hettie",
                    "Eunice",
                    "Fanny",
                    "Ola",
                    "Lenora",
                    "Adelaide",
                    "Christina",
                    "Lelia",
                    "Nelle",
                    "Sue",
                    "Johanna",
                    "Lilly",
                    "Lucinda",
                    "Minerva",
                    "Lettie",
                    "Roxie",
                    "Cynthia",
                    "Helena",
                    "Hilda",
                    "Hulda",
                    "Bernice",
                    "Genevieve",
                    "Jean",
                    "Cordelia",
                    "Marian",
                    "Francis",
                    "Jeanette",
                    "Adeline",
                    "Gussie",
                    "Leah",
                    "Lois",
                    "Lura",
                    "Mittie",
                    "Hallie",
                    "Isabella",
                    "Olga",
                    "Phoebe",
                    "Teresa",
                    "Hester",
                    "Lida",
                    "Lina",
                    "Winnie",
                    "Claudia",
                    "Marguerite",
                    "Vera",
                    "Cecelia",
                    "Bess",
                    "Emilie",
                    "Rosetta",
                    "Verna",
                    "Myrtie",
                    "Cecilia",
                    "Elva",
                    "Olivia",
                    "Ophelia",
                    "Georgie",
                    "Elnora",
                    "Violet",
                    "Adele",
                    "Lily",
                    "Linnie",
                    "Loretta",
                    "Madge",
                    "Polly",
                    "Virgie",
                    "Eugenia",
                    "Lucile",
                    "Lucille",
                    "Mabelle",
                    "Rosalie"
                ],
                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
                "it": [
                    "Ada",
                    "Adriana",
                    "Alessandra",
                    "Alessia",
                    "Alice",
                    "Angela",
                    "Anna",
                    "Anna Maria",
                    "Annalisa",
                    "Annita",
                    "Annunziata",
                    "Antonella",
                    "Arianna",
                    "Asia",
                    "Assunta",
                    "Aurora",
                    "Barbara",
                    "Beatrice",
                    "Benedetta",
                    "Bianca",
                    "Bruna",
                    "Camilla",
                    "Carla",
                    "Carlotta",
                    "Carmela",
                    "Carolina",
                    "Caterina",
                    "Catia",
                    "Cecilia",
                    "Chiara",
                    "Cinzia",
                    "Clara",
                    "Claudia",
                    "Costanza",
                    "Cristina",
                    "Daniela",
                    "Debora",
                    "Diletta",
                    "Dina",
                    "Donatella",
                    "Elena",
                    "Eleonora",
                    "Elisa",
                    "Elisabetta",
                    "Emanuela",
                    "Emma",
                    "Eva",
                    "Federica",
                    "Fernanda",
                    "Fiorella",
                    "Fiorenza",
                    "Flora",
                    "Franca",
                    "Francesca",
                    "Gabriella",
                    "Gaia",
                    "Gemma",
                    "Giada",
                    "Gianna",
                    "Gina",
                    "Ginevra",
                    "Giorgia",
                    "Giovanna",
                    "Giulia",
                    "Giuliana",
                    "Giuseppa",
                    "Giuseppina",
                    "Grazia",
                    "Graziella",
                    "Greta",
                    "Ida",
                    "Ilaria",
                    "Ines",
                    "Iolanda",
                    "Irene",
                    "Irma",
                    "Isabella",
                    "Jessica",
                    "Laura",
                    "Lea",
                    "Letizia",
                    "Licia",
                    "Lidia",
                    "Liliana",
                    "Lina",
                    "Linda",
                    "Lisa",
                    "Livia",
                    "Loretta",
                    "Luana",
                    "Lucia",
                    "Luciana",
                    "Lucrezia",
                    "Luisa",
                    "Manuela",
                    "Mara",
                    "Marcella",
                    "Margherita",
                    "Maria",
                    "Maria Cristina",
                    "Maria Grazia",
                    "Maria Luisa",
                    "Maria Pia",
                    "Maria Teresa",
                    "Marina",
                    "Marisa",
                    "Marta",
                    "Martina",
                    "Marzia",
                    "Matilde",
                    "Melissa",
                    "Michela",
                    "Milena",
                    "Mirella",
                    "Monica",
                    "Natalina",
                    "Nella",
                    "Nicoletta",
                    "Noemi",
                    "Olga",
                    "Paola",
                    "Patrizia",
                    "Piera",
                    "Pierina",
                    "Raffaella",
                    "Rebecca",
                    "Renata",
                    "Rina",
                    "Rita",
                    "Roberta",
                    "Rosa",
                    "Rosanna",
                    "Rossana",
                    "Rossella",
                    "Sabrina",
                    "Sandra",
                    "Sara",
                    "Serena",
                    "Silvana",
                    "Silvia",
                    "Simona",
                    "Simonetta",
                    "Sofia",
                    "Sonia",
                    "Stefania",
                    "Susanna",
                    "Teresa",
                    "Tina",
                    "Tiziana",
                    "Tosca",
                    "Valentina",
                    "Valeria",
                    "Vanda",
                    "Vanessa",
                    "Vanna",
                    "Vera",
                    "Veronica",
                    "Vilma",
                    "Viola",
                    "Virginia",
                    "Vittoria"
                ],
                // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
                "nl": [
                    "Ada",
                    "Arianne",
                    "Afke",
                    "Amanda",
                    "Amber",
                    "Amy",
                    "Aniek",
                    "Anita",
                    "Anja",
                    "Anna",
                    "Anne",
                    "Annelies",
                    "Annemarie",
                    "Annette",
                    "Anouk",
                    "Astrid",
                    "Aukje",
                    "Barbara",
                    "Bianca",
                    "Carla",
                    "Carlijn",
                    "Carolien",
                    "Chantal",
                    "Charlotte",
                    "Claudia",
                    "Dani\xeblle",
                    "Debora",
                    "Diane",
                    "Dora",
                    "Eline",
                    "Elise",
                    "Ella",
                    "Ellen",
                    "Emma",
                    "Esmee",
                    "Evelien",
                    "Esther",
                    "Erica",
                    "Eva",
                    "Femke",
                    "Fleur",
                    "Floor",
                    "Froukje",
                    "Gea",
                    "Gerda",
                    "Hanna",
                    "Hanneke",
                    "Heleen",
                    "Hilde",
                    "Ilona",
                    "Ina",
                    "Inge",
                    "Ingrid",
                    "Iris",
                    "Isabel",
                    "Isabelle",
                    "Janneke",
                    "Jasmijn",
                    "Jeanine",
                    "Jennifer",
                    "Jessica",
                    "Johanna",
                    "Joke",
                    "Julia",
                    "Julie",
                    "Karen",
                    "Karin",
                    "Katja",
                    "Kim",
                    "Lara",
                    "Laura",
                    "Lena",
                    "Lianne",
                    "Lieke",
                    "Lilian",
                    "Linda",
                    "Lisa",
                    "Lisanne",
                    "Lotte",
                    "Louise",
                    "Maaike",
                    "Manon",
                    "Marga",
                    "Maria",
                    "Marissa",
                    "Marit",
                    "Marjolein",
                    "Martine",
                    "Marleen",
                    "Melissa",
                    "Merel",
                    "Miranda",
                    "Michelle",
                    "Mirjam",
                    "Mirthe",
                    "Naomi",
                    "Natalie",
                    'Nienke',
                    "Nina",
                    "Noortje",
                    "Olivia",
                    "Patricia",
                    "Paula",
                    "Paulien",
                    "Ramona",
                    "Ria",
                    "Rianne",
                    "Roos",
                    "Rosanne",
                    "Ruth",
                    "Sabrina",
                    "Sandra",
                    "Sanne",
                    "Sara",
                    "Saskia",
                    "Silvia",
                    "Sofia",
                    "Sophie",
                    "Sonja",
                    "Suzanne",
                    "Tamara",
                    "Tess",
                    "Tessa",
                    "Tineke",
                    "Valerie",
                    "Vanessa",
                    "Veerle",
                    "Vera",
                    "Victoria",
                    "Wendy",
                    "Willeke",
                    "Yvonne",
                    "Zo\xeb"
                ],
                // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
                "fr": [
                    "Abdon",
                    "Abel",
                    "Abiga\xeblle",
                    "Abiga\xefl",
                    "Acacius",
                    "Acanthe",
                    "Adalbert",
                    "Adalsinde",
                    "Adegrine",
                    "Ad\xe9la\xefde",
                    "Ad\xe8le",
                    "Ad\xe9lie",
                    "Adeline",
                    "Adeltrude",
                    "Adolphe",
                    "Adonis",
                    "Adrast\xe9e",
                    "Adrehilde",
                    "Adrienne",
                    "Agathe",
                    "Agilbert",
                    "Agla\xe9",
                    "Aignan",
                    "Agnefl\xe8te",
                    "Agn\xe8s",
                    "Agrippine",
                    "Aim\xe9",
                    "Alaine",
                    "Ala\xefs",
                    "Albane",
                    "Alb\xe9rade",
                    "Alberte",
                    "Alcide",
                    "Alcine",
                    "Alcyone",
                    "Aldegonde",
                    "Aleth",
                    "Alexandrine",
                    "Alexine",
                    "Alice",
                    "Ali\xe9nor",
                    "Aliette",
                    "Aline",
                    "Alix",
                    "Aliz\xe9",
                    "Alo\xefse",
                    "Aloyse",
                    "Alphonsine",
                    "Alth\xe9e",
                    "Amaliane",
                    "Amalth\xe9e",
                    "Amande",
                    "Amandine",
                    "Amant",
                    "Amarande",
                    "Amaranthe",
                    "Amaryllis",
                    "Ambre",
                    "Ambroisie",
                    "Am\xe9lie",
                    "Am\xe9thyste",
                    "Aminte",
                    "Ana\xebl",
                    "Ana\xefs",
                    "Anastasie",
                    "Anatole",
                    "Ancelin",
                    "Andr\xe9e",
                    "An\xe9mone",
                    "Angadr\xeame",
                    "Ang\xe8le",
                    "Angeline",
                    "Ang\xe9lique",
                    "Angilbert",
                    "Anicet",
                    "Annabelle",
                    "Anne",
                    "Annette",
                    "Annick",
                    "Annie",
                    "Annonciade",
                    "Ansbert",
                    "Anstrudie",
                    "Anthelme",
                    "Antigone",
                    "Antoinette",
                    "Antonine",
                    "Aph\xe9lie",
                    "Apolline",
                    "Apollonie",
                    "Aquiline",
                    "Arabelle",
                    "Arcadie",
                    "Archange",
                    "Argine",
                    "Ariane",
                    "Aricie",
                    "Ariel",
                    "Arielle",
                    "Arlette",
                    "Armance",
                    "Armande",
                    "Armandine",
                    "Armelle",
                    "Armide",
                    "Armelle",
                    "Armin",
                    "Arnaud",
                    "Ars\xe8ne",
                    "Arsino\xe9",
                    "Art\xe9mis",
                    "Arthur",
                    "Ascelin",
                    "Ascension",
                    "Assomption",
                    "Astart\xe9",
                    "Ast\xe9rie",
                    "Astr\xe9e",
                    "Astrid",
                    "Athalie",
                    "Athanasie",
                    "Athina",
                    "Aube",
                    "Albert",
                    "Aude",
                    "Audrey",
                    "Augustine",
                    "Aure",
                    "Aur\xe9lie",
                    "Aur\xe9lien",
                    "Aur\xe8le",
                    "Aurore",
                    "Auxence",
                    "Aveline",
                    "Abiga\xeblle",
                    "Avoye",
                    "Axelle",
                    "Aymard",
                    "Azal\xe9e",
                    "Ad\xe8le",
                    "Adeline",
                    "Barbe",
                    "Basilisse",
                    "Bathilde",
                    "B\xe9atrice",
                    "B\xe9atrix",
                    "B\xe9n\xe9dicte",
                    "B\xe9reng\xe8re",
                    "Bernadette",
                    "Berthe",
                    "Bertille",
                    "Beuve",
                    "Blanche",
                    "Blanc",
                    "Blandine",
                    "Brigitte",
                    "Brune",
                    "Brunehilde",
                    "Callista",
                    "Camille",
                    "Capucine",
                    "Carine",
                    "Caroline",
                    "Cassandre",
                    "Catherine",
                    "C\xe9cile",
                    "C\xe9leste",
                    "C\xe9lestine",
                    "C\xe9line",
                    "Chantal",
                    "Charl\xe8ne",
                    "Charline",
                    "Charlotte",
                    "Chlo\xe9",
                    "Christelle",
                    "Christiane",
                    "Christine",
                    "Claire",
                    "Clara",
                    "Claude",
                    "Claudine",
                    "Clarisse",
                    "Cl\xe9mence",
                    "Cl\xe9mentine",
                    "Cl\xe9o",
                    "Clio",
                    "Clotilde",
                    "Coline",
                    "Conception",
                    "Constance",
                    "Coralie",
                    "Coraline",
                    "Corentine",
                    "Corinne",
                    "Cyrielle",
                    "Daniel",
                    "Daniel",
                    "Daphn\xe9",
                    "D\xe9bora",
                    "Delphine",
                    "Denise",
                    "Diane",
                    "Dieudonn\xe9",
                    "Dominique",
                    "Doriane",
                    "Doroth\xe9e",
                    "Douce",
                    "\xc9dith",
                    "Edm\xe9e",
                    "\xc9l\xe9onore",
                    "\xc9liane",
                    "\xc9lia",
                    "\xc9liette",
                    "\xc9lisabeth",
                    "\xc9lise",
                    "Ella",
                    "\xc9lodie",
                    "\xc9lo\xefse",
                    "Elsa",
                    "\xc9meline",
                    "\xc9m\xe9rance",
                    "\xc9m\xe9rentienne",
                    "\xc9m\xe9rencie",
                    "\xc9milie",
                    "Emma",
                    "Emmanuelle",
                    "Emmelie",
                    "Ernestine",
                    "Esther",
                    "Estelle",
                    "Eudoxie",
                    "Eug\xe9nie",
                    "Eulalie",
                    "Euphrasie",
                    "Eus\xe9bie",
                    "\xc9vang\xe9line",
                    "Eva",
                    "\xc8ve",
                    "\xc9velyne",
                    "Fanny",
                    "Fantine",
                    "Faustine",
                    "F\xe9licie",
                    "Fernande",
                    "Flavie",
                    "Fleur",
                    "Flore",
                    "Florence",
                    "Florie",
                    "Fortun\xe9",
                    "France",
                    "Francia",
                    "Fran\xe7oise",
                    "Francine",
                    "Gabrielle",
                    "Ga\xeblle",
                    "Garance",
                    "Genevi\xe8ve",
                    "Georgette",
                    "Gerberge",
                    "Germaine",
                    "Gertrude",
                    "Gis\xe8le",
                    "Gueni\xe8vre",
                    "Guilhemine",
                    "Guillemette",
                    "Gustave",
                    "Gwenael",
                    "H\xe9l\xe8ne",
                    "H\xe9lo\xefse",
                    "Henriette",
                    "Hermine",
                    "Hermione",
                    "Hippolyte",
                    "Honorine",
                    "Hortense",
                    "Huguette",
                    "Ines",
                    "Ir\xe8ne",
                    "Irina",
                    "Iris",
                    "Isabeau",
                    "Isabelle",
                    "Iseult",
                    "Isolde",
                    "Ism\xe9rie",
                    "Jacinthe",
                    "Jacqueline",
                    "Jade",
                    "Janine",
                    "Jeanne",
                    "Jocelyne",
                    "Jo\xeblle",
                    "Jos\xe9phine",
                    "Judith",
                    "Julia",
                    "Julie",
                    "Jules",
                    "Juliette",
                    "Justine",
                    "Katy",
                    "Kathy",
                    "Katie",
                    "Laura",
                    "Laure",
                    "Laureline",
                    "Laurence",
                    "Laurene",
                    "Lauriane",
                    "Laurianne",
                    "Laurine",
                    "L\xe9a",
                    "L\xe9na",
                    "L\xe9onie",
                    "L\xe9on",
                    "L\xe9ontine",
                    "Lorraine",
                    "Lucie",
                    "Lucienne",
                    "Lucille",
                    "Ludivine",
                    "Lydie",
                    "Lydie",
                    "Megane",
                    "Madeleine",
                    "Magali",
                    "Maguelone",
                    "Mallaury",
                    "Manon",
                    "Marceline",
                    "Margot",
                    "Marguerite",
                    "Marianne",
                    "Marie",
                    "Myriam",
                    "Marie",
                    "Marine",
                    "Marion",
                    "Marl\xe8ne",
                    "Marthe",
                    "Martine",
                    "Mathilde",
                    "Maud",
                    "Maureen",
                    "Mauricette",
                    "Maxime",
                    "M\xe9lanie",
                    "Melissa",
                    "M\xe9lissandre",
                    "M\xe9lisande",
                    "M\xe9lodie",
                    "Michel",
                    "Micheline",
                    "Mireille",
                    "Miriam",
                    "Mo\xefse",
                    "Monique",
                    "Morgane",
                    "Muriel",
                    "Myl\xe8ne",
                    "Nad\xe8ge",
                    "Nadine",
                    "Nathalie",
                    "Nicole",
                    "Nicolette",
                    "Nine",
                    "No\xebl",
                    "No\xe9mie",
                    "Oc\xe9ane",
                    "Odette",
                    "Odile",
                    "Olive",
                    "Olivia",
                    "Olympe",
                    "Ombline",
                    "Ombeline",
                    "Oph\xe9lie",
                    "Oriande",
                    "Oriane",
                    "Ozanne",
                    "Pascale",
                    "Pascaline",
                    "Paule",
                    "Paulette",
                    "Pauline",
                    "Priscille",
                    "Prisca",
                    "Prisque",
                    "P\xe9cine",
                    "P\xe9lagie",
                    "P\xe9n\xe9lope",
                    "Perrine",
                    "P\xe9tronille",
                    "Philippine",
                    "Philom\xe8ne",
                    "Philoth\xe9e",
                    "Primerose",
                    "Prudence",
                    "Pulch\xe9rie",
                    "Quentine",
                    "Qui\xe9ta",
                    "Quintia",
                    "Quintilla",
                    "Rachel",
                    "Rapha\xeblle",
                    "Raymonde",
                    "Rebecca",
                    "R\xe9gine",
                    "R\xe9jeanne",
                    "Ren\xe9",
                    "Rita",
                    "Rita",
                    "Rolande",
                    "Romane",
                    "Rosalie",
                    "Rose",
                    "Roseline",
                    "Sabine",
                    "Salom\xe9",
                    "Sandra",
                    "Sandrine",
                    "Sarah",
                    "S\xe9gol\xe8ne",
                    "S\xe9verine",
                    "Sibylle",
                    "Simone",
                    "Sixt",
                    "Solange",
                    "Soline",
                    "Sol\xe8ne",
                    "Sophie",
                    "St\xe9phanie",
                    "Suzanne",
                    "Sylvain",
                    "Sylvie",
                    "Tatiana",
                    "Tha\xefs",
                    "Th\xe9odora",
                    "Th\xe9r\xe8se",
                    "Tiphaine",
                    "Ursule",
                    "Valentine",
                    "Val\xe9rie",
                    "V\xe9ronique",
                    "Victoire",
                    "Victorine",
                    "Vinciane",
                    "Violette",
                    "Virginie",
                    "Viviane",
                    "Xavi\xe8re",
                    "Yolande",
                    "Ysaline",
                    "Yvette",
                    "Yvonne",
                    "Z\xe9lie",
                    "Zita",
                    "Zo\xe9"
                ]
            }
        },
        lastNames: {
            "en": [
                'Smith',
                'Johnson',
                'Williams',
                'Jones',
                'Brown',
                'Davis',
                'Miller',
                'Wilson',
                'Moore',
                'Taylor',
                'Anderson',
                'Thomas',
                'Jackson',
                'White',
                'Harris',
                'Martin',
                'Thompson',
                'Garcia',
                'Martinez',
                'Robinson',
                'Clark',
                'Rodriguez',
                'Lewis',
                'Lee',
                'Walker',
                'Hall',
                'Allen',
                'Young',
                'Hernandez',
                'King',
                'Wright',
                'Lopez',
                'Hill',
                'Scott',
                'Green',
                'Adams',
                'Baker',
                'Gonzalez',
                'Nelson',
                'Carter',
                'Mitchell',
                'Perez',
                'Roberts',
                'Turner',
                'Phillips',
                'Campbell',
                'Parker',
                'Evans',
                'Edwards',
                'Collins',
                'Stewart',
                'Sanchez',
                'Morris',
                'Rogers',
                'Reed',
                'Cook',
                'Morgan',
                'Bell',
                'Murphy',
                'Bailey',
                'Rivera',
                'Cooper',
                'Richardson',
                'Cox',
                'Howard',
                'Ward',
                'Torres',
                'Peterson',
                'Gray',
                'Ramirez',
                'James',
                'Watson',
                'Brooks',
                'Kelly',
                'Sanders',
                'Price',
                'Bennett',
                'Wood',
                'Barnes',
                'Ross',
                'Henderson',
                'Coleman',
                'Jenkins',
                'Perry',
                'Powell',
                'Long',
                'Patterson',
                'Hughes',
                'Flores',
                'Washington',
                'Butler',
                'Simmons',
                'Foster',
                'Gonzales',
                'Bryant',
                'Alexander',
                'Russell',
                'Griffin',
                'Diaz',
                'Hayes',
                'Myers',
                'Ford',
                'Hamilton',
                'Graham',
                'Sullivan',
                'Wallace',
                'Woods',
                'Cole',
                'West',
                'Jordan',
                'Owens',
                'Reynolds',
                'Fisher',
                'Ellis',
                'Harrison',
                'Gibson',
                'McDonald',
                'Cruz',
                'Marshall',
                'Ortiz',
                'Gomez',
                'Murray',
                'Freeman',
                'Wells',
                'Webb',
                'Simpson',
                'Stevens',
                'Tucker',
                'Porter',
                'Hunter',
                'Hicks',
                'Crawford',
                'Henry',
                'Boyd',
                'Mason',
                'Morales',
                'Kennedy',
                'Warren',
                'Dixon',
                'Ramos',
                'Reyes',
                'Burns',
                'Gordon',
                'Shaw',
                'Holmes',
                'Rice',
                'Robertson',
                'Hunt',
                'Black',
                'Daniels',
                'Palmer',
                'Mills',
                'Nichols',
                'Grant',
                'Knight',
                'Ferguson',
                'Rose',
                'Stone',
                'Hawkins',
                'Dunn',
                'Perkins',
                'Hudson',
                'Spencer',
                'Gardner',
                'Stephens',
                'Payne',
                'Pierce',
                'Berry',
                'Matthews',
                'Arnold',
                'Wagner',
                'Willis',
                'Ray',
                'Watkins',
                'Olson',
                'Carroll',
                'Duncan',
                'Snyder',
                'Hart',
                'Cunningham',
                'Bradley',
                'Lane',
                'Andrews',
                'Ruiz',
                'Harper',
                'Fox',
                'Riley',
                'Armstrong',
                'Carpenter',
                'Weaver',
                'Greene',
                'Lawrence',
                'Elliott',
                'Chavez',
                'Sims',
                'Austin',
                'Peters',
                'Kelley',
                'Franklin',
                'Lawson',
                'Fields',
                'Gutierrez',
                'Ryan',
                'Schmidt',
                'Carr',
                'Vasquez',
                'Castillo',
                'Wheeler',
                'Chapman',
                'Oliver',
                'Montgomery',
                'Richards',
                'Williamson',
                'Johnston',
                'Banks',
                'Meyer',
                'Bishop',
                'McCoy',
                'Howell',
                'Alvarez',
                'Morrison',
                'Hansen',
                'Fernandez',
                'Garza',
                'Harvey',
                'Little',
                'Burton',
                'Stanley',
                'Nguyen',
                'George',
                'Jacobs',
                'Reid',
                'Kim',
                'Fuller',
                'Lynch',
                'Dean',
                'Gilbert',
                'Garrett',
                'Romero',
                'Welch',
                'Larson',
                'Frazier',
                'Burke',
                'Hanson',
                'Day',
                'Mendoza',
                'Moreno',
                'Bowman',
                'Medina',
                'Fowler',
                'Brewer',
                'Hoffman',
                'Carlson',
                'Silva',
                'Pearson',
                'Holland',
                'Douglas',
                'Fleming',
                'Jensen',
                'Vargas',
                'Byrd',
                'Davidson',
                'Hopkins',
                'May',
                'Terry',
                'Herrera',
                'Wade',
                'Soto',
                'Walters',
                'Curtis',
                'Neal',
                'Caldwell',
                'Lowe',
                'Jennings',
                'Barnett',
                'Graves',
                'Jimenez',
                'Horton',
                'Shelton',
                'Barrett',
                'Obrien',
                'Castro',
                'Sutton',
                'Gregory',
                'McKinney',
                'Lucas',
                'Miles',
                'Craig',
                'Rodriquez',
                'Chambers',
                'Holt',
                'Lambert',
                'Fletcher',
                'Watts',
                'Bates',
                'Hale',
                'Rhodes',
                'Pena',
                'Beck',
                'Newman',
                'Haynes',
                'McDaniel',
                'Mendez',
                'Bush',
                'Vaughn',
                'Parks',
                'Dawson',
                'Santiago',
                'Norris',
                'Hardy',
                'Love',
                'Steele',
                'Curry',
                'Powers',
                'Schultz',
                'Barker',
                'Guzman',
                'Page',
                'Munoz',
                'Ball',
                'Keller',
                'Chandler',
                'Weber',
                'Leonard',
                'Walsh',
                'Lyons',
                'Ramsey',
                'Wolfe',
                'Schneider',
                'Mullins',
                'Benson',
                'Sharp',
                'Bowen',
                'Daniel',
                'Barber',
                'Cummings',
                'Hines',
                'Baldwin',
                'Griffith',
                'Valdez',
                'Hubbard',
                'Salazar',
                'Reeves',
                'Warner',
                'Stevenson',
                'Burgess',
                'Santos',
                'Tate',
                'Cross',
                'Garner',
                'Mann',
                'Mack',
                'Moss',
                'Thornton',
                'Dennis',
                'McGee',
                'Farmer',
                'Delgado',
                'Aguilar',
                'Vega',
                'Glover',
                'Manning',
                'Cohen',
                'Harmon',
                'Rodgers',
                'Robbins',
                'Newton',
                'Todd',
                'Blair',
                'Higgins',
                'Ingram',
                'Reese',
                'Cannon',
                'Strickland',
                'Townsend',
                'Potter',
                'Goodwin',
                'Walton',
                'Rowe',
                'Hampton',
                'Ortega',
                'Patton',
                'Swanson',
                'Joseph',
                'Francis',
                'Goodman',
                'Maldonado',
                'Yates',
                'Becker',
                'Erickson',
                'Hodges',
                'Rios',
                'Conner',
                'Adkins',
                'Webster',
                'Norman',
                'Malone',
                'Hammond',
                'Flowers',
                'Cobb',
                'Moody',
                'Quinn',
                'Blake',
                'Maxwell',
                'Pope',
                'Floyd',
                'Osborne',
                'Paul',
                'McCarthy',
                'Guerrero',
                'Lindsey',
                'Estrada',
                'Sandoval',
                'Gibbs',
                'Tyler',
                'Gross',
                'Fitzgerald',
                'Stokes',
                'Doyle',
                'Sherman',
                'Saunders',
                'Wise',
                'Colon',
                'Gill',
                'Alvarado',
                'Greer',
                'Padilla',
                'Simon',
                'Waters',
                'Nunez',
                'Ballard',
                'Schwartz',
                'McBride',
                'Houston',
                'Christensen',
                'Klein',
                'Pratt',
                'Briggs',
                'Parsons',
                'McLaughlin',
                'Zimmerman',
                'French',
                'Buchanan',
                'Moran',
                'Copeland',
                'Roy',
                'Pittman',
                'Brady',
                'McCormick',
                'Holloway',
                'Brock',
                'Poole',
                'Frank',
                'Logan',
                'Owen',
                'Bass',
                'Marsh',
                'Drake',
                'Wong',
                'Jefferson',
                'Park',
                'Morton',
                'Abbott',
                'Sparks',
                'Patrick',
                'Norton',
                'Huff',
                'Clayton',
                'Massey',
                'Lloyd',
                'Figueroa',
                'Carson',
                'Bowers',
                'Roberson',
                'Barton',
                'Tran',
                'Lamb',
                'Harrington',
                'Casey',
                'Boone',
                'Cortez',
                'Clarke',
                'Mathis',
                'Singleton',
                'Wilkins',
                'Cain',
                'Bryan',
                'Underwood',
                'Hogan',
                'McKenzie',
                'Collier',
                'Luna',
                'Phelps',
                'McGuire',
                'Allison',
                'Bridges',
                'Wilkerson',
                'Nash',
                'Summers',
                'Atkins'
            ],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
            "it": [
                "Acciai",
                "Aglietti",
                "Agostini",
                "Agresti",
                "Ahmed",
                "Aiazzi",
                "Albanese",
                "Alberti",
                "Alessi",
                "Alfani",
                "Alinari",
                "Alterini",
                "Amato",
                "Ammannati",
                "Ancillotti",
                "Andrei",
                "Andreini",
                "Andreoni",
                "Angeli",
                "Anichini",
                "Antonelli",
                "Antonini",
                "Arena",
                "Ariani",
                "Arnetoli",
                "Arrighi",
                "Baccani",
                "Baccetti",
                "Bacci",
                "Bacherini",
                "Badii",
                "Baggiani",
                "Baglioni",
                "Bagni",
                "Bagnoli",
                "Baldassini",
                "Baldi",
                "Baldini",
                "Ballerini",
                "Balli",
                "Ballini",
                "Balloni",
                "Bambi",
                "Banchi",
                "Bandinelli",
                "Bandini",
                "Bani",
                "Barbetti",
                "Barbieri",
                "Barchielli",
                "Bardazzi",
                "Bardelli",
                "Bardi",
                "Barducci",
                "Bargellini",
                "Bargiacchi",
                "Barni",
                "Baroncelli",
                "Baroncini",
                "Barone",
                "Baroni",
                "Baronti",
                "Bartalesi",
                "Bartoletti",
                "Bartoli",
                "Bartolini",
                "Bartoloni",
                "Bartolozzi",
                "Basagni",
                "Basile",
                "Bassi",
                "Batacchi",
                "Battaglia",
                "Battaglini",
                "Bausi",
                "Becagli",
                "Becattini",
                "Becchi",
                "Becucci",
                "Bellandi",
                "Bellesi",
                "Belli",
                "Bellini",
                "Bellucci",
                "Bencini",
                "Benedetti",
                "Benelli",
                "Beni",
                "Benini",
                "Bensi",
                "Benucci",
                "Benvenuti",
                "Berlincioni",
                "Bernacchioni",
                "Bernardi",
                "Bernardini",
                "Berni",
                "Bernini",
                "Bertelli",
                "Berti",
                "Bertini",
                "Bessi",
                "Betti",
                "Bettini",
                "Biagi",
                "Biagini",
                "Biagioni",
                "Biagiotti",
                "Biancalani",
                "Bianchi",
                "Bianchini",
                "Bianco",
                "Biffoli",
                "Bigazzi",
                "Bigi",
                "Biliotti",
                "Billi",
                "Binazzi",
                "Bindi",
                "Bini",
                "Biondi",
                "Bizzarri",
                "Bocci",
                "Bogani",
                "Bolognesi",
                "Bonaiuti",
                "Bonanni",
                "Bonciani",
                "Boncinelli",
                "Bondi",
                "Bonechi",
                "Bongini",
                "Boni",
                "Bonini",
                "Borchi",
                "Boretti",
                "Borghi",
                "Borghini",
                "Borgioli",
                "Borri",
                "Borselli",
                "Boschi",
                "Bottai",
                "Bracci",
                "Braccini",
                "Brandi",
                "Braschi",
                "Bravi",
                "Brazzini",
                "Breschi",
                "Brilli",
                "Brizzi",
                "Brogelli",
                "Brogi",
                "Brogioni",
                "Brunelli",
                "Brunetti",
                "Bruni",
                "Bruno",
                "Brunori",
                "Bruschi",
                "Bucci",
                "Bucciarelli",
                "Buccioni",
                "Bucelli",
                "Bulli",
                "Burberi",
                "Burchi",
                "Burgassi",
                "Burroni",
                "Bussotti",
                "Buti",
                "Caciolli",
                "Caiani",
                "Calabrese",
                "Calamai",
                "Calamandrei",
                "Caldini",
                "Calo'",
                "Calonaci",
                "Calosi",
                "Calvelli",
                "Cambi",
                "Camiciottoli",
                "Cammelli",
                "Cammilli",
                "Campolmi",
                "Cantini",
                "Capanni",
                "Capecchi",
                "Caponi",
                "Cappelletti",
                "Cappelli",
                "Cappellini",
                "Cappugi",
                "Capretti",
                "Caputo",
                "Carbone",
                "Carboni",
                "Cardini",
                "Carlesi",
                "Carletti",
                "Carli",
                "Caroti",
                "Carotti",
                "Carrai",
                "Carraresi",
                "Carta",
                "Caruso",
                "Casalini",
                "Casati",
                "Caselli",
                "Casini",
                "Castagnoli",
                "Castellani",
                "Castelli",
                "Castellucci",
                "Catalano",
                "Catarzi",
                "Catelani",
                "Cavaciocchi",
                "Cavallaro",
                "Cavallini",
                "Cavicchi",
                "Cavini",
                "Ceccarelli",
                "Ceccatelli",
                "Ceccherelli",
                "Ceccherini",
                "Cecchi",
                "Cecchini",
                "Cecconi",
                "Cei",
                "Cellai",
                "Celli",
                "Cellini",
                "Cencetti",
                "Ceni",
                "Cenni",
                "Cerbai",
                "Cesari",
                "Ceseri",
                "Checcacci",
                "Checchi",
                "Checcucci",
                "Cheli",
                "Chellini",
                "Chen",
                "Cheng",
                "Cherici",
                "Cherubini",
                "Chiaramonti",
                "Chiarantini",
                "Chiarelli",
                "Chiari",
                "Chiarini",
                "Chiarugi",
                "Chiavacci",
                "Chiesi",
                "Chimenti",
                "Chini",
                "Chirici",
                "Chiti",
                "Ciabatti",
                "Ciampi",
                "Cianchi",
                "Cianfanelli",
                "Cianferoni",
                "Ciani",
                "Ciapetti",
                "Ciappi",
                "Ciardi",
                "Ciatti",
                "Cicali",
                "Ciccone",
                "Cinelli",
                "Cini",
                "Ciobanu",
                "Ciolli",
                "Cioni",
                "Cipriani",
                "Cirillo",
                "Cirri",
                "Ciucchi",
                "Ciuffi",
                "Ciulli",
                "Ciullini",
                "Clemente",
                "Cocchi",
                "Cognome",
                "Coli",
                "Collini",
                "Colombo",
                "Colzi",
                "Comparini",
                "Conforti",
                "Consigli",
                "Conte",
                "Conti",
                "Contini",
                "Coppini",
                "Coppola",
                "Corsi",
                "Corsini",
                "Corti",
                "Cortini",
                "Cosi",
                "Costa",
                "Costantini",
                "Costantino",
                "Cozzi",
                "Cresci",
                "Crescioli",
                "Cresti",
                "Crini",
                "Curradi",
                "D'Agostino",
                "D'Alessandro",
                "D'Amico",
                "D'Angelo",
                "Daddi",
                "Dainelli",
                "Dallai",
                "Danti",
                "Davitti",
                "De Angelis",
                "De Luca",
                "De Marco",
                "De Rosa",
                "De Santis",
                "De Simone",
                "De Vita",
                "Degl'Innocenti",
                "Degli Innocenti",
                "Dei",
                "Del Lungo",
                "Del Re",
                "Di Marco",
                "Di Stefano",
                "Dini",
                "Diop",
                "Dobre",
                "Dolfi",
                "Donati",
                "Dondoli",
                "Dong",
                "Donnini",
                "Ducci",
                "Dumitru",
                "Ermini",
                "Esposito",
                "Evangelisti",
                "Fabbri",
                "Fabbrini",
                "Fabbrizzi",
                "Fabbroni",
                "Fabbrucci",
                "Fabiani",
                "Facchini",
                "Faggi",
                "Fagioli",
                "Failli",
                "Faini",
                "Falciani",
                "Falcini",
                "Falcone",
                "Fallani",
                "Falorni",
                "Falsini",
                "Falugiani",
                "Fancelli",
                "Fanelli",
                "Fanetti",
                "Fanfani",
                "Fani",
                "Fantappie'",
                "Fantechi",
                "Fanti",
                "Fantini",
                "Fantoni",
                "Farina",
                "Fattori",
                "Favilli",
                "Fedi",
                "Fei",
                "Ferrante",
                "Ferrara",
                "Ferrari",
                "Ferraro",
                "Ferretti",
                "Ferri",
                "Ferrini",
                "Ferroni",
                "Fiaschi",
                "Fibbi",
                "Fiesoli",
                "Filippi",
                "Filippini",
                "Fini",
                "Fioravanti",
                "Fiore",
                "Fiorentini",
                "Fiorini",
                "Fissi",
                "Focardi",
                "Foggi",
                "Fontana",
                "Fontanelli",
                "Fontani",
                "Forconi",
                "Formigli",
                "Forte",
                "Forti",
                "Fortini",
                "Fossati",
                "Fossi",
                "Francalanci",
                "Franceschi",
                "Franceschini",
                "Franchi",
                "Franchini",
                "Franci",
                "Francini",
                "Francioni",
                "Franco",
                "Frassineti",
                "Frati",
                "Fratini",
                "Frilli",
                "Frizzi",
                "Frosali",
                "Frosini",
                "Frullini",
                "Fusco",
                "Fusi",
                "Gabbrielli",
                "Gabellini",
                "Gagliardi",
                "Galanti",
                "Galardi",
                "Galeotti",
                "Galletti",
                "Galli",
                "Gallo",
                "Gallori",
                "Gambacciani",
                "Gargani",
                "Garofalo",
                "Garuglieri",
                "Gashi",
                "Gasperini",
                "Gatti",
                "Gelli",
                "Gensini",
                "Gentile",
                "Gentili",
                "Geri",
                "Gerini",
                "Gheri",
                "Ghini",
                "Giachetti",
                "Giachi",
                "Giacomelli",
                "Gianassi",
                "Giani",
                "Giannelli",
                "Giannetti",
                "Gianni",
                "Giannini",
                "Giannoni",
                "Giannotti",
                "Giannozzi",
                "Gigli",
                "Giordano",
                "Giorgetti",
                "Giorgi",
                "Giovacchini",
                "Giovannelli",
                "Giovannetti",
                "Giovannini",
                "Giovannoni",
                "Giuliani",
                "Giunti",
                "Giuntini",
                "Giusti",
                "Gonnelli",
                "Goretti",
                "Gori",
                "Gradi",
                "Gramigni",
                "Grassi",
                "Grasso",
                "Graziani",
                "Grazzini",
                "Greco",
                "Grifoni",
                "Grillo",
                "Grimaldi",
                "Grossi",
                "Gualtieri",
                "Guarducci",
                "Guarino",
                "Guarnieri",
                "Guasti",
                "Guerra",
                "Guerri",
                "Guerrini",
                "Guidi",
                "Guidotti",
                "He",
                "Hoxha",
                "Hu",
                "Huang",
                "Iandelli",
                "Ignesti",
                "Innocenti",
                "Jin",
                "La Rosa",
                "Lai",
                "Landi",
                "Landini",
                "Lanini",
                "Lapi",
                "Lapini",
                "Lari",
                "Lascialfari",
                "Lastrucci",
                "Latini",
                "Lazzeri",
                "Lazzerini",
                "Lelli",
                "Lenzi",
                "Leonardi",
                "Leoncini",
                "Leone",
                "Leoni",
                "Lepri",
                "Li",
                "Liao",
                "Lin",
                "Linari",
                "Lippi",
                "Lisi",
                "Livi",
                "Lombardi",
                "Lombardini",
                "Lombardo",
                "Longo",
                "Lopez",
                "Lorenzi",
                "Lorenzini",
                "Lorini",
                "Lotti",
                "Lu",
                "Lucchesi",
                "Lucherini",
                "Lunghi",
                "Lupi",
                "Madiai",
                "Maestrini",
                "Maffei",
                "Maggi",
                "Maggini",
                "Magherini",
                "Magini",
                "Magnani",
                "Magnelli",
                "Magni",
                "Magnolfi",
                "Magrini",
                "Malavolti",
                "Malevolti",
                "Manca",
                "Mancini",
                "Manetti",
                "Manfredi",
                "Mangani",
                "Mannelli",
                "Manni",
                "Mannini",
                "Mannucci",
                "Manuelli",
                "Manzini",
                "Marcelli",
                "Marchese",
                "Marchetti",
                "Marchi",
                "Marchiani",
                "Marchionni",
                "Marconi",
                "Marcucci",
                "Margheri",
                "Mari",
                "Mariani",
                "Marilli",
                "Marinai",
                "Marinari",
                "Marinelli",
                "Marini",
                "Marino",
                "Mariotti",
                "Marsili",
                "Martelli",
                "Martinelli",
                "Martini",
                "Martino",
                "Marzi",
                "Masi",
                "Masini",
                "Masoni",
                "Massai",
                "Materassi",
                "Mattei",
                "Matteini",
                "Matteucci",
                "Matteuzzi",
                "Mattioli",
                "Mattolini",
                "Matucci",
                "Mauro",
                "Mazzanti",
                "Mazzei",
                "Mazzetti",
                "Mazzi",
                "Mazzini",
                "Mazzocchi",
                "Mazzoli",
                "Mazzoni",
                "Mazzuoli",
                "Meacci",
                "Mecocci",
                "Meini",
                "Melani",
                "Mele",
                "Meli",
                "Mengoni",
                "Menichetti",
                "Meoni",
                "Merlini",
                "Messeri",
                "Messina",
                "Meucci",
                "Miccinesi",
                "Miceli",
                "Micheli",
                "Michelini",
                "Michelozzi",
                "Migliori",
                "Migliorini",
                "Milani",
                "Miniati",
                "Misuri",
                "Monaco",
                "Montagnani",
                "Montagni",
                "Montanari",
                "Montelatici",
                "Monti",
                "Montigiani",
                "Montini",
                "Morandi",
                "Morandini",
                "Morelli",
                "Moretti",
                "Morganti",
                "Mori",
                "Morini",
                "Moroni",
                "Morozzi",
                "Mugnai",
                "Mugnaini",
                "Mustafa",
                "Naldi",
                "Naldini",
                "Nannelli",
                "Nanni",
                "Nannini",
                "Nannucci",
                "Nardi",
                "Nardini",
                "Nardoni",
                "Natali",
                "Ndiaye",
                "Nencetti",
                "Nencini",
                "Nencioni",
                "Neri",
                "Nesi",
                "Nesti",
                "Niccolai",
                "Niccoli",
                "Niccolini",
                "Nigi",
                "Nistri",
                "Nocentini",
                "Noferini",
                "Novelli",
                "Nucci",
                "Nuti",
                "Nutini",
                "Oliva",
                "Olivieri",
                "Olmi",
                "Orlandi",
                "Orlandini",
                "Orlando",
                "Orsini",
                "Ortolani",
                "Ottanelli",
                "Pacciani",
                "Pace",
                "Paci",
                "Pacini",
                "Pagani",
                "Pagano",
                "Paggetti",
                "Pagliai",
                "Pagni",
                "Pagnini",
                "Paladini",
                "Palagi",
                "Palchetti",
                "Palloni",
                "Palmieri",
                "Palumbo",
                "Pampaloni",
                "Pancani",
                "Pandolfi",
                "Pandolfini",
                "Panerai",
                "Panichi",
                "Paoletti",
                "Paoli",
                "Paolini",
                "Papi",
                "Papini",
                "Papucci",
                "Parenti",
                "Parigi",
                "Parisi",
                "Parri",
                "Parrini",
                "Pasquini",
                "Passeri",
                "Pecchioli",
                "Pecorini",
                "Pellegrini",
                "Pepi",
                "Perini",
                "Perrone",
                "Peruzzi",
                "Pesci",
                "Pestelli",
                "Petri",
                "Petrini",
                "Petrucci",
                "Pettini",
                "Pezzati",
                "Pezzatini",
                "Piani",
                "Piazza",
                "Piazzesi",
                "Piazzini",
                "Piccardi",
                "Picchi",
                "Piccini",
                "Piccioli",
                "Pieraccini",
                "Pieraccioni",
                "Pieralli",
                "Pierattini",
                "Pieri",
                "Pierini",
                "Pieroni",
                "Pietrini",
                "Pini",
                "Pinna",
                "Pinto",
                "Pinzani",
                "Pinzauti",
                "Piras",
                "Pisani",
                "Pistolesi",
                "Poggesi",
                "Poggi",
                "Poggiali",
                "Poggiolini",
                "Poli",
                "Pollastri",
                "Porciani",
                "Pozzi",
                "Pratellesi",
                "Pratesi",
                "Prosperi",
                "Pruneti",
                "Pucci",
                "Puccini",
                "Puccioni",
                "Pugi",
                "Pugliese",
                "Puliti",
                "Querci",
                "Quercioli",
                "Raddi",
                "Radu",
                "Raffaelli",
                "Ragazzini",
                "Ranfagni",
                "Ranieri",
                "Rastrelli",
                "Raugei",
                "Raveggi",
                "Renai",
                "Renzi",
                "Rettori",
                "Ricci",
                "Ricciardi",
                "Ridi",
                "Ridolfi",
                "Rigacci",
                "Righi",
                "Righini",
                "Rinaldi",
                "Risaliti",
                "Ristori",
                "Rizzo",
                "Rocchi",
                "Rocchini",
                "Rogai",
                "Romagnoli",
                "Romanelli",
                "Romani",
                "Romano",
                "Romei",
                "Romeo",
                "Romiti",
                "Romoli",
                "Romolini",
                "Rontini",
                "Rosati",
                "Roselli",
                "Rosi",
                "Rossetti",
                "Rossi",
                "Rossini",
                "Rovai",
                "Ruggeri",
                "Ruggiero",
                "Russo",
                "Sabatini",
                "Saccardi",
                "Sacchetti",
                "Sacchi",
                "Sacco",
                "Salerno",
                "Salimbeni",
                "Salucci",
                "Salvadori",
                "Salvestrini",
                "Salvi",
                "Salvini",
                "Sanesi",
                "Sani",
                "Sanna",
                "Santi",
                "Santini",
                "Santoni",
                "Santoro",
                "Santucci",
                "Sardi",
                "Sarri",
                "Sarti",
                "Sassi",
                "Sbolci",
                "Scali",
                "Scarpelli",
                "Scarselli",
                "Scopetani",
                "Secci",
                "Selvi",
                "Senatori",
                "Senesi",
                "Serafini",
                "Sereni",
                "Serra",
                "Sestini",
                "Sguanci",
                "Sieni",
                "Signorini",
                "Silvestri",
                "Simoncini",
                "Simonetti",
                "Simoni",
                "Singh",
                "Sodi",
                "Soldi",
                "Somigli",
                "Sorbi",
                "Sorelli",
                "Sorrentino",
                "Sottili",
                "Spina",
                "Spinelli",
                "Staccioli",
                "Staderini",
                "Stefanelli",
                "Stefani",
                "Stefanini",
                "Stella",
                "Susini",
                "Tacchi",
                "Tacconi",
                "Taddei",
                "Tagliaferri",
                "Tamburini",
                "Tanganelli",
                "Tani",
                "Tanini",
                "Tapinassi",
                "Tarchi",
                "Tarchiani",
                "Targioni",
                "Tassi",
                "Tassini",
                "Tempesti",
                "Terzani",
                "Tesi",
                "Testa",
                "Testi",
                "Tilli",
                "Tinti",
                "Tirinnanzi",
                "Toccafondi",
                "Tofanari",
                "Tofani",
                "Tognaccini",
                "Tonelli",
                "Tonini",
                "Torelli",
                "Torrini",
                "Tosi",
                "Toti",
                "Tozzi",
                "Trambusti",
                "Trapani",
                "Tucci",
                "Turchi",
                "Ugolini",
                "Ulivi",
                "Valente",
                "Valenti",
                "Valentini",
                "Vangelisti",
                "Vanni",
                "Vannini",
                "Vannoni",
                "Vannozzi",
                "Vannucchi",
                "Vannucci",
                "Ventura",
                "Venturi",
                "Venturini",
                "Vestri",
                "Vettori",
                "Vichi",
                "Viciani",
                "Vieri",
                "Vigiani",
                "Vignoli",
                "Vignolini",
                "Vignozzi",
                "Villani",
                "Vinci",
                "Visani",
                "Vitale",
                "Vitali",
                "Viti",
                "Viviani",
                "Vivoli",
                "Volpe",
                "Volpi",
                "Wang",
                "Wu",
                "Xu",
                "Yang",
                "Ye",
                "Zagli",
                "Zani",
                "Zanieri",
                "Zanobini",
                "Zecchi",
                "Zetti",
                "Zhang",
                "Zheng",
                "Zhou",
                "Zhu",
                "Zingoni",
                "Zini",
                "Zoppi"
            ],
            // http://www.voornamelijk.nl/meest-voorkomende-achternamen-in-nederland-en-amsterdam/
            "nl": [
                "Albers",
                "Alblas",
                "Appelman",
                "Baars",
                "Baas",
                "Bakker",
                "Blank",
                "Bleeker",
                "Blok",
                "Blom",
                "Boer",
                "Boers",
                "Boldewijn",
                "Boon",
                "Boot",
                "Bos",
                "Bosch",
                "Bosma",
                "Bosman",
                "Bouma",
                "Bouman",
                "Bouwman",
                "Brands",
                "Brouwer",
                "Burger",
                "Buijs",
                "Buitenhuis",
                "Ceder",
                "Cohen",
                "Dekker",
                "Dekkers",
                "Dijkman",
                "Dijkstra",
                "Driessen",
                "Drost",
                "Engel",
                "Evers",
                "Faber",
                "Franke",
                "Gerritsen",
                "Goedhart",
                "Goossens",
                "Groen",
                "Groenenberg",
                "Groot",
                "Haan",
                "Hart",
                "Heemskerk",
                "Hendriks",
                "Hermans",
                "Hoekstra",
                "Hofman",
                "Hopman",
                "Huisman",
                "Jacobs",
                "Jansen",
                "Janssen",
                "Jonker",
                "Jaspers",
                "Keijzer",
                "Klaassen",
                "Klein",
                "Koek",
                "Koenders",
                "Kok",
                "Kool",
                "Koopman",
                "Koopmans",
                "Koning",
                "Koster",
                "Kramer",
                "Kroon",
                "Kuijpers",
                "Kuiper",
                "Kuipers",
                "Kurt",
                "Koster",
                "Kwakman",
                "Los",
                "Lubbers",
                "Maas",
                "Markus",
                "Martens",
                "Meijer",
                "Mol",
                "Molenaar",
                "Mulder",
                "Nieuwenhuis",
                "Peeters",
                "Peters",
                "Pengel",
                "Pieters",
                "Pool",
                "Post",
                "Postma",
                "Prins",
                "Pronk",
                "Reijnders",
                "Rietveld",
                "Roest",
                "Roos",
                "Sanders",
                "Schaap",
                "Scheffer",
                "Schenk",
                "Schilder",
                "Schipper",
                "Schmidt",
                "Scholten",
                "Schouten",
                "Schut",
                "Schutte",
                "Schuurman",
                "Simons",
                "Smeets",
                "Smit",
                "Smits",
                "Snel",
                "Swinkels",
                "Tas",
                "Terpstra",
                "Timmermans",
                "Tol",
                "Tromp",
                "Troost",
                "Valk",
                "Veenstra",
                "Veldkamp",
                "Verbeek",
                "Verheul",
                "Verhoeven",
                "Vermeer",
                "Vermeulen",
                "Verweij",
                "Vink",
                "Visser",
                "Voorn",
                "Vos",
                "Wagenaar",
                "Wiersema",
                "Willems",
                "Willemsen",
                "Witteveen",
                "Wolff",
                "Wolters",
                "Zijlstra",
                "Zwart",
                "de Beer",
                "de Boer",
                "de Bruijn",
                "de Bruin",
                "de Graaf",
                "de Groot",
                "de Haan",
                "de Haas",
                "de Jager",
                "de Jong",
                "de Jonge",
                "de Koning",
                "de Lange",
                "de Leeuw",
                "de Ridder",
                "de Rooij",
                "de Ruiter",
                "de Vos",
                "de Vries",
                "de Waal",
                "de Wit",
                "de Zwart",
                "van Beek",
                "van Boven",
                "van Dam",
                "van Dijk",
                "van Dongen",
                "van Doorn",
                "van Egmond",
                "van Eijk",
                "van Es",
                "van Gelder",
                "van Gelderen",
                "van Houten",
                "van Hulst",
                "van Kempen",
                "van Kesteren",
                "van Leeuwen",
                "van Loon",
                "van Mill",
                "van Noord",
                "van Ommen",
                "van Ommeren",
                "van Oosten",
                "van Oostveen",
                "van Rijn",
                "van Schaik",
                "van Veen",
                "van Vliet",
                "van Wijk",
                "van Wijngaarden",
                "van den Poel",
                "van de Pol",
                "van den Ploeg",
                "van de Ven",
                "van den Berg",
                "van den Bosch",
                "van den Brink",
                "van den Broek",
                "van den Heuvel",
                "van der Heijden",
                "van der Horst",
                "van der Hulst",
                "van der Kroon",
                "van der Laan",
                "van der Linden",
                "van der Meer",
                "van der Meij",
                "van der Meulen",
                "van der Molen",
                "van der Sluis",
                "van der Spek",
                "van der Veen",
                "van der Velde",
                "van der Velden",
                "van der Vliet",
                "van der Wal"
            ],
            // https://surnames.behindthename.com/top/lists/england-wales/1991
            "uk": [
                "Smith",
                "Jones",
                "Williams",
                "Taylor",
                "Brown",
                "Davies",
                "Evans",
                "Wilson",
                "Thomas",
                "Johnson",
                "Roberts",
                "Robinson",
                "Thompson",
                "Wright",
                "Walker",
                "White",
                "Edwards",
                "Hughes",
                "Green",
                "Hall",
                "Lewis",
                "Harris",
                "Clarke",
                "Patel",
                "Jackson",
                "Wood",
                "Turner",
                "Martin",
                "Cooper",
                "Hill",
                "Ward",
                "Morris",
                "Moore",
                "Clark",
                "Lee",
                "King",
                "Baker",
                "Harrison",
                "Morgan",
                "Allen",
                "James",
                "Scott",
                "Phillips",
                "Watson",
                "Davis",
                "Parker",
                "Price",
                "Bennett",
                "Young",
                "Griffiths",
                "Mitchell",
                "Kelly",
                "Cook",
                "Carter",
                "Richardson",
                "Bailey",
                "Collins",
                "Bell",
                "Shaw",
                "Murphy",
                "Miller",
                "Cox",
                "Richards",
                "Khan",
                "Marshall",
                "Anderson",
                "Simpson",
                "Ellis",
                "Adams",
                "Singh",
                "Begum",
                "Wilkinson",
                "Foster",
                "Chapman",
                "Powell",
                "Webb",
                "Rogers",
                "Gray",
                "Mason",
                "Ali",
                "Hunt",
                "Hussain",
                "Campbell",
                "Matthews",
                "Owen",
                "Palmer",
                "Holmes",
                "Mills",
                "Barnes",
                "Knight",
                "Lloyd",
                "Butler",
                "Russell",
                "Barker",
                "Fisher",
                "Stevens",
                "Jenkins",
                "Murray",
                "Dixon",
                "Harvey",
                "Graham",
                "Pearson",
                "Ahmed",
                "Fletcher",
                "Walsh",
                "Kaur",
                "Gibson",
                "Howard",
                "Andrews",
                "Stewart",
                "Elliott",
                "Reynolds",
                "Saunders",
                "Payne",
                "Fox",
                "Ford",
                "Pearce",
                "Day",
                "Brooks",
                "West",
                "Lawrence",
                "Cole",
                "Atkinson",
                "Bradley",
                "Spencer",
                "Gill",
                "Dawson",
                "Ball",
                "Burton",
                "O'brien",
                "Watts",
                "Rose",
                "Booth",
                "Perry",
                "Ryan",
                "Grant",
                "Wells",
                "Armstrong",
                "Francis",
                "Rees",
                "Hayes",
                "Hart",
                "Hudson",
                "Newman",
                "Barrett",
                "Webster",
                "Hunter",
                "Gregory",
                "Carr",
                "Lowe",
                "Page",
                "Marsh",
                "Riley",
                "Dunn",
                "Woods",
                "Parsons",
                "Berry",
                "Stone",
                "Reid",
                "Holland",
                "Hawkins",
                "Harding",
                "Porter",
                "Robertson",
                "Newton",
                "Oliver",
                "Reed",
                "Kennedy",
                "Williamson",
                "Bird",
                "Gardner",
                "Shah",
                "Dean",
                "Lane",
                "Cooke",
                "Bates",
                "Henderson",
                "Parry",
                "Burgess",
                "Bishop",
                "Walton",
                "Burns",
                "Nicholson",
                "Shepherd",
                "Ross",
                "Cross",
                "Long",
                "Freeman",
                "Warren",
                "Nicholls",
                "Hamilton",
                "Byrne",
                "Sutton",
                "Mcdonald",
                "Yates",
                "Hodgson",
                "Robson",
                "Curtis",
                "Hopkins",
                "O'connor",
                "Harper",
                "Coleman",
                "Watkins",
                "Moss",
                "Mccarthy",
                "Chambers",
                "O'neill",
                "Griffin",
                "Sharp",
                "Hardy",
                "Wheeler",
                "Potter",
                "Osborne",
                "Johnston",
                "Gordon",
                "Doyle",
                "Wallace",
                "George",
                "Jordan",
                "Hutchinson",
                "Rowe",
                "Burke",
                "May",
                "Pritchard",
                "Gilbert",
                "Willis",
                "Higgins",
                "Read",
                "Miles",
                "Stevenson",
                "Stephenson",
                "Hammond",
                "Arnold",
                "Buckley",
                "Walters",
                "Hewitt",
                "Barber",
                "Nelson",
                "Slater",
                "Austin",
                "Sullivan",
                "Whitehead",
                "Mann",
                "Frost",
                "Lambert",
                "Stephens",
                "Blake",
                "Akhtar",
                "Lynch",
                "Goodwin",
                "Barton",
                "Woodward",
                "Thomson",
                "Cunningham",
                "Quinn",
                "Barnett",
                "Baxter",
                "Bibi",
                "Clayton",
                "Nash",
                "Greenwood",
                "Jennings",
                "Holt",
                "Kemp",
                "Poole",
                "Gallagher",
                "Bond",
                "Stokes",
                "Tucker",
                "Davidson",
                "Fowler",
                "Heath",
                "Norman",
                "Middleton",
                "Lawson",
                "Banks",
                "French",
                "Stanley",
                "Jarvis",
                "Gibbs",
                "Ferguson",
                "Hayward",
                "Carroll",
                "Douglas",
                "Dickinson",
                "Todd",
                "Barlow",
                "Peters",
                "Lucas",
                "Knowles",
                "Hartley",
                "Miah",
                "Simmons",
                "Morton",
                "Alexander",
                "Field",
                "Morrison",
                "Norris",
                "Townsend",
                "Preston",
                "Hancock",
                "Thornton",
                "Baldwin",
                "Burrows",
                "Briggs",
                "Parkinson",
                "Reeves",
                "Macdonald",
                "Lamb",
                "Black",
                "Abbott",
                "Sanders",
                "Thorpe",
                "Holden",
                "Tomlinson",
                "Perkins",
                "Ashton",
                "Rhodes",
                "Fuller",
                "Howe",
                "Bryant",
                "Vaughan",
                "Dale",
                "Davey",
                "Weston",
                "Bartlett",
                "Whittaker",
                "Davison",
                "Kent",
                "Skinner",
                "Birch",
                "Morley",
                "Daniels",
                "Glover",
                "Howell",
                "Cartwright",
                "Pugh",
                "Humphreys",
                "Goddard",
                "Brennan",
                "Wall",
                "Kirby",
                "Bowen",
                "Savage",
                "Bull",
                "Wong",
                "Dobson",
                "Smart",
                "Wilkins",
                "Kirk",
                "Fraser",
                "Duffy",
                "Hicks",
                "Patterson",
                "Bradshaw",
                "Little",
                "Archer",
                "Warner",
                "Waters",
                "O'sullivan",
                "Farrell",
                "Brookes",
                "Atkins",
                "Kay",
                "Dodd",
                "Bentley",
                "Flynn",
                "John",
                "Schofield",
                "Short",
                "Haynes",
                "Wade",
                "Butcher",
                "Henry",
                "Sanderson",
                "Crawford",
                "Sheppard",
                "Bolton",
                "Coates",
                "Giles",
                "Gould",
                "Houghton",
                "Gibbons",
                "Pratt",
                "Manning",
                "Law",
                "Hooper",
                "Noble",
                "Dyer",
                "Rahman",
                "Clements",
                "Moran",
                "Sykes",
                "Chan",
                "Doherty",
                "Connolly",
                "Joyce",
                "Franklin",
                "Hobbs",
                "Coles",
                "Herbert",
                "Steele",
                "Kerr",
                "Leach",
                "Winter",
                "Owens",
                "Duncan",
                "Naylor",
                "Fleming",
                "Horton",
                "Finch",
                "Fitzgerald",
                "Randall",
                "Carpenter",
                "Marsden",
                "Browne",
                "Garner",
                "Pickering",
                "Hale",
                "Dennis",
                "Vincent",
                "Chadwick",
                "Chandler",
                "Sharpe",
                "Nolan",
                "Lyons",
                "Hurst",
                "Collier",
                "Peacock",
                "Howarth",
                "Faulkner",
                "Rice",
                "Pollard",
                "Welch",
                "Norton",
                "Gough",
                "Sinclair",
                "Blackburn",
                "Bryan",
                "Conway",
                "Power",
                "Cameron",
                "Daly",
                "Allan",
                "Hanson",
                "Gardiner",
                "Boyle",
                "Myers",
                "Turnbull",
                "Wallis",
                "Mahmood",
                "Sims",
                "Swift",
                "Iqbal",
                "Pope",
                "Brady",
                "Chamberlain",
                "Rowley",
                "Tyler",
                "Farmer",
                "Metcalfe",
                "Hilton",
                "Godfrey",
                "Holloway",
                "Parkin",
                "Bray",
                "Talbot",
                "Donnelly",
                "Nixon",
                "Charlton",
                "Benson",
                "Whitehouse",
                "Barry",
                "Hope",
                "Lord",
                "North",
                "Storey",
                "Connor",
                "Potts",
                "Bevan",
                "Hargreaves",
                "Mclean",
                "Mistry",
                "Bruce",
                "Howells",
                "Hyde",
                "Parkes",
                "Wyatt",
                "Fry",
                "Lees",
                "O'donnell",
                "Craig",
                "Forster",
                "Mckenzie",
                "Humphries",
                "Mellor",
                "Carey",
                "Ingram",
                "Summers",
                "Leonard"
            ],
            // https://surnames.behindthename.com/top/lists/germany/2017
            "de": [
                "M\xfcller",
                "Schmidt",
                "Schneider",
                "Fischer",
                "Weber",
                "Meyer",
                "Wagner",
                "Becker",
                "Schulz",
                "Hoffmann",
                "Sch\xe4fer",
                "Koch",
                "Bauer",
                "Richter",
                "Klein",
                "Wolf",
                "Schr\xf6der",
                "Neumann",
                "Schwarz",
                "Zimmermann",
                "Braun",
                "Kr\xfcger",
                "Hofmann",
                "Hartmann",
                "Lange",
                "Schmitt",
                "Werner",
                "Schmitz",
                "Krause",
                "Meier",
                "Lehmann",
                "Schmid",
                "Schulze",
                "Maier",
                "K\xf6hler",
                "Herrmann",
                "K\xf6nig",
                "Walter",
                "Mayer",
                "Huber",
                "Kaiser",
                "Fuchs",
                "Peters",
                "Lang",
                "Scholz",
                "M\xf6ller",
                "Wei\xdf",
                "Jung",
                "Hahn",
                "Schubert",
                "Vogel",
                "Friedrich",
                "Keller",
                "G\xfcnther",
                "Frank",
                "Berger",
                "Winkler",
                "Roth",
                "Beck",
                "Lorenz",
                "Baumann",
                "Franke",
                "Albrecht",
                "Schuster",
                "Simon",
                "Ludwig",
                "B\xf6hm",
                "Winter",
                "Kraus",
                "Martin",
                "Schumacher",
                "Kr\xe4mer",
                "Vogt",
                "Stein",
                "J\xe4ger",
                "Otto",
                "Sommer",
                "Gro\xdf",
                "Seidel",
                "Heinrich",
                "Brandt",
                "Haas",
                "Schreiber",
                "Graf",
                "Schulte",
                "Dietrich",
                "Ziegler",
                "Kuhn",
                "K\xfchn",
                "Pohl",
                "Engel",
                "Horn",
                "Busch",
                "Bergmann",
                "Thomas",
                "Voigt",
                "Sauer",
                "Arnold",
                "Wolff",
                "Pfeiffer"
            ],
            // http://www.japantimes.co.jp/life/2009/10/11/lifestyle/japans-top-100-most-common-family-names/
            "jp": [
                "Sato",
                "Suzuki",
                "Takahashi",
                "Tanaka",
                "Watanabe",
                "Ito",
                "Yamamoto",
                "Nakamura",
                "Kobayashi",
                "Kato",
                "Yoshida",
                "Yamada",
                "Sasaki",
                "Yamaguchi",
                "Saito",
                "Matsumoto",
                "Inoue",
                "Kimura",
                "Hayashi",
                "Shimizu",
                "Yamazaki",
                "Mori",
                "Abe",
                "Ikeda",
                "Hashimoto",
                "Yamashita",
                "Ishikawa",
                "Nakajima",
                "Maeda",
                "Fujita",
                "Ogawa",
                "Goto",
                "Okada",
                "Hasegawa",
                "Murakami",
                "Kondo",
                "Ishii",
                "Saito",
                "Sakamoto",
                "Endo",
                "Aoki",
                "Fujii",
                "Nishimura",
                "Fukuda",
                "Ota",
                "Miura",
                "Fujiwara",
                "Okamoto",
                "Matsuda",
                "Nakagawa",
                "Nakano",
                "Harada",
                "Ono",
                "Tamura",
                "Takeuchi",
                "Kaneko",
                "Wada",
                "Nakayama",
                "Ishida",
                "Ueda",
                "Morita",
                "Hara",
                "Shibata",
                "Sakai",
                "Kudo",
                "Yokoyama",
                "Miyazaki",
                "Miyamoto",
                "Uchida",
                "Takagi",
                "Ando",
                "Taniguchi",
                "Ohno",
                "Maruyama",
                "Imai",
                "Takada",
                "Fujimoto",
                "Takeda",
                "Murata",
                "Ueno",
                "Sugiyama",
                "Masuda",
                "Sugawara",
                "Hirano",
                "Kojima",
                "Otsuka",
                "Chiba",
                "Kubo",
                "Matsui",
                "Iwasaki",
                "Sakurai",
                "Kinoshita",
                "Noguchi",
                "Matsuo",
                "Nomura",
                "Kikuchi",
                "Sano",
                "Onishi",
                "Sugimoto",
                "Arai"
            ],
            // http://www.lowchensaustralia.com/names/popular-spanish-names.htm
            "es": [
                "Garcia",
                "Fernandez",
                "Lopez",
                "Martinez",
                "Gonzalez",
                "Rodriguez",
                "Sanchez",
                "Perez",
                "Martin",
                "Gomez",
                "Ruiz",
                "Diaz",
                "Hernandez",
                "Alvarez",
                "Jimenez",
                "Moreno",
                "Munoz",
                "Alonso",
                "Romero",
                "Navarro",
                "Gutierrez",
                "Torres",
                "Dominguez",
                "Gil",
                "Vazquez",
                "Blanco",
                "Serrano",
                "Ramos",
                "Castro",
                "Suarez",
                "Sanz",
                "Rubio",
                "Ortega",
                "Molina",
                "Delgado",
                "Ortiz",
                "Morales",
                "Ramirez",
                "Marin",
                "Iglesias",
                "Santos",
                "Castillo",
                "Garrido",
                "Calvo",
                "Pena",
                "Cruz",
                "Cano",
                "Nunez",
                "Prieto",
                "Diez",
                "Lozano",
                "Vidal",
                "Pascual",
                "Ferrer",
                "Medina",
                "Vega",
                "Leon",
                "Herrero",
                "Vicente",
                "Mendez",
                "Guerrero",
                "Fuentes",
                "Campos",
                "Nieto",
                "Cortes",
                "Caballero",
                "Ibanez",
                "Lorenzo",
                "Pastor",
                "Gimenez",
                "Saez",
                "Soler",
                "Marquez",
                "Carrasco",
                "Herrera",
                "Montero",
                "Arias",
                "Crespo",
                "Flores",
                "Andres",
                "Aguilar",
                "Hidalgo",
                "Cabrera",
                "Mora",
                "Duran",
                "Velasco",
                "Rey",
                "Pardo",
                "Roman",
                "Vila",
                "Bravo",
                "Merino",
                "Moya",
                "Soto",
                "Izquierdo",
                "Reyes",
                "Redondo",
                "Marcos",
                "Carmona",
                "Menendez"
            ],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_des_noms_de_famille_les_plus_courants_en_France
            "fr": [
                "Martin",
                "Bernard",
                "Thomas",
                "Petit",
                "Robert",
                "Richard",
                "Durand",
                "Dubois",
                "Moreau",
                "Laurent",
                "Simon",
                "Michel",
                "Lef\xe8vre",
                "Leroy",
                "Roux",
                "David",
                "Bertrand",
                "Morel",
                "Fournier",
                "Girard",
                "Bonnet",
                "Dupont",
                "Lambert",
                "Fontaine",
                "Rousseau",
                "Vincent",
                "M\xfcller",
                "Lef\xe8vre",
                "Faure",
                "Andr\xe9",
                "Mercier",
                "Blanc",
                "Gu\xe9rin",
                "Boyer",
                "Garnier",
                "Chevalier",
                "Fran\xe7ois",
                "Legrand",
                "Gauthier",
                "Garcia",
                "Perrin",
                "Robin",
                "Cl\xe9ment",
                "Morin",
                "Nicolas",
                "Henry",
                "Roussel",
                "Matthieu",
                "Gautier",
                "Masson",
                "Marchand",
                "Duval",
                "Denis",
                "Dumont",
                "Marie",
                "Lemaire",
                "No\xebl",
                "Meyer",
                "Dufour",
                "Meunier",
                "Brun",
                "Blanchard",
                "Giraud",
                "Joly",
                "Rivi\xe8re",
                "Lucas",
                "Brunet",
                "Gaillard",
                "Barbier",
                "Arnaud",
                "Mart\xednez",
                "G\xe9rard",
                "Roche",
                "Renard",
                "Schmitt",
                "Roy",
                "Leroux",
                "Colin",
                "Vidal",
                "Caron",
                "Picard",
                "Roger",
                "Fabre",
                "Aubert",
                "Lemoine",
                "Renaud",
                "Dumas",
                "Lacroix",
                "Olivier",
                "Philippe",
                "Bourgeois",
                "Pierre",
                "Beno\xeet",
                "Rey",
                "Leclerc",
                "Payet",
                "Rolland",
                "Leclercq",
                "Guillaume",
                "Lecomte",
                "L\xf3pez",
                "Jean",
                "Dupuy",
                "Guillot",
                "Hubert",
                "Berger",
                "Carpentier",
                "S\xe1nchez",
                "Dupuis",
                "Moulin",
                "Louis",
                "Deschamps",
                "Huet",
                "Vasseur",
                "Perez",
                "Boucher",
                "Fleury",
                "Royer",
                "Klein",
                "Jacquet",
                "Adam",
                "Paris",
                "Poirier",
                "Marty",
                "Aubry",
                "Guyot",
                "Carr\xe9",
                "Charles",
                "Renault",
                "Charpentier",
                "M\xe9nard",
                "Maillard",
                "Baron",
                "Bertin",
                "Bailly",
                "Herv\xe9",
                "Schneider",
                "Fern\xe1ndez",
                "Le GallGall",
                "Collet",
                "L\xe9ger",
                "Bouvier",
                "Julien",
                "Pr\xe9vost",
                "Millet",
                "Perrot",
                "Daniel",
                "Le RouxRoux",
                "Cousin",
                "Germain",
                "Breton",
                "Besson",
                "Langlois",
                "R\xe9mi",
                "Le GoffGoff",
                "Pelletier",
                "L\xe9v\xeaque",
                "Perrier",
                "Leblanc",
                "Barr\xe9",
                "Lebrun",
                "Marchal",
                "Weber",
                "Mallet",
                "Hamon",
                "Boulanger",
                "Jacob",
                "Monnier",
                "Michaud",
                "Rodr\xedguez",
                "Guichard",
                "Gillet",
                "\xc9tienne",
                "Grondin",
                "Poulain",
                "Tessier",
                "Chevallier",
                "Collin",
                "Chauvin",
                "Da SilvaSilva",
                "Bouchet",
                "Gay",
                "Lema\xeetre",
                "B\xe9nard",
                "Mar\xe9chal",
                "Humbert",
                "Reynaud",
                "Antoine",
                "Hoarau",
                "Perret",
                "Barth\xe9lemy",
                "Cordier",
                "Pichon",
                "Lejeune",
                "Gilbert",
                "Lamy",
                "Delaunay",
                "Pasquier",
                "Carlier",
                "LaporteLaporte"
            ]
        },
        // Data taken from http://geoportal.statistics.gov.uk/datasets/ons-postcode-directory-latest-centroids
        postcodeAreas: [
            {
                code: 'AB'
            },
            {
                code: 'AL'
            },
            {
                code: 'B'
            },
            {
                code: 'BA'
            },
            {
                code: 'BB'
            },
            {
                code: 'BD'
            },
            {
                code: 'BH'
            },
            {
                code: 'BL'
            },
            {
                code: 'BN'
            },
            {
                code: 'BR'
            },
            {
                code: 'BS'
            },
            {
                code: 'BT'
            },
            {
                code: 'CA'
            },
            {
                code: 'CB'
            },
            {
                code: 'CF'
            },
            {
                code: 'CH'
            },
            {
                code: 'CM'
            },
            {
                code: 'CO'
            },
            {
                code: 'CR'
            },
            {
                code: 'CT'
            },
            {
                code: 'CV'
            },
            {
                code: 'CW'
            },
            {
                code: 'DA'
            },
            {
                code: 'DD'
            },
            {
                code: 'DE'
            },
            {
                code: 'DG'
            },
            {
                code: 'DH'
            },
            {
                code: 'DL'
            },
            {
                code: 'DN'
            },
            {
                code: 'DT'
            },
            {
                code: 'DY'
            },
            {
                code: 'E'
            },
            {
                code: 'EC'
            },
            {
                code: 'EH'
            },
            {
                code: 'EN'
            },
            {
                code: 'EX'
            },
            {
                code: 'FK'
            },
            {
                code: 'FY'
            },
            {
                code: 'G'
            },
            {
                code: 'GL'
            },
            {
                code: 'GU'
            },
            {
                code: 'GY'
            },
            {
                code: 'HA'
            },
            {
                code: 'HD'
            },
            {
                code: 'HG'
            },
            {
                code: 'HP'
            },
            {
                code: 'HR'
            },
            {
                code: 'HS'
            },
            {
                code: 'HU'
            },
            {
                code: 'HX'
            },
            {
                code: 'IG'
            },
            {
                code: 'IM'
            },
            {
                code: 'IP'
            },
            {
                code: 'IV'
            },
            {
                code: 'JE'
            },
            {
                code: 'KA'
            },
            {
                code: 'KT'
            },
            {
                code: 'KW'
            },
            {
                code: 'KY'
            },
            {
                code: 'L'
            },
            {
                code: 'LA'
            },
            {
                code: 'LD'
            },
            {
                code: 'LE'
            },
            {
                code: 'LL'
            },
            {
                code: 'LN'
            },
            {
                code: 'LS'
            },
            {
                code: 'LU'
            },
            {
                code: 'M'
            },
            {
                code: 'ME'
            },
            {
                code: 'MK'
            },
            {
                code: 'ML'
            },
            {
                code: 'N'
            },
            {
                code: 'NE'
            },
            {
                code: 'NG'
            },
            {
                code: 'NN'
            },
            {
                code: 'NP'
            },
            {
                code: 'NR'
            },
            {
                code: 'NW'
            },
            {
                code: 'OL'
            },
            {
                code: 'OX'
            },
            {
                code: 'PA'
            },
            {
                code: 'PE'
            },
            {
                code: 'PH'
            },
            {
                code: 'PL'
            },
            {
                code: 'PO'
            },
            {
                code: 'PR'
            },
            {
                code: 'RG'
            },
            {
                code: 'RH'
            },
            {
                code: 'RM'
            },
            {
                code: 'S'
            },
            {
                code: 'SA'
            },
            {
                code: 'SE'
            },
            {
                code: 'SG'
            },
            {
                code: 'SK'
            },
            {
                code: 'SL'
            },
            {
                code: 'SM'
            },
            {
                code: 'SN'
            },
            {
                code: 'SO'
            },
            {
                code: 'SP'
            },
            {
                code: 'SR'
            },
            {
                code: 'SS'
            },
            {
                code: 'ST'
            },
            {
                code: 'SW'
            },
            {
                code: 'SY'
            },
            {
                code: 'TA'
            },
            {
                code: 'TD'
            },
            {
                code: 'TF'
            },
            {
                code: 'TN'
            },
            {
                code: 'TQ'
            },
            {
                code: 'TR'
            },
            {
                code: 'TS'
            },
            {
                code: 'TW'
            },
            {
                code: 'UB'
            },
            {
                code: 'W'
            },
            {
                code: 'WA'
            },
            {
                code: 'WC'
            },
            {
                code: 'WD'
            },
            {
                code: 'WF'
            },
            {
                code: 'WN'
            },
            {
                code: 'WR'
            },
            {
                code: 'WS'
            },
            {
                code: 'WV'
            },
            {
                code: 'YO'
            },
            {
                code: 'ZE'
            }
        ],
        // Data taken from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        countries: [
            {
                "name": "Afghanistan",
                "abbreviation": "AF"
            },
            {
                "name": "\xc5land Islands",
                "abbreviation": "AX"
            },
            {
                "name": "Albania",
                "abbreviation": "AL"
            },
            {
                "name": "Algeria",
                "abbreviation": "DZ"
            },
            {
                "name": "American Samoa",
                "abbreviation": "AS"
            },
            {
                "name": "Andorra",
                "abbreviation": "AD"
            },
            {
                "name": "Angola",
                "abbreviation": "AO"
            },
            {
                "name": "Anguilla",
                "abbreviation": "AI"
            },
            {
                "name": "Antarctica",
                "abbreviation": "AQ"
            },
            {
                "name": "Antigua and Barbuda",
                "abbreviation": "AG"
            },
            {
                "name": "Argentina",
                "abbreviation": "AR"
            },
            {
                "name": "Armenia",
                "abbreviation": "AM"
            },
            {
                "name": "Aruba",
                "abbreviation": "AW"
            },
            {
                "name": "Australia",
                "abbreviation": "AU"
            },
            {
                "name": "Austria",
                "abbreviation": "AT"
            },
            {
                "name": "Azerbaijan",
                "abbreviation": "AZ"
            },
            {
                "name": "Bahamas",
                "abbreviation": "BS"
            },
            {
                "name": "Bahrain",
                "abbreviation": "BH"
            },
            {
                "name": "Bangladesh",
                "abbreviation": "BD"
            },
            {
                "name": "Barbados",
                "abbreviation": "BB"
            },
            {
                "name": "Belarus",
                "abbreviation": "BY"
            },
            {
                "name": "Belgium",
                "abbreviation": "BE"
            },
            {
                "name": "Belize",
                "abbreviation": "BZ"
            },
            {
                "name": "Benin",
                "abbreviation": "BJ"
            },
            {
                "name": "Bermuda",
                "abbreviation": "BM"
            },
            {
                "name": "Bhutan",
                "abbreviation": "BT"
            },
            {
                "name": "Plurinational State of Bolivia",
                "abbreviation": "BO"
            },
            {
                "name": "Bonaire, Sint Eustatius and Saba",
                "abbreviation": "BQ"
            },
            {
                "name": "Bosnia and Herzegovina",
                "abbreviation": "BA"
            },
            {
                "name": "Botswana",
                "abbreviation": "BW"
            },
            {
                "name": "Bouvet Island",
                "abbreviation": "BV"
            },
            {
                "name": "Brazil",
                "abbreviation": "BR"
            },
            {
                "name": "British Indian Ocean Territory",
                "abbreviation": "IO"
            },
            {
                "name": "Brunei Darussalam",
                "abbreviation": "BN"
            },
            {
                "name": "Bulgaria",
                "abbreviation": "BG"
            },
            {
                "name": "Burkina Faso",
                "abbreviation": "BF"
            },
            {
                "name": "Burundi",
                "abbreviation": "BI"
            },
            {
                "name": "Cabo Verde",
                "abbreviation": "CV"
            },
            {
                "name": "Cambodia",
                "abbreviation": "KH"
            },
            {
                "name": "Cameroon",
                "abbreviation": "CM"
            },
            {
                "name": "Canada",
                "abbreviation": "CA"
            },
            {
                "name": "Cayman Islands",
                "abbreviation": "KY"
            },
            {
                "name": "Central African Republic",
                "abbreviation": "CF"
            },
            {
                "name": "Chad",
                "abbreviation": "TD"
            },
            {
                "name": "Chile",
                "abbreviation": "CL"
            },
            {
                "name": "China",
                "abbreviation": "CN"
            },
            {
                "name": "Christmas Island",
                "abbreviation": "CX"
            },
            {
                "name": "Cocos (Keeling) Islands",
                "abbreviation": "CC"
            },
            {
                "name": "Colombia",
                "abbreviation": "CO"
            },
            {
                "name": "Comoros",
                "abbreviation": "KM"
            },
            {
                "name": "Congo",
                "abbreviation": "CG"
            },
            {
                "name": "Democratic Republic of the Congo",
                "abbreviation": "CD"
            },
            {
                "name": "Cook Islands",
                "abbreviation": "CK"
            },
            {
                "name": "Costa Rica",
                "abbreviation": "CR"
            },
            {
                "name": "C\xf4te d'Ivoire",
                "abbreviation": "CI"
            },
            {
                "name": "Croatia",
                "abbreviation": "HR"
            },
            {
                "name": "Cuba",
                "abbreviation": "CU"
            },
            {
                "name": "Cura\xe7ao",
                "abbreviation": "CW"
            },
            {
                "name": "Cyprus",
                "abbreviation": "CY"
            },
            {
                "name": "Czechia",
                "abbreviation": "CZ"
            },
            {
                "name": "Denmark",
                "abbreviation": "DK"
            },
            {
                "name": "Djibouti",
                "abbreviation": "DJ"
            },
            {
                "name": "Dominica",
                "abbreviation": "DM"
            },
            {
                "name": "Dominican Republic",
                "abbreviation": "DO"
            },
            {
                "name": "Ecuador",
                "abbreviation": "EC"
            },
            {
                "name": "Egypt",
                "abbreviation": "EG"
            },
            {
                "name": "El Salvador",
                "abbreviation": "SV"
            },
            {
                "name": "Equatorial Guinea",
                "abbreviation": "GQ"
            },
            {
                "name": "Eritrea",
                "abbreviation": "ER"
            },
            {
                "name": "Estonia",
                "abbreviation": "EE"
            },
            {
                "name": "Eswatini",
                "abbreviation": "SZ"
            },
            {
                "name": "Ethiopia",
                "abbreviation": "ET"
            },
            {
                "name": "Falkland Islands (Malvinas)",
                "abbreviation": "FK"
            },
            {
                "name": "Faroe Islands",
                "abbreviation": "FO"
            },
            {
                "name": "Fiji",
                "abbreviation": "FJ"
            },
            {
                "name": "Finland",
                "abbreviation": "FI"
            },
            {
                "name": "France",
                "abbreviation": "FR"
            },
            {
                "name": "French Guiana",
                "abbreviation": "GF"
            },
            {
                "name": "French Polynesia",
                "abbreviation": "PF"
            },
            {
                "name": "French Southern Territories",
                "abbreviation": "TF"
            },
            {
                "name": "Gabon",
                "abbreviation": "GA"
            },
            {
                "name": "Gambia",
                "abbreviation": "GM"
            },
            {
                "name": "Georgia",
                "abbreviation": "GE"
            },
            {
                "name": "Germany",
                "abbreviation": "DE"
            },
            {
                "name": "Ghana",
                "abbreviation": "GH"
            },
            {
                "name": "Gibraltar",
                "abbreviation": "GI"
            },
            {
                "name": "Greece",
                "abbreviation": "GR"
            },
            {
                "name": "Greenland",
                "abbreviation": "GL"
            },
            {
                "name": "Grenada",
                "abbreviation": "GD"
            },
            {
                "name": "Guadeloupe",
                "abbreviation": "GP"
            },
            {
                "name": "Guam",
                "abbreviation": "GU"
            },
            {
                "name": "Guatemala",
                "abbreviation": "GT"
            },
            {
                "name": "Guernsey",
                "abbreviation": "GG"
            },
            {
                "name": "Guinea",
                "abbreviation": "GN"
            },
            {
                "name": "Guinea-Bissau",
                "abbreviation": "GW"
            },
            {
                "name": "Guyana",
                "abbreviation": "GY"
            },
            {
                "name": "Haiti",
                "abbreviation": "HT"
            },
            {
                "name": "Heard Island and McDonald Islands",
                "abbreviation": "HM"
            },
            {
                "name": "Holy See",
                "abbreviation": "VA"
            },
            {
                "name": "Honduras",
                "abbreviation": "HN"
            },
            {
                "name": "Hong Kong",
                "abbreviation": "HK"
            },
            {
                "name": "Hungary",
                "abbreviation": "HU"
            },
            {
                "name": "Iceland",
                "abbreviation": "IS"
            },
            {
                "name": "India",
                "abbreviation": "IN"
            },
            {
                "name": "Indonesia",
                "abbreviation": "ID"
            },
            {
                "name": "Islamic Republic of Iran",
                "abbreviation": "IR"
            },
            {
                "name": "Iraq",
                "abbreviation": "IQ"
            },
            {
                "name": "Ireland",
                "abbreviation": "IE"
            },
            {
                "name": "Isle of Man",
                "abbreviation": "IM"
            },
            {
                "name": "Israel",
                "abbreviation": "IL"
            },
            {
                "name": "Italy",
                "abbreviation": "IT"
            },
            {
                "name": "Jamaica",
                "abbreviation": "JM"
            },
            {
                "name": "Japan",
                "abbreviation": "JP"
            },
            {
                "name": "Jersey",
                "abbreviation": "JE"
            },
            {
                "name": "Jordan",
                "abbreviation": "JO"
            },
            {
                "name": "Kazakhstan",
                "abbreviation": "KZ"
            },
            {
                "name": "Kenya",
                "abbreviation": "KE"
            },
            {
                "name": "Kiribati",
                "abbreviation": "KI"
            },
            {
                "name": "Democratic People's Republic of Korea",
                "abbreviation": "KP"
            },
            {
                "name": "Republic of Korea",
                "abbreviation": "KR"
            },
            {
                "name": "Kuwait",
                "abbreviation": "KW"
            },
            {
                "name": "Kyrgyzstan",
                "abbreviation": "KG"
            },
            {
                "name": "Lao People's Democratic Republic",
                "abbreviation": "LA"
            },
            {
                "name": "Latvia",
                "abbreviation": "LV"
            },
            {
                "name": "Lebanon",
                "abbreviation": "LB"
            },
            {
                "name": "Lesotho",
                "abbreviation": "LS"
            },
            {
                "name": "Liberia",
                "abbreviation": "LR"
            },
            {
                "name": "Libya",
                "abbreviation": "LY"
            },
            {
                "name": "Liechtenstein",
                "abbreviation": "LI"
            },
            {
                "name": "Lithuania",
                "abbreviation": "LT"
            },
            {
                "name": "Luxembourg",
                "abbreviation": "LU"
            },
            {
                "name": "Macao",
                "abbreviation": "MO"
            },
            {
                "name": "Madagascar",
                "abbreviation": "MG"
            },
            {
                "name": "Malawi",
                "abbreviation": "MW"
            },
            {
                "name": "Malaysia",
                "abbreviation": "MY"
            },
            {
                "name": "Maldives",
                "abbreviation": "MV"
            },
            {
                "name": "Mali",
                "abbreviation": "ML"
            },
            {
                "name": "Malta",
                "abbreviation": "MT"
            },
            {
                "name": "Marshall Islands",
                "abbreviation": "MH"
            },
            {
                "name": "Martinique",
                "abbreviation": "MQ"
            },
            {
                "name": "Mauritania",
                "abbreviation": "MR"
            },
            {
                "name": "Mauritius",
                "abbreviation": "MU"
            },
            {
                "name": "Mayotte",
                "abbreviation": "YT"
            },
            {
                "name": "Mexico",
                "abbreviation": "MX"
            },
            {
                "name": "Federated States of Micronesia",
                "abbreviation": "FM"
            },
            {
                "name": "Republic of Moldova",
                "abbreviation": "MD"
            },
            {
                "name": "Monaco",
                "abbreviation": "MC"
            },
            {
                "name": "Mongolia",
                "abbreviation": "MN"
            },
            {
                "name": "Montenegro",
                "abbreviation": "ME"
            },
            {
                "name": "Montserrat",
                "abbreviation": "MS"
            },
            {
                "name": "Morocco",
                "abbreviation": "MA"
            },
            {
                "name": "Mozambique",
                "abbreviation": "MZ"
            },
            {
                "name": "Myanmar",
                "abbreviation": "MM"
            },
            {
                "name": "Namibia",
                "abbreviation": "NA"
            },
            {
                "name": "Nauru",
                "abbreviation": "NR"
            },
            {
                "name": "Nepal",
                "abbreviation": "NP"
            },
            {
                "name": "Kingdom of the Netherlands",
                "abbreviation": "NL"
            },
            {
                "name": "New Caledonia",
                "abbreviation": "NC"
            },
            {
                "name": "New Zealand",
                "abbreviation": "NZ"
            },
            {
                "name": "Nicaragua",
                "abbreviation": "NI"
            },
            {
                "name": "Niger",
                "abbreviation": "NE"
            },
            {
                "name": "Nigeria",
                "abbreviation": "NG"
            },
            {
                "name": "Niue",
                "abbreviation": "NU"
            },
            {
                "name": "Norfolk Island",
                "abbreviation": "NF"
            },
            {
                "name": "North Macedonia",
                "abbreviation": "MK"
            },
            {
                "name": "Northern Mariana Islands",
                "abbreviation": "MP"
            },
            {
                "name": "Norway",
                "abbreviation": "NO"
            },
            {
                "name": "Oman",
                "abbreviation": "OM"
            },
            {
                "name": "Pakistan",
                "abbreviation": "PK"
            },
            {
                "name": "Palau",
                "abbreviation": "PW"
            },
            {
                "name": "State of Palestine",
                "abbreviation": "PS"
            },
            {
                "name": "Panama",
                "abbreviation": "PA"
            },
            {
                "name": "Papua New Guinea",
                "abbreviation": "PG"
            },
            {
                "name": "Paraguay",
                "abbreviation": "PY"
            },
            {
                "name": "Peru",
                "abbreviation": "PE"
            },
            {
                "name": "Philippines",
                "abbreviation": "PH"
            },
            {
                "name": "Pitcairn",
                "abbreviation": "PN"
            },
            {
                "name": "Poland",
                "abbreviation": "PL"
            },
            {
                "name": "Portugal",
                "abbreviation": "PT"
            },
            {
                "name": "Puerto Rico",
                "abbreviation": "PR"
            },
            {
                "name": "Qatar",
                "abbreviation": "QA"
            },
            {
                "name": "R\xe9union",
                "abbreviation": "RE"
            },
            {
                "name": "Romania",
                "abbreviation": "RO"
            },
            {
                "name": "Russian Federation",
                "abbreviation": "RU"
            },
            {
                "name": "Rwanda",
                "abbreviation": "RW"
            },
            {
                "name": "Saint Barth\xe9lemy",
                "abbreviation": "BL"
            },
            {
                "name": "Saint Helena, Ascension and Tristan da Cunha",
                "abbreviation": "SH"
            },
            {
                "name": "Saint Kitts and Nevis",
                "abbreviation": "KN"
            },
            {
                "name": "Saint Lucia",
                "abbreviation": "LC"
            },
            {
                "name": "Saint Martin (French part)",
                "abbreviation": "MF"
            },
            {
                "name": "Saint Pierre and Miquelon",
                "abbreviation": "PM"
            },
            {
                "name": "Saint Vincent and the Grenadines",
                "abbreviation": "VC"
            },
            {
                "name": "Samoa",
                "abbreviation": "WS"
            },
            {
                "name": "San Marino",
                "abbreviation": "SM"
            },
            {
                "name": "Sao Tome and Principe",
                "abbreviation": "ST"
            },
            {
                "name": "Saudi Arabia",
                "abbreviation": "SA"
            },
            {
                "name": "Senegal",
                "abbreviation": "SN"
            },
            {
                "name": "Serbia",
                "abbreviation": "RS"
            },
            {
                "name": "Seychelles",
                "abbreviation": "SC"
            },
            {
                "name": "Sierra Leone",
                "abbreviation": "SL"
            },
            {
                "name": "Singapore",
                "abbreviation": "SG"
            },
            {
                "name": "Sint Maarten (Dutch part)",
                "abbreviation": "SX"
            },
            {
                "name": "Slovakia",
                "abbreviation": "SK"
            },
            {
                "name": "Slovenia",
                "abbreviation": "SI"
            },
            {
                "name": "Solomon Islands",
                "abbreviation": "SB"
            },
            {
                "name": "Somalia",
                "abbreviation": "SO"
            },
            {
                "name": "South Africa",
                "abbreviation": "ZA"
            },
            {
                "name": "South Georgia and the South Sandwich Islands",
                "abbreviation": "GS"
            },
            {
                "name": "South Sudan",
                "abbreviation": "SS"
            },
            {
                "name": "Spain",
                "abbreviation": "ES"
            },
            {
                "name": "Sri Lanka",
                "abbreviation": "LK"
            },
            {
                "name": "Sudan",
                "abbreviation": "SD"
            },
            {
                "name": "Suriname",
                "abbreviation": "SR"
            },
            {
                "name": "Svalbard and Jan Mayen",
                "abbreviation": "SJ"
            },
            {
                "name": "Sweden",
                "abbreviation": "SE"
            },
            {
                "name": "Switzerland",
                "abbreviation": "CH"
            },
            {
                "name": "Syrian Arab Republic",
                "abbreviation": "SY"
            },
            {
                "name": "Taiwan, Province of China",
                "abbreviation": "TW"
            },
            {
                "name": "Tajikistan",
                "abbreviation": "TJ"
            },
            {
                "name": "United Republic of Tanzania",
                "abbreviation": "TZ"
            },
            {
                "name": "Thailand",
                "abbreviation": "TH"
            },
            {
                "name": "Timor-Leste",
                "abbreviation": "TL"
            },
            {
                "name": "Togo",
                "abbreviation": "TG"
            },
            {
                "name": "Tokelau",
                "abbreviation": "TK"
            },
            {
                "name": "Tonga",
                "abbreviation": "TO"
            },
            {
                "name": "Trinidad and Tobago",
                "abbreviation": "TT"
            },
            {
                "name": "Tunisia",
                "abbreviation": "TN"
            },
            {
                "name": "T\xfcrkiye",
                "abbreviation": "TR"
            },
            {
                "name": "Turkmenistan",
                "abbreviation": "TM"
            },
            {
                "name": "Turks and Caicos Islands",
                "abbreviation": "TC"
            },
            {
                "name": "Tuvalu",
                "abbreviation": "TV"
            },
            {
                "name": "Uganda",
                "abbreviation": "UG"
            },
            {
                "name": "Ukraine",
                "abbreviation": "UA"
            },
            {
                "name": "United Arab Emirates",
                "abbreviation": "AE"
            },
            {
                "name": "United Kingdom of Great Britain and Northern Ireland",
                "abbreviation": "GB"
            },
            {
                "name": "United States Minor Outlying Islands",
                "abbreviation": "UM"
            },
            {
                "name": "United States of America",
                "abbreviation": "US"
            },
            {
                "name": "Uruguay",
                "abbreviation": "UY"
            },
            {
                "name": "Uzbekistan",
                "abbreviation": "UZ"
            },
            {
                "name": "Vanuatu",
                "abbreviation": "VU"
            },
            {
                "name": "Bolivarian Republic of Venezuela",
                "abbreviation": "VE"
            },
            {
                "name": "Viet Nam",
                "abbreviation": "VN"
            },
            {
                "name": "Virgin Islands (British)",
                "abbreviation": "VG"
            },
            {
                "name": "Virgin Islands (U.S.)",
                "abbreviation": "VI"
            },
            {
                "name": "Wallis and Futuna",
                "abbreviation": "WF"
            },
            {
                "name": "Western Sahara",
                "abbreviation": "EH"
            },
            {
                "name": "Yemen",
                "abbreviation": "YE"
            },
            {
                "name": "Zambia",
                "abbreviation": "ZM"
            },
            {
                "name": "Zimbabwe",
                "abbreviation": "ZW"
            }
        ],
        counties: {
            // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
            "uk": [
                {
                    name: 'Bath and North East Somerset'
                },
                {
                    name: 'Aberdeenshire'
                },
                {
                    name: 'Anglesey'
                },
                {
                    name: 'Angus'
                },
                {
                    name: 'Bedford'
                },
                {
                    name: 'Blackburn with Darwen'
                },
                {
                    name: 'Blackpool'
                },
                {
                    name: 'Bournemouth'
                },
                {
                    name: 'Bracknell Forest'
                },
                {
                    name: 'Brighton & Hove'
                },
                {
                    name: 'Bristol'
                },
                {
                    name: 'Buckinghamshire'
                },
                {
                    name: 'Cambridgeshire'
                },
                {
                    name: 'Carmarthenshire'
                },
                {
                    name: 'Central Bedfordshire'
                },
                {
                    name: 'Ceredigion'
                },
                {
                    name: 'Cheshire East'
                },
                {
                    name: 'Cheshire West and Chester'
                },
                {
                    name: 'Clackmannanshire'
                },
                {
                    name: 'Conwy'
                },
                {
                    name: 'Cornwall'
                },
                {
                    name: 'County Antrim'
                },
                {
                    name: 'County Armagh'
                },
                {
                    name: 'County Down'
                },
                {
                    name: 'County Durham'
                },
                {
                    name: 'County Fermanagh'
                },
                {
                    name: 'County Londonderry'
                },
                {
                    name: 'County Tyrone'
                },
                {
                    name: 'Cumbria'
                },
                {
                    name: 'Darlington'
                },
                {
                    name: 'Denbighshire'
                },
                {
                    name: 'Derby'
                },
                {
                    name: 'Derbyshire'
                },
                {
                    name: 'Devon'
                },
                {
                    name: 'Dorset'
                },
                {
                    name: 'Dumfries and Galloway'
                },
                {
                    name: 'Dundee'
                },
                {
                    name: 'East Lothian'
                },
                {
                    name: 'East Riding of Yorkshire'
                },
                {
                    name: 'East Sussex'
                },
                {
                    name: 'Edinburgh?'
                },
                {
                    name: 'Essex'
                },
                {
                    name: 'Falkirk'
                },
                {
                    name: 'Fife'
                },
                {
                    name: 'Flintshire'
                },
                {
                    name: 'Gloucestershire'
                },
                {
                    name: 'Greater London'
                },
                {
                    name: 'Greater Manchester'
                },
                {
                    name: 'Gwent'
                },
                {
                    name: 'Gwynedd'
                },
                {
                    name: 'Halton'
                },
                {
                    name: 'Hampshire'
                },
                {
                    name: 'Hartlepool'
                },
                {
                    name: 'Herefordshire'
                },
                {
                    name: 'Hertfordshire'
                },
                {
                    name: 'Highlands'
                },
                {
                    name: 'Hull'
                },
                {
                    name: 'Isle of Wight'
                },
                {
                    name: 'Isles of Scilly'
                },
                {
                    name: 'Kent'
                },
                {
                    name: 'Lancashire'
                },
                {
                    name: 'Leicester'
                },
                {
                    name: 'Leicestershire'
                },
                {
                    name: 'Lincolnshire'
                },
                {
                    name: 'Lothian'
                },
                {
                    name: 'Luton'
                },
                {
                    name: 'Medway'
                },
                {
                    name: 'Merseyside'
                },
                {
                    name: 'Mid Glamorgan'
                },
                {
                    name: 'Middlesbrough'
                },
                {
                    name: 'Milton Keynes'
                },
                {
                    name: 'Monmouthshire'
                },
                {
                    name: 'Moray'
                },
                {
                    name: 'Norfolk'
                },
                {
                    name: 'North East Lincolnshire'
                },
                {
                    name: 'North Lincolnshire'
                },
                {
                    name: 'North Somerset'
                },
                {
                    name: 'North Yorkshire'
                },
                {
                    name: 'Northamptonshire'
                },
                {
                    name: 'Northumberland'
                },
                {
                    name: 'Nottingham'
                },
                {
                    name: 'Nottinghamshire'
                },
                {
                    name: 'Oxfordshire'
                },
                {
                    name: 'Pembrokeshire'
                },
                {
                    name: 'Perth and Kinross'
                },
                {
                    name: 'Peterborough'
                },
                {
                    name: 'Plymouth'
                },
                {
                    name: 'Poole'
                },
                {
                    name: 'Portsmouth'
                },
                {
                    name: 'Powys'
                },
                {
                    name: 'Reading'
                },
                {
                    name: 'Redcar and Cleveland'
                },
                {
                    name: 'Rutland'
                },
                {
                    name: 'Scottish Borders'
                },
                {
                    name: 'Shropshire'
                },
                {
                    name: 'Slough'
                },
                {
                    name: 'Somerset'
                },
                {
                    name: 'South Glamorgan'
                },
                {
                    name: 'South Gloucestershire'
                },
                {
                    name: 'South Yorkshire'
                },
                {
                    name: 'Southampton'
                },
                {
                    name: 'Southend-on-Sea'
                },
                {
                    name: 'Staffordshire'
                },
                {
                    name: 'Stirlingshire'
                },
                {
                    name: 'Stockton-on-Tees'
                },
                {
                    name: 'Stoke-on-Trent'
                },
                {
                    name: 'Strathclyde'
                },
                {
                    name: 'Suffolk'
                },
                {
                    name: 'Surrey'
                },
                {
                    name: 'Swindon'
                },
                {
                    name: 'Telford and Wrekin'
                },
                {
                    name: 'Thurrock'
                },
                {
                    name: 'Torbay'
                },
                {
                    name: 'Tyne and Wear'
                },
                {
                    name: 'Warrington'
                },
                {
                    name: 'Warwickshire'
                },
                {
                    name: 'West Berkshire'
                },
                {
                    name: 'West Glamorgan'
                },
                {
                    name: 'West Lothian'
                },
                {
                    name: 'West Midlands'
                },
                {
                    name: 'West Sussex'
                },
                {
                    name: 'West Yorkshire'
                },
                {
                    name: 'Western Isles'
                },
                {
                    name: 'Wiltshire'
                },
                {
                    name: 'Windsor and Maidenhead'
                },
                {
                    name: 'Wokingham'
                },
                {
                    name: 'Worcestershire'
                },
                {
                    name: 'Wrexham'
                },
                {
                    name: 'York'
                }
            ]
        },
        provinces: {
            "ca": [
                {
                    name: 'Alberta',
                    abbreviation: 'AB'
                },
                {
                    name: 'British Columbia',
                    abbreviation: 'BC'
                },
                {
                    name: 'Manitoba',
                    abbreviation: 'MB'
                },
                {
                    name: 'New Brunswick',
                    abbreviation: 'NB'
                },
                {
                    name: 'Newfoundland and Labrador',
                    abbreviation: 'NL'
                },
                {
                    name: 'Nova Scotia',
                    abbreviation: 'NS'
                },
                {
                    name: 'Ontario',
                    abbreviation: 'ON'
                },
                {
                    name: 'Prince Edward Island',
                    abbreviation: 'PE'
                },
                {
                    name: 'Quebec',
                    abbreviation: 'QC'
                },
                {
                    name: 'Saskatchewan',
                    abbreviation: 'SK'
                },
                // The case could be made that the following are not actually provinces
                // since they are technically considered "territories" however they all
                // look the same on an envelope!
                {
                    name: 'Northwest Territories',
                    abbreviation: 'NT'
                },
                {
                    name: 'Nunavut',
                    abbreviation: 'NU'
                },
                {
                    name: 'Yukon',
                    abbreviation: 'YT'
                }
            ],
            "it": [
                {
                    name: "Agrigento",
                    abbreviation: "AG",
                    code: 84
                },
                {
                    name: "Alessandria",
                    abbreviation: "AL",
                    code: 6
                },
                {
                    name: "Ancona",
                    abbreviation: "AN",
                    code: 42
                },
                {
                    name: "Aosta",
                    abbreviation: "AO",
                    code: 7
                },
                {
                    name: "L'Aquila",
                    abbreviation: "AQ",
                    code: 66
                },
                {
                    name: "Arezzo",
                    abbreviation: "AR",
                    code: 51
                },
                {
                    name: "Ascoli-Piceno",
                    abbreviation: "AP",
                    code: 44
                },
                {
                    name: "Asti",
                    abbreviation: "AT",
                    code: 5
                },
                {
                    name: "Avellino",
                    abbreviation: "AV",
                    code: 64
                },
                {
                    name: "Bari",
                    abbreviation: "BA",
                    code: 72
                },
                {
                    name: "Barletta-Andria-Trani",
                    abbreviation: "BT",
                    code: 72
                },
                {
                    name: "Belluno",
                    abbreviation: "BL",
                    code: 25
                },
                {
                    name: "Benevento",
                    abbreviation: "BN",
                    code: 62
                },
                {
                    name: "Bergamo",
                    abbreviation: "BG",
                    code: 16
                },
                {
                    name: "Biella",
                    abbreviation: "BI",
                    code: 96
                },
                {
                    name: "Bologna",
                    abbreviation: "BO",
                    code: 37
                },
                {
                    name: "Bolzano",
                    abbreviation: "BZ",
                    code: 21
                },
                {
                    name: "Brescia",
                    abbreviation: "BS",
                    code: 17
                },
                {
                    name: "Brindisi",
                    abbreviation: "BR",
                    code: 74
                },
                {
                    name: "Cagliari",
                    abbreviation: "CA",
                    code: 92
                },
                {
                    name: "Caltanissetta",
                    abbreviation: "CL",
                    code: 85
                },
                {
                    name: "Campobasso",
                    abbreviation: "CB",
                    code: 70
                },
                {
                    name: "Carbonia Iglesias",
                    abbreviation: "CI",
                    code: 70
                },
                {
                    name: "Caserta",
                    abbreviation: "CE",
                    code: 61
                },
                {
                    name: "Catania",
                    abbreviation: "CT",
                    code: 87
                },
                {
                    name: "Catanzaro",
                    abbreviation: "CZ",
                    code: 79
                },
                {
                    name: "Chieti",
                    abbreviation: "CH",
                    code: 69
                },
                {
                    name: "Como",
                    abbreviation: "CO",
                    code: 13
                },
                {
                    name: "Cosenza",
                    abbreviation: "CS",
                    code: 78
                },
                {
                    name: "Cremona",
                    abbreviation: "CR",
                    code: 19
                },
                {
                    name: "Crotone",
                    abbreviation: "KR",
                    code: 101
                },
                {
                    name: "Cuneo",
                    abbreviation: "CN",
                    code: 4
                },
                {
                    name: "Enna",
                    abbreviation: "EN",
                    code: 86
                },
                {
                    name: "Fermo",
                    abbreviation: "FM",
                    code: 86
                },
                {
                    name: "Ferrara",
                    abbreviation: "FE",
                    code: 38
                },
                {
                    name: "Firenze",
                    abbreviation: "FI",
                    code: 48
                },
                {
                    name: "Foggia",
                    abbreviation: "FG",
                    code: 71
                },
                {
                    name: "Forli-Cesena",
                    abbreviation: "FC",
                    code: 71
                },
                {
                    name: "Frosinone",
                    abbreviation: "FR",
                    code: 60
                },
                {
                    name: "Genova",
                    abbreviation: "GE",
                    code: 10
                },
                {
                    name: "Gorizia",
                    abbreviation: "GO",
                    code: 31
                },
                {
                    name: "Grosseto",
                    abbreviation: "GR",
                    code: 53
                },
                {
                    name: "Imperia",
                    abbreviation: "IM",
                    code: 8
                },
                {
                    name: "Isernia",
                    abbreviation: "IS",
                    code: 94
                },
                {
                    name: "La-Spezia",
                    abbreviation: "SP",
                    code: 66
                },
                {
                    name: "Latina",
                    abbreviation: "LT",
                    code: 59
                },
                {
                    name: "Lecce",
                    abbreviation: "LE",
                    code: 75
                },
                {
                    name: "Lecco",
                    abbreviation: "LC",
                    code: 97
                },
                {
                    name: "Livorno",
                    abbreviation: "LI",
                    code: 49
                },
                {
                    name: "Lodi",
                    abbreviation: "LO",
                    code: 98
                },
                {
                    name: "Lucca",
                    abbreviation: "LU",
                    code: 46
                },
                {
                    name: "Macerata",
                    abbreviation: "MC",
                    code: 43
                },
                {
                    name: "Mantova",
                    abbreviation: "MN",
                    code: 20
                },
                {
                    name: "Massa-Carrara",
                    abbreviation: "MS",
                    code: 45
                },
                {
                    name: "Matera",
                    abbreviation: "MT",
                    code: 77
                },
                {
                    name: "Medio Campidano",
                    abbreviation: "VS",
                    code: 77
                },
                {
                    name: "Messina",
                    abbreviation: "ME",
                    code: 83
                },
                {
                    name: "Milano",
                    abbreviation: "MI",
                    code: 15
                },
                {
                    name: "Modena",
                    abbreviation: "MO",
                    code: 36
                },
                {
                    name: "Monza-Brianza",
                    abbreviation: "MB",
                    code: 36
                },
                {
                    name: "Napoli",
                    abbreviation: "NA",
                    code: 63
                },
                {
                    name: "Novara",
                    abbreviation: "NO",
                    code: 3
                },
                {
                    name: "Nuoro",
                    abbreviation: "NU",
                    code: 91
                },
                {
                    name: "Ogliastra",
                    abbreviation: "OG",
                    code: 91
                },
                {
                    name: "Olbia Tempio",
                    abbreviation: "OT",
                    code: 91
                },
                {
                    name: "Oristano",
                    abbreviation: "OR",
                    code: 95
                },
                {
                    name: "Padova",
                    abbreviation: "PD",
                    code: 28
                },
                {
                    name: "Palermo",
                    abbreviation: "PA",
                    code: 82
                },
                {
                    name: "Parma",
                    abbreviation: "PR",
                    code: 34
                },
                {
                    name: "Pavia",
                    abbreviation: "PV",
                    code: 18
                },
                {
                    name: "Perugia",
                    abbreviation: "PG",
                    code: 54
                },
                {
                    name: "Pesaro-Urbino",
                    abbreviation: "PU",
                    code: 41
                },
                {
                    name: "Pescara",
                    abbreviation: "PE",
                    code: 68
                },
                {
                    name: "Piacenza",
                    abbreviation: "PC",
                    code: 33
                },
                {
                    name: "Pisa",
                    abbreviation: "PI",
                    code: 50
                },
                {
                    name: "Pistoia",
                    abbreviation: "PT",
                    code: 47
                },
                {
                    name: "Pordenone",
                    abbreviation: "PN",
                    code: 93
                },
                {
                    name: "Potenza",
                    abbreviation: "PZ",
                    code: 76
                },
                {
                    name: "Prato",
                    abbreviation: "PO",
                    code: 100
                },
                {
                    name: "Ragusa",
                    abbreviation: "RG",
                    code: 88
                },
                {
                    name: "Ravenna",
                    abbreviation: "RA",
                    code: 39
                },
                {
                    name: "Reggio-Calabria",
                    abbreviation: "RC",
                    code: 35
                },
                {
                    name: "Reggio-Emilia",
                    abbreviation: "RE",
                    code: 35
                },
                {
                    name: "Rieti",
                    abbreviation: "RI",
                    code: 57
                },
                {
                    name: "Rimini",
                    abbreviation: "RN",
                    code: 99
                },
                {
                    name: "Roma",
                    abbreviation: "Roma",
                    code: 58
                },
                {
                    name: "Rovigo",
                    abbreviation: "RO",
                    code: 29
                },
                {
                    name: "Salerno",
                    abbreviation: "SA",
                    code: 65
                },
                {
                    name: "Sassari",
                    abbreviation: "SS",
                    code: 90
                },
                {
                    name: "Savona",
                    abbreviation: "SV",
                    code: 9
                },
                {
                    name: "Siena",
                    abbreviation: "SI",
                    code: 52
                },
                {
                    name: "Siracusa",
                    abbreviation: "SR",
                    code: 89
                },
                {
                    name: "Sondrio",
                    abbreviation: "SO",
                    code: 14
                },
                {
                    name: "Taranto",
                    abbreviation: "TA",
                    code: 73
                },
                {
                    name: "Teramo",
                    abbreviation: "TE",
                    code: 67
                },
                {
                    name: "Terni",
                    abbreviation: "TR",
                    code: 55
                },
                {
                    name: "Torino",
                    abbreviation: "TO",
                    code: 1
                },
                {
                    name: "Trapani",
                    abbreviation: "TP",
                    code: 81
                },
                {
                    name: "Trento",
                    abbreviation: "TN",
                    code: 22
                },
                {
                    name: "Treviso",
                    abbreviation: "TV",
                    code: 26
                },
                {
                    name: "Trieste",
                    abbreviation: "TS",
                    code: 32
                },
                {
                    name: "Udine",
                    abbreviation: "UD",
                    code: 30
                },
                {
                    name: "Varese",
                    abbreviation: "VA",
                    code: 12
                },
                {
                    name: "Venezia",
                    abbreviation: "VE",
                    code: 27
                },
                {
                    name: "Verbania",
                    abbreviation: "VB",
                    code: 27
                },
                {
                    name: "Vercelli",
                    abbreviation: "VC",
                    code: 2
                },
                {
                    name: "Verona",
                    abbreviation: "VR",
                    code: 23
                },
                {
                    name: "Vibo-Valentia",
                    abbreviation: "VV",
                    code: 102
                },
                {
                    name: "Vicenza",
                    abbreviation: "VI",
                    code: 24
                },
                {
                    name: "Viterbo",
                    abbreviation: "VT",
                    code: 56
                }
            ]
        },
        // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
        nationalities: [
            {
                name: 'Afghan'
            },
            {
                name: 'Albanian'
            },
            {
                name: 'Algerian'
            },
            {
                name: 'American'
            },
            {
                name: 'Andorran'
            },
            {
                name: 'Angolan'
            },
            {
                name: 'Antiguans'
            },
            {
                name: 'Argentinean'
            },
            {
                name: 'Armenian'
            },
            {
                name: 'Australian'
            },
            {
                name: 'Austrian'
            },
            {
                name: 'Azerbaijani'
            },
            {
                name: 'Bahami'
            },
            {
                name: 'Bahraini'
            },
            {
                name: 'Bangladeshi'
            },
            {
                name: 'Barbadian'
            },
            {
                name: 'Barbudans'
            },
            {
                name: 'Batswana'
            },
            {
                name: 'Belarusian'
            },
            {
                name: 'Belgian'
            },
            {
                name: 'Belizean'
            },
            {
                name: 'Beninese'
            },
            {
                name: 'Bhutanese'
            },
            {
                name: 'Bolivian'
            },
            {
                name: 'Bosnian'
            },
            {
                name: 'Brazilian'
            },
            {
                name: 'British'
            },
            {
                name: 'Bruneian'
            },
            {
                name: 'Bulgarian'
            },
            {
                name: 'Burkinabe'
            },
            {
                name: 'Burmese'
            },
            {
                name: 'Burundian'
            },
            {
                name: 'Cambodian'
            },
            {
                name: 'Cameroonian'
            },
            {
                name: 'Canadian'
            },
            {
                name: 'Cape Verdean'
            },
            {
                name: 'Central African'
            },
            {
                name: 'Chadian'
            },
            {
                name: 'Chilean'
            },
            {
                name: 'Chinese'
            },
            {
                name: 'Colombian'
            },
            {
                name: 'Comoran'
            },
            {
                name: 'Congolese'
            },
            {
                name: 'Costa Rican'
            },
            {
                name: 'Croatian'
            },
            {
                name: 'Cuban'
            },
            {
                name: 'Cypriot'
            },
            {
                name: 'Czech'
            },
            {
                name: 'Danish'
            },
            {
                name: 'Djibouti'
            },
            {
                name: 'Dominican'
            },
            {
                name: 'Dutch'
            },
            {
                name: 'East Timorese'
            },
            {
                name: 'Ecuadorean'
            },
            {
                name: 'Egyptian'
            },
            {
                name: 'Emirian'
            },
            {
                name: 'Equatorial Guinean'
            },
            {
                name: 'Eritrean'
            },
            {
                name: 'Estonian'
            },
            {
                name: 'Ethiopian'
            },
            {
                name: 'Fijian'
            },
            {
                name: 'Filipino'
            },
            {
                name: 'Finnish'
            },
            {
                name: 'French'
            },
            {
                name: 'Gabonese'
            },
            {
                name: 'Gambian'
            },
            {
                name: 'Georgian'
            },
            {
                name: 'German'
            },
            {
                name: 'Ghanaian'
            },
            {
                name: 'Greek'
            },
            {
                name: 'Grenadian'
            },
            {
                name: 'Guatemalan'
            },
            {
                name: 'Guinea-Bissauan'
            },
            {
                name: 'Guinean'
            },
            {
                name: 'Guyanese'
            },
            {
                name: 'Haitian'
            },
            {
                name: 'Herzegovinian'
            },
            {
                name: 'Honduran'
            },
            {
                name: 'Hungarian'
            },
            {
                name: 'I-Kiribati'
            },
            {
                name: 'Icelander'
            },
            {
                name: 'Indian'
            },
            {
                name: 'Indonesian'
            },
            {
                name: 'Iranian'
            },
            {
                name: 'Iraqi'
            },
            {
                name: 'Irish'
            },
            {
                name: 'Israeli'
            },
            {
                name: 'Italian'
            },
            {
                name: 'Ivorian'
            },
            {
                name: 'Jamaican'
            },
            {
                name: 'Japanese'
            },
            {
                name: 'Jordanian'
            },
            {
                name: 'Kazakhstani'
            },
            {
                name: 'Kenyan'
            },
            {
                name: 'Kittian and Nevisian'
            },
            {
                name: 'Kuwaiti'
            },
            {
                name: 'Kyrgyz'
            },
            {
                name: 'Laotian'
            },
            {
                name: 'Latvian'
            },
            {
                name: 'Lebanese'
            },
            {
                name: 'Liberian'
            },
            {
                name: 'Libyan'
            },
            {
                name: 'Liechtensteiner'
            },
            {
                name: 'Lithuanian'
            },
            {
                name: 'Luxembourger'
            },
            {
                name: 'Macedonian'
            },
            {
                name: 'Malagasy'
            },
            {
                name: 'Malawian'
            },
            {
                name: 'Malaysian'
            },
            {
                name: 'Maldivan'
            },
            {
                name: 'Malian'
            },
            {
                name: 'Maltese'
            },
            {
                name: 'Marshallese'
            },
            {
                name: 'Mauritanian'
            },
            {
                name: 'Mauritian'
            },
            {
                name: 'Mexican'
            },
            {
                name: 'Micronesian'
            },
            {
                name: 'Moldovan'
            },
            {
                name: 'Monacan'
            },
            {
                name: 'Mongolian'
            },
            {
                name: 'Moroccan'
            },
            {
                name: 'Mosotho'
            },
            {
                name: 'Motswana'
            },
            {
                name: 'Mozambican'
            },
            {
                name: 'Namibian'
            },
            {
                name: 'Nauruan'
            },
            {
                name: 'Nepalese'
            },
            {
                name: 'New Zealander'
            },
            {
                name: 'Nicaraguan'
            },
            {
                name: 'Nigerian'
            },
            {
                name: 'Nigerien'
            },
            {
                name: 'North Korean'
            },
            {
                name: 'Northern Irish'
            },
            {
                name: 'Norwegian'
            },
            {
                name: 'Omani'
            },
            {
                name: 'Pakistani'
            },
            {
                name: 'Palauan'
            },
            {
                name: 'Panamanian'
            },
            {
                name: 'Papua New Guinean'
            },
            {
                name: 'Paraguayan'
            },
            {
                name: 'Peruvian'
            },
            {
                name: 'Polish'
            },
            {
                name: 'Portuguese'
            },
            {
                name: 'Qatari'
            },
            {
                name: 'Romani'
            },
            {
                name: 'Russian'
            },
            {
                name: 'Rwandan'
            },
            {
                name: 'Saint Lucian'
            },
            {
                name: 'Salvadoran'
            },
            {
                name: 'Samoan'
            },
            {
                name: 'San Marinese'
            },
            {
                name: 'Sao Tomean'
            },
            {
                name: 'Saudi'
            },
            {
                name: 'Scottish'
            },
            {
                name: 'Senegalese'
            },
            {
                name: 'Serbian'
            },
            {
                name: 'Seychellois'
            },
            {
                name: 'Sierra Leonean'
            },
            {
                name: 'Singaporean'
            },
            {
                name: 'Slovakian'
            },
            {
                name: 'Slovenian'
            },
            {
                name: 'Solomon Islander'
            },
            {
                name: 'Somali'
            },
            {
                name: 'South African'
            },
            {
                name: 'South Korean'
            },
            {
                name: 'Spanish'
            },
            {
                name: 'Sri Lankan'
            },
            {
                name: 'Sudanese'
            },
            {
                name: 'Surinamer'
            },
            {
                name: 'Swazi'
            },
            {
                name: 'Swedish'
            },
            {
                name: 'Swiss'
            },
            {
                name: 'Syrian'
            },
            {
                name: 'Taiwanese'
            },
            {
                name: 'Tajik'
            },
            {
                name: 'Tanzanian'
            },
            {
                name: 'Thai'
            },
            {
                name: 'Togolese'
            },
            {
                name: 'Tongan'
            },
            {
                name: 'Trinidadian or Tobagonian'
            },
            {
                name: 'Tunisian'
            },
            {
                name: 'Turkish'
            },
            {
                name: 'Tuvaluan'
            },
            {
                name: 'Ugandan'
            },
            {
                name: 'Ukrainian'
            },
            {
                name: 'Uruguaya'
            },
            {
                name: 'Uzbekistani'
            },
            {
                name: 'Venezuela'
            },
            {
                name: 'Vietnamese'
            },
            {
                name: 'Wels'
            },
            {
                name: 'Yemenit'
            },
            {
                name: 'Zambia'
            },
            {
                name: 'Zimbabwe'
            }
        ],
        // http://www.loc.gov/standards/iso639-2/php/code_list.php (ISO-639-1 codes)
        locale_languages: [
            "aa",
            "ab",
            "ae",
            "af",
            "ak",
            "am",
            "an",
            "ar",
            "as",
            "av",
            "ay",
            "az",
            "ba",
            "be",
            "bg",
            "bh",
            "bi",
            "bm",
            "bn",
            "bo",
            "br",
            "bs",
            "ca",
            "ce",
            "ch",
            "co",
            "cr",
            "cs",
            "cu",
            "cv",
            "cy",
            "da",
            "de",
            "dv",
            "dz",
            "ee",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fa",
            "ff",
            "fi",
            "fj",
            "fo",
            "fr",
            "fy",
            "ga",
            "gd",
            "gl",
            "gn",
            "gu",
            "gv",
            "ha",
            "he",
            "hi",
            "ho",
            "hr",
            "ht",
            "hu",
            "hy",
            "hz",
            "ia",
            "id",
            "ie",
            "ig",
            "ii",
            "ik",
            "io",
            "is",
            "it",
            "iu",
            "ja",
            "jv",
            "ka",
            "kg",
            "ki",
            "kj",
            "kk",
            "kl",
            "km",
            "kn",
            "ko",
            "kr",
            "ks",
            "ku",
            "kv",
            "kw",
            "ky",
            "la",
            "lb",
            "lg",
            "li",
            "ln",
            "lo",
            "lt",
            "lu",
            "lv",
            "mg",
            "mh",
            "mi",
            "mk",
            "ml",
            "mn",
            "mr",
            "ms",
            "mt",
            "my",
            "na",
            "nb",
            "nd",
            "ne",
            "ng",
            "nl",
            "nn",
            "no",
            "nr",
            "nv",
            "ny",
            "oc",
            "oj",
            "om",
            "or",
            "os",
            "pa",
            "pi",
            "pl",
            "ps",
            "pt",
            "qu",
            "rm",
            "rn",
            "ro",
            "ru",
            "rw",
            "sa",
            "sc",
            "sd",
            "se",
            "sg",
            "si",
            "sk",
            "sl",
            "sm",
            "sn",
            "so",
            "sq",
            "sr",
            "ss",
            "st",
            "su",
            "sv",
            "sw",
            "ta",
            "te",
            "tg",
            "th",
            "ti",
            "tk",
            "tl",
            "tn",
            "to",
            "tr",
            "ts",
            "tt",
            "tw",
            "ty",
            "ug",
            "uk",
            "ur",
            "uz",
            "ve",
            "vi",
            "vo",
            "wa",
            "wo",
            "xh",
            "yi",
            "yo",
            "za",
            "zh",
            "zu"
        ],
        // From http://data.okfn.org/data/core/language-codes#resource-language-codes-full (IETF language tags)
        locale_regions: [
            "agq-CM",
            "asa-TZ",
            "ast-ES",
            "bas-CM",
            "bem-ZM",
            "bez-TZ",
            "brx-IN",
            "cgg-UG",
            "chr-US",
            "dav-KE",
            "dje-NE",
            "dsb-DE",
            "dua-CM",
            "dyo-SN",
            "ebu-KE",
            "ewo-CM",
            "fil-PH",
            "fur-IT",
            "gsw-CH",
            "gsw-FR",
            "gsw-LI",
            "guz-KE",
            "haw-US",
            "hsb-DE",
            "jgo-CM",
            "jmc-TZ",
            "kab-DZ",
            "kam-KE",
            "kde-TZ",
            "kea-CV",
            "khq-ML",
            "kkj-CM",
            "kln-KE",
            "kok-IN",
            "ksb-TZ",
            "ksf-CM",
            "ksh-DE",
            "lag-TZ",
            "lkt-US",
            "luo-KE",
            "luy-KE",
            "mas-KE",
            "mas-TZ",
            "mer-KE",
            "mfe-MU",
            "mgh-MZ",
            "mgo-CM",
            "mua-CM",
            "naq-NA",
            "nmg-CM",
            "nnh-CM",
            "nus-SD",
            "nyn-UG",
            "rof-TZ",
            "rwk-TZ",
            "sah-RU",
            "saq-KE",
            "sbp-TZ",
            "seh-MZ",
            "ses-ML",
            "shi-Latn",
            "shi-Latn-MA",
            "shi-Tfng",
            "shi-Tfng-MA",
            "smn-FI",
            "teo-KE",
            "teo-UG",
            "twq-NE",
            "tzm-Latn",
            "tzm-Latn-MA",
            "vai-Latn",
            "vai-Latn-LR",
            "vai-Vaii",
            "vai-Vaii-LR",
            "vun-TZ",
            "wae-CH",
            "xog-UG",
            "yav-CM",
            "zgh-MA",
            "af-NA",
            "af-ZA",
            "ak-GH",
            "am-ET",
            "ar-001",
            "ar-AE",
            "ar-BH",
            "ar-DJ",
            "ar-DZ",
            "ar-EG",
            "ar-EH",
            "ar-ER",
            "ar-IL",
            "ar-IQ",
            "ar-JO",
            "ar-KM",
            "ar-KW",
            "ar-LB",
            "ar-LY",
            "ar-MA",
            "ar-MR",
            "ar-OM",
            "ar-PS",
            "ar-QA",
            "ar-SA",
            "ar-SD",
            "ar-SO",
            "ar-SS",
            "ar-SY",
            "ar-TD",
            "ar-TN",
            "ar-YE",
            "as-IN",
            "az-Cyrl",
            "az-Cyrl-AZ",
            "az-Latn",
            "az-Latn-AZ",
            "be-BY",
            "bg-BG",
            "bm-Latn",
            "bm-Latn-ML",
            "bn-BD",
            "bn-IN",
            "bo-CN",
            "bo-IN",
            "br-FR",
            "bs-Cyrl",
            "bs-Cyrl-BA",
            "bs-Latn",
            "bs-Latn-BA",
            "ca-AD",
            "ca-ES",
            "ca-ES-VALENCIA",
            "ca-FR",
            "ca-IT",
            "cs-CZ",
            "cy-GB",
            "da-DK",
            "da-GL",
            "de-AT",
            "de-BE",
            "de-CH",
            "de-DE",
            "de-LI",
            "de-LU",
            "dz-BT",
            "ee-GH",
            "ee-TG",
            "el-CY",
            "el-GR",
            "en-001",
            "en-150",
            "en-AG",
            "en-AI",
            "en-AS",
            "en-AU",
            "en-BB",
            "en-BE",
            "en-BM",
            "en-BS",
            "en-BW",
            "en-BZ",
            "en-CA",
            "en-CC",
            "en-CK",
            "en-CM",
            "en-CX",
            "en-DG",
            "en-DM",
            "en-ER",
            "en-FJ",
            "en-FK",
            "en-FM",
            "en-GB",
            "en-GD",
            "en-GG",
            "en-GH",
            "en-GI",
            "en-GM",
            "en-GU",
            "en-GY",
            "en-HK",
            "en-IE",
            "en-IM",
            "en-IN",
            "en-IO",
            "en-JE",
            "en-JM",
            "en-KE",
            "en-KI",
            "en-KN",
            "en-KY",
            "en-LC",
            "en-LR",
            "en-LS",
            "en-MG",
            "en-MH",
            "en-MO",
            "en-MP",
            "en-MS",
            "en-MT",
            "en-MU",
            "en-MW",
            "en-MY",
            "en-NA",
            "en-NF",
            "en-NG",
            "en-NR",
            "en-NU",
            "en-NZ",
            "en-PG",
            "en-PH",
            "en-PK",
            "en-PN",
            "en-PR",
            "en-PW",
            "en-RW",
            "en-SB",
            "en-SC",
            "en-SD",
            "en-SG",
            "en-SH",
            "en-SL",
            "en-SS",
            "en-SX",
            "en-SZ",
            "en-TC",
            "en-TK",
            "en-TO",
            "en-TT",
            "en-TV",
            "en-TZ",
            "en-UG",
            "en-UM",
            "en-US",
            "en-US-POSIX",
            "en-VC",
            "en-VG",
            "en-VI",
            "en-VU",
            "en-WS",
            "en-ZA",
            "en-ZM",
            "en-ZW",
            "eo-001",
            "es-419",
            "es-AR",
            "es-BO",
            "es-CL",
            "es-CO",
            "es-CR",
            "es-CU",
            "es-DO",
            "es-EA",
            "es-EC",
            "es-ES",
            "es-GQ",
            "es-GT",
            "es-HN",
            "es-IC",
            "es-MX",
            "es-NI",
            "es-PA",
            "es-PE",
            "es-PH",
            "es-PR",
            "es-PY",
            "es-SV",
            "es-US",
            "es-UY",
            "es-VE",
            "et-EE",
            "eu-ES",
            "fa-AF",
            "fa-IR",
            "ff-CM",
            "ff-GN",
            "ff-MR",
            "ff-SN",
            "fi-FI",
            "fo-FO",
            "fr-BE",
            "fr-BF",
            "fr-BI",
            "fr-BJ",
            "fr-BL",
            "fr-CA",
            "fr-CD",
            "fr-CF",
            "fr-CG",
            "fr-CH",
            "fr-CI",
            "fr-CM",
            "fr-DJ",
            "fr-DZ",
            "fr-FR",
            "fr-GA",
            "fr-GF",
            "fr-GN",
            "fr-GP",
            "fr-GQ",
            "fr-HT",
            "fr-KM",
            "fr-LU",
            "fr-MA",
            "fr-MC",
            "fr-MF",
            "fr-MG",
            "fr-ML",
            "fr-MQ",
            "fr-MR",
            "fr-MU",
            "fr-NC",
            "fr-NE",
            "fr-PF",
            "fr-PM",
            "fr-RE",
            "fr-RW",
            "fr-SC",
            "fr-SN",
            "fr-SY",
            "fr-TD",
            "fr-TG",
            "fr-TN",
            "fr-VU",
            "fr-WF",
            "fr-YT",
            "fy-NL",
            "ga-IE",
            "gd-GB",
            "gl-ES",
            "gu-IN",
            "gv-IM",
            "ha-Latn",
            "ha-Latn-GH",
            "ha-Latn-NE",
            "ha-Latn-NG",
            "he-IL",
            "hi-IN",
            "hr-BA",
            "hr-HR",
            "hu-HU",
            "hy-AM",
            "id-ID",
            "ig-NG",
            "ii-CN",
            "is-IS",
            "it-CH",
            "it-IT",
            "it-SM",
            "ja-JP",
            "ka-GE",
            "ki-KE",
            "kk-Cyrl",
            "kk-Cyrl-KZ",
            "kl-GL",
            "km-KH",
            "kn-IN",
            "ko-KP",
            "ko-KR",
            "ks-Arab",
            "ks-Arab-IN",
            "kw-GB",
            "ky-Cyrl",
            "ky-Cyrl-KG",
            "lb-LU",
            "lg-UG",
            "ln-AO",
            "ln-CD",
            "ln-CF",
            "ln-CG",
            "lo-LA",
            "lt-LT",
            "lu-CD",
            "lv-LV",
            "mg-MG",
            "mk-MK",
            "ml-IN",
            "mn-Cyrl",
            "mn-Cyrl-MN",
            "mr-IN",
            "ms-Latn",
            "ms-Latn-BN",
            "ms-Latn-MY",
            "ms-Latn-SG",
            "mt-MT",
            "my-MM",
            "nb-NO",
            "nb-SJ",
            "nd-ZW",
            "ne-IN",
            "ne-NP",
            "nl-AW",
            "nl-BE",
            "nl-BQ",
            "nl-CW",
            "nl-NL",
            "nl-SR",
            "nl-SX",
            "nn-NO",
            "om-ET",
            "om-KE",
            "or-IN",
            "os-GE",
            "os-RU",
            "pa-Arab",
            "pa-Arab-PK",
            "pa-Guru",
            "pa-Guru-IN",
            "pl-PL",
            "ps-AF",
            "pt-AO",
            "pt-BR",
            "pt-CV",
            "pt-GW",
            "pt-MO",
            "pt-MZ",
            "pt-PT",
            "pt-ST",
            "pt-TL",
            "qu-BO",
            "qu-EC",
            "qu-PE",
            "rm-CH",
            "rn-BI",
            "ro-MD",
            "ro-RO",
            "ru-BY",
            "ru-KG",
            "ru-KZ",
            "ru-MD",
            "ru-RU",
            "ru-UA",
            "rw-RW",
            "se-FI",
            "se-NO",
            "se-SE",
            "sg-CF",
            "si-LK",
            "sk-SK",
            "sl-SI",
            "sn-ZW",
            "so-DJ",
            "so-ET",
            "so-KE",
            "so-SO",
            "sq-AL",
            "sq-MK",
            "sq-XK",
            "sr-Cyrl",
            "sr-Cyrl-BA",
            "sr-Cyrl-ME",
            "sr-Cyrl-RS",
            "sr-Cyrl-XK",
            "sr-Latn",
            "sr-Latn-BA",
            "sr-Latn-ME",
            "sr-Latn-RS",
            "sr-Latn-XK",
            "sv-AX",
            "sv-FI",
            "sv-SE",
            "sw-CD",
            "sw-KE",
            "sw-TZ",
            "sw-UG",
            "ta-IN",
            "ta-LK",
            "ta-MY",
            "ta-SG",
            "te-IN",
            "th-TH",
            "ti-ER",
            "ti-ET",
            "to-TO",
            "tr-CY",
            "tr-TR",
            "ug-Arab",
            "ug-Arab-CN",
            "uk-UA",
            "ur-IN",
            "ur-PK",
            "uz-Arab",
            "uz-Arab-AF",
            "uz-Cyrl",
            "uz-Cyrl-UZ",
            "uz-Latn",
            "uz-Latn-UZ",
            "vi-VN",
            "yi-001",
            "yo-BJ",
            "yo-NG",
            "zh-Hans",
            "zh-Hans-CN",
            "zh-Hans-HK",
            "zh-Hans-MO",
            "zh-Hans-SG",
            "zh-Hant",
            "zh-Hant-HK",
            "zh-Hant-MO",
            "zh-Hant-TW",
            "zu-ZA"
        ],
        us_states_and_dc: [
            {
                name: 'Alabama',
                abbreviation: 'AL'
            },
            {
                name: 'Alaska',
                abbreviation: 'AK'
            },
            {
                name: 'Arizona',
                abbreviation: 'AZ'
            },
            {
                name: 'Arkansas',
                abbreviation: 'AR'
            },
            {
                name: 'California',
                abbreviation: 'CA'
            },
            {
                name: 'Colorado',
                abbreviation: 'CO'
            },
            {
                name: 'Connecticut',
                abbreviation: 'CT'
            },
            {
                name: 'Delaware',
                abbreviation: 'DE'
            },
            {
                name: 'District of Columbia',
                abbreviation: 'DC'
            },
            {
                name: 'Florida',
                abbreviation: 'FL'
            },
            {
                name: 'Georgia',
                abbreviation: 'GA'
            },
            {
                name: 'Hawaii',
                abbreviation: 'HI'
            },
            {
                name: 'Idaho',
                abbreviation: 'ID'
            },
            {
                name: 'Illinois',
                abbreviation: 'IL'
            },
            {
                name: 'Indiana',
                abbreviation: 'IN'
            },
            {
                name: 'Iowa',
                abbreviation: 'IA'
            },
            {
                name: 'Kansas',
                abbreviation: 'KS'
            },
            {
                name: 'Kentucky',
                abbreviation: 'KY'
            },
            {
                name: 'Louisiana',
                abbreviation: 'LA'
            },
            {
                name: 'Maine',
                abbreviation: 'ME'
            },
            {
                name: 'Maryland',
                abbreviation: 'MD'
            },
            {
                name: 'Massachusetts',
                abbreviation: 'MA'
            },
            {
                name: 'Michigan',
                abbreviation: 'MI'
            },
            {
                name: 'Minnesota',
                abbreviation: 'MN'
            },
            {
                name: 'Mississippi',
                abbreviation: 'MS'
            },
            {
                name: 'Missouri',
                abbreviation: 'MO'
            },
            {
                name: 'Montana',
                abbreviation: 'MT'
            },
            {
                name: 'Nebraska',
                abbreviation: 'NE'
            },
            {
                name: 'Nevada',
                abbreviation: 'NV'
            },
            {
                name: 'New Hampshire',
                abbreviation: 'NH'
            },
            {
                name: 'New Jersey',
                abbreviation: 'NJ'
            },
            {
                name: 'New Mexico',
                abbreviation: 'NM'
            },
            {
                name: 'New York',
                abbreviation: 'NY'
            },
            {
                name: 'North Carolina',
                abbreviation: 'NC'
            },
            {
                name: 'North Dakota',
                abbreviation: 'ND'
            },
            {
                name: 'Ohio',
                abbreviation: 'OH'
            },
            {
                name: 'Oklahoma',
                abbreviation: 'OK'
            },
            {
                name: 'Oregon',
                abbreviation: 'OR'
            },
            {
                name: 'Pennsylvania',
                abbreviation: 'PA'
            },
            {
                name: 'Rhode Island',
                abbreviation: 'RI'
            },
            {
                name: 'South Carolina',
                abbreviation: 'SC'
            },
            {
                name: 'South Dakota',
                abbreviation: 'SD'
            },
            {
                name: 'Tennessee',
                abbreviation: 'TN'
            },
            {
                name: 'Texas',
                abbreviation: 'TX'
            },
            {
                name: 'Utah',
                abbreviation: 'UT'
            },
            {
                name: 'Vermont',
                abbreviation: 'VT'
            },
            {
                name: 'Virginia',
                abbreviation: 'VA'
            },
            {
                name: 'Washington',
                abbreviation: 'WA'
            },
            {
                name: 'West Virginia',
                abbreviation: 'WV'
            },
            {
                name: 'Wisconsin',
                abbreviation: 'WI'
            },
            {
                name: 'Wyoming',
                abbreviation: 'WY'
            }
        ],
        territories: [
            {
                name: 'American Samoa',
                abbreviation: 'AS'
            },
            {
                name: 'Federated States of Micronesia',
                abbreviation: 'FM'
            },
            {
                name: 'Guam',
                abbreviation: 'GU'
            },
            {
                name: 'Marshall Islands',
                abbreviation: 'MH'
            },
            {
                name: 'Northern Mariana Islands',
                abbreviation: 'MP'
            },
            {
                name: 'Puerto Rico',
                abbreviation: 'PR'
            },
            {
                name: 'Virgin Islands, U.S.',
                abbreviation: 'VI'
            }
        ],
        armed_forces: [
            {
                name: 'Armed Forces Europe',
                abbreviation: 'AE'
            },
            {
                name: 'Armed Forces Pacific',
                abbreviation: 'AP'
            },
            {
                name: 'Armed Forces the Americas',
                abbreviation: 'AA'
            }
        ],
        country_regions: {
            it: [
                {
                    name: "Valle d'Aosta",
                    abbreviation: "VDA"
                },
                {
                    name: "Piemonte",
                    abbreviation: "PIE"
                },
                {
                    name: "Lombardia",
                    abbreviation: "LOM"
                },
                {
                    name: "Veneto",
                    abbreviation: "VEN"
                },
                {
                    name: "Trentino Alto Adige",
                    abbreviation: "TAA"
                },
                {
                    name: "Friuli Venezia Giulia",
                    abbreviation: "FVG"
                },
                {
                    name: "Liguria",
                    abbreviation: "LIG"
                },
                {
                    name: "Emilia Romagna",
                    abbreviation: "EMR"
                },
                {
                    name: "Toscana",
                    abbreviation: "TOS"
                },
                {
                    name: "Umbria",
                    abbreviation: "UMB"
                },
                {
                    name: "Marche",
                    abbreviation: "MAR"
                },
                {
                    name: "Abruzzo",
                    abbreviation: "ABR"
                },
                {
                    name: "Lazio",
                    abbreviation: "LAZ"
                },
                {
                    name: "Campania",
                    abbreviation: "CAM"
                },
                {
                    name: "Puglia",
                    abbreviation: "PUG"
                },
                {
                    name: "Basilicata",
                    abbreviation: "BAS"
                },
                {
                    name: "Molise",
                    abbreviation: "MOL"
                },
                {
                    name: "Calabria",
                    abbreviation: "CAL"
                },
                {
                    name: "Sicilia",
                    abbreviation: "SIC"
                },
                {
                    name: "Sardegna",
                    abbreviation: "SAR"
                }
            ],
            mx: [
                {
                    name: 'Aguascalientes',
                    abbreviation: 'AGU'
                },
                {
                    name: 'Baja California',
                    abbreviation: 'BCN'
                },
                {
                    name: 'Baja California Sur',
                    abbreviation: 'BCS'
                },
                {
                    name: 'Campeche',
                    abbreviation: 'CAM'
                },
                {
                    name: 'Chiapas',
                    abbreviation: 'CHP'
                },
                {
                    name: 'Chihuahua',
                    abbreviation: 'CHH'
                },
                {
                    name: "Ciudad de M\xe9xico",
                    abbreviation: 'DIF'
                },
                {
                    name: 'Coahuila',
                    abbreviation: 'COA'
                },
                {
                    name: 'Colima',
                    abbreviation: 'COL'
                },
                {
                    name: 'Durango',
                    abbreviation: 'DUR'
                },
                {
                    name: 'Guanajuato',
                    abbreviation: 'GUA'
                },
                {
                    name: 'Guerrero',
                    abbreviation: 'GRO'
                },
                {
                    name: 'Hidalgo',
                    abbreviation: 'HID'
                },
                {
                    name: 'Jalisco',
                    abbreviation: 'JAL'
                },
                {
                    name: "M\xe9xico",
                    abbreviation: 'MEX'
                },
                {
                    name: "Michoac\xe1n",
                    abbreviation: 'MIC'
                },
                {
                    name: 'Morelos',
                    abbreviation: 'MOR'
                },
                {
                    name: 'Nayarit',
                    abbreviation: 'NAY'
                },
                {
                    name: "Nuevo Le\xf3n",
                    abbreviation: 'NLE'
                },
                {
                    name: 'Oaxaca',
                    abbreviation: 'OAX'
                },
                {
                    name: 'Puebla',
                    abbreviation: 'PUE'
                },
                {
                    name: "Quer\xe9taro",
                    abbreviation: 'QUE'
                },
                {
                    name: 'Quintana Roo',
                    abbreviation: 'ROO'
                },
                {
                    name: "San Luis Potos\xed",
                    abbreviation: 'SLP'
                },
                {
                    name: 'Sinaloa',
                    abbreviation: 'SIN'
                },
                {
                    name: 'Sonora',
                    abbreviation: 'SON'
                },
                {
                    name: 'Tabasco',
                    abbreviation: 'TAB'
                },
                {
                    name: 'Tamaulipas',
                    abbreviation: 'TAM'
                },
                {
                    name: 'Tlaxcala',
                    abbreviation: 'TLA'
                },
                {
                    name: 'Veracruz',
                    abbreviation: 'VER'
                },
                {
                    name: "Yucat\xe1n",
                    abbreviation: 'YUC'
                },
                {
                    name: 'Zacatecas',
                    abbreviation: 'ZAC'
                }
            ]
        },
        street_suffixes: {
            'us': [
                {
                    name: 'Avenue',
                    abbreviation: 'Ave'
                },
                {
                    name: 'Boulevard',
                    abbreviation: 'Blvd'
                },
                {
                    name: 'Center',
                    abbreviation: 'Ctr'
                },
                {
                    name: 'Circle',
                    abbreviation: 'Cir'
                },
                {
                    name: 'Court',
                    abbreviation: 'Ct'
                },
                {
                    name: 'Drive',
                    abbreviation: 'Dr'
                },
                {
                    name: 'Extension',
                    abbreviation: 'Ext'
                },
                {
                    name: 'Glen',
                    abbreviation: 'Gln'
                },
                {
                    name: 'Grove',
                    abbreviation: 'Grv'
                },
                {
                    name: 'Heights',
                    abbreviation: 'Hts'
                },
                {
                    name: 'Highway',
                    abbreviation: 'Hwy'
                },
                {
                    name: 'Junction',
                    abbreviation: 'Jct'
                },
                {
                    name: 'Key',
                    abbreviation: 'Key'
                },
                {
                    name: 'Lane',
                    abbreviation: 'Ln'
                },
                {
                    name: 'Loop',
                    abbreviation: 'Loop'
                },
                {
                    name: 'Manor',
                    abbreviation: 'Mnr'
                },
                {
                    name: 'Mill',
                    abbreviation: 'Mill'
                },
                {
                    name: 'Park',
                    abbreviation: 'Park'
                },
                {
                    name: 'Parkway',
                    abbreviation: 'Pkwy'
                },
                {
                    name: 'Pass',
                    abbreviation: 'Pass'
                },
                {
                    name: 'Path',
                    abbreviation: 'Path'
                },
                {
                    name: 'Pike',
                    abbreviation: 'Pike'
                },
                {
                    name: 'Place',
                    abbreviation: 'Pl'
                },
                {
                    name: 'Plaza',
                    abbreviation: 'Plz'
                },
                {
                    name: 'Point',
                    abbreviation: 'Pt'
                },
                {
                    name: 'Ridge',
                    abbreviation: 'Rdg'
                },
                {
                    name: 'River',
                    abbreviation: 'Riv'
                },
                {
                    name: 'Road',
                    abbreviation: 'Rd'
                },
                {
                    name: 'Square',
                    abbreviation: 'Sq'
                },
                {
                    name: 'Street',
                    abbreviation: 'St'
                },
                {
                    name: 'Terrace',
                    abbreviation: 'Ter'
                },
                {
                    name: 'Trail',
                    abbreviation: 'Trl'
                },
                {
                    name: 'Turnpike',
                    abbreviation: 'Tpke'
                },
                {
                    name: 'View',
                    abbreviation: 'Vw'
                },
                {
                    name: 'Way',
                    abbreviation: 'Way'
                }
            ],
            'it': [
                {
                    name: 'Accesso',
                    abbreviation: 'Acc.'
                },
                {
                    name: 'Alzaia',
                    abbreviation: 'Alz.'
                },
                {
                    name: 'Arco',
                    abbreviation: 'Arco'
                },
                {
                    name: 'Archivolto',
                    abbreviation: 'Acv.'
                },
                {
                    name: 'Arena',
                    abbreviation: 'Arena'
                },
                {
                    name: 'Argine',
                    abbreviation: 'Argine'
                },
                {
                    name: 'Bacino',
                    abbreviation: 'Bacino'
                },
                {
                    name: 'Banchi',
                    abbreviation: 'Banchi'
                },
                {
                    name: 'Banchina',
                    abbreviation: 'Ban.'
                },
                {
                    name: 'Bastioni',
                    abbreviation: 'Bas.'
                },
                {
                    name: 'Belvedere',
                    abbreviation: 'Belv.'
                },
                {
                    name: 'Borgata',
                    abbreviation: 'B.ta'
                },
                {
                    name: 'Borgo',
                    abbreviation: 'B.go'
                },
                {
                    name: 'Calata',
                    abbreviation: 'Cal.'
                },
                {
                    name: 'Calle',
                    abbreviation: 'Calle'
                },
                {
                    name: 'Campiello',
                    abbreviation: 'Cam.'
                },
                {
                    name: 'Campo',
                    abbreviation: 'Cam.'
                },
                {
                    name: 'Canale',
                    abbreviation: 'Can.'
                },
                {
                    name: 'Carraia',
                    abbreviation: 'Carr.'
                },
                {
                    name: 'Cascina',
                    abbreviation: 'Cascina'
                },
                {
                    name: 'Case sparse',
                    abbreviation: 'c.s.'
                },
                {
                    name: 'Cavalcavia',
                    abbreviation: 'Cv.'
                },
                {
                    name: 'Circonvallazione',
                    abbreviation: 'Cv.'
                },
                {
                    name: 'Complanare',
                    abbreviation: 'C.re'
                },
                {
                    name: 'Contrada',
                    abbreviation: 'C.da'
                },
                {
                    name: 'Corso',
                    abbreviation: 'C.so'
                },
                {
                    name: 'Corte',
                    abbreviation: 'C.te'
                },
                {
                    name: 'Cortile',
                    abbreviation: 'C.le'
                },
                {
                    name: 'Diramazione',
                    abbreviation: 'Dir.'
                },
                {
                    name: 'Fondaco',
                    abbreviation: 'F.co'
                },
                {
                    name: 'Fondamenta',
                    abbreviation: 'F.ta'
                },
                {
                    name: 'Fondo',
                    abbreviation: 'F.do'
                },
                {
                    name: 'Frazione',
                    abbreviation: 'Fr.'
                },
                {
                    name: 'Isola',
                    abbreviation: 'Is.'
                },
                {
                    name: 'Largo',
                    abbreviation: 'L.go'
                },
                {
                    name: 'Litoranea',
                    abbreviation: 'Lit.'
                },
                {
                    name: 'Lungolago',
                    abbreviation: 'L.go lago'
                },
                {
                    name: 'Lungo Po',
                    abbreviation: 'l.go Po'
                },
                {
                    name: 'Molo',
                    abbreviation: 'Molo'
                },
                {
                    name: 'Mura',
                    abbreviation: 'Mura'
                },
                {
                    name: 'Passaggio privato',
                    abbreviation: 'pass. priv.'
                },
                {
                    name: 'Passeggiata',
                    abbreviation: 'Pass.'
                },
                {
                    name: 'Piazza',
                    abbreviation: 'P.zza'
                },
                {
                    name: 'Piazzale',
                    abbreviation: 'P.le'
                },
                {
                    name: 'Ponte',
                    abbreviation: 'P.te'
                },
                {
                    name: 'Portico',
                    abbreviation: 'P.co'
                },
                {
                    name: 'Rampa',
                    abbreviation: 'Rampa'
                },
                {
                    name: 'Regione',
                    abbreviation: 'Reg.'
                },
                {
                    name: 'Rione',
                    abbreviation: 'R.ne'
                },
                {
                    name: 'Rio',
                    abbreviation: 'Rio'
                },
                {
                    name: 'Ripa',
                    abbreviation: 'Ripa'
                },
                {
                    name: 'Riva',
                    abbreviation: 'Riva'
                },
                {
                    name: "Rond\xf2",
                    abbreviation: "Rond\xf2"
                },
                {
                    name: 'Rotonda',
                    abbreviation: 'Rot.'
                },
                {
                    name: 'Sagrato',
                    abbreviation: 'Sagr.'
                },
                {
                    name: 'Salita',
                    abbreviation: 'Sal.'
                },
                {
                    name: 'Scalinata',
                    abbreviation: 'Scal.'
                },
                {
                    name: 'Scalone',
                    abbreviation: 'Scal.'
                },
                {
                    name: 'Slargo',
                    abbreviation: 'Sl.'
                },
                {
                    name: 'Sottoportico',
                    abbreviation: 'Sott.'
                },
                {
                    name: 'Strada',
                    abbreviation: 'Str.'
                },
                {
                    name: 'Stradale',
                    abbreviation: 'Str.le'
                },
                {
                    name: 'Strettoia',
                    abbreviation: 'Strett.'
                },
                {
                    name: 'Traversa',
                    abbreviation: 'Trav.'
                },
                {
                    name: 'Via',
                    abbreviation: 'V.'
                },
                {
                    name: 'Viale',
                    abbreviation: 'V.le'
                },
                {
                    name: 'Vicinale',
                    abbreviation: 'Vic.le'
                },
                {
                    name: 'Vicolo',
                    abbreviation: 'Vic.'
                }
            ],
            'uk': [
                {
                    name: 'Avenue',
                    abbreviation: 'Ave'
                },
                {
                    name: 'Close',
                    abbreviation: 'Cl'
                },
                {
                    name: 'Court',
                    abbreviation: 'Ct'
                },
                {
                    name: 'Crescent',
                    abbreviation: 'Cr'
                },
                {
                    name: 'Drive',
                    abbreviation: 'Dr'
                },
                {
                    name: 'Garden',
                    abbreviation: 'Gdn'
                },
                {
                    name: 'Gardens',
                    abbreviation: 'Gdns'
                },
                {
                    name: 'Green',
                    abbreviation: 'Gn'
                },
                {
                    name: 'Grove',
                    abbreviation: 'Gr'
                },
                {
                    name: 'Lane',
                    abbreviation: 'Ln'
                },
                {
                    name: 'Mount',
                    abbreviation: 'Mt'
                },
                {
                    name: 'Place',
                    abbreviation: 'Pl'
                },
                {
                    name: 'Park',
                    abbreviation: 'Pk'
                },
                {
                    name: 'Ridge',
                    abbreviation: 'Rdg'
                },
                {
                    name: 'Road',
                    abbreviation: 'Rd'
                },
                {
                    name: 'Square',
                    abbreviation: 'Sq'
                },
                {
                    name: 'Street',
                    abbreviation: 'St'
                },
                {
                    name: 'Terrace',
                    abbreviation: 'Ter'
                },
                {
                    name: 'Valley',
                    abbreviation: 'Val'
                }
            ]
        },
        months: [
            {
                name: 'January',
                short_name: 'Jan',
                numeric: '01',
                days: 31
            },
            // Not messing with leap years...
            {
                name: 'February',
                short_name: 'Feb',
                numeric: '02',
                days: 28
            },
            {
                name: 'March',
                short_name: 'Mar',
                numeric: '03',
                days: 31
            },
            {
                name: 'April',
                short_name: 'Apr',
                numeric: '04',
                days: 30
            },
            {
                name: 'May',
                short_name: 'May',
                numeric: '05',
                days: 31
            },
            {
                name: 'June',
                short_name: 'Jun',
                numeric: '06',
                days: 30
            },
            {
                name: 'July',
                short_name: 'Jul',
                numeric: '07',
                days: 31
            },
            {
                name: 'August',
                short_name: 'Aug',
                numeric: '08',
                days: 31
            },
            {
                name: 'September',
                short_name: 'Sep',
                numeric: '09',
                days: 30
            },
            {
                name: 'October',
                short_name: 'Oct',
                numeric: '10',
                days: 31
            },
            {
                name: 'November',
                short_name: 'Nov',
                numeric: '11',
                days: 30
            },
            {
                name: 'December',
                short_name: 'Dec',
                numeric: '12',
                days: 31
            }
        ],
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        cc_types: [
            {
                name: "American Express",
                short_name: 'amex',
                prefix: '34',
                length: 15
            },
            {
                name: "Bankcard",
                short_name: 'bankcard',
                prefix: '5610',
                length: 16
            },
            {
                name: "China UnionPay",
                short_name: 'chinaunion',
                prefix: '62',
                length: 16
            },
            {
                name: "Diners Club Carte Blanche",
                short_name: 'dccarte',
                prefix: '300',
                length: 14
            },
            {
                name: "Diners Club enRoute",
                short_name: 'dcenroute',
                prefix: '2014',
                length: 15
            },
            {
                name: "Diners Club International",
                short_name: 'dcintl',
                prefix: '36',
                length: 14
            },
            {
                name: "Diners Club United States & Canada",
                short_name: 'dcusc',
                prefix: '54',
                length: 16
            },
            {
                name: "Discover Card",
                short_name: 'discover',
                prefix: '6011',
                length: 16
            },
            {
                name: "InstaPayment",
                short_name: 'instapay',
                prefix: '637',
                length: 16
            },
            {
                name: "JCB",
                short_name: 'jcb',
                prefix: '3528',
                length: 16
            },
            {
                name: "Laser",
                short_name: 'laser',
                prefix: '6304',
                length: 16
            },
            {
                name: "Maestro",
                short_name: 'maestro',
                prefix: '5018',
                length: 16
            },
            {
                name: "Mastercard",
                short_name: 'mc',
                prefix: '51',
                length: 16
            },
            {
                name: "Solo",
                short_name: 'solo',
                prefix: '6334',
                length: 16
            },
            {
                name: "Switch",
                short_name: 'switch',
                prefix: '4903',
                length: 16
            },
            {
                name: "Visa",
                short_name: 'visa',
                prefix: '4',
                length: 16
            },
            {
                name: "Visa Electron",
                short_name: 'electron',
                prefix: '4026',
                length: 16
            }
        ],
        //return all world currency by ISO 4217
        currency_types: [
            {
                'code': 'AED',
                'name': 'United Arab Emirates Dirham'
            },
            {
                'code': 'AFN',
                'name': 'Afghanistan Afghani'
            },
            {
                'code': 'ALL',
                'name': 'Albania Lek'
            },
            {
                'code': 'AMD',
                'name': 'Armenia Dram'
            },
            {
                'code': 'ANG',
                'name': 'Netherlands Antilles Guilder'
            },
            {
                'code': 'AOA',
                'name': 'Angola Kwanza'
            },
            {
                'code': 'ARS',
                'name': 'Argentina Peso'
            },
            {
                'code': 'AUD',
                'name': 'Australia Dollar'
            },
            {
                'code': 'AWG',
                'name': 'Aruba Guilder'
            },
            {
                'code': 'AZN',
                'name': 'Azerbaijan New Manat'
            },
            {
                'code': 'BAM',
                'name': 'Bosnia and Herzegovina Convertible Marka'
            },
            {
                'code': 'BBD',
                'name': 'Barbados Dollar'
            },
            {
                'code': 'BDT',
                'name': 'Bangladesh Taka'
            },
            {
                'code': 'BGN',
                'name': 'Bulgaria Lev'
            },
            {
                'code': 'BHD',
                'name': 'Bahrain Dinar'
            },
            {
                'code': 'BIF',
                'name': 'Burundi Franc'
            },
            {
                'code': 'BMD',
                'name': 'Bermuda Dollar'
            },
            {
                'code': 'BND',
                'name': 'Brunei Darussalam Dollar'
            },
            {
                'code': 'BOB',
                'name': 'Bolivia Boliviano'
            },
            {
                'code': 'BRL',
                'name': 'Brazil Real'
            },
            {
                'code': 'BSD',
                'name': 'Bahamas Dollar'
            },
            {
                'code': 'BTN',
                'name': 'Bhutan Ngultrum'
            },
            {
                'code': 'BWP',
                'name': 'Botswana Pula'
            },
            {
                'code': 'BYR',
                'name': 'Belarus Ruble'
            },
            {
                'code': 'BZD',
                'name': 'Belize Dollar'
            },
            {
                'code': 'CAD',
                'name': 'Canada Dollar'
            },
            {
                'code': 'CDF',
                'name': 'Congo/Kinshasa Franc'
            },
            {
                'code': 'CHF',
                'name': 'Switzerland Franc'
            },
            {
                'code': 'CLP',
                'name': 'Chile Peso'
            },
            {
                'code': 'CNY',
                'name': 'China Yuan Renminbi'
            },
            {
                'code': 'COP',
                'name': 'Colombia Peso'
            },
            {
                'code': 'CRC',
                'name': 'Costa Rica Colon'
            },
            {
                'code': 'CUC',
                'name': 'Cuba Convertible Peso'
            },
            {
                'code': 'CUP',
                'name': 'Cuba Peso'
            },
            {
                'code': 'CVE',
                'name': 'Cape Verde Escudo'
            },
            {
                'code': 'CZK',
                'name': 'Czech Republic Koruna'
            },
            {
                'code': 'DJF',
                'name': 'Djibouti Franc'
            },
            {
                'code': 'DKK',
                'name': 'Denmark Krone'
            },
            {
                'code': 'DOP',
                'name': 'Dominican Republic Peso'
            },
            {
                'code': 'DZD',
                'name': 'Algeria Dinar'
            },
            {
                'code': 'EGP',
                'name': 'Egypt Pound'
            },
            {
                'code': 'ERN',
                'name': 'Eritrea Nakfa'
            },
            {
                'code': 'ETB',
                'name': 'Ethiopia Birr'
            },
            {
                'code': 'EUR',
                'name': 'Euro Member Countries'
            },
            {
                'code': 'FJD',
                'name': 'Fiji Dollar'
            },
            {
                'code': 'FKP',
                'name': 'Falkland Islands (Malvinas) Pound'
            },
            {
                'code': 'GBP',
                'name': 'United Kingdom Pound'
            },
            {
                'code': 'GEL',
                'name': 'Georgia Lari'
            },
            {
                'code': 'GGP',
                'name': 'Guernsey Pound'
            },
            {
                'code': 'GHS',
                'name': 'Ghana Cedi'
            },
            {
                'code': 'GIP',
                'name': 'Gibraltar Pound'
            },
            {
                'code': 'GMD',
                'name': 'Gambia Dalasi'
            },
            {
                'code': 'GNF',
                'name': 'Guinea Franc'
            },
            {
                'code': 'GTQ',
                'name': 'Guatemala Quetzal'
            },
            {
                'code': 'GYD',
                'name': 'Guyana Dollar'
            },
            {
                'code': 'HKD',
                'name': 'Hong Kong Dollar'
            },
            {
                'code': 'HNL',
                'name': 'Honduras Lempira'
            },
            {
                'code': 'HRK',
                'name': 'Croatia Kuna'
            },
            {
                'code': 'HTG',
                'name': 'Haiti Gourde'
            },
            {
                'code': 'HUF',
                'name': 'Hungary Forint'
            },
            {
                'code': 'IDR',
                'name': 'Indonesia Rupiah'
            },
            {
                'code': 'ILS',
                'name': 'Israel Shekel'
            },
            {
                'code': 'IMP',
                'name': 'Isle of Man Pound'
            },
            {
                'code': 'INR',
                'name': 'India Rupee'
            },
            {
                'code': 'IQD',
                'name': 'Iraq Dinar'
            },
            {
                'code': 'IRR',
                'name': 'Iran Rial'
            },
            {
                'code': 'ISK',
                'name': 'Iceland Krona'
            },
            {
                'code': 'JEP',
                'name': 'Jersey Pound'
            },
            {
                'code': 'JMD',
                'name': 'Jamaica Dollar'
            },
            {
                'code': 'JOD',
                'name': 'Jordan Dinar'
            },
            {
                'code': 'JPY',
                'name': 'Japan Yen'
            },
            {
                'code': 'KES',
                'name': 'Kenya Shilling'
            },
            {
                'code': 'KGS',
                'name': 'Kyrgyzstan Som'
            },
            {
                'code': 'KHR',
                'name': 'Cambodia Riel'
            },
            {
                'code': 'KMF',
                'name': 'Comoros Franc'
            },
            {
                'code': 'KPW',
                'name': 'Korea (North) Won'
            },
            {
                'code': 'KRW',
                'name': 'Korea (South) Won'
            },
            {
                'code': 'KWD',
                'name': 'Kuwait Dinar'
            },
            {
                'code': 'KYD',
                'name': 'Cayman Islands Dollar'
            },
            {
                'code': 'KZT',
                'name': 'Kazakhstan Tenge'
            },
            {
                'code': 'LAK',
                'name': 'Laos Kip'
            },
            {
                'code': 'LBP',
                'name': 'Lebanon Pound'
            },
            {
                'code': 'LKR',
                'name': 'Sri Lanka Rupee'
            },
            {
                'code': 'LRD',
                'name': 'Liberia Dollar'
            },
            {
                'code': 'LSL',
                'name': 'Lesotho Loti'
            },
            {
                'code': 'LTL',
                'name': 'Lithuania Litas'
            },
            {
                'code': 'LYD',
                'name': 'Libya Dinar'
            },
            {
                'code': 'MAD',
                'name': 'Morocco Dirham'
            },
            {
                'code': 'MDL',
                'name': 'Moldova Leu'
            },
            {
                'code': 'MGA',
                'name': 'Madagascar Ariary'
            },
            {
                'code': 'MKD',
                'name': 'Macedonia Denar'
            },
            {
                'code': 'MMK',
                'name': 'Myanmar (Burma) Kyat'
            },
            {
                'code': 'MNT',
                'name': 'Mongolia Tughrik'
            },
            {
                'code': 'MOP',
                'name': 'Macau Pataca'
            },
            {
                'code': 'MRO',
                'name': 'Mauritania Ouguiya'
            },
            {
                'code': 'MUR',
                'name': 'Mauritius Rupee'
            },
            {
                'code': 'MVR',
                'name': 'Maldives (Maldive Islands) Rufiyaa'
            },
            {
                'code': 'MWK',
                'name': 'Malawi Kwacha'
            },
            {
                'code': 'MXN',
                'name': 'Mexico Peso'
            },
            {
                'code': 'MYR',
                'name': 'Malaysia Ringgit'
            },
            {
                'code': 'MZN',
                'name': 'Mozambique Metical'
            },
            {
                'code': 'NAD',
                'name': 'Namibia Dollar'
            },
            {
                'code': 'NGN',
                'name': 'Nigeria Naira'
            },
            {
                'code': 'NIO',
                'name': 'Nicaragua Cordoba'
            },
            {
                'code': 'NOK',
                'name': 'Norway Krone'
            },
            {
                'code': 'NPR',
                'name': 'Nepal Rupee'
            },
            {
                'code': 'NZD',
                'name': 'New Zealand Dollar'
            },
            {
                'code': 'OMR',
                'name': 'Oman Rial'
            },
            {
                'code': 'PAB',
                'name': 'Panama Balboa'
            },
            {
                'code': 'PEN',
                'name': 'Peru Nuevo Sol'
            },
            {
                'code': 'PGK',
                'name': 'Papua New Guinea Kina'
            },
            {
                'code': 'PHP',
                'name': 'Philippines Peso'
            },
            {
                'code': 'PKR',
                'name': 'Pakistan Rupee'
            },
            {
                'code': 'PLN',
                'name': 'Poland Zloty'
            },
            {
                'code': 'PYG',
                'name': 'Paraguay Guarani'
            },
            {
                'code': 'QAR',
                'name': 'Qatar Riyal'
            },
            {
                'code': 'RON',
                'name': 'Romania New Leu'
            },
            {
                'code': 'RSD',
                'name': 'Serbia Dinar'
            },
            {
                'code': 'RUB',
                'name': 'Russia Ruble'
            },
            {
                'code': 'RWF',
                'name': 'Rwanda Franc'
            },
            {
                'code': 'SAR',
                'name': 'Saudi Arabia Riyal'
            },
            {
                'code': 'SBD',
                'name': 'Solomon Islands Dollar'
            },
            {
                'code': 'SCR',
                'name': 'Seychelles Rupee'
            },
            {
                'code': 'SDG',
                'name': 'Sudan Pound'
            },
            {
                'code': 'SEK',
                'name': 'Sweden Krona'
            },
            {
                'code': 'SGD',
                'name': 'Singapore Dollar'
            },
            {
                'code': 'SHP',
                'name': 'Saint Helena Pound'
            },
            {
                'code': 'SLL',
                'name': 'Sierra Leone Leone'
            },
            {
                'code': 'SOS',
                'name': 'Somalia Shilling'
            },
            {
                'code': 'SPL',
                'name': 'Seborga Luigino'
            },
            {
                'code': 'SRD',
                'name': 'Suriname Dollar'
            },
            {
                'code': 'STD',
                'name': "S\xe3o Tom\xe9 and Pr\xedncipe Dobra"
            },
            {
                'code': 'SVC',
                'name': 'El Salvador Colon'
            },
            {
                'code': 'SYP',
                'name': 'Syria Pound'
            },
            {
                'code': 'SZL',
                'name': 'Swaziland Lilangeni'
            },
            {
                'code': 'THB',
                'name': 'Thailand Baht'
            },
            {
                'code': 'TJS',
                'name': 'Tajikistan Somoni'
            },
            {
                'code': 'TMT',
                'name': 'Turkmenistan Manat'
            },
            {
                'code': 'TND',
                'name': 'Tunisia Dinar'
            },
            {
                'code': 'TOP',
                'name': 'Tonga Pa\'anga'
            },
            {
                'code': 'TRY',
                'name': 'Turkey Lira'
            },
            {
                'code': 'TTD',
                'name': 'Trinidad and Tobago Dollar'
            },
            {
                'code': 'TVD',
                'name': 'Tuvalu Dollar'
            },
            {
                'code': 'TWD',
                'name': 'Taiwan New Dollar'
            },
            {
                'code': 'TZS',
                'name': 'Tanzania Shilling'
            },
            {
                'code': 'UAH',
                'name': 'Ukraine Hryvnia'
            },
            {
                'code': 'UGX',
                'name': 'Uganda Shilling'
            },
            {
                'code': 'USD',
                'name': 'United States Dollar'
            },
            {
                'code': 'UYU',
                'name': 'Uruguay Peso'
            },
            {
                'code': 'UZS',
                'name': 'Uzbekistan Som'
            },
            {
                'code': 'VEF',
                'name': 'Venezuela Bolivar'
            },
            {
                'code': 'VND',
                'name': 'Viet Nam Dong'
            },
            {
                'code': 'VUV',
                'name': 'Vanuatu Vatu'
            },
            {
                'code': 'WST',
                'name': 'Samoa Tala'
            },
            {
                'code': 'XAF',
                'name': "Communaut\xe9 Financi\xe8re Africaine (BEAC) CFA Franc BEAC"
            },
            {
                'code': 'XCD',
                'name': 'East Caribbean Dollar'
            },
            {
                'code': 'XDR',
                'name': 'International Monetary Fund (IMF) Special Drawing Rights'
            },
            {
                'code': 'XOF',
                'name': "Communaut\xe9 Financi\xe8re Africaine (BCEAO) Franc"
            },
            {
                'code': 'XPF',
                'name': "Comptoirs Fran\xe7ais du Pacifique (CFP) Franc"
            },
            {
                'code': 'YER',
                'name': 'Yemen Rial'
            },
            {
                'code': 'ZAR',
                'name': 'South Africa Rand'
            },
            {
                'code': 'ZMW',
                'name': 'Zambia Kwacha'
            },
            {
                'code': 'ZWD',
                'name': 'Zimbabwe Dollar'
            }
        ],
        // return the names of all valide colors
        colorNames: [
            "AliceBlue",
            "Black",
            "Navy",
            "DarkBlue",
            "MediumBlue",
            "Blue",
            "DarkGreen",
            "Green",
            "Teal",
            "DarkCyan",
            "DeepSkyBlue",
            "DarkTurquoise",
            "MediumSpringGreen",
            "Lime",
            "SpringGreen",
            "Aqua",
            "Cyan",
            "MidnightBlue",
            "DodgerBlue",
            "LightSeaGreen",
            "ForestGreen",
            "SeaGreen",
            "DarkSlateGray",
            "LimeGreen",
            "MediumSeaGreen",
            "Turquoise",
            "RoyalBlue",
            "SteelBlue",
            "DarkSlateBlue",
            "MediumTurquoise",
            "Indigo",
            "DarkOliveGreen",
            "CadetBlue",
            "CornflowerBlue",
            "RebeccaPurple",
            "MediumAquaMarine",
            "DimGray",
            "SlateBlue",
            "OliveDrab",
            "SlateGray",
            "LightSlateGray",
            "MediumSlateBlue",
            "LawnGreen",
            "Chartreuse",
            "Aquamarine",
            "Maroon",
            "Purple",
            "Olive",
            "Gray",
            "SkyBlue",
            "LightSkyBlue",
            "BlueViolet",
            "DarkRed",
            "DarkMagenta",
            "SaddleBrown",
            "Ivory",
            "White",
            "DarkSeaGreen",
            "LightGreen",
            "MediumPurple",
            "DarkViolet",
            "PaleGreen",
            "DarkOrchid",
            "YellowGreen",
            "Sienna",
            "Brown",
            "DarkGray",
            "LightBlue",
            "GreenYellow",
            "PaleTurquoise",
            "LightSteelBlue",
            "PowderBlue",
            "FireBrick",
            "DarkGoldenRod",
            "MediumOrchid",
            "RosyBrown",
            "DarkKhaki",
            "Silver",
            "MediumVioletRed",
            "IndianRed",
            "Peru",
            "Chocolate",
            "Tan",
            "LightGray",
            "Thistle",
            "Orchid",
            "GoldenRod",
            "PaleVioletRed",
            "Crimson",
            "Gainsboro",
            "Plum",
            "BurlyWood",
            "LightCyan",
            "Lavender",
            "DarkSalmon",
            "Violet",
            "PaleGoldenRod",
            "LightCoral",
            "Khaki",
            "AliceBlue",
            "HoneyDew",
            "Azure",
            "SandyBrown",
            "Wheat",
            "Beige",
            "WhiteSmoke",
            "MintCream",
            "GhostWhite",
            "Salmon",
            "AntiqueWhite",
            "Linen",
            "LightGoldenRodYellow",
            "OldLace",
            "Red",
            "Fuchsia",
            "Magenta",
            "DeepPink",
            "OrangeRed",
            "Tomato",
            "HotPink",
            "Coral",
            "DarkOrange",
            "LightSalmon",
            "Orange",
            "LightPink",
            "Pink",
            "Gold",
            "PeachPuff",
            "NavajoWhite",
            "Moccasin",
            "Bisque",
            "MistyRose",
            "BlanchedAlmond",
            "PapayaWhip",
            "LavenderBlush",
            "SeaShell",
            "Cornsilk",
            "LemonChiffon",
            "FloralWhite",
            "Snow",
            "Yellow",
            "LightYellow"
        ],
        // Data taken from https://www.sec.gov/rules/other/4-460list.htm
        company: [
            "3Com Corp",
            "3M Company",
            "A.G. Edwards Inc.",
            "Abbott Laboratories",
            "Abercrombie & Fitch Co.",
            "ABM Industries Incorporated",
            "Ace Hardware Corporation",
            "ACT Manufacturing Inc.",
            "Acterna Corp.",
            "Adams Resources & Energy, Inc.",
            "ADC Telecommunications, Inc.",
            "Adelphia Communications Corporation",
            "Administaff, Inc.",
            "Adobe Systems Incorporated",
            "Adolph Coors Company",
            "Advance Auto Parts, Inc.",
            "Advanced Micro Devices, Inc.",
            "AdvancePCS, Inc.",
            "Advantica Restaurant Group, Inc.",
            "The AES Corporation",
            "Aetna Inc.",
            "Affiliated Computer Services, Inc.",
            "AFLAC Incorporated",
            "AGCO Corporation",
            "Agilent Technologies, Inc.",
            "Agway Inc.",
            "Apartment Investment and Management Company",
            "Air Products and Chemicals, Inc.",
            "Airborne, Inc.",
            "Airgas, Inc.",
            "AK Steel Holding Corporation",
            "Alaska Air Group, Inc.",
            "Alberto-Culver Company",
            "Albertson's, Inc.",
            "Alcoa Inc.",
            "Alleghany Corporation",
            "Allegheny Energy, Inc.",
            "Allegheny Technologies Incorporated",
            "Allergan, Inc.",
            "ALLETE, Inc.",
            "Alliant Energy Corporation",
            "Allied Waste Industries, Inc.",
            "Allmerica Financial Corporation",
            "The Allstate Corporation",
            "ALLTEL Corporation",
            "The Alpine Group, Inc.",
            "Amazon.com, Inc.",
            "AMC Entertainment Inc.",
            "American Power Conversion Corporation",
            "Amerada Hess Corporation",
            "AMERCO",
            "Ameren Corporation",
            "America West Holdings Corporation",
            "American Axle & Manufacturing Holdings, Inc.",
            "American Eagle Outfitters, Inc.",
            "American Electric Power Company, Inc.",
            "American Express Company",
            "American Financial Group, Inc.",
            "American Greetings Corporation",
            "American International Group, Inc.",
            "American Standard Companies Inc.",
            "American Water Works Company, Inc.",
            "AmerisourceBergen Corporation",
            "Ames Department Stores, Inc.",
            "Amgen Inc.",
            "Amkor Technology, Inc.",
            "AMR Corporation",
            "AmSouth Bancorp.",
            "Amtran, Inc.",
            "Anadarko Petroleum Corporation",
            "Analog Devices, Inc.",
            "Anheuser-Busch Companies, Inc.",
            "Anixter International Inc.",
            "AnnTaylor Inc.",
            "Anthem, Inc.",
            "AOL Time Warner Inc.",
            "Aon Corporation",
            "Apache Corporation",
            "Apple Computer, Inc.",
            "Applera Corporation",
            "Applied Industrial Technologies, Inc.",
            "Applied Materials, Inc.",
            "Aquila, Inc.",
            "ARAMARK Corporation",
            "Arch Coal, Inc.",
            "Archer Daniels Midland Company",
            "Arkansas Best Corporation",
            "Armstrong Holdings, Inc.",
            "Arrow Electronics, Inc.",
            "ArvinMeritor, Inc.",
            "Ashland Inc.",
            "Astoria Financial Corporation",
            "AT&T Corp.",
            "Atmel Corporation",
            "Atmos Energy Corporation",
            "Audiovox Corporation",
            "Autoliv, Inc.",
            "Automatic Data Processing, Inc.",
            "AutoNation, Inc.",
            "AutoZone, Inc.",
            "Avaya Inc.",
            "Avery Dennison Corporation",
            "Avista Corporation",
            "Avnet, Inc.",
            "Avon Products, Inc.",
            "Baker Hughes Incorporated",
            "Ball Corporation",
            "Bank of America Corporation",
            "The Bank of New York Company, Inc.",
            "Bank One Corporation",
            "Banknorth Group, Inc.",
            "Banta Corporation",
            "Barnes & Noble, Inc.",
            "Bausch & Lomb Incorporated",
            "Baxter International Inc.",
            "BB&T Corporation",
            "The Bear Stearns Companies Inc.",
            "Beazer Homes USA, Inc.",
            "Beckman Coulter, Inc.",
            "Becton, Dickinson and Company",
            "Bed Bath & Beyond Inc.",
            "Belk, Inc.",
            "Bell Microproducts Inc.",
            "BellSouth Corporation",
            "Belo Corp.",
            "Bemis Company, Inc.",
            "Benchmark Electronics, Inc.",
            "Berkshire Hathaway Inc.",
            "Best Buy Co., Inc.",
            "Bethlehem Steel Corporation",
            "Beverly Enterprises, Inc.",
            "Big Lots, Inc.",
            "BJ Services Company",
            "BJ's Wholesale Club, Inc.",
            "The Black & Decker Corporation",
            "Black Hills Corporation",
            "BMC Software, Inc.",
            "The Boeing Company",
            "Boise Cascade Corporation",
            "Borders Group, Inc.",
            "BorgWarner Inc.",
            "Boston Scientific Corporation",
            "Bowater Incorporated",
            "Briggs & Stratton Corporation",
            "Brightpoint, Inc.",
            "Brinker International, Inc.",
            "Bristol-Myers Squibb Company",
            "Broadwing, Inc.",
            "Brown Shoe Company, Inc.",
            "Brown-Forman Corporation",
            "Brunswick Corporation",
            "Budget Group, Inc.",
            "Burlington Coat Factory Warehouse Corporation",
            "Burlington Industries, Inc.",
            "Burlington Northern Santa Fe Corporation",
            "Burlington Resources Inc.",
            "C. H. Robinson Worldwide Inc.",
            "Cablevision Systems Corp",
            "Cabot Corp",
            "Cadence Design Systems, Inc.",
            "Calpine Corp.",
            "Campbell Soup Co.",
            "Capital One Financial Corp.",
            "Cardinal Health Inc.",
            "Caremark Rx Inc.",
            "Carlisle Cos. Inc.",
            "Carpenter Technology Corp.",
            "Casey's General Stores Inc.",
            "Caterpillar Inc.",
            "CBRL Group Inc.",
            "CDI Corp.",
            "CDW Computer Centers Inc.",
            "CellStar Corp.",
            "Cendant Corp",
            "Cenex Harvest States Cooperatives",
            "Centex Corp.",
            "CenturyTel Inc.",
            "Ceridian Corp.",
            "CH2M Hill Cos. Ltd.",
            "Champion Enterprises Inc.",
            "Charles Schwab Corp.",
            "Charming Shoppes Inc.",
            "Charter Communications Inc.",
            "Charter One Financial Inc.",
            "ChevronTexaco Corp.",
            "Chiquita Brands International Inc.",
            "Chubb Corp",
            "Ciena Corp.",
            "Cigna Corp",
            "Cincinnati Financial Corp.",
            "Cinergy Corp.",
            "Cintas Corp.",
            "Circuit City Stores Inc.",
            "Cisco Systems Inc.",
            "Citigroup, Inc",
            "Citizens Communications Co.",
            "CKE Restaurants Inc.",
            "Clear Channel Communications Inc.",
            "The Clorox Co.",
            "CMGI Inc.",
            "CMS Energy Corp.",
            "CNF Inc.",
            "Coca-Cola Co.",
            "Coca-Cola Enterprises Inc.",
            "Colgate-Palmolive Co.",
            "Collins & Aikman Corp.",
            "Comcast Corp.",
            "Comdisco Inc.",
            "Comerica Inc.",
            "Comfort Systems USA Inc.",
            "Commercial Metals Co.",
            "Community Health Systems Inc.",
            "Compass Bancshares Inc",
            "Computer Associates International Inc.",
            "Computer Sciences Corp.",
            "Compuware Corp.",
            "Comverse Technology Inc.",
            "ConAgra Foods Inc.",
            "Concord EFS Inc.",
            "Conectiv, Inc",
            "Conoco Inc",
            "Conseco Inc.",
            "Consolidated Freightways Corp.",
            "Consolidated Edison Inc.",
            "Constellation Brands Inc.",
            "Constellation Emergy Group Inc.",
            "Continental Airlines Inc.",
            "Convergys Corp.",
            "Cooper Cameron Corp.",
            "Cooper Industries Ltd.",
            "Cooper Tire & Rubber Co.",
            "Corn Products International Inc.",
            "Corning Inc.",
            "Costco Wholesale Corp.",
            "Countrywide Credit Industries Inc.",
            "Coventry Health Care Inc.",
            "Cox Communications Inc.",
            "Crane Co.",
            "Crompton Corp.",
            "Crown Cork & Seal Co. Inc.",
            "CSK Auto Corp.",
            "CSX Corp.",
            "Cummins Inc.",
            "CVS Corp.",
            "Cytec Industries Inc.",
            "D&K Healthcare Resources, Inc.",
            "D.R. Horton Inc.",
            "Dana Corporation",
            "Danaher Corporation",
            "Darden Restaurants Inc.",
            "DaVita Inc.",
            "Dean Foods Company",
            "Deere & Company",
            "Del Monte Foods Co",
            "Dell Computer Corporation",
            "Delphi Corp.",
            "Delta Air Lines Inc.",
            "Deluxe Corporation",
            "Devon Energy Corporation",
            "Di Giorgio Corporation",
            "Dial Corporation",
            "Diebold Incorporated",
            "Dillard's Inc.",
            "DIMON Incorporated",
            "Dole Food Company, Inc.",
            "Dollar General Corporation",
            "Dollar Tree Stores, Inc.",
            "Dominion Resources, Inc.",
            "Domino's Pizza LLC",
            "Dover Corporation, Inc.",
            "Dow Chemical Company",
            "Dow Jones & Company, Inc.",
            "DPL Inc.",
            "DQE Inc.",
            "Dreyer's Grand Ice Cream, Inc.",
            "DST Systems, Inc.",
            "DTE Energy Co.",
            "E.I. Du Pont de Nemours and Company",
            "Duke Energy Corp",
            "Dun & Bradstreet Inc.",
            "DURA Automotive Systems Inc.",
            "DynCorp",
            "Dynegy Inc.",
            "E*Trade Group, Inc.",
            "E.W. Scripps Company",
            "Earthlink, Inc.",
            "Eastman Chemical Company",
            "Eastman Kodak Company",
            "Eaton Corporation",
            "Echostar Communications Corporation",
            "Ecolab Inc.",
            "Edison International",
            "EGL Inc.",
            "El Paso Corporation",
            "Electronic Arts Inc.",
            "Electronic Data Systems Corp.",
            "Eli Lilly and Company",
            "EMC Corporation",
            "Emcor Group Inc.",
            "Emerson Electric Co.",
            "Encompass Services Corporation",
            "Energizer Holdings Inc.",
            "Energy East Corporation",
            "Engelhard Corporation",
            "Enron Corp.",
            "Entergy Corporation",
            "Enterprise Products Partners L.P.",
            "EOG Resources, Inc.",
            "Equifax Inc.",
            "Equitable Resources Inc.",
            "Equity Office Properties Trust",
            "Equity Residential Properties Trust",
            "Estee Lauder Companies Inc.",
            "Exelon Corporation",
            "Exide Technologies",
            "Expeditors International of Washington Inc.",
            "Express Scripts Inc.",
            "ExxonMobil Corporation",
            "Fairchild Semiconductor International Inc.",
            "Family Dollar Stores Inc.",
            "Farmland Industries Inc.",
            "Federal Mogul Corp.",
            "Federated Department Stores Inc.",
            "Federal Express Corp.",
            "Felcor Lodging Trust Inc.",
            "Ferro Corp.",
            "Fidelity National Financial Inc.",
            "Fifth Third Bancorp",
            "First American Financial Corp.",
            "First Data Corp.",
            "First National of Nebraska Inc.",
            "First Tennessee National Corp.",
            "FirstEnergy Corp.",
            "Fiserv Inc.",
            "Fisher Scientific International Inc.",
            "FleetBoston Financial Co.",
            "Fleetwood Enterprises Inc.",
            "Fleming Companies Inc.",
            "Flowers Foods Inc.",
            "Flowserv Corp",
            "Fluor Corp",
            "FMC Corp",
            "Foamex International Inc",
            "Foot Locker Inc",
            "Footstar Inc.",
            "Ford Motor Co",
            "Forest Laboratories Inc.",
            "Fortune Brands Inc.",
            "Foster Wheeler Ltd.",
            "FPL Group Inc.",
            "Franklin Resources Inc.",
            "Freeport McMoran Copper & Gold Inc.",
            "Frontier Oil Corp",
            "Furniture Brands International Inc.",
            "Gannett Co., Inc.",
            "Gap Inc.",
            "Gateway Inc.",
            "GATX Corporation",
            "Gemstar-TV Guide International Inc.",
            "GenCorp Inc.",
            "General Cable Corporation",
            "General Dynamics Corporation",
            "General Electric Company",
            "General Mills Inc",
            "General Motors Corporation",
            "Genesis Health Ventures Inc.",
            "Gentek Inc.",
            "Gentiva Health Services Inc.",
            "Genuine Parts Company",
            "Genuity Inc.",
            "Genzyme Corporation",
            "Georgia Gulf Corporation",
            "Georgia-Pacific Corporation",
            "Gillette Company",
            "Gold Kist Inc.",
            "Golden State Bancorp Inc.",
            "Golden West Financial Corporation",
            "Goldman Sachs Group Inc.",
            "Goodrich Corporation",
            "The Goodyear Tire & Rubber Company",
            "Granite Construction Incorporated",
            "Graybar Electric Company Inc.",
            "Great Lakes Chemical Corporation",
            "Great Plains Energy Inc.",
            "GreenPoint Financial Corp.",
            "Greif Bros. Corporation",
            "Grey Global Group Inc.",
            "Group 1 Automotive Inc.",
            "Guidant Corporation",
            "H&R Block Inc.",
            "H.B. Fuller Company",
            "H.J. Heinz Company",
            "Halliburton Co.",
            "Harley-Davidson Inc.",
            "Harman International Industries Inc.",
            "Harrah's Entertainment Inc.",
            "Harris Corp.",
            "Harsco Corp.",
            "Hartford Financial Services Group Inc.",
            "Hasbro Inc.",
            "Hawaiian Electric Industries Inc.",
            "HCA Inc.",
            "Health Management Associates Inc.",
            "Health Net Inc.",
            "Healthsouth Corp",
            "Henry Schein Inc.",
            "Hercules Inc.",
            "Herman Miller Inc.",
            "Hershey Foods Corp.",
            "Hewlett-Packard Company",
            "Hibernia Corp.",
            "Hillenbrand Industries Inc.",
            "Hilton Hotels Corp.",
            "Hollywood Entertainment Corp.",
            "Home Depot Inc.",
            "Hon Industries Inc.",
            "Honeywell International Inc.",
            "Hormel Foods Corp.",
            "Host Marriott Corp.",
            "Household International Corp.",
            "Hovnanian Enterprises Inc.",
            "Hub Group Inc.",
            "Hubbell Inc.",
            "Hughes Supply Inc.",
            "Humana Inc.",
            "Huntington Bancshares Inc.",
            "Idacorp Inc.",
            "IDT Corporation",
            "IKON Office Solutions Inc.",
            "Illinois Tool Works Inc.",
            "IMC Global Inc.",
            "Imperial Sugar Company",
            "IMS Health Inc.",
            "Ingles Market Inc",
            "Ingram Micro Inc.",
            "Insight Enterprises Inc.",
            "Integrated Electrical Services Inc.",
            "Intel Corporation",
            "International Paper Co.",
            "Interpublic Group of Companies Inc.",
            "Interstate Bakeries Corporation",
            "International Business Machines Corp.",
            "International Flavors & Fragrances Inc.",
            "International Multifoods Corporation",
            "Intuit Inc.",
            "IT Group Inc.",
            "ITT Industries Inc.",
            "Ivax Corp.",
            "J.B. Hunt Transport Services Inc.",
            "J.C. Penny Co.",
            "J.P. Morgan Chase & Co.",
            "Jabil Circuit Inc.",
            "Jack In The Box Inc.",
            "Jacobs Engineering Group Inc.",
            "JDS Uniphase Corp.",
            "Jefferson-Pilot Co.",
            "John Hancock Financial Services Inc.",
            "Johnson & Johnson",
            "Johnson Controls Inc.",
            "Jones Apparel Group Inc.",
            "KB Home",
            "Kellogg Company",
            "Kellwood Company",
            "Kelly Services Inc.",
            "Kemet Corp.",
            "Kennametal Inc.",
            "Kerr-McGee Corporation",
            "KeyCorp",
            "KeySpan Corp.",
            "Kimball International Inc.",
            "Kimberly-Clark Corporation",
            "Kindred Healthcare Inc.",
            "KLA-Tencor Corporation",
            "K-Mart Corp.",
            "Knight-Ridder Inc.",
            "Kohl's Corp.",
            "KPMG Consulting Inc.",
            "Kroger Co.",
            "L-3 Communications Holdings Inc.",
            "Laboratory Corporation of America Holdings",
            "Lam Research Corporation",
            "LandAmerica Financial Group Inc.",
            "Lands' End Inc.",
            "Landstar System Inc.",
            "La-Z-Boy Inc.",
            "Lear Corporation",
            "Legg Mason Inc.",
            "Leggett & Platt Inc.",
            "Lehman Brothers Holdings Inc.",
            "Lennar Corporation",
            "Lennox International Inc.",
            "Level 3 Communications Inc.",
            "Levi Strauss & Co.",
            "Lexmark International Inc.",
            "Limited Inc.",
            "Lincoln National Corporation",
            "Linens 'n Things Inc.",
            "Lithia Motors Inc.",
            "Liz Claiborne Inc.",
            "Lockheed Martin Corporation",
            "Loews Corporation",
            "Longs Drug Stores Corporation",
            "Louisiana-Pacific Corporation",
            "Lowe's Companies Inc.",
            "LSI Logic Corporation",
            "The LTV Corporation",
            "The Lubrizol Corporation",
            "Lucent Technologies Inc.",
            "Lyondell Chemical Company",
            "M & T Bank Corporation",
            "Magellan Health Services Inc.",
            "Mail-Well Inc.",
            "Mandalay Resort Group",
            "Manor Care Inc.",
            "Manpower Inc.",
            "Marathon Oil Corporation",
            "Mariner Health Care Inc.",
            "Markel Corporation",
            "Marriott International Inc.",
            "Marsh & McLennan Companies Inc.",
            "Marsh Supermarkets Inc.",
            "Marshall & Ilsley Corporation",
            "Martin Marietta Materials Inc.",
            "Masco Corporation",
            "Massey Energy Company",
            "MasTec Inc.",
            "Mattel Inc.",
            "Maxim Integrated Products Inc.",
            "Maxtor Corporation",
            "Maxxam Inc.",
            "The May Department Stores Company",
            "Maytag Corporation",
            "MBNA Corporation",
            "McCormick & Company Incorporated",
            "McDonald's Corporation",
            "The McGraw-Hill Companies Inc.",
            "McKesson Corporation",
            "McLeodUSA Incorporated",
            "M.D.C. Holdings Inc.",
            "MDU Resources Group Inc.",
            "MeadWestvaco Corporation",
            "Medtronic Inc.",
            "Mellon Financial Corporation",
            "The Men's Wearhouse Inc.",
            "Merck & Co., Inc.",
            "Mercury General Corporation",
            "Merrill Lynch & Co. Inc.",
            "Metaldyne Corporation",
            "Metals USA Inc.",
            "MetLife Inc.",
            "Metris Companies Inc",
            "MGIC Investment Corporation",
            "MGM Mirage",
            "Michaels Stores Inc.",
            "Micron Technology Inc.",
            "Microsoft Corporation",
            "Milacron Inc.",
            "Millennium Chemicals Inc.",
            "Mirant Corporation",
            "Mohawk Industries Inc.",
            "Molex Incorporated",
            "The MONY Group Inc.",
            "Morgan Stanley Dean Witter & Co.",
            "Motorola Inc.",
            "MPS Group Inc.",
            "Murphy Oil Corporation",
            "Nabors Industries Inc",
            "Nacco Industries Inc",
            "Nash Finch Company",
            "National City Corp.",
            "National Commerce Financial Corporation",
            "National Fuel Gas Company",
            "National Oilwell Inc",
            "National Rural Utilities Cooperative Finance Corporation",
            "National Semiconductor Corporation",
            "National Service Industries Inc",
            "Navistar International Corporation",
            "NCR Corporation",
            "The Neiman Marcus Group Inc.",
            "New Jersey Resources Corporation",
            "New York Times Company",
            "Newell Rubbermaid Inc",
            "Newmont Mining Corporation",
            "Nextel Communications Inc",
            "Nicor Inc",
            "Nike Inc",
            "NiSource Inc",
            "Noble Energy Inc",
            "Nordstrom Inc",
            "Norfolk Southern Corporation",
            "Nortek Inc",
            "North Fork Bancorporation Inc",
            "Northeast Utilities System",
            "Northern Trust Corporation",
            "Northrop Grumman Corporation",
            "NorthWestern Corporation",
            "Novellus Systems Inc",
            "NSTAR",
            "NTL Incorporated",
            "Nucor Corp",
            "Nvidia Corp",
            "NVR Inc",
            "Northwest Airlines Corp",
            "Occidental Petroleum Corp",
            "Ocean Energy Inc",
            "Office Depot Inc.",
            "OfficeMax Inc",
            "OGE Energy Corp",
            "Oglethorpe Power Corp.",
            "Ohio Casualty Corp.",
            "Old Republic International Corp.",
            "Olin Corp.",
            "OM Group Inc",
            "Omnicare Inc",
            "Omnicom Group",
            "On Semiconductor Corp",
            "ONEOK Inc",
            "Oracle Corp",
            "Oshkosh Truck Corp",
            "Outback Steakhouse Inc.",
            "Owens & Minor Inc.",
            "Owens Corning",
            "Owens-Illinois Inc",
            "Oxford Health Plans Inc",
            "Paccar Inc",
            "PacifiCare Health Systems Inc",
            "Packaging Corp. of America",
            "Pactiv Corp",
            "Pall Corp",
            "Pantry Inc",
            "Park Place Entertainment Corp",
            "Parker Hannifin Corp.",
            "Pathmark Stores Inc.",
            "Paychex Inc",
            "Payless Shoesource Inc",
            "Penn Traffic Co.",
            "Pennzoil-Quaker State Company",
            "Pentair Inc",
            "Peoples Energy Corp.",
            "PeopleSoft Inc",
            "Pep Boys Manny, Moe & Jack",
            "Potomac Electric Power Co.",
            "Pepsi Bottling Group Inc.",
            "PepsiAmericas Inc.",
            "PepsiCo Inc.",
            "Performance Food Group Co.",
            "Perini Corp",
            "PerkinElmer Inc",
            "Perot Systems Corp",
            "Petco Animal Supplies Inc.",
            "Peter Kiewit Sons', Inc.",
            "PETsMART Inc",
            "Pfizer Inc",
            "Pacific Gas & Electric Corp.",
            "Pharmacia Corp",
            "Phar Mor Inc.",
            "Phelps Dodge Corp.",
            "Philip Morris Companies Inc.",
            "Phillips Petroleum Co",
            "Phillips Van Heusen Corp.",
            "Phoenix Companies Inc",
            "Pier 1 Imports Inc.",
            "Pilgrim's Pride Corporation",
            "Pinnacle West Capital Corp",
            "Pioneer-Standard Electronics Inc.",
            "Pitney Bowes Inc.",
            "Pittston Brinks Group",
            "Plains All American Pipeline LP",
            "PNC Financial Services Group Inc.",
            "PNM Resources Inc",
            "Polaris Industries Inc.",
            "Polo Ralph Lauren Corp",
            "PolyOne Corp",
            "Popular Inc",
            "Potlatch Corp",
            "PPG Industries Inc",
            "PPL Corp",
            "Praxair Inc",
            "Precision Castparts Corp",
            "Premcor Inc.",
            "Pride International Inc",
            "Primedia Inc",
            "Principal Financial Group Inc.",
            "Procter & Gamble Co.",
            "Pro-Fac Cooperative Inc.",
            "Progress Energy Inc",
            "Progressive Corporation",
            "Protective Life Corp",
            "Provident Financial Group",
            "Providian Financial Corp.",
            "Prudential Financial Inc.",
            "PSS World Medical Inc",
            "Public Service Enterprise Group Inc.",
            "Publix Super Markets Inc.",
            "Puget Energy Inc.",
            "Pulte Homes Inc",
            "Qualcomm Inc",
            "Quanta Services Inc.",
            "Quantum Corp",
            "Quest Diagnostics Inc.",
            "Questar Corp",
            "Quintiles Transnational",
            "Qwest Communications Intl Inc",
            "R.J. Reynolds Tobacco Company",
            "R.R. Donnelley & Sons Company",
            "Radio Shack Corporation",
            "Raymond James Financial Inc.",
            "Raytheon Company",
            "Reader's Digest Association Inc.",
            "Reebok International Ltd.",
            "Regions Financial Corp.",
            "Regis Corporation",
            "Reliance Steel & Aluminum Co.",
            "Reliant Energy Inc.",
            "Rent A Center Inc",
            "Republic Services Inc",
            "Revlon Inc",
            "RGS Energy Group Inc",
            "Rite Aid Corp",
            "Riverwood Holding Inc.",
            "RoadwayCorp",
            "Robert Half International Inc.",
            "Rock-Tenn Co",
            "Rockwell Automation Inc",
            "Rockwell Collins Inc",
            "Rohm & Haas Co.",
            "Ross Stores Inc",
            "RPM Inc.",
            "Ruddick Corp",
            "Ryder System Inc",
            "Ryerson Tull Inc",
            "Ryland Group Inc.",
            "Sabre Holdings Corp",
            "Safeco Corp",
            "Safeguard Scientifics Inc.",
            "Safeway Inc",
            "Saks Inc",
            "Sanmina-SCI Inc",
            "Sara Lee Corp",
            "SBC Communications Inc",
            "Scana Corp.",
            "Schering-Plough Corp",
            "Scholastic Corp",
            "SCI Systems Onc.",
            "Science Applications Intl. Inc.",
            "Scientific-Atlanta Inc",
            "Scotts Company",
            "Seaboard Corp",
            "Sealed Air Corp",
            "Sears Roebuck & Co",
            "Sempra Energy",
            "Sequa Corp",
            "Service Corp. International",
            "ServiceMaster Co",
            "Shaw Group Inc",
            "Sherwin-Williams Company",
            "Shopko Stores Inc",
            "Siebel Systems Inc",
            "Sierra Health Services Inc",
            "Sierra Pacific Resources",
            "Silgan Holdings Inc.",
            "Silicon Graphics Inc",
            "Simon Property Group Inc",
            "SLM Corporation",
            "Smith International Inc",
            "Smithfield Foods Inc",
            "Smurfit-Stone Container Corp",
            "Snap-On Inc",
            "Solectron Corp",
            "Solutia Inc",
            "Sonic Automotive Inc.",
            "Sonoco Products Co.",
            "Southern Company",
            "Southern Union Company",
            "SouthTrust Corp.",
            "Southwest Airlines Co",
            "Southwest Gas Corp",
            "Sovereign Bancorp Inc.",
            "Spartan Stores Inc",
            "Spherion Corp",
            "Sports Authority Inc",
            "Sprint Corp.",
            "SPX Corp",
            "St. Jude Medical Inc",
            "St. Paul Cos.",
            "Staff Leasing Inc.",
            "StanCorp Financial Group Inc",
            "Standard Pacific Corp.",
            "Stanley Works",
            "Staples Inc",
            "Starbucks Corp",
            "Starwood Hotels & Resorts Worldwide Inc",
            "State Street Corp.",
            "Stater Bros. Holdings Inc.",
            "Steelcase Inc",
            "Stein Mart Inc",
            "Stewart & Stevenson Services Inc",
            "Stewart Information Services Corp",
            "Stilwell Financial Inc",
            "Storage Technology Corporation",
            "Stryker Corp",
            "Sun Healthcare Group Inc.",
            "Sun Microsystems Inc.",
            "SunGard Data Systems Inc.",
            "Sunoco Inc.",
            "SunTrust Banks Inc",
            "Supervalu Inc",
            "Swift Transportation, Co., Inc",
            "Symbol Technologies Inc",
            "Synovus Financial Corp.",
            "Sysco Corp",
            "Systemax Inc.",
            "Target Corp.",
            "Tech Data Corporation",
            "TECO Energy Inc",
            "Tecumseh Products Company",
            "Tektronix Inc",
            "Teleflex Incorporated",
            "Telephone & Data Systems Inc",
            "Tellabs Inc.",
            "Temple-Inland Inc",
            "Tenet Healthcare Corporation",
            "Tenneco Automotive Inc.",
            "Teradyne Inc",
            "Terex Corp",
            "Tesoro Petroleum Corp.",
            "Texas Industries Inc.",
            "Texas Instruments Incorporated",
            "Textron Inc",
            "Thermo Electron Corporation",
            "Thomas & Betts Corporation",
            "Tiffany & Co",
            "Timken Company",
            "TJX Companies Inc",
            "TMP Worldwide Inc",
            "Toll Brothers Inc",
            "Torchmark Corporation",
            "Toro Company",
            "Tower Automotive Inc.",
            "Toys 'R' Us Inc",
            "Trans World Entertainment Corp.",
            "TransMontaigne Inc",
            "Transocean Inc",
            "TravelCenters of America Inc.",
            "Triad Hospitals Inc",
            "Tribune Company",
            "Trigon Healthcare Inc.",
            "Trinity Industries Inc",
            "Trump Hotels & Casino Resorts Inc.",
            "TruServ Corporation",
            "TRW Inc",
            "TXU Corp",
            "Tyson Foods Inc",
            "U.S. Bancorp",
            "U.S. Industries Inc.",
            "UAL Corporation",
            "UGI Corporation",
            "Unified Western Grocers Inc",
            "Union Pacific Corporation",
            "Union Planters Corp",
            "Unisource Energy Corp",
            "Unisys Corporation",
            "United Auto Group Inc",
            "United Defense Industries Inc.",
            "United Parcel Service Inc",
            "United Rentals Inc",
            "United Stationers Inc",
            "United Technologies Corporation",
            "UnitedHealth Group Incorporated",
            "Unitrin Inc",
            "Universal Corporation",
            "Universal Forest Products Inc",
            "Universal Health Services Inc",
            "Unocal Corporation",
            "Unova Inc",
            "UnumProvident Corporation",
            "URS Corporation",
            "US Airways Group Inc",
            "US Oncology Inc",
            "USA Interactive",
            "USFreighways Corporation",
            "USG Corporation",
            "UST Inc",
            "Valero Energy Corporation",
            "Valspar Corporation",
            "Value City Department Stores Inc",
            "Varco International Inc",
            "Vectren Corporation",
            "Veritas Software Corporation",
            "Verizon Communications Inc",
            "VF Corporation",
            "Viacom Inc",
            "Viad Corp",
            "Viasystems Group Inc",
            "Vishay Intertechnology Inc",
            "Visteon Corporation",
            "Volt Information Sciences Inc",
            "Vulcan Materials Company",
            "W.R. Berkley Corporation",
            "W.R. Grace & Co",
            "W.W. Grainger Inc",
            "Wachovia Corporation",
            "Wakenhut Corporation",
            "Walgreen Co",
            "Wallace Computer Services Inc",
            "Wal-Mart Stores Inc",
            "Walt Disney Co",
            "Walter Industries Inc",
            "Washington Mutual Inc",
            "Washington Post Co.",
            "Waste Management Inc",
            "Watsco Inc",
            "Weatherford International Inc",
            "Weis Markets Inc.",
            "Wellpoint Health Networks Inc",
            "Wells Fargo & Company",
            "Wendy's International Inc",
            "Werner Enterprises Inc",
            "WESCO International Inc",
            "Western Digital Inc",
            "Western Gas Resources Inc",
            "WestPoint Stevens Inc",
            "Weyerhauser Company",
            "WGL Holdings Inc",
            "Whirlpool Corporation",
            "Whole Foods Market Inc",
            "Willamette Industries Inc.",
            "Williams Companies Inc",
            "Williams Sonoma Inc",
            "Winn Dixie Stores Inc",
            "Wisconsin Energy Corporation",
            "Wm Wrigley Jr Company",
            "World Fuel Services Corporation",
            "WorldCom Inc",
            "Worthington Industries Inc",
            "WPS Resources Corporation",
            "Wyeth",
            "Wyndham International Inc",
            "Xcel Energy Inc",
            "Xerox Corp",
            "Xilinx Inc",
            "XO Communications Inc",
            "Yellow Corporation",
            "York International Corp",
            "Yum Brands Inc.",
            "Zale Corporation",
            "Zions Bancorporation"
        ],
        fileExtension: {
            "raster": [
                "bmp",
                "gif",
                "gpl",
                "ico",
                "jpeg",
                "psd",
                "png",
                "psp",
                "raw",
                "tiff"
            ],
            "vector": [
                "3dv",
                "amf",
                "awg",
                "ai",
                "cgm",
                "cdr",
                "cmx",
                "dxf",
                "e2d",
                "egt",
                "eps",
                "fs",
                "odg",
                "svg",
                "xar"
            ],
            "3d": [
                "3dmf",
                "3dm",
                "3mf",
                "3ds",
                "an8",
                "aoi",
                "blend",
                "cal3d",
                "cob",
                "ctm",
                "iob",
                "jas",
                "max",
                "mb",
                "mdx",
                "obj",
                "x",
                "x3d"
            ],
            "document": [
                "doc",
                "docx",
                "dot",
                "html",
                "xml",
                "odt",
                "odm",
                "ott",
                "csv",
                "rtf",
                "tex",
                "xhtml",
                "xps"
            ]
        },
        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
        timezones: [
            {
                "name": "Dateline Standard Time",
                "abbr": "DST",
                "offset": -12,
                "isdst": false,
                "text": "(UTC-12:00) International Date Line West",
                "utc": [
                    "Etc/GMT+12"
                ]
            },
            {
                "name": "UTC-11",
                "abbr": "U",
                "offset": -11,
                "isdst": false,
                "text": "(UTC-11:00) Coordinated Universal Time-11",
                "utc": [
                    "Etc/GMT+11",
                    "Pacific/Midway",
                    "Pacific/Niue",
                    "Pacific/Pago_Pago"
                ]
            },
            {
                "name": "Hawaiian Standard Time",
                "abbr": "HST",
                "offset": -10,
                "isdst": false,
                "text": "(UTC-10:00) Hawaii",
                "utc": [
                    "Etc/GMT+10",
                    "Pacific/Honolulu",
                    "Pacific/Johnston",
                    "Pacific/Rarotonga",
                    "Pacific/Tahiti"
                ]
            },
            {
                "name": "Alaskan Standard Time",
                "abbr": "AKDT",
                "offset": -8,
                "isdst": true,
                "text": "(UTC-09:00) Alaska",
                "utc": [
                    "America/Anchorage",
                    "America/Juneau",
                    "America/Nome",
                    "America/Sitka",
                    "America/Yakutat"
                ]
            },
            {
                "name": "Pacific Standard Time (Mexico)",
                "abbr": "PDT",
                "offset": -7,
                "isdst": true,
                "text": "(UTC-08:00) Baja California",
                "utc": [
                    "America/Santa_Isabel"
                ]
            },
            {
                "name": "Pacific Daylight Time",
                "abbr": "PDT",
                "offset": -7,
                "isdst": true,
                "text": "(UTC-07:00) Pacific Time (US & Canada)",
                "utc": [
                    "America/Dawson",
                    "America/Los_Angeles",
                    "America/Tijuana",
                    "America/Vancouver",
                    "America/Whitehorse"
                ]
            },
            {
                "name": "Pacific Standard Time",
                "abbr": "PST",
                "offset": -8,
                "isdst": false,
                "text": "(UTC-08:00) Pacific Time (US & Canada)",
                "utc": [
                    "America/Dawson",
                    "America/Los_Angeles",
                    "America/Tijuana",
                    "America/Vancouver",
                    "America/Whitehorse",
                    "PST8PDT"
                ]
            },
            {
                "name": "US Mountain Standard Time",
                "abbr": "UMST",
                "offset": -7,
                "isdst": false,
                "text": "(UTC-07:00) Arizona",
                "utc": [
                    "America/Creston",
                    "America/Dawson_Creek",
                    "America/Hermosillo",
                    "America/Phoenix",
                    "Etc/GMT+7"
                ]
            },
            {
                "name": "Mountain Standard Time (Mexico)",
                "abbr": "MDT",
                "offset": -6,
                "isdst": true,
                "text": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
                "utc": [
                    "America/Chihuahua",
                    "America/Mazatlan"
                ]
            },
            {
                "name": "Mountain Standard Time",
                "abbr": "MDT",
                "offset": -6,
                "isdst": true,
                "text": "(UTC-07:00) Mountain Time (US & Canada)",
                "utc": [
                    "America/Boise",
                    "America/Cambridge_Bay",
                    "America/Denver",
                    "America/Edmonton",
                    "America/Inuvik",
                    "America/Ojinaga",
                    "America/Yellowknife",
                    "MST7MDT"
                ]
            },
            {
                "name": "Central America Standard Time",
                "abbr": "CAST",
                "offset": -6,
                "isdst": false,
                "text": "(UTC-06:00) Central America",
                "utc": [
                    "America/Belize",
                    "America/Costa_Rica",
                    "America/El_Salvador",
                    "America/Guatemala",
                    "America/Managua",
                    "America/Tegucigalpa",
                    "Etc/GMT+6",
                    "Pacific/Galapagos"
                ]
            },
            {
                "name": "Central Standard Time",
                "abbr": "CDT",
                "offset": -5,
                "isdst": true,
                "text": "(UTC-06:00) Central Time (US & Canada)",
                "utc": [
                    "America/Chicago",
                    "America/Indiana/Knox",
                    "America/Indiana/Tell_City",
                    "America/Matamoros",
                    "America/Menominee",
                    "America/North_Dakota/Beulah",
                    "America/North_Dakota/Center",
                    "America/North_Dakota/New_Salem",
                    "America/Rainy_River",
                    "America/Rankin_Inlet",
                    "America/Resolute",
                    "America/Winnipeg",
                    "CST6CDT"
                ]
            },
            {
                "name": "Central Standard Time (Mexico)",
                "abbr": "CDT",
                "offset": -5,
                "isdst": true,
                "text": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
                "utc": [
                    "America/Bahia_Banderas",
                    "America/Cancun",
                    "America/Merida",
                    "America/Mexico_City",
                    "America/Monterrey"
                ]
            },
            {
                "name": "Canada Central Standard Time",
                "abbr": "CCST",
                "offset": -6,
                "isdst": false,
                "text": "(UTC-06:00) Saskatchewan",
                "utc": [
                    "America/Regina",
                    "America/Swift_Current"
                ]
            },
            {
                "name": "SA Pacific Standard Time",
                "abbr": "SPST",
                "offset": -5,
                "isdst": false,
                "text": "(UTC-05:00) Bogota, Lima, Quito",
                "utc": [
                    "America/Bogota",
                    "America/Cayman",
                    "America/Coral_Harbour",
                    "America/Eirunepe",
                    "America/Guayaquil",
                    "America/Jamaica",
                    "America/Lima",
                    "America/Panama",
                    "America/Rio_Branco",
                    "Etc/GMT+5"
                ]
            },
            {
                "name": "Eastern Standard Time",
                "abbr": "EDT",
                "offset": -4,
                "isdst": true,
                "text": "(UTC-05:00) Eastern Time (US & Canada)",
                "utc": [
                    "America/Detroit",
                    "America/Havana",
                    "America/Indiana/Petersburg",
                    "America/Indiana/Vincennes",
                    "America/Indiana/Winamac",
                    "America/Iqaluit",
                    "America/Kentucky/Monticello",
                    "America/Louisville",
                    "America/Montreal",
                    "America/Nassau",
                    "America/New_York",
                    "America/Nipigon",
                    "America/Pangnirtung",
                    "America/Port-au-Prince",
                    "America/Thunder_Bay",
                    "America/Toronto",
                    "EST5EDT"
                ]
            },
            {
                "name": "US Eastern Standard Time",
                "abbr": "UEDT",
                "offset": -4,
                "isdst": true,
                "text": "(UTC-05:00) Indiana (East)",
                "utc": [
                    "America/Indiana/Marengo",
                    "America/Indiana/Vevay",
                    "America/Indianapolis"
                ]
            },
            {
                "name": "Venezuela Standard Time",
                "abbr": "VST",
                "offset": -4.5,
                "isdst": false,
                "text": "(UTC-04:30) Caracas",
                "utc": [
                    "America/Caracas"
                ]
            },
            {
                "name": "Paraguay Standard Time",
                "abbr": "PYT",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Asuncion",
                "utc": [
                    "America/Asuncion"
                ]
            },
            {
                "name": "Atlantic Standard Time",
                "abbr": "ADT",
                "offset": -3,
                "isdst": true,
                "text": "(UTC-04:00) Atlantic Time (Canada)",
                "utc": [
                    "America/Glace_Bay",
                    "America/Goose_Bay",
                    "America/Halifax",
                    "America/Moncton",
                    "America/Thule",
                    "Atlantic/Bermuda"
                ]
            },
            {
                "name": "Central Brazilian Standard Time",
                "abbr": "CBST",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Cuiaba",
                "utc": [
                    "America/Campo_Grande",
                    "America/Cuiaba"
                ]
            },
            {
                "name": "SA Western Standard Time",
                "abbr": "SWST",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
                "utc": [
                    "America/Anguilla",
                    "America/Antigua",
                    "America/Aruba",
                    "America/Barbados",
                    "America/Blanc-Sablon",
                    "America/Boa_Vista",
                    "America/Curacao",
                    "America/Dominica",
                    "America/Grand_Turk",
                    "America/Grenada",
                    "America/Guadeloupe",
                    "America/Guyana",
                    "America/Kralendijk",
                    "America/La_Paz",
                    "America/Lower_Princes",
                    "America/Manaus",
                    "America/Marigot",
                    "America/Martinique",
                    "America/Montserrat",
                    "America/Port_of_Spain",
                    "America/Porto_Velho",
                    "America/Puerto_Rico",
                    "America/Santo_Domingo",
                    "America/St_Barthelemy",
                    "America/St_Kitts",
                    "America/St_Lucia",
                    "America/St_Thomas",
                    "America/St_Vincent",
                    "America/Tortola",
                    "Etc/GMT+4"
                ]
            },
            {
                "name": "Pacific SA Standard Time",
                "abbr": "PSST",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Santiago",
                "utc": [
                    "America/Santiago",
                    "Antarctica/Palmer"
                ]
            },
            {
                "name": "Newfoundland Standard Time",
                "abbr": "NDT",
                "offset": -2.5,
                "isdst": true,
                "text": "(UTC-03:30) Newfoundland",
                "utc": [
                    "America/St_Johns"
                ]
            },
            {
                "name": "E. South America Standard Time",
                "abbr": "ESAST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Brasilia",
                "utc": [
                    "America/Sao_Paulo"
                ]
            },
            {
                "name": "Argentina Standard Time",
                "abbr": "AST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Buenos Aires",
                "utc": [
                    "America/Argentina/La_Rioja",
                    "America/Argentina/Rio_Gallegos",
                    "America/Argentina/Salta",
                    "America/Argentina/San_Juan",
                    "America/Argentina/San_Luis",
                    "America/Argentina/Tucuman",
                    "America/Argentina/Ushuaia",
                    "America/Buenos_Aires",
                    "America/Catamarca",
                    "America/Cordoba",
                    "America/Jujuy",
                    "America/Mendoza"
                ]
            },
            {
                "name": "SA Eastern Standard Time",
                "abbr": "SEST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Cayenne, Fortaleza",
                "utc": [
                    "America/Araguaina",
                    "America/Belem",
                    "America/Cayenne",
                    "America/Fortaleza",
                    "America/Maceio",
                    "America/Paramaribo",
                    "America/Recife",
                    "America/Santarem",
                    "Antarctica/Rothera",
                    "Atlantic/Stanley",
                    "Etc/GMT+3"
                ]
            },
            {
                "name": "Greenland Standard Time",
                "abbr": "GDT",
                "offset": -3,
                "isdst": true,
                "text": "(UTC-03:00) Greenland",
                "utc": [
                    "America/Godthab"
                ]
            },
            {
                "name": "Montevideo Standard Time",
                "abbr": "MST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Montevideo",
                "utc": [
                    "America/Montevideo"
                ]
            },
            {
                "name": "Bahia Standard Time",
                "abbr": "BST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Salvador",
                "utc": [
                    "America/Bahia"
                ]
            },
            {
                "name": "UTC-02",
                "abbr": "U",
                "offset": -2,
                "isdst": false,
                "text": "(UTC-02:00) Coordinated Universal Time-02",
                "utc": [
                    "America/Noronha",
                    "Atlantic/South_Georgia",
                    "Etc/GMT+2"
                ]
            },
            {
                "name": "Mid-Atlantic Standard Time",
                "abbr": "MDT",
                "offset": -1,
                "isdst": true,
                "text": "(UTC-02:00) Mid-Atlantic - Old",
                "utc": []
            },
            {
                "name": "Azores Standard Time",
                "abbr": "ADT",
                "offset": 0,
                "isdst": true,
                "text": "(UTC-01:00) Azores",
                "utc": [
                    "America/Scoresbysund",
                    "Atlantic/Azores"
                ]
            },
            {
                "name": "Cape Verde Standard Time",
                "abbr": "CVST",
                "offset": -1,
                "isdst": false,
                "text": "(UTC-01:00) Cape Verde Is.",
                "utc": [
                    "Atlantic/Cape_Verde",
                    "Etc/GMT+1"
                ]
            },
            {
                "name": "Morocco Standard Time",
                "abbr": "MDT",
                "offset": 1,
                "isdst": true,
                "text": "(UTC) Casablanca",
                "utc": [
                    "Africa/Casablanca",
                    "Africa/El_Aaiun"
                ]
            },
            {
                "name": "UTC",
                "abbr": "UTC",
                "offset": 0,
                "isdst": false,
                "text": "(UTC) Coordinated Universal Time",
                "utc": [
                    "America/Danmarkshavn",
                    "Etc/GMT"
                ]
            },
            {
                "name": "GMT Standard Time",
                "abbr": "GMT",
                "offset": 0,
                "isdst": false,
                "text": "(UTC) Edinburgh, London",
                "utc": [
                    "Europe/Isle_of_Man",
                    "Europe/Guernsey",
                    "Europe/Jersey",
                    "Europe/London"
                ]
            },
            {
                "name": "British Summer Time",
                "abbr": "BST",
                "offset": 1,
                "isdst": true,
                "text": "(UTC+01:00) Edinburgh, London",
                "utc": [
                    "Europe/Isle_of_Man",
                    "Europe/Guernsey",
                    "Europe/Jersey",
                    "Europe/London"
                ]
            },
            {
                "name": "GMT Standard Time",
                "abbr": "GDT",
                "offset": 1,
                "isdst": true,
                "text": "(UTC) Dublin, Lisbon",
                "utc": [
                    "Atlantic/Canary",
                    "Atlantic/Faeroe",
                    "Atlantic/Madeira",
                    "Europe/Dublin",
                    "Europe/Lisbon"
                ]
            },
            {
                "name": "Greenwich Standard Time",
                "abbr": "GST",
                "offset": 0,
                "isdst": false,
                "text": "(UTC) Monrovia, Reykjavik",
                "utc": [
                    "Africa/Abidjan",
                    "Africa/Accra",
                    "Africa/Bamako",
                    "Africa/Banjul",
                    "Africa/Bissau",
                    "Africa/Conakry",
                    "Africa/Dakar",
                    "Africa/Freetown",
                    "Africa/Lome",
                    "Africa/Monrovia",
                    "Africa/Nouakchott",
                    "Africa/Ouagadougou",
                    "Africa/Sao_Tome",
                    "Atlantic/Reykjavik",
                    "Atlantic/St_Helena"
                ]
            },
            {
                "name": "W. Europe Standard Time",
                "abbr": "WEDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
                "utc": [
                    "Arctic/Longyearbyen",
                    "Europe/Amsterdam",
                    "Europe/Andorra",
                    "Europe/Berlin",
                    "Europe/Busingen",
                    "Europe/Gibraltar",
                    "Europe/Luxembourg",
                    "Europe/Malta",
                    "Europe/Monaco",
                    "Europe/Oslo",
                    "Europe/Rome",
                    "Europe/San_Marino",
                    "Europe/Stockholm",
                    "Europe/Vaduz",
                    "Europe/Vatican",
                    "Europe/Vienna",
                    "Europe/Zurich"
                ]
            },
            {
                "name": "Central Europe Standard Time",
                "abbr": "CEDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
                "utc": [
                    "Europe/Belgrade",
                    "Europe/Bratislava",
                    "Europe/Budapest",
                    "Europe/Ljubljana",
                    "Europe/Podgorica",
                    "Europe/Prague",
                    "Europe/Tirane"
                ]
            },
            {
                "name": "Romance Standard Time",
                "abbr": "RDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
                "utc": [
                    "Africa/Ceuta",
                    "Europe/Brussels",
                    "Europe/Copenhagen",
                    "Europe/Madrid",
                    "Europe/Paris"
                ]
            },
            {
                "name": "Central European Standard Time",
                "abbr": "CEDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
                "utc": [
                    "Europe/Sarajevo",
                    "Europe/Skopje",
                    "Europe/Warsaw",
                    "Europe/Zagreb"
                ]
            },
            {
                "name": "W. Central Africa Standard Time",
                "abbr": "WCAST",
                "offset": 1,
                "isdst": false,
                "text": "(UTC+01:00) West Central Africa",
                "utc": [
                    "Africa/Algiers",
                    "Africa/Bangui",
                    "Africa/Brazzaville",
                    "Africa/Douala",
                    "Africa/Kinshasa",
                    "Africa/Lagos",
                    "Africa/Libreville",
                    "Africa/Luanda",
                    "Africa/Malabo",
                    "Africa/Ndjamena",
                    "Africa/Niamey",
                    "Africa/Porto-Novo",
                    "Africa/Tunis",
                    "Etc/GMT-1"
                ]
            },
            {
                "name": "Namibia Standard Time",
                "abbr": "NST",
                "offset": 1,
                "isdst": false,
                "text": "(UTC+01:00) Windhoek",
                "utc": [
                    "Africa/Windhoek"
                ]
            },
            {
                "name": "GTB Standard Time",
                "abbr": "GDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Athens, Bucharest",
                "utc": [
                    "Asia/Nicosia",
                    "Europe/Athens",
                    "Europe/Bucharest",
                    "Europe/Chisinau"
                ]
            },
            {
                "name": "Middle East Standard Time",
                "abbr": "MEDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Beirut",
                "utc": [
                    "Asia/Beirut"
                ]
            },
            {
                "name": "Egypt Standard Time",
                "abbr": "EST",
                "offset": 2,
                "isdst": false,
                "text": "(UTC+02:00) Cairo",
                "utc": [
                    "Africa/Cairo"
                ]
            },
            {
                "name": "Syria Standard Time",
                "abbr": "SDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Damascus",
                "utc": [
                    "Asia/Damascus"
                ]
            },
            {
                "name": "E. Europe Standard Time",
                "abbr": "EEDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) E. Europe",
                "utc": [
                    "Asia/Nicosia",
                    "Europe/Athens",
                    "Europe/Bucharest",
                    "Europe/Chisinau",
                    "Europe/Helsinki",
                    "Europe/Kiev",
                    "Europe/Mariehamn",
                    "Europe/Nicosia",
                    "Europe/Riga",
                    "Europe/Sofia",
                    "Europe/Tallinn",
                    "Europe/Uzhgorod",
                    "Europe/Vilnius",
                    "Europe/Zaporozhye"
                ]
            },
            {
                "name": "South Africa Standard Time",
                "abbr": "SAST",
                "offset": 2,
                "isdst": false,
                "text": "(UTC+02:00) Harare, Pretoria",
                "utc": [
                    "Africa/Blantyre",
                    "Africa/Bujumbura",
                    "Africa/Gaborone",
                    "Africa/Harare",
                    "Africa/Johannesburg",
                    "Africa/Kigali",
                    "Africa/Lubumbashi",
                    "Africa/Lusaka",
                    "Africa/Maputo",
                    "Africa/Maseru",
                    "Africa/Mbabane",
                    "Etc/GMT-2"
                ]
            },
            {
                "name": "FLE Standard Time",
                "abbr": "FDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
                "utc": [
                    "Europe/Helsinki",
                    "Europe/Kiev",
                    "Europe/Mariehamn",
                    "Europe/Riga",
                    "Europe/Sofia",
                    "Europe/Tallinn",
                    "Europe/Uzhgorod",
                    "Europe/Vilnius",
                    "Europe/Zaporozhye"
                ]
            },
            {
                "name": "Turkey Standard Time",
                "abbr": "TDT",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Istanbul",
                "utc": [
                    "Europe/Istanbul"
                ]
            },
            {
                "name": "Israel Standard Time",
                "abbr": "JDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Jerusalem",
                "utc": [
                    "Asia/Jerusalem"
                ]
            },
            {
                "name": "Libya Standard Time",
                "abbr": "LST",
                "offset": 2,
                "isdst": false,
                "text": "(UTC+02:00) Tripoli",
                "utc": [
                    "Africa/Tripoli"
                ]
            },
            {
                "name": "Jordan Standard Time",
                "abbr": "JST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Amman",
                "utc": [
                    "Asia/Amman"
                ]
            },
            {
                "name": "Arabic Standard Time",
                "abbr": "AST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Baghdad",
                "utc": [
                    "Asia/Baghdad"
                ]
            },
            {
                "name": "Kaliningrad Standard Time",
                "abbr": "KST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+02:00) Kaliningrad",
                "utc": [
                    "Europe/Kaliningrad"
                ]
            },
            {
                "name": "Arab Standard Time",
                "abbr": "AST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Kuwait, Riyadh",
                "utc": [
                    "Asia/Aden",
                    "Asia/Bahrain",
                    "Asia/Kuwait",
                    "Asia/Qatar",
                    "Asia/Riyadh"
                ]
            },
            {
                "name": "E. Africa Standard Time",
                "abbr": "EAST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Nairobi",
                "utc": [
                    "Africa/Addis_Ababa",
                    "Africa/Asmera",
                    "Africa/Dar_es_Salaam",
                    "Africa/Djibouti",
                    "Africa/Juba",
                    "Africa/Kampala",
                    "Africa/Khartoum",
                    "Africa/Mogadishu",
                    "Africa/Nairobi",
                    "Antarctica/Syowa",
                    "Etc/GMT-3",
                    "Indian/Antananarivo",
                    "Indian/Comoro",
                    "Indian/Mayotte"
                ]
            },
            {
                "name": "Moscow Standard Time",
                "abbr": "MSK",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
                "utc": [
                    "Europe/Kirov",
                    "Europe/Moscow",
                    "Europe/Simferopol",
                    "Europe/Volgograd",
                    "Europe/Minsk"
                ]
            },
            {
                "name": "Samara Time",
                "abbr": "SAMT",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Samara, Ulyanovsk, Saratov",
                "utc": [
                    "Europe/Astrakhan",
                    "Europe/Samara",
                    "Europe/Ulyanovsk"
                ]
            },
            {
                "name": "Iran Standard Time",
                "abbr": "IDT",
                "offset": 4.5,
                "isdst": true,
                "text": "(UTC+03:30) Tehran",
                "utc": [
                    "Asia/Tehran"
                ]
            },
            {
                "name": "Arabian Standard Time",
                "abbr": "AST",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Abu Dhabi, Muscat",
                "utc": [
                    "Asia/Dubai",
                    "Asia/Muscat",
                    "Etc/GMT-4"
                ]
            },
            {
                "name": "Azerbaijan Standard Time",
                "abbr": "ADT",
                "offset": 5,
                "isdst": true,
                "text": "(UTC+04:00) Baku",
                "utc": [
                    "Asia/Baku"
                ]
            },
            {
                "name": "Mauritius Standard Time",
                "abbr": "MST",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Port Louis",
                "utc": [
                    "Indian/Mahe",
                    "Indian/Mauritius",
                    "Indian/Reunion"
                ]
            },
            {
                "name": "Georgian Standard Time",
                "abbr": "GET",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Tbilisi",
                "utc": [
                    "Asia/Tbilisi"
                ]
            },
            {
                "name": "Caucasus Standard Time",
                "abbr": "CST",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Yerevan",
                "utc": [
                    "Asia/Yerevan"
                ]
            },
            {
                "name": "Afghanistan Standard Time",
                "abbr": "AST",
                "offset": 4.5,
                "isdst": false,
                "text": "(UTC+04:30) Kabul",
                "utc": [
                    "Asia/Kabul"
                ]
            },
            {
                "name": "West Asia Standard Time",
                "abbr": "WAST",
                "offset": 5,
                "isdst": false,
                "text": "(UTC+05:00) Ashgabat, Tashkent",
                "utc": [
                    "Antarctica/Mawson",
                    "Asia/Aqtau",
                    "Asia/Aqtobe",
                    "Asia/Ashgabat",
                    "Asia/Dushanbe",
                    "Asia/Oral",
                    "Asia/Samarkand",
                    "Asia/Tashkent",
                    "Etc/GMT-5",
                    "Indian/Kerguelen",
                    "Indian/Maldives"
                ]
            },
            {
                "name": "Yekaterinburg Time",
                "abbr": "YEKT",
                "offset": 5,
                "isdst": false,
                "text": "(UTC+05:00) Yekaterinburg",
                "utc": [
                    "Asia/Yekaterinburg"
                ]
            },
            {
                "name": "Pakistan Standard Time",
                "abbr": "PKT",
                "offset": 5,
                "isdst": false,
                "text": "(UTC+05:00) Islamabad, Karachi",
                "utc": [
                    "Asia/Karachi"
                ]
            },
            {
                "name": "India Standard Time",
                "abbr": "IST",
                "offset": 5.5,
                "isdst": false,
                "text": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
                "utc": [
                    "Asia/Kolkata"
                ]
            },
            {
                "name": "Sri Lanka Standard Time",
                "abbr": "SLST",
                "offset": 5.5,
                "isdst": false,
                "text": "(UTC+05:30) Sri Jayawardenepura",
                "utc": [
                    "Asia/Colombo"
                ]
            },
            {
                "name": "Nepal Standard Time",
                "abbr": "NST",
                "offset": 5.75,
                "isdst": false,
                "text": "(UTC+05:45) Kathmandu",
                "utc": [
                    "Asia/Kathmandu"
                ]
            },
            {
                "name": "Central Asia Standard Time",
                "abbr": "CAST",
                "offset": 6,
                "isdst": false,
                "text": "(UTC+06:00) Nur-Sultan (Astana)",
                "utc": [
                    "Antarctica/Vostok",
                    "Asia/Almaty",
                    "Asia/Bishkek",
                    "Asia/Qyzylorda",
                    "Asia/Urumqi",
                    "Etc/GMT-6",
                    "Indian/Chagos"
                ]
            },
            {
                "name": "Bangladesh Standard Time",
                "abbr": "BST",
                "offset": 6,
                "isdst": false,
                "text": "(UTC+06:00) Dhaka",
                "utc": [
                    "Asia/Dhaka",
                    "Asia/Thimphu"
                ]
            },
            {
                "name": "Myanmar Standard Time",
                "abbr": "MST",
                "offset": 6.5,
                "isdst": false,
                "text": "(UTC+06:30) Yangon (Rangoon)",
                "utc": [
                    "Asia/Rangoon",
                    "Indian/Cocos"
                ]
            },
            {
                "name": "SE Asia Standard Time",
                "abbr": "SAST",
                "offset": 7,
                "isdst": false,
                "text": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
                "utc": [
                    "Antarctica/Davis",
                    "Asia/Bangkok",
                    "Asia/Hovd",
                    "Asia/Jakarta",
                    "Asia/Phnom_Penh",
                    "Asia/Pontianak",
                    "Asia/Saigon",
                    "Asia/Vientiane",
                    "Etc/GMT-7",
                    "Indian/Christmas"
                ]
            },
            {
                "name": "N. Central Asia Standard Time",
                "abbr": "NCAST",
                "offset": 7,
                "isdst": false,
                "text": "(UTC+07:00) Novosibirsk",
                "utc": [
                    "Asia/Novokuznetsk",
                    "Asia/Novosibirsk",
                    "Asia/Omsk"
                ]
            },
            {
                "name": "China Standard Time",
                "abbr": "CST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
                "utc": [
                    "Asia/Hong_Kong",
                    "Asia/Macau",
                    "Asia/Shanghai"
                ]
            },
            {
                "name": "North Asia Standard Time",
                "abbr": "NAST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Krasnoyarsk",
                "utc": [
                    "Asia/Krasnoyarsk"
                ]
            },
            {
                "name": "Singapore Standard Time",
                "abbr": "MPST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Kuala Lumpur, Singapore",
                "utc": [
                    "Asia/Brunei",
                    "Asia/Kuala_Lumpur",
                    "Asia/Kuching",
                    "Asia/Makassar",
                    "Asia/Manila",
                    "Asia/Singapore",
                    "Etc/GMT-8"
                ]
            },
            {
                "name": "W. Australia Standard Time",
                "abbr": "WAST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Perth",
                "utc": [
                    "Antarctica/Casey",
                    "Australia/Perth"
                ]
            },
            {
                "name": "Taipei Standard Time",
                "abbr": "TST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Taipei",
                "utc": [
                    "Asia/Taipei"
                ]
            },
            {
                "name": "Ulaanbaatar Standard Time",
                "abbr": "UST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Ulaanbaatar",
                "utc": [
                    "Asia/Choibalsan",
                    "Asia/Ulaanbaatar"
                ]
            },
            {
                "name": "North Asia East Standard Time",
                "abbr": "NAEST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Irkutsk",
                "utc": [
                    "Asia/Irkutsk"
                ]
            },
            {
                "name": "Japan Standard Time",
                "abbr": "JST",
                "offset": 9,
                "isdst": false,
                "text": "(UTC+09:00) Osaka, Sapporo, Tokyo",
                "utc": [
                    "Asia/Dili",
                    "Asia/Jayapura",
                    "Asia/Tokyo",
                    "Etc/GMT-9",
                    "Pacific/Palau"
                ]
            },
            {
                "name": "Korea Standard Time",
                "abbr": "KST",
                "offset": 9,
                "isdst": false,
                "text": "(UTC+09:00) Seoul",
                "utc": [
                    "Asia/Pyongyang",
                    "Asia/Seoul"
                ]
            },
            {
                "name": "Cen. Australia Standard Time",
                "abbr": "CAST",
                "offset": 9.5,
                "isdst": false,
                "text": "(UTC+09:30) Adelaide",
                "utc": [
                    "Australia/Adelaide",
                    "Australia/Broken_Hill"
                ]
            },
            {
                "name": "AUS Central Standard Time",
                "abbr": "ACST",
                "offset": 9.5,
                "isdst": false,
                "text": "(UTC+09:30) Darwin",
                "utc": [
                    "Australia/Darwin"
                ]
            },
            {
                "name": "E. Australia Standard Time",
                "abbr": "EAST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Brisbane",
                "utc": [
                    "Australia/Brisbane",
                    "Australia/Lindeman"
                ]
            },
            {
                "name": "AUS Eastern Standard Time",
                "abbr": "AEST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Canberra, Melbourne, Sydney",
                "utc": [
                    "Australia/Melbourne",
                    "Australia/Sydney"
                ]
            },
            {
                "name": "West Pacific Standard Time",
                "abbr": "WPST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Guam, Port Moresby",
                "utc": [
                    "Antarctica/DumontDUrville",
                    "Etc/GMT-10",
                    "Pacific/Guam",
                    "Pacific/Port_Moresby",
                    "Pacific/Saipan",
                    "Pacific/Truk"
                ]
            },
            {
                "name": "Tasmania Standard Time",
                "abbr": "TST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Hobart",
                "utc": [
                    "Australia/Currie",
                    "Australia/Hobart"
                ]
            },
            {
                "name": "Yakutsk Standard Time",
                "abbr": "YST",
                "offset": 9,
                "isdst": false,
                "text": "(UTC+09:00) Yakutsk",
                "utc": [
                    "Asia/Chita",
                    "Asia/Khandyga",
                    "Asia/Yakutsk"
                ]
            },
            {
                "name": "Central Pacific Standard Time",
                "abbr": "CPST",
                "offset": 11,
                "isdst": false,
                "text": "(UTC+11:00) Solomon Is., New Caledonia",
                "utc": [
                    "Antarctica/Macquarie",
                    "Etc/GMT-11",
                    "Pacific/Efate",
                    "Pacific/Guadalcanal",
                    "Pacific/Kosrae",
                    "Pacific/Noumea",
                    "Pacific/Ponape"
                ]
            },
            {
                "name": "Vladivostok Standard Time",
                "abbr": "VST",
                "offset": 11,
                "isdst": false,
                "text": "(UTC+11:00) Vladivostok",
                "utc": [
                    "Asia/Sakhalin",
                    "Asia/Ust-Nera",
                    "Asia/Vladivostok"
                ]
            },
            {
                "name": "New Zealand Standard Time",
                "abbr": "NZST",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Auckland, Wellington",
                "utc": [
                    "Antarctica/McMurdo",
                    "Pacific/Auckland"
                ]
            },
            {
                "name": "UTC+12",
                "abbr": "U",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Coordinated Universal Time+12",
                "utc": [
                    "Etc/GMT-12",
                    "Pacific/Funafuti",
                    "Pacific/Kwajalein",
                    "Pacific/Majuro",
                    "Pacific/Nauru",
                    "Pacific/Tarawa",
                    "Pacific/Wake",
                    "Pacific/Wallis"
                ]
            },
            {
                "name": "Fiji Standard Time",
                "abbr": "FST",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Fiji",
                "utc": [
                    "Pacific/Fiji"
                ]
            },
            {
                "name": "Magadan Standard Time",
                "abbr": "MST",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Magadan",
                "utc": [
                    "Asia/Anadyr",
                    "Asia/Kamchatka",
                    "Asia/Magadan",
                    "Asia/Srednekolymsk"
                ]
            },
            {
                "name": "Kamchatka Standard Time",
                "abbr": "KDT",
                "offset": 13,
                "isdst": true,
                "text": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
                "utc": [
                    "Asia/Kamchatka"
                ]
            },
            {
                "name": "Tonga Standard Time",
                "abbr": "TST",
                "offset": 13,
                "isdst": false,
                "text": "(UTC+13:00) Nuku'alofa",
                "utc": [
                    "Etc/GMT-13",
                    "Pacific/Enderbury",
                    "Pacific/Fakaofo",
                    "Pacific/Tongatapu"
                ]
            },
            {
                "name": "Samoa Standard Time",
                "abbr": "SST",
                "offset": 13,
                "isdst": false,
                "text": "(UTC+13:00) Samoa",
                "utc": [
                    "Pacific/Apia"
                ]
            }
        ],
        //List source: http://answers.google.com/answers/threadview/id/589312.html
        profession: [
            "Airline Pilot",
            "Academic Team",
            "Accountant",
            "Account Executive",
            "Actor",
            "Actuary",
            "Acquisition Analyst",
            "Administrative Asst.",
            "Administrative Analyst",
            "Administrator",
            "Advertising Director",
            "Aerospace Engineer",
            "Agent",
            "Agricultural Inspector",
            "Agricultural Scientist",
            "Air Traffic Controller",
            "Animal Trainer",
            "Anthropologist",
            "Appraiser",
            "Architect",
            "Art Director",
            "Artist",
            "Astronomer",
            "Athletic Coach",
            "Auditor",
            "Author",
            "Baker",
            "Banker",
            "Bankruptcy Attorney",
            "Benefits Manager",
            "Biologist",
            "Bio-feedback Specialist",
            "Biomedical Engineer",
            "Biotechnical Researcher",
            "Broadcaster",
            "Broker",
            "Building Manager",
            "Building Contractor",
            "Building Inspector",
            "Business Analyst",
            "Business Planner",
            "Business Manager",
            "Buyer",
            "Call Center Manager",
            "Career Counselor",
            "Cash Manager",
            "Ceramic Engineer",
            "Chief Executive Officer",
            "Chief Operation Officer",
            "Chef",
            "Chemical Engineer",
            "Chemist",
            "Child Care Manager",
            "Chief Medical Officer",
            "Chiropractor",
            "Cinematographer",
            "City Housing Manager",
            "City Manager",
            "Civil Engineer",
            "Claims Manager",
            "Clinical Research Assistant",
            "Collections Manager",
            "Compliance Manager",
            "Comptroller",
            "Computer Manager",
            "Commercial Artist",
            "Communications Affairs Director",
            "Communications Director",
            "Communications Engineer",
            "Compensation Analyst",
            "Computer Programmer",
            "Computer Ops. Manager",
            "Computer Engineer",
            "Computer Operator",
            "Computer Graphics Specialist",
            "Construction Engineer",
            "Construction Manager",
            "Consultant",
            "Consumer Relations Manager",
            "Contract Administrator",
            "Copyright Attorney",
            "Copywriter",
            "Corporate Planner",
            "Corrections Officer",
            "Cosmetologist",
            "Credit Analyst",
            "Cruise Director",
            "Chief Information Officer",
            "Chief Technology Officer",
            "Customer Service Manager",
            "Cryptologist",
            "Dancer",
            "Data Security Manager",
            "Database Manager",
            "Day Care Instructor",
            "Dentist",
            "Designer",
            "Design Engineer",
            "Desktop Publisher",
            "Developer",
            "Development Officer",
            "Diamond Merchant",
            "Dietitian",
            "Direct Marketer",
            "Director",
            "Distribution Manager",
            "Diversity Manager",
            "Economist",
            "EEO Compliance Manager",
            "Editor",
            "Education Adminator",
            "Electrical Engineer",
            "Electro Optical Engineer",
            "Electronics Engineer",
            "Embassy Management",
            "Employment Agent",
            "Engineer Technician",
            "Entrepreneur",
            "Environmental Analyst",
            "Environmental Attorney",
            "Environmental Engineer",
            "Environmental Specialist",
            "Escrow Officer",
            "Estimator",
            "Executive Assistant",
            "Executive Director",
            "Executive Recruiter",
            "Facilities Manager",
            "Family Counselor",
            "Fashion Events Manager",
            "Fashion Merchandiser",
            "Fast Food Manager",
            "Film Producer",
            "Film Production Assistant",
            "Financial Analyst",
            "Financial Planner",
            "Financier",
            "Fine Artist",
            "Wildlife Specialist",
            "Fitness Consultant",
            "Flight Attendant",
            "Flight Engineer",
            "Floral Designer",
            "Food & Beverage Director",
            "Food Service Manager",
            "Forestry Technician",
            "Franchise Management",
            "Franchise Sales",
            "Fraud Investigator",
            "Freelance Writer",
            "Fund Raiser",
            "General Manager",
            "Geologist",
            "General Counsel",
            "Geriatric Specialist",
            "Gerontologist",
            "Glamour Photographer",
            "Golf Club Manager",
            "Gourmet Chef",
            "Graphic Designer",
            "Grounds Keeper",
            "Hazardous Waste Manager",
            "Health Care Manager",
            "Health Therapist",
            "Health Service Administrator",
            "Hearing Officer",
            "Home Economist",
            "Horticulturist",
            "Hospital Administrator",
            "Hotel Manager",
            "Human Resources Manager",
            "Importer",
            "Industrial Designer",
            "Industrial Engineer",
            "Information Director",
            "Inside Sales",
            "Insurance Adjuster",
            "Interior Decorator",
            "Internal Controls Director",
            "International Acct.",
            "International Courier",
            "International Lawyer",
            "Interpreter",
            "Investigator",
            "Investment Banker",
            "Investment Manager",
            "IT Architect",
            "IT Project Manager",
            "IT Systems Analyst",
            "Jeweler",
            "Joint Venture Manager",
            "Journalist",
            "Labor Negotiator",
            "Labor Organizer",
            "Labor Relations Manager",
            "Lab Services Director",
            "Lab Technician",
            "Land Developer",
            "Landscape Architect",
            "Law Enforcement Officer",
            "Lawyer",
            "Lead Software Engineer",
            "Lead Software Test Engineer",
            "Leasing Manager",
            "Legal Secretary",
            "Library Manager",
            "Litigation Attorney",
            "Loan Officer",
            "Lobbyist",
            "Logistics Manager",
            "Maintenance Manager",
            "Management Consultant",
            "Managed Care Director",
            "Managing Partner",
            "Manufacturing Director",
            "Manpower Planner",
            "Marine Biologist",
            "Market Res. Analyst",
            "Marketing Director",
            "Materials Manager",
            "Mathematician",
            "Membership Chairman",
            "Mechanic",
            "Mechanical Engineer",
            "Media Buyer",
            "Medical Investor",
            "Medical Secretary",
            "Medical Technician",
            "Mental Health Counselor",
            "Merchandiser",
            "Metallurgical Engineering",
            "Meteorologist",
            "Microbiologist",
            "MIS Manager",
            "Motion Picture Director",
            "Multimedia Director",
            "Musician",
            "Network Administrator",
            "Network Specialist",
            "Network Operator",
            "New Product Manager",
            "Novelist",
            "Nuclear Engineer",
            "Nuclear Specialist",
            "Nutritionist",
            "Nursing Administrator",
            "Occupational Therapist",
            "Oceanographer",
            "Office Manager",
            "Operations Manager",
            "Operations Research Director",
            "Optical Technician",
            "Optometrist",
            "Organizational Development Manager",
            "Outplacement Specialist",
            "Paralegal",
            "Park Ranger",
            "Patent Attorney",
            "Payroll Specialist",
            "Personnel Specialist",
            "Petroleum Engineer",
            "Pharmacist",
            "Photographer",
            "Physical Therapist",
            "Physician",
            "Physician Assistant",
            "Physicist",
            "Planning Director",
            "Podiatrist",
            "Political Analyst",
            "Political Scientist",
            "Politician",
            "Portfolio Manager",
            "Preschool Management",
            "Preschool Teacher",
            "Principal",
            "Private Banker",
            "Private Investigator",
            "Probation Officer",
            "Process Engineer",
            "Producer",
            "Product Manager",
            "Product Engineer",
            "Production Engineer",
            "Production Planner",
            "Professional Athlete",
            "Professional Coach",
            "Professor",
            "Project Engineer",
            "Project Manager",
            "Program Manager",
            "Property Manager",
            "Public Administrator",
            "Public Safety Director",
            "PR Specialist",
            "Publisher",
            "Purchasing Agent",
            "Publishing Director",
            "Quality Assurance Specialist",
            "Quality Control Engineer",
            "Quality Control Inspector",
            "Radiology Manager",
            "Railroad Engineer",
            "Real Estate Broker",
            "Recreational Director",
            "Recruiter",
            "Redevelopment Specialist",
            "Regulatory Affairs Manager",
            "Registered Nurse",
            "Rehabilitation Counselor",
            "Relocation Manager",
            "Reporter",
            "Research Specialist",
            "Restaurant Manager",
            "Retail Store Manager",
            "Risk Analyst",
            "Safety Engineer",
            "Sales Engineer",
            "Sales Trainer",
            "Sales Promotion Manager",
            "Sales Representative",
            "Sales Manager",
            "Service Manager",
            "Sanitation Engineer",
            "Scientific Programmer",
            "Scientific Writer",
            "Securities Analyst",
            "Security Consultant",
            "Security Director",
            "Seminar Presenter",
            "Ship's Officer",
            "Singer",
            "Social Director",
            "Social Program Planner",
            "Social Research",
            "Social Scientist",
            "Social Worker",
            "Sociologist",
            "Software Developer",
            "Software Engineer",
            "Software Test Engineer",
            "Soil Scientist",
            "Special Events Manager",
            "Special Education Teacher",
            "Special Projects Director",
            "Speech Pathologist",
            "Speech Writer",
            "Sports Event Manager",
            "Statistician",
            "Store Manager",
            "Strategic Alliance Director",
            "Strategic Planning Director",
            "Stress Reduction Specialist",
            "Stockbroker",
            "Surveyor",
            "Structural Engineer",
            "Superintendent",
            "Supply Chain Director",
            "System Engineer",
            "Systems Analyst",
            "Systems Programmer",
            "System Administrator",
            "Tax Specialist",
            "Teacher",
            "Technical Support Specialist",
            "Technical Illustrator",
            "Technical Writer",
            "Technology Director",
            "Telecom Analyst",
            "Telemarketer",
            "Theatrical Director",
            "Title Examiner",
            "Tour Escort",
            "Tour Guide Director",
            "Traffic Manager",
            "Trainer Translator",
            "Transportation Manager",
            "Travel Agent",
            "Treasurer",
            "TV Programmer",
            "Underwriter",
            "Union Representative",
            "University Administrator",
            "University Dean",
            "Urban Planner",
            "Veterinarian",
            "Vendor Relations Director",
            "Viticulturist",
            "Warehouse Manager"
        ],
        animals: {
            //list of ocean animals comes from https://owlcation.com/stem/list-of-ocean-animals
            "ocean": [
                "Acantharea",
                "Anemone",
                "Angelfish King",
                "Ahi Tuna",
                "Albacore",
                "American Oyster",
                "Anchovy",
                "Armored Snail",
                "Arctic Char",
                "Atlantic Bluefin Tuna",
                "Atlantic Cod",
                "Atlantic Goliath Grouper",
                "Atlantic Trumpetfish",
                "Atlantic Wolffish",
                "Baleen Whale",
                "Banded Butterflyfish",
                "Banded Coral Shrimp",
                "Banded Sea Krait",
                "Barnacle",
                "Barndoor Skate",
                "Barracuda",
                "Basking Shark",
                "Bass",
                "Beluga Whale",
                "Bluebanded Goby",
                "Bluehead Wrasse",
                "Bluefish",
                "Bluestreak Cleaner-Wrasse",
                "Blue Marlin",
                "Blue Shark",
                "Blue Spiny Lobster",
                "Blue Tang",
                "Blue Whale",
                "Broadclub Cuttlefish",
                "Bull Shark",
                "Chambered Nautilus",
                "Chilean Basket Star",
                "Chilean Jack Mackerel",
                "Chinook Salmon",
                "Christmas Tree Worm",
                "Clam",
                "Clown Anemonefish",
                "Clown Triggerfish",
                "Cod",
                "Coelacanth",
                "Cockscomb Cup Coral",
                "Common Fangtooth",
                "Conch",
                "Cookiecutter Shark",
                "Copepod",
                "Coral",
                "Corydoras",
                "Cownose Ray",
                "Crab",
                "Crown-of-Thorns Starfish",
                "Cushion Star",
                "Cuttlefish",
                "California Sea Otters",
                "Dolphin",
                "Dolphinfish",
                "Dory",
                "Devil Fish",
                "Dugong",
                "Dumbo Octopus",
                "Dungeness Crab",
                "Eccentric Sand Dollar",
                "Edible Sea Cucumber",
                "Eel",
                "Elephant Seal",
                "Elkhorn Coral",
                "Emperor Shrimp",
                "Estuarine Crocodile",
                "Fathead Sculpin",
                "Fiddler Crab",
                "Fin Whale",
                "Flameback",
                "Flamingo Tongue Snail",
                "Flashlight Fish",
                "Flatback Turtle",
                "Flatfish",
                "Flying Fish",
                "Flounder",
                "Fluke",
                "French Angelfish",
                "Frilled Shark",
                "Fugu (also called Pufferfish)",
                "Gar",
                "Geoduck",
                "Giant Barrel Sponge",
                "Giant Caribbean Sea Anemone",
                "Giant Clam",
                "Giant Isopod",
                "Giant Kingfish",
                "Giant Oarfish",
                "Giant Pacific Octopus",
                "Giant Pyrosome",
                "Giant Sea Star",
                "Giant Squid",
                "Glowing Sucker Octopus",
                "Giant Tube Worm",
                "Goblin Shark",
                "Goosefish",
                "Great White Shark",
                "Greenland Shark",
                "Grey Atlantic Seal",
                "Grouper",
                "Grunion",
                "Guineafowl Puffer",
                "Haddock",
                "Hake",
                "Halibut",
                "Hammerhead Shark",
                "Hapuka",
                "Harbor Porpoise",
                "Harbor Seal",
                "Hatchetfish",
                "Hawaiian Monk Seal",
                "Hawksbill Turtle",
                "Hector's Dolphin",
                "Hermit Crab",
                "Herring",
                "Hoki",
                "Horn Shark",
                "Horseshoe Crab",
                "Humpback Anglerfish",
                "Humpback Whale",
                "Icefish",
                "Imperator Angelfish",
                "Irukandji Jellyfish",
                "Isopod",
                "Ivory Bush Coral",
                "Japanese Spider Crab",
                "Jellyfish",
                "John Dory",
                "Juan Fernandez Fur Seal",
                "Killer Whale",
                "Kiwa Hirsuta",
                "Krill",
                "Lagoon Triggerfish",
                "Lamprey",
                "Leafy Seadragon",
                "Leopard Seal",
                "Limpet",
                "Ling",
                "Lionfish",
                "Lions Mane Jellyfish",
                "Lobe Coral",
                "Lobster",
                "Loggerhead Turtle",
                "Longnose Sawshark",
                "Longsnout Seahorse",
                "Lophelia Coral",
                "Marrus Orthocanna",
                "Manatee",
                "Manta Ray",
                "Marlin",
                "Megamouth Shark",
                "Mexican Lookdown",
                "Mimic Octopus",
                "Moon Jelly",
                "Mollusk",
                "Monkfish",
                "Moray Eel",
                "Mullet",
                "Mussel",
                "Megaladon",
                "Napoleon Wrasse",
                "Nassau Grouper",
                "Narwhal",
                "Nautilus",
                "Needlefish",
                "Northern Seahorse",
                "North Atlantic Right Whale",
                "Northern Red Snapper",
                "Norway Lobster",
                "Nudibranch",
                "Nurse Shark",
                "Oarfish",
                "Ocean Sunfish",
                "Oceanic Whitetip Shark",
                "Octopus",
                "Olive Sea Snake",
                "Orange Roughy",
                "Ostracod",
                "Otter",
                "Oyster",
                "Pacific Angelshark",
                "Pacific Blackdragon",
                "Pacific Halibut",
                "Pacific Sardine",
                "Pacific Sea Nettle Jellyfish",
                "Pacific White Sided Dolphin",
                "Pantropical Spotted Dolphin",
                "Patagonian Toothfish",
                "Peacock Mantis Shrimp",
                "Pelagic Thresher Shark",
                "Penguin",
                "Peruvian Anchoveta",
                "Pilchard",
                "Pink Salmon",
                "Pinniped",
                "Plankton",
                "Porpoise",
                "Polar Bear",
                "Portuguese Man o' War",
                "Pycnogonid Sea Spider",
                "Quahog",
                "Queen Angelfish",
                "Queen Conch",
                "Queen Parrotfish",
                "Queensland Grouper",
                "Ragfish",
                "Ratfish",
                "Rattail Fish",
                "Ray",
                "Red Drum",
                "Red King Crab",
                "Ringed Seal",
                "Risso's Dolphin",
                "Ross Seals",
                "Sablefish",
                "Salmon",
                "Sand Dollar",
                "Sandbar Shark",
                "Sawfish",
                "Sarcastic Fringehead",
                "Scalloped Hammerhead Shark",
                "Seahorse",
                "Sea Cucumber",
                "Sea Lion",
                "Sea Urchin",
                "Seal",
                "Shark",
                "Shortfin Mako Shark",
                "Shovelnose Guitarfish",
                "Shrimp",
                "Silverside Fish",
                "Skipjack Tuna",
                "Slender Snipe Eel",
                "Smalltooth Sawfish",
                "Smelts",
                "Sockeye Salmon",
                "Southern Stingray",
                "Sponge",
                "Spotted Porcupinefish",
                "Spotted Dolphin",
                "Spotted Eagle Ray",
                "Spotted Moray",
                "Squid",
                "Squidworm",
                "Starfish",
                "Stickleback",
                "Stonefish",
                "Stoplight Loosejaw",
                "Sturgeon",
                "Swordfish",
                "Tan Bristlemouth",
                "Tasseled Wobbegong",
                "Terrible Claw Lobster",
                "Threespot Damselfish",
                "Tiger Prawn",
                "Tiger Shark",
                "Tilefish",
                "Toadfish",
                "Tropical Two-Wing Flyfish",
                "Tuna",
                "Umbrella Squid",
                "Velvet Crab",
                "Venus Flytrap Sea Anemone",
                "Vigtorniella Worm",
                "Viperfish",
                "Vampire Squid",
                "Vaquita",
                "Wahoo",
                "Walrus",
                "West Indian Manatee",
                "Whale",
                "Whale Shark",
                "Whiptail Gulper",
                "White-Beaked Dolphin",
                "White-Ring Garden Eel",
                "White Shrimp",
                "Wobbegong",
                "Wrasse",
                "Wreckfish",
                "Xiphosura",
                "Yellowtail Damselfish",
                "Yelloweye Rockfish",
                "Yellow Cup Black Coral",
                "Yellow Tube Sponge",
                "Yellowfin Tuna",
                "Zebrashark",
                "Zooplankton"
            ],
            //list of desert, grassland, and forest animals comes from http://www.skyenimals.com/
            "desert": [
                "Aardwolf",
                "Addax",
                "African Wild Ass",
                "Ant",
                "Antelope",
                "Armadillo",
                "Baboon",
                "Badger",
                "Bat",
                "Bearded Dragon",
                "Beetle",
                "Bird",
                "Black-footed Cat",
                "Boa",
                "Brown Bear",
                "Bustard",
                "Butterfly",
                "Camel",
                "Caracal",
                "Caracara",
                "Caterpillar",
                "Centipede",
                "Cheetah",
                "Chipmunk",
                "Chuckwalla",
                "Climbing Mouse",
                "Coati",
                "Cobra",
                "Cotton Rat",
                "Cougar",
                "Courser",
                "Crane Fly",
                "Crow",
                "Dassie Rat",
                "Dove",
                "Dunnart",
                "Eagle",
                "Echidna",
                "Elephant",
                "Emu",
                "Falcon",
                "Fly",
                "Fox",
                "Frogmouth",
                "Gecko",
                "Geoffroy's Cat",
                "Gerbil",
                "Grasshopper",
                "Guanaco",
                "Gundi",
                "Hamster",
                "Hawk",
                "Hedgehog",
                "Hyena",
                "Hyrax",
                "Jackal",
                "Kangaroo",
                "Kangaroo Rat",
                "Kestrel",
                "Kowari",
                "Kultarr",
                "Leopard",
                "Lion",
                "Macaw",
                "Meerkat",
                "Mouse",
                "Oryx",
                "Ostrich",
                "Owl",
                "Pronghorn",
                "Python",
                "Rabbit",
                "Raccoon",
                "Rattlesnake",
                "Rhinoceros",
                "Sand Cat",
                "Spectacled Bear",
                "Spiny Mouse",
                "Starling",
                "Stick Bug",
                "Tarantula",
                "Tit",
                "Toad",
                "Tortoise",
                "Tyrant Flycatcher",
                "Viper",
                "Vulture",
                "Waxwing",
                "Xerus",
                "Zebra"
            ],
            "grassland": [
                "Aardvark",
                "Aardwolf",
                "Accentor",
                "African Buffalo",
                "African Wild Dog",
                "Alpaca",
                "Anaconda",
                "Ant",
                "Anteater",
                "Antelope",
                "Armadillo",
                "Baboon",
                "Badger",
                "Bandicoot",
                "Barbet",
                "Bat",
                "Bee",
                "Bee-eater",
                "Beetle",
                "Bird",
                "Bison",
                "Black-footed Cat",
                "Black-footed Ferret",
                "Bluebird",
                "Boa",
                "Bowerbird",
                "Brown Bear",
                "Bush Dog",
                "Bushshrike",
                "Bustard",
                "Butterfly",
                "Buzzard",
                "Caracal",
                "Caracara",
                "Cardinal",
                "Caterpillar",
                "Cheetah",
                "Chipmunk",
                "Civet",
                "Climbing Mouse",
                "Clouded Leopard",
                "Coati",
                "Cobra",
                "Cockatoo",
                "Cockroach",
                "Common Genet",
                "Cotton Rat",
                "Cougar",
                "Courser",
                "Coyote",
                "Crane",
                "Crane Fly",
                "Cricket",
                "Crow",
                "Culpeo",
                "Death Adder",
                "Deer",
                "Deer Mouse",
                "Dingo",
                "Dinosaur",
                "Dove",
                "Drongo",
                "Duck",
                "Duiker",
                "Dunnart",
                "Eagle",
                "Echidna",
                "Elephant",
                "Elk",
                "Emu",
                "Falcon",
                "Finch",
                "Flea",
                "Fly",
                "Flying Frog",
                "Fox",
                "Frog",
                "Frogmouth",
                "Garter Snake",
                "Gazelle",
                "Gecko",
                "Geoffroy's Cat",
                "Gerbil",
                "Giant Tortoise",
                "Giraffe",
                "Grasshopper",
                "Grison",
                "Groundhog",
                "Grouse",
                "Guanaco",
                "Guinea Pig",
                "Hamster",
                "Harrier",
                "Hartebeest",
                "Hawk",
                "Hedgehog",
                "Helmetshrike",
                "Hippopotamus",
                "Hornbill",
                "Hyena",
                "Hyrax",
                "Impala",
                "Jackal",
                "Jaguar",
                "Jaguarundi",
                "Kangaroo",
                "Kangaroo Rat",
                "Kestrel",
                "Kultarr",
                "Ladybug",
                "Leopard",
                "Lion",
                "Macaw",
                "Meerkat",
                "Mouse",
                "Newt",
                "Oryx",
                "Ostrich",
                "Owl",
                "Pangolin",
                "Pheasant",
                "Prairie Dog",
                "Pronghorn",
                "Przewalski's Horse",
                "Python",
                "Quoll",
                "Rabbit",
                "Raven",
                "Rhinoceros",
                "Shelduck",
                "Sloth Bear",
                "Spectacled Bear",
                "Squirrel",
                "Starling",
                "Stick Bug",
                "Tamandua",
                "Tasmanian Devil",
                "Thornbill",
                "Thrush",
                "Toad",
                "Tortoise"
            ],
            "forest": [
                "Agouti",
                "Anaconda",
                "Anoa",
                "Ant",
                "Anteater",
                "Antelope",
                "Armadillo",
                "Asian Black Bear",
                "Aye-aye",
                "Babirusa",
                "Baboon",
                "Badger",
                "Bandicoot",
                "Banteng",
                "Barbet",
                "Basilisk",
                "Bat",
                "Bearded Dragon",
                "Bee",
                "Bee-eater",
                "Beetle",
                "Bettong",
                "Binturong",
                "Bird-of-paradise",
                "Bongo",
                "Bowerbird",
                "Bulbul",
                "Bush Dog",
                "Bushbaby",
                "Bushshrike",
                "Butterfly",
                "Buzzard",
                "Caecilian",
                "Cardinal",
                "Cassowary",
                "Caterpillar",
                "Centipede",
                "Chameleon",
                "Chimpanzee",
                "Cicada",
                "Civet",
                "Clouded Leopard",
                "Coati",
                "Cobra",
                "Cockatoo",
                "Cockroach",
                "Colugo",
                "Cotinga",
                "Cotton Rat",
                "Cougar",
                "Crane Fly",
                "Cricket",
                "Crocodile",
                "Crow",
                "Cuckoo",
                "Cuscus",
                "Death Adder",
                "Deer",
                "Dhole",
                "Dingo",
                "Dinosaur",
                "Drongo",
                "Duck",
                "Duiker",
                "Eagle",
                "Echidna",
                "Elephant",
                "Finch",
                "Flat-headed Cat",
                "Flea",
                "Flowerpecker",
                "Fly",
                "Flying Frog",
                "Fossa",
                "Frog",
                "Frogmouth",
                "Gaur",
                "Gecko",
                "Gorilla",
                "Grison",
                "Hawaiian Honeycreeper",
                "Hawk",
                "Hedgehog",
                "Helmetshrike",
                "Hornbill",
                "Hyrax",
                "Iguana",
                "Jackal",
                "Jaguar",
                "Jaguarundi",
                "Kestrel",
                "Ladybug",
                "Lemur",
                "Leopard",
                "Lion",
                "Macaw",
                "Mandrill",
                "Margay",
                "Monkey",
                "Mouse",
                "Mouse Deer",
                "Newt",
                "Okapi",
                "Old World Flycatcher",
                "Orangutan",
                "Owl",
                "Pangolin",
                "Peafowl",
                "Pheasant",
                "Possum",
                "Python",
                "Quokka",
                "Rabbit",
                "Raccoon",
                "Red Panda",
                "Red River Hog",
                "Rhinoceros",
                "Sloth Bear",
                "Spectacled Bear",
                "Squirrel",
                "Starling",
                "Stick Bug",
                "Sun Bear",
                "Tamandua",
                "Tamarin",
                "Tapir",
                "Tarantula",
                "Thrush",
                "Tiger",
                "Tit",
                "Toad",
                "Tortoise",
                "Toucan",
                "Trogon",
                "Trumpeter",
                "Turaco",
                "Turtle",
                "Tyrant Flycatcher",
                "Viper",
                "Vulture",
                "Wallaby",
                "Warbler",
                "Wasp",
                "Waxwing",
                "Weaver",
                "Weaver-finch",
                "Whistler",
                "White-eye",
                "Whydah",
                "Woodswallow",
                "Worm",
                "Wren",
                "Xenops",
                "Yellowjacket",
                "Accentor",
                "African Buffalo",
                "American Black Bear",
                "Anole",
                "Bird",
                "Bison",
                "Boa",
                "Brown Bear",
                "Chipmunk",
                "Common Genet",
                "Copperhead",
                "Coyote",
                "Deer Mouse",
                "Dormouse",
                "Elk",
                "Emu",
                "Fisher",
                "Fox",
                "Garter Snake",
                "Giant Panda",
                "Giant Tortoise",
                "Groundhog",
                "Grouse",
                "Guanaco",
                "Himalayan Tahr",
                "Kangaroo",
                "Koala",
                "Numbat",
                "Quoll",
                "Raccoon dog",
                "Tasmanian Devil",
                "Thornbill",
                "Turkey",
                "Vole",
                "Weasel",
                "Wildcat",
                "Wolf",
                "Wombat",
                "Woodchuck",
                "Woodpecker"
            ],
            //list of farm animals comes from https://www.buzzle.com/articles/farm-animals-list.html
            "farm": [
                "Alpaca",
                "Buffalo",
                "Banteng",
                "Cow",
                "Cat",
                "Chicken",
                "Carp",
                "Camel",
                "Donkey",
                "Dog",
                "Duck",
                "Emu",
                "Goat",
                "Gayal",
                "Guinea",
                "Goose",
                "Horse",
                "Honey",
                "Llama",
                "Pig",
                "Pigeon",
                "Rhea",
                "Rabbit",
                "Sheep",
                "Silkworm",
                "Turkey",
                "Yak",
                "Zebu"
            ],
            //list of pet animals comes from https://www.dogbreedinfo.com/pets/pet.htm
            "pet": [
                "Bearded Dragon",
                "Birds",
                "Burro",
                "Cats",
                "Chameleons",
                "Chickens",
                "Chinchillas",
                "Chinese Water Dragon",
                "Cows",
                "Dogs",
                "Donkey",
                "Ducks",
                "Ferrets",
                "Fish",
                "Geckos",
                "Geese",
                "Gerbils",
                "Goats",
                "Guinea Fowl",
                "Guinea Pigs",
                "Hamsters",
                "Hedgehogs",
                "Horses",
                "Iguanas",
                "Llamas",
                "Lizards",
                "Mice",
                "Mule",
                "Peafowl",
                "Pigs and Hogs",
                "Pigeons",
                "Ponies",
                "Pot Bellied Pig",
                "Rabbits",
                "Rats",
                "Sheep",
                "Skinks",
                "Snakes",
                "Stick Insects",
                "Sugar Gliders",
                "Tarantula",
                "Turkeys",
                "Turtles"
            ],
            //list of zoo animals comes from https://bronxzoo.com/animals
            "zoo": [
                "Aardvark",
                "African Wild Dog",
                "Aldabra Tortoise",
                "American Alligator",
                "American Bison",
                "Amur Tiger",
                "Anaconda",
                "Andean Condor",
                "Asian Elephant",
                "Baby Doll Sheep",
                "Bald Eagle",
                "Barred Owl",
                "Blue Iguana",
                "Boer Goat",
                "California Sea Lion",
                "Caribbean Flamingo",
                "Chinchilla",
                "Collared Lemur",
                "Coquerel's Sifaka",
                "Cuban Amazon Parrot",
                "Ebony Langur",
                "Fennec Fox",
                "Fossa",
                "Gelada",
                "Giant Anteater",
                "Giraffe",
                "Gorilla",
                "Grizzly Bear",
                "Henkel's Leaf-tailed Gecko",
                "Indian Gharial",
                "Indian Rhinoceros",
                "King Cobra",
                "King Vulture",
                "Komodo Dragon",
                "Linne's Two-toed Sloth",
                "Lion",
                "Little Penguin",
                "Madagascar Tree Boa",
                "Magellanic Penguin",
                "Malayan Tapir",
                "Malayan Tiger",
                "Matschies Tree Kangaroo",
                "Mini Donkey",
                "Monarch Butterfly",
                "Nile crocodile",
                "North American Porcupine",
                "Nubian Ibex",
                "Okapi",
                "Poison Dart Frog",
                "Polar Bear",
                "Pygmy Marmoset",
                "Radiated Tortoise",
                "Red Panda",
                "Red Ruffed Lemur",
                "Ring-tailed Lemur",
                "Ring-tailed Mongoose",
                "Rock Hyrax",
                "Small Clawed Asian Otter",
                "Snow Leopard",
                "Snowy Owl",
                "Southern White-faced Owl",
                "Southern White Rhinocerous",
                "Squirrel Monkey",
                "Tufted Puffin",
                "White Cheeked Gibbon",
                "White-throated Bee Eater",
                "Zebra"
            ]
        },
        primes: [
            // 1230 first primes, i.e. all primes up to the first one greater than 10000, inclusive.
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37,
            41,
            43,
            47,
            53,
            59,
            61,
            67,
            71,
            73,
            79,
            83,
            89,
            97,
            101,
            103,
            107,
            109,
            113,
            127,
            131,
            137,
            139,
            149,
            151,
            157,
            163,
            167,
            173,
            179,
            181,
            191,
            193,
            197,
            199,
            211,
            223,
            227,
            229,
            233,
            239,
            241,
            251,
            257,
            263,
            269,
            271,
            277,
            281,
            283,
            293,
            307,
            311,
            313,
            317,
            331,
            337,
            347,
            349,
            353,
            359,
            367,
            373,
            379,
            383,
            389,
            397,
            401,
            409,
            419,
            421,
            431,
            433,
            439,
            443,
            449,
            457,
            461,
            463,
            467,
            479,
            487,
            491,
            499,
            503,
            509,
            521,
            523,
            541,
            547,
            557,
            563,
            569,
            571,
            577,
            587,
            593,
            599,
            601,
            607,
            613,
            617,
            619,
            631,
            641,
            643,
            647,
            653,
            659,
            661,
            673,
            677,
            683,
            691,
            701,
            709,
            719,
            727,
            733,
            739,
            743,
            751,
            757,
            761,
            769,
            773,
            787,
            797,
            809,
            811,
            821,
            823,
            827,
            829,
            839,
            853,
            857,
            859,
            863,
            877,
            881,
            883,
            887,
            907,
            911,
            919,
            929,
            937,
            941,
            947,
            953,
            967,
            971,
            977,
            983,
            991,
            997,
            1009,
            1013,
            1019,
            1021,
            1031,
            1033,
            1039,
            1049,
            1051,
            1061,
            1063,
            1069,
            1087,
            1091,
            1093,
            1097,
            1103,
            1109,
            1117,
            1123,
            1129,
            1151,
            1153,
            1163,
            1171,
            1181,
            1187,
            1193,
            1201,
            1213,
            1217,
            1223,
            1229,
            1231,
            1237,
            1249,
            1259,
            1277,
            1279,
            1283,
            1289,
            1291,
            1297,
            1301,
            1303,
            1307,
            1319,
            1321,
            1327,
            1361,
            1367,
            1373,
            1381,
            1399,
            1409,
            1423,
            1427,
            1429,
            1433,
            1439,
            1447,
            1451,
            1453,
            1459,
            1471,
            1481,
            1483,
            1487,
            1489,
            1493,
            1499,
            1511,
            1523,
            1531,
            1543,
            1549,
            1553,
            1559,
            1567,
            1571,
            1579,
            1583,
            1597,
            1601,
            1607,
            1609,
            1613,
            1619,
            1621,
            1627,
            1637,
            1657,
            1663,
            1667,
            1669,
            1693,
            1697,
            1699,
            1709,
            1721,
            1723,
            1733,
            1741,
            1747,
            1753,
            1759,
            1777,
            1783,
            1787,
            1789,
            1801,
            1811,
            1823,
            1831,
            1847,
            1861,
            1867,
            1871,
            1873,
            1877,
            1879,
            1889,
            1901,
            1907,
            1913,
            1931,
            1933,
            1949,
            1951,
            1973,
            1979,
            1987,
            1993,
            1997,
            1999,
            2003,
            2011,
            2017,
            2027,
            2029,
            2039,
            2053,
            2063,
            2069,
            2081,
            2083,
            2087,
            2089,
            2099,
            2111,
            2113,
            2129,
            2131,
            2137,
            2141,
            2143,
            2153,
            2161,
            2179,
            2203,
            2207,
            2213,
            2221,
            2237,
            2239,
            2243,
            2251,
            2267,
            2269,
            2273,
            2281,
            2287,
            2293,
            2297,
            2309,
            2311,
            2333,
            2339,
            2341,
            2347,
            2351,
            2357,
            2371,
            2377,
            2381,
            2383,
            2389,
            2393,
            2399,
            2411,
            2417,
            2423,
            2437,
            2441,
            2447,
            2459,
            2467,
            2473,
            2477,
            2503,
            2521,
            2531,
            2539,
            2543,
            2549,
            2551,
            2557,
            2579,
            2591,
            2593,
            2609,
            2617,
            2621,
            2633,
            2647,
            2657,
            2659,
            2663,
            2671,
            2677,
            2683,
            2687,
            2689,
            2693,
            2699,
            2707,
            2711,
            2713,
            2719,
            2729,
            2731,
            2741,
            2749,
            2753,
            2767,
            2777,
            2789,
            2791,
            2797,
            2801,
            2803,
            2819,
            2833,
            2837,
            2843,
            2851,
            2857,
            2861,
            2879,
            2887,
            2897,
            2903,
            2909,
            2917,
            2927,
            2939,
            2953,
            2957,
            2963,
            2969,
            2971,
            2999,
            3001,
            3011,
            3019,
            3023,
            3037,
            3041,
            3049,
            3061,
            3067,
            3079,
            3083,
            3089,
            3109,
            3119,
            3121,
            3137,
            3163,
            3167,
            3169,
            3181,
            3187,
            3191,
            3203,
            3209,
            3217,
            3221,
            3229,
            3251,
            3253,
            3257,
            3259,
            3271,
            3299,
            3301,
            3307,
            3313,
            3319,
            3323,
            3329,
            3331,
            3343,
            3347,
            3359,
            3361,
            3371,
            3373,
            3389,
            3391,
            3407,
            3413,
            3433,
            3449,
            3457,
            3461,
            3463,
            3467,
            3469,
            3491,
            3499,
            3511,
            3517,
            3527,
            3529,
            3533,
            3539,
            3541,
            3547,
            3557,
            3559,
            3571,
            3581,
            3583,
            3593,
            3607,
            3613,
            3617,
            3623,
            3631,
            3637,
            3643,
            3659,
            3671,
            3673,
            3677,
            3691,
            3697,
            3701,
            3709,
            3719,
            3727,
            3733,
            3739,
            3761,
            3767,
            3769,
            3779,
            3793,
            3797,
            3803,
            3821,
            3823,
            3833,
            3847,
            3851,
            3853,
            3863,
            3877,
            3881,
            3889,
            3907,
            3911,
            3917,
            3919,
            3923,
            3929,
            3931,
            3943,
            3947,
            3967,
            3989,
            4001,
            4003,
            4007,
            4013,
            4019,
            4021,
            4027,
            4049,
            4051,
            4057,
            4073,
            4079,
            4091,
            4093,
            4099,
            4111,
            4127,
            4129,
            4133,
            4139,
            4153,
            4157,
            4159,
            4177,
            4201,
            4211,
            4217,
            4219,
            4229,
            4231,
            4241,
            4243,
            4253,
            4259,
            4261,
            4271,
            4273,
            4283,
            4289,
            4297,
            4327,
            4337,
            4339,
            4349,
            4357,
            4363,
            4373,
            4391,
            4397,
            4409,
            4421,
            4423,
            4441,
            4447,
            4451,
            4457,
            4463,
            4481,
            4483,
            4493,
            4507,
            4513,
            4517,
            4519,
            4523,
            4547,
            4549,
            4561,
            4567,
            4583,
            4591,
            4597,
            4603,
            4621,
            4637,
            4639,
            4643,
            4649,
            4651,
            4657,
            4663,
            4673,
            4679,
            4691,
            4703,
            4721,
            4723,
            4729,
            4733,
            4751,
            4759,
            4783,
            4787,
            4789,
            4793,
            4799,
            4801,
            4813,
            4817,
            4831,
            4861,
            4871,
            4877,
            4889,
            4903,
            4909,
            4919,
            4931,
            4933,
            4937,
            4943,
            4951,
            4957,
            4967,
            4969,
            4973,
            4987,
            4993,
            4999,
            5003,
            5009,
            5011,
            5021,
            5023,
            5039,
            5051,
            5059,
            5077,
            5081,
            5087,
            5099,
            5101,
            5107,
            5113,
            5119,
            5147,
            5153,
            5167,
            5171,
            5179,
            5189,
            5197,
            5209,
            5227,
            5231,
            5233,
            5237,
            5261,
            5273,
            5279,
            5281,
            5297,
            5303,
            5309,
            5323,
            5333,
            5347,
            5351,
            5381,
            5387,
            5393,
            5399,
            5407,
            5413,
            5417,
            5419,
            5431,
            5437,
            5441,
            5443,
            5449,
            5471,
            5477,
            5479,
            5483,
            5501,
            5503,
            5507,
            5519,
            5521,
            5527,
            5531,
            5557,
            5563,
            5569,
            5573,
            5581,
            5591,
            5623,
            5639,
            5641,
            5647,
            5651,
            5653,
            5657,
            5659,
            5669,
            5683,
            5689,
            5693,
            5701,
            5711,
            5717,
            5737,
            5741,
            5743,
            5749,
            5779,
            5783,
            5791,
            5801,
            5807,
            5813,
            5821,
            5827,
            5839,
            5843,
            5849,
            5851,
            5857,
            5861,
            5867,
            5869,
            5879,
            5881,
            5897,
            5903,
            5923,
            5927,
            5939,
            5953,
            5981,
            5987,
            6007,
            6011,
            6029,
            6037,
            6043,
            6047,
            6053,
            6067,
            6073,
            6079,
            6089,
            6091,
            6101,
            6113,
            6121,
            6131,
            6133,
            6143,
            6151,
            6163,
            6173,
            6197,
            6199,
            6203,
            6211,
            6217,
            6221,
            6229,
            6247,
            6257,
            6263,
            6269,
            6271,
            6277,
            6287,
            6299,
            6301,
            6311,
            6317,
            6323,
            6329,
            6337,
            6343,
            6353,
            6359,
            6361,
            6367,
            6373,
            6379,
            6389,
            6397,
            6421,
            6427,
            6449,
            6451,
            6469,
            6473,
            6481,
            6491,
            6521,
            6529,
            6547,
            6551,
            6553,
            6563,
            6569,
            6571,
            6577,
            6581,
            6599,
            6607,
            6619,
            6637,
            6653,
            6659,
            6661,
            6673,
            6679,
            6689,
            6691,
            6701,
            6703,
            6709,
            6719,
            6733,
            6737,
            6761,
            6763,
            6779,
            6781,
            6791,
            6793,
            6803,
            6823,
            6827,
            6829,
            6833,
            6841,
            6857,
            6863,
            6869,
            6871,
            6883,
            6899,
            6907,
            6911,
            6917,
            6947,
            6949,
            6959,
            6961,
            6967,
            6971,
            6977,
            6983,
            6991,
            6997,
            7001,
            7013,
            7019,
            7027,
            7039,
            7043,
            7057,
            7069,
            7079,
            7103,
            7109,
            7121,
            7127,
            7129,
            7151,
            7159,
            7177,
            7187,
            7193,
            7207,
            7211,
            7213,
            7219,
            7229,
            7237,
            7243,
            7247,
            7253,
            7283,
            7297,
            7307,
            7309,
            7321,
            7331,
            7333,
            7349,
            7351,
            7369,
            7393,
            7411,
            7417,
            7433,
            7451,
            7457,
            7459,
            7477,
            7481,
            7487,
            7489,
            7499,
            7507,
            7517,
            7523,
            7529,
            7537,
            7541,
            7547,
            7549,
            7559,
            7561,
            7573,
            7577,
            7583,
            7589,
            7591,
            7603,
            7607,
            7621,
            7639,
            7643,
            7649,
            7669,
            7673,
            7681,
            7687,
            7691,
            7699,
            7703,
            7717,
            7723,
            7727,
            7741,
            7753,
            7757,
            7759,
            7789,
            7793,
            7817,
            7823,
            7829,
            7841,
            7853,
            7867,
            7873,
            7877,
            7879,
            7883,
            7901,
            7907,
            7919,
            7927,
            7933,
            7937,
            7949,
            7951,
            7963,
            7993,
            8009,
            8011,
            8017,
            8039,
            8053,
            8059,
            8069,
            8081,
            8087,
            8089,
            8093,
            8101,
            8111,
            8117,
            8123,
            8147,
            8161,
            8167,
            8171,
            8179,
            8191,
            8209,
            8219,
            8221,
            8231,
            8233,
            8237,
            8243,
            8263,
            8269,
            8273,
            8287,
            8291,
            8293,
            8297,
            8311,
            8317,
            8329,
            8353,
            8363,
            8369,
            8377,
            8387,
            8389,
            8419,
            8423,
            8429,
            8431,
            8443,
            8447,
            8461,
            8467,
            8501,
            8513,
            8521,
            8527,
            8537,
            8539,
            8543,
            8563,
            8573,
            8581,
            8597,
            8599,
            8609,
            8623,
            8627,
            8629,
            8641,
            8647,
            8663,
            8669,
            8677,
            8681,
            8689,
            8693,
            8699,
            8707,
            8713,
            8719,
            8731,
            8737,
            8741,
            8747,
            8753,
            8761,
            8779,
            8783,
            8803,
            8807,
            8819,
            8821,
            8831,
            8837,
            8839,
            8849,
            8861,
            8863,
            8867,
            8887,
            8893,
            8923,
            8929,
            8933,
            8941,
            8951,
            8963,
            8969,
            8971,
            8999,
            9001,
            9007,
            9011,
            9013,
            9029,
            9041,
            9043,
            9049,
            9059,
            9067,
            9091,
            9103,
            9109,
            9127,
            9133,
            9137,
            9151,
            9157,
            9161,
            9173,
            9181,
            9187,
            9199,
            9203,
            9209,
            9221,
            9227,
            9239,
            9241,
            9257,
            9277,
            9281,
            9283,
            9293,
            9311,
            9319,
            9323,
            9337,
            9341,
            9343,
            9349,
            9371,
            9377,
            9391,
            9397,
            9403,
            9413,
            9419,
            9421,
            9431,
            9433,
            9437,
            9439,
            9461,
            9463,
            9467,
            9473,
            9479,
            9491,
            9497,
            9511,
            9521,
            9533,
            9539,
            9547,
            9551,
            9587,
            9601,
            9613,
            9619,
            9623,
            9629,
            9631,
            9643,
            9649,
            9661,
            9677,
            9679,
            9689,
            9697,
            9719,
            9721,
            9733,
            9739,
            9743,
            9749,
            9767,
            9769,
            9781,
            9787,
            9791,
            9803,
            9811,
            9817,
            9829,
            9833,
            9839,
            9851,
            9857,
            9859,
            9871,
            9883,
            9887,
            9901,
            9907,
            9923,
            9929,
            9931,
            9941,
            9949,
            9967,
            9973,
            10007
        ],
        emotions: [
            "love",
            "joy",
            "surprise",
            "anger",
            "sadness",
            "fear"
        ],
        music_genres: {
            'general': [
                'Rock',
                'Pop',
                'Hip-Hop',
                'Jazz',
                'Classical',
                'Electronic',
                'Country',
                'R&B',
                'Reggae',
                'Blues',
                'Metal',
                'Folk',
                'Alternative',
                'Punk',
                'Disco',
                'Funk',
                'Techno',
                'Indie',
                'Gospel',
                'Dance',
                'Children\'s',
                'World'
            ],
            'alternative': [
                'Art Punk',
                'Alternative Rock',
                'Britpunk',
                'College Rock',
                'Crossover Thrash',
                'Crust Punk',
                'Emo / Emocore',
                'Experimental Rock',
                'Folk Punk',
                'Goth / Gothic Rock',
                'Grunge',
                'Hardcore Punk',
                'Hard Rock',
                'Indie Rock',
                'Lo-fi',
                "Musique Concr\xe8te",
                'New Wave',
                'Progressive Rock',
                'Punk',
                'Shoegaze',
                'Steampunk'
            ],
            'blues': [
                'Acoustic Blues',
                'African Blues',
                'Blues Rock',
                'Blues Shouter',
                'British Blues',
                'Canadian Blues',
                'Chicago Blues',
                'Classic Blues',
                'Classic Female Blues',
                'Contemporary Blues',
                'Country Blues',
                'Dark Blues',
                'Delta Blues',
                'Detroit Blues',
                'Doom Blues',
                'Electric Blues',
                'Folk Blues',
                'Gospel Blues',
                'Harmonica Blues',
                'Hill Country Blues',
                'Hokum Blues',
                'Jazz Blues',
                'Jump Blues',
                'Kansas City Blues',
                'Louisiana Blues',
                'Memphis Blues',
                'Modern Blues',
                'New Orlean Blues',
                'NY Blues',
                'Piano Blues',
                'Piedmont Blues',
                'Punk Blues',
                'Ragtime Blues',
                'Rhythm Blues',
                'Soul Blues',
                'St.Louis Blues',
                'Soul Blues',
                'Swamp Blues',
                'Texas Blues',
                'Urban Blues',
                'Vandeville',
                'West Coast Blues'
            ],
            'children\'s': [
                'Lullabies',
                'Sing - Along',
                'Stories'
            ],
            'classical': [
                'Avant-Garde',
                'Ballet',
                'Baroque',
                'Cantata',
                'Chamber Music',
                'String Quartet',
                'Chant',
                'Choral',
                'Classical Crossover',
                'Concerto',
                'Concerto Grosso',
                'Contemporary Classical',
                'Early Music',
                'Expressionist',
                'High Classical',
                'Impressionist',
                'Mass Requiem',
                'Medieval',
                'Minimalism',
                'Modern Composition',
                'Modern Classical',
                'Opera',
                'Oratorio',
                'Orchestral',
                'Organum',
                'Renaissance',
                'Romantic (early period)',
                'Romantic (later period)',
                'Sonata',
                'Symphonic',
                'Symphony',
                'Twelve-tone',
                'Wedding Music'
            ],
            'country': [
                'Alternative Country',
                'Americana',
                'Australian Country',
                'Bakersfield Sound',
                'Bluegrass',
                'Blues Country',
                'Cajun Fiddle Tunes',
                'Christian Country',
                'Classic Country',
                'Close Harmony',
                'Contemporary Bluegrass',
                'Contemporary Country',
                'Country Gospel',
                'Country Pop',
                'Country Rap',
                'Country Rock',
                'Country Soul',
                'Cowboy / Western',
                'Cowpunk',
                'Dansband',
                'Honky Tonk',
                'Franco-Country',
                'Gulf and Western',
                'Hellbilly Music',
                'Honky Tonk',
                'Instrumental Country',
                'Lubbock Sound',
                'Nashville Sound',
                'Neotraditional Country',
                'Outlaw Country',
                'Progressive',
                'Psychobilly / Punkabilly',
                'Red Dirt',
                'Sertanejo',
                'Texas County',
                'Traditional Bluegrass',
                'Traditional Country',
                'Truck-Driving Country',
                'Urban Cowboy',
                'Western Swing'
            ],
            'dance': [
                'Club / Club Dance',
                'Breakcore',
                'Breakbeat / Breakstep',
                'Chillstep',
                'Deep House',
                'Dubstep',
                'Dancehall',
                'Electro House',
                'Electroswing',
                'Exercise',
                'Future Garage',
                'Garage',
                'Glitch Hop',
                'Glitch Pop',
                'Grime',
                'Hardcore',
                'Hard Dance',
                'Hi-NRG / Eurodance',
                'Horrorcore',
                'House',
                'Jackin House',
                'Jungle / Drum n bass',
                'Liquid Dub',
                'Regstep',
                'Speedcore',
                'Techno',
                'Trance',
                'Trap'
            ],
            electronic: [
                '2-Step',
                '8bit',
                'Ambient',
                'Asian Underground',
                'Bassline',
                'Chillwave',
                'Chiptune',
                'Crunk',
                'Downtempo',
                'Drum & Bass',
                'Hard Step',
                'Electro',
                'Electro-swing',
                'Electroacoustic',
                'Electronica',
                'Electronic Rock',
                'Eurodance',
                'Hardstyle',
                'Hi-Nrg',
                'IDM/Experimental',
                'Industrial',
                'Trip Hop',
                'Vaporwave',
                'UK Garage',
                'House',
                'Dubstep',
                'Deep House',
                'EDM',
                'Future Bass',
                'Psychedelic trance'
            ],
            'jazz': [
                'Acid Jazz',
                'Afro-Cuban Jazz',
                'Avant-Garde Jazz',
                'Bebop',
                'Big Band',
                'Blue Note',
                'British Dance Band (Jazz)',
                'Cape Jazz',
                'Chamber Jazz',
                'Contemporary Jazz',
                'Continental Jazz',
                'Cool Jazz',
                'Crossover Jazz',
                'Dark Jazz',
                'Dixieland',
                'Early Jazz',
                'Electro Swing (Jazz)',
                'Ethio-jazz',
                'Ethno-Jazz',
                'European Free Jazz',
                'Free Funk (Avant-Garde / Funk Jazz)',
                'Free Jazz',
                'Fusion',
                'Gypsy Jazz',
                'Hard Bop',
                'Indo Jazz',
                'Jazz Blues',
                'Jazz-Funk (see Free Funk)',
                'Jazz-Fusion',
                'Jazz Rap',
                'Jazz Rock',
                'Kansas City Jazz',
                'Latin Jazz',
                'M-Base Jazz',
                'Mainstream Jazz',
                'Modal Jazz',
                'Neo-Bop',
                'Neo-Swing',
                'Nu Jazz',
                'Orchestral Jazz',
                'Post-Bop',
                'Punk Jazz',
                'Ragtime',
                'Ska Jazz',
                'Skiffle (also Folk)',
                'Smooth Jazz',
                'Soul Jazz',
                'Swing Jazz',
                'Straight-Ahead Jazz',
                'Trad Jazz',
                'Third Stream',
                'Jazz-Funk',
                'Free Jazz',
                'West Coast Jazz'
            ],
            'metal': [
                'Heavy Metal',
                'Speed Metal',
                'Thrash Metal',
                'Power Metal',
                'Death Metal',
                'Black Metal',
                'Pagan Metal',
                'Viking Metal',
                'Folk Metal',
                'Symphonic Metal',
                'Gothic Metal',
                'Glam Metal',
                'Hair Metal',
                'Doom Metal',
                'Groove Metal',
                'Industrial Metal',
                'Modern Metal',
                'Neoclassical Metal',
                'New Wave Of British Heavy Metal',
                'Post Metal',
                'Progressive Metal',
                'Avantgarde Metal',
                'Sludge',
                'Djent',
                'Drone',
                'Kawaii Metal',
                'Pirate Metal',
                'Nu Metal',
                "Neue Deutsche H\xe4rte",
                'Math Metal',
                'Crossover',
                'Grindcore',
                'Hardcore',
                'Metalcore',
                'Deathcore',
                'Post Hardcore',
                'Mathcore'
            ],
            'folk': [
                'American Folk Revival',
                'Anti - Folk',
                'British Folk Revival',
                'Contemporary Folk',
                'Filk Music',
                'Freak Folk',
                'Indie Folk',
                'Industrial Folk',
                'Neofolk',
                'Progressive Folk',
                'Psychedelic Folk',
                'Sung Poetry',
                'Techno - Folk',
                'Folk Rock',
                'Old-time Music',
                'Bluegrass',
                'Appalachian',
                'Roots Revival',
                'Celtic',
                'Indie Folk'
            ],
            'pop': [
                'Adult Contemporary',
                'Arab Pop',
                'Baroque',
                'Britpop',
                'Bubblegum Pop',
                'Chamber Pop',
                'Chanson',
                'Christian Pop',
                'Classical Crossover',
                'Europop',
                'Austropop',
                'Balkan Pop',
                'French Pop',
                'Korean Pop',
                'Japanese Pop',
                'Chinese Pop',
                'Latin Pop',
                "La\xefk\xf3",
                'Nederpop',
                'Russian Pop',
                'Dance Pop',
                'Dream Pop',
                'Electro Pop',
                'Iranian Pop',
                'Jangle Pop',
                'Latin Ballad',
                'Levenslied',
                'Louisiana Swamp Pop',
                'Mexican Pop',
                'Motorpop',
                'New Romanticism',
                'Orchestral Pop',
                'Pop Rap',
                'Popera',
                'Pop / Rock',
                'Pop Punk',
                'Power Pop',
                'Psychedelic Pop',
                'Russian Pop',
                'Schlager',
                'Soft Rock',
                'Sophisti - Pop',
                'Space Age Pop',
                'Sunshine Pop',
                'Surf Pop',
                'Synthpop',
                'Teen Pop',
                'Traditional Pop Music',
                'Turkish Pop',
                'Vispop',
                'Wonky Pop'
            ],
            'r&b': [
                '(Carolina) Beach Music',
                'Contemporary R & B',
                'Disco',
                'Doo Wop',
                'Funk',
                'Modern Soul',
                'Motown',
                'Neo - Soul',
                'Northern Soul',
                'Psychedelic Soul',
                'Quiet Storm',
                'Soul',
                'Soul Blues',
                'Southern Soul'
            ],
            'reggae': [
                '2 - Tone',
                'Dub',
                'Roots Reggae',
                'Reggae Fusion',
                "Reggae en Espa\xf1ol",
                'Spanish Reggae',
                'Reggae 110',
                "Reggae Bultr\xf3n",
                'Romantic Flow',
                'Lovers Rock',
                'Raggamuffin',
                'Ragga',
                'Dancehall',
                'Ska'
            ],
            'rock': [
                'Acid Rock',
                'Adult - Oriented Rock',
                'Afro Punk',
                'Adult Alternative',
                'Alternative Rock',
                'American Traditional Rock',
                'Anatolian Rock',
                'Arena Rock',
                'Art Rock',
                'Blues - Rock',
                'British Invasion',
                'Cock Rock',
                'Death Metal / Black Metal',
                'Doom Metal',
                'Glam Rock',
                'Gothic Metal',
                'Grind Core',
                'Hair Metal',
                'Hard Rock',
                'Math Metal',
                'Math Rock',
                'Metal',
                'Metal Core',
                'Noise Rock',
                'Jam Bands',
                'Post Punk',
                'Post Rock',
                'Prog - Rock / Art Rock',
                'Progressive Metal',
                'Psychedelic',
                'Rock & Roll',
                'Rockabilly',
                'Roots Rock',
                'Singer / Songwriter',
                'Southern Rock',
                'Spazzcore',
                'Stoner Metal',
                'Surf',
                'Technical Death Metal',
                'Tex - Mex',
                'Thrash Metal',
                'Time Lord Rock(Trock)',
                'Trip - hop',
                'Yacht Rock',
                'School House Rock'
            ],
            'hip-hop': [
                'Alternative Rap',
                'Avant - Garde',
                'Bounce',
                'Chap Hop',
                'Christian Hip Hop',
                'Conscious Hip Hop',
                'Country - Rap',
                'Grunk',
                'Crunkcore',
                'Cumbia Rap',
                'Dirty South',
                'East Coast',
                'Brick City Club',
                'Hardcore Hip Hop',
                'Mafioso Rap',
                'New Jersey Hip Hop',
                'Freestyle Rap',
                'G - Funk',
                'Gangsta Rap',
                'Golden Age',
                'Grime',
                'Hardcore Rap',
                'Hip - Hop',
                'Hip Pop',
                'Horrorcore',
                'Hyphy',
                'Industrial Hip Hop',
                'Instrumental Hip Hop',
                'Jazz Rap',
                'Latin Rap',
                'Low Bap',
                'Lyrical Hip Hop',
                'Merenrap',
                'Midwest Hip Hop',
                'Chicago Hip Hop',
                'Detroit Hip Hop',
                'Horrorcore',
                'St.Louis Hip Hop',
                'Twin Cities Hip Hop',
                'Motswako',
                'Nerdcore',
                'New Jack Swing',
                'New School Hip Hop',
                'Old School Rap',
                'Rap',
                'Trap',
                'Turntablism',
                'Underground Rap',
                'West Coast Rap',
                'East Coast Rap',
                'Trap',
                'UK Grime',
                'Hyphy',
                'Emo-rap',
                'Cloud rap',
                'G-funk',
                'Boom Bap',
                'Mumble',
                'Drill',
                'UK Drill',
                'Soundcloud Rap',
                'Lo-fi'
            ],
            'punk': [
                'Afro-punk',
                'Anarcho punk',
                'Art punk',
                'Christian punk',
                'Crust punk',
                'Deathrock',
                'Egg punk',
                'Garage punk',
                'Glam punk',
                'Hardcore punk',
                'Horror punk',
                'Incelcore/e-punk',
                'Oi!',
                'Peace punk',
                'Punk pathetique',
                'Queercore',
                'Riot Grrrl',
                'Skate punk',
                'Street punk',
                'Taqwacore',
                'Trallpunk'
            ],
            'disco': [
                'Nu-disco',
                'Disco-funk',
                'Hi-NRG',
                'Italo Disco',
                'Eurodisco',
                'Boogie',
                'Space Disco',
                'Post-disco',
                'Electro Disco',
                'Disco House',
                'Disco Pop',
                'Soulful House'
            ],
            'funk': [
                'Funk Rock',
                'P-Funk (Parliament-Funkadelic)',
                'Psychedelic Funk',
                'Funk Metal',
                'Electro-Funk',
                'Go-go',
                'Boogie-Funk',
                'Jazz-Funk',
                'Soul-Funk',
                'Funky Disco',
                'Nu-Funk',
                'Afrobeat',
                'Latin Funk',
                'G-Funk',
                'Acid Jazz',
                'Funktronica',
                'Folk-Funk',
                'Space Funk',
                'Ambient Funk',
                'Hard Funk',
                'Fusion Funk'
            ],
            'techno': [
                'Acid Techno',
                'Ambient Techno',
                'Detroit Techno',
                'Dub Techno',
                'Minimal Techno',
                'Industrial Techno',
                'Hard Techno',
                'Trance',
                'Progressive Techno',
                'Tech House',
                'Electronica',
                'Breakbeat Techno',
                'Electro Techno',
                'Melodic Techno',
                'Experimental Techno',
                'Dark Techno',
                'Ebm',
                'Hypnotic Techno',
                'Psychedelic Techno',
                'Rave Techno',
                'Techno-Pop'
            ],
            'indie': [
                'Indie Rock',
                'Indie Pop',
                'Indie Folk',
                'Indie Electronic',
                'Indie Punk',
                'Indie Hip-Hop',
                'Dream Pop',
                'Shoegaze',
                'Lo-fi',
                'Chillwave',
                'Freak Folk',
                'Noise Pop',
                'Math Rock',
                'Post-Punk',
                'Garage Rock',
                'Experimental Indie',
                'Surf Rock',
                'Alternative Country',
                'Indie Soul',
                'Art Rock',
                'Indie R&B',
                'Indietronica',
                'Emo',
                'Post-Rock',
                'Indie Pop-Rock',
                'Indie Synthpop',
                'Noise Rock',
                'Psych Folk',
                'Indie Blues'
            ],
            'gospel': [
                'Traditional Gospel',
                'Contemporary Gospel',
                'Southern Gospel',
                'Black Gospel',
                'Urban Contemporary Gospel',
                'Gospel Blues',
                'Bluegrass Gospel',
                'Country Gospel',
                'Praise and Worship',
                'Christian Hip-Hop',
                'Gospel Jazz',
                'Reggae Gospel',
                'African Gospel',
                'Latin Gospel',
                'R&B Gospel',
                'Gospel Choir',
                'Acappella Gospel',
                'Instrumental Gospel',
                'Gospel Rap'
            ],
            'world': [
                'African',
                'Arabic',
                'Asian',
                'Caribbean',
                'Celtic',
                'European',
                'Latin American',
                'Middle Eastern',
                'Native American',
                'Polynesian',
                'Reggae',
                'Ska',
                'Salsa',
                'Flamenco',
                'Bossa Nova',
                'Tango',
                'Fado',
                'Klezmer',
                'Balkan',
                'Afrobeat',
                'Mongolian Throat Singing',
                'Indian Classical',
                'Gamelan',
                'Sufi Music',
                'Zydeco',
                'Kora Music',
                'Andean Music',
                'Irish Traditional',
                'Gypsy Jazz',
                'Bollywood',
                'Bhangra',
                'Jawaiian',
                'Hawaiian Slack Key Guitar',
                'Calypso',
                'Cuban Son',
                'Taiko Drumming',
                'African Highlife',
                'Merengue',
                'Tuvan Throat Singing'
            ]
        },
        // Data sourced from https://unicode.org/emoji/charts/full-emoji-list.html
        emojis: {
            "smileys_and_emotion": [
                "0x1f600",
                "0x1f603",
                "0x1f604",
                "0x1f601",
                "0x1f606",
                "0x1f605",
                "0x1f923",
                "0x1f602",
                "0x1f642",
                "0x1f643",
                "0x1fae0",
                "0x1f609",
                "0x1f60a",
                "0x1f607",
                "0x1f970",
                "0x1f60d",
                "0x1f929",
                "0x1f618",
                "0x1f617",
                "0x263a",
                "0x1f61a",
                "0x1f619",
                "0x1f972",
                "0x1f60b",
                "0x1f61b",
                "0x1f61c",
                "0x1f92a",
                "0x1f61d",
                "0x1f911",
                "0x1f917",
                "0x1f92d",
                "0x1fae2",
                "0x1fae3",
                "0x1f92b",
                "0x1f914",
                "0x1fae1",
                "0x1f910",
                "0x1f928",
                "0x1f610",
                "0x1f611",
                "0x1f636",
                "0x1fae5",
                "0x1f636",
                "0x200d",
                "0x1f32b",
                "0xfe0f",
                "0x1f60f",
                "0x1f612",
                "0x1f644",
                "0x1f62c",
                "0x1f62e",
                "0x200d",
                "0x1f4a8",
                "0x1f925",
                "0x1fae8",
                "0x1f642",
                "0x200d",
                "0x2194",
                "0xfe0f",
                "0x1f642",
                "0x200d",
                "0x2195",
                "0xfe0f",
                "0x1f60c",
                "0x1f614",
                "0x1f62a",
                "0x1f924",
                "0x1f634",
                "0x1f637",
                "0x1f912",
                "0x1f915",
                "0x1f922",
                "0x1f92e",
                "0x1f927",
                "0x1f975",
                "0x1f976",
                "0x1f974",
                "0x1f635",
                "0x1f635",
                "0x200d",
                "0x1f4ab",
                "0x1f92f",
                "0x1f920",
                "0x1f973",
                "0x1f978",
                "0x1f60e",
                "0x1f913",
                "0x1f9d0",
                "0x1f615",
                "0x1fae4",
                "0x1f61f",
                "0x1f641",
                "0x2639",
                "0x1f62e",
                "0x1f62f",
                "0x1f632",
                "0x1f633",
                "0x1f97a",
                "0x1f979",
                "0x1f626",
                "0x1f627",
                "0x1f628",
                "0x1f630",
                "0x1f625",
                "0x1f622",
                "0x1f62d",
                "0x1f631",
                "0x1f616",
                "0x1f623",
                "0x1f61e",
                "0x1f613",
                "0x1f629",
                "0x1f62b",
                "0x1f971",
                "0x1f624",
                "0x1f621",
                "0x1f620",
                "0x1f92c",
                "0x1f608",
                "0x1f47f",
                "0x1f480",
                "0x2620",
                "0x1f4a9",
                "0x1f921",
                "0x1f479",
                "0x1f47a",
                "0x1f47b",
                "0x1f47d",
                "0x1f47e",
                "0x1f916",
                "0x1f63a",
                "0x1f638",
                "0x1f639",
                "0x1f63b",
                "0x1f63c",
                "0x1f63d",
                "0x1f640",
                "0x1f63f",
                "0x1f63e",
                "0x1f648",
                "0x1f649",
                "0x1f64a",
                "0x1f48c",
                "0x1f498",
                "0x1f49d",
                "0x1f496",
                "0x1f497",
                "0x1f493",
                "0x1f49e",
                "0x1f495",
                "0x1f49f",
                "0x2763",
                "0x1f494",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f525",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1fa79",
                "0x2764",
                "0x1fa77",
                "0x1f9e1",
                "0x1f49b",
                "0x1f49a",
                "0x1f499",
                "0x1fa75",
                "0x1f49c",
                "0x1f90e",
                "0x1f5a4",
                "0x1fa76",
                "0x1f90d",
                "0x1f48b",
                "0x1f4af",
                "0x1f4a2",
                "0x1f4a5",
                "0x1f4ab",
                "0x1f4a6",
                "0x1f4a8",
                "0x1f573",
                "0x1f4ac",
                "0x1f441",
                "0xfe0f",
                "0x200d",
                "0x1f5e8",
                "0xfe0f",
                "0x1f5e8",
                "0x1f5ef",
                "0x1f4ad",
                "0x1f4a4"
            ],
            "people_and_body": [
                "0x1f44b",
                "0x1f91a",
                "0x1f590",
                "0x270b",
                "0x1f596",
                "0x1faf1",
                "0x1faf2",
                "0x1faf3",
                "0x1faf4",
                "0x1faf7",
                "0x1faf8",
                "0x1f44c",
                "0x1f90c",
                "0x1f90f",
                "0x270c",
                "0x1f91e",
                "0x1faf0",
                "0x1f91f",
                "0x1f918",
                "0x1f919",
                "0x1f448",
                "0x1f449",
                "0x1f446",
                "0x1f595",
                "0x1f447",
                "0x261d",
                "0x1faf5",
                "0x1f44d",
                "0x1f44e",
                "0x270a",
                "0x1f44a",
                "0x1f91b",
                "0x1f91c",
                "0x1f44f",
                "0x1f64c",
                "0x1faf6",
                "0x1f450",
                "0x1f932",
                "0x1f91d",
                "0x1f64f",
                "0x270d",
                "0x1f485",
                "0x1f933",
                "0x1f4aa",
                "0x1f9be",
                "0x1f9bf",
                "0x1f9b5",
                "0x1f9b6",
                "0x1f442",
                "0x1f9bb",
                "0x1f443",
                "0x1f9e0",
                "0x1fac0",
                "0x1fac1",
                "0x1f9b7",
                "0x1f9b4",
                "0x1f440",
                "0x1f441",
                "0x1f445",
                "0x1f444",
                "0x1fae6",
                "0x1f476",
                "0x1f9d2",
                "0x1f466",
                "0x1f467",
                "0x1f9d1",
                "0x1f471",
                "0x1f468",
                "0x1f9d4",
                "0x1f9d4",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d4",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9b0",
                "0x1f468",
                "0x200d",
                "0x1f9b1",
                "0x1f468",
                "0x200d",
                "0x1f9b3",
                "0x1f468",
                "0x200d",
                "0x1f9b2",
                "0x1f469",
                "0x1f469",
                "0x200d",
                "0x1f9b0",
                "0x1f9d1",
                "0x200d",
                "0x1f9b0",
                "0x1f469",
                "0x200d",
                "0x1f9b1",
                "0x1f9d1",
                "0x200d",
                "0x1f9b1",
                "0x1f469",
                "0x200d",
                "0x1f9b3",
                "0x1f9d1",
                "0x200d",
                "0x1f9b3",
                "0x1f469",
                "0x200d",
                "0x1f9b2",
                "0x1f9d1",
                "0x200d",
                "0x1f9b2",
                "0x1f471",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f471",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d3",
                "0x1f474",
                "0x1f475",
                "0x1f64d",
                "0x1f64d",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f64d",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f64e",
                "0x1f64e",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f64e",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f645",
                "0x1f645",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f645",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f646",
                "0x1f646",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f646",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f481",
                "0x1f481",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f481",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f64b",
                "0x1f64b",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f64b",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9cf",
                "0x1f9cf",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9cf",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f647",
                "0x1f647",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f647",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f926",
                "0x1f926",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f926",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f937",
                "0x1f937",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f937",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x2695",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x2695",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x2695",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f393",
                "0x1f468",
                "0x200d",
                "0x1f393",
                "0x1f469",
                "0x200d",
                "0x1f393",
                "0x1f9d1",
                "0x200d",
                "0x1f3eb",
                "0x1f468",
                "0x200d",
                "0x1f3eb",
                "0x1f469",
                "0x200d",
                "0x1f3eb",
                "0x1f9d1",
                "0x200d",
                "0x2696",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x2696",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x2696",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f33e",
                "0x1f468",
                "0x200d",
                "0x1f33e",
                "0x1f469",
                "0x200d",
                "0x1f33e",
                "0x1f9d1",
                "0x200d",
                "0x1f373",
                "0x1f468",
                "0x200d",
                "0x1f373",
                "0x1f469",
                "0x200d",
                "0x1f373",
                "0x1f9d1",
                "0x200d",
                "0x1f527",
                "0x1f468",
                "0x200d",
                "0x1f527",
                "0x1f469",
                "0x200d",
                "0x1f527",
                "0x1f9d1",
                "0x200d",
                "0x1f3ed",
                "0x1f468",
                "0x200d",
                "0x1f3ed",
                "0x1f469",
                "0x200d",
                "0x1f3ed",
                "0x1f9d1",
                "0x200d",
                "0x1f4bc",
                "0x1f468",
                "0x200d",
                "0x1f4bc",
                "0x1f469",
                "0x200d",
                "0x1f4bc",
                "0x1f9d1",
                "0x200d",
                "0x1f52c",
                "0x1f468",
                "0x200d",
                "0x1f52c",
                "0x1f469",
                "0x200d",
                "0x1f52c",
                "0x1f9d1",
                "0x200d",
                "0x1f4bb",
                "0x1f468",
                "0x200d",
                "0x1f4bb",
                "0x1f469",
                "0x200d",
                "0x1f4bb",
                "0x1f9d1",
                "0x200d",
                "0x1f3a4",
                "0x1f468",
                "0x200d",
                "0x1f3a4",
                "0x1f469",
                "0x200d",
                "0x1f3a4",
                "0x1f9d1",
                "0x200d",
                "0x1f3a8",
                "0x1f468",
                "0x200d",
                "0x1f3a8",
                "0x1f469",
                "0x200d",
                "0x1f3a8",
                "0x1f9d1",
                "0x200d",
                "0x2708",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x2708",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x2708",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f680",
                "0x1f468",
                "0x200d",
                "0x1f680",
                "0x1f469",
                "0x200d",
                "0x1f680",
                "0x1f9d1",
                "0x200d",
                "0x1f692",
                "0x1f468",
                "0x200d",
                "0x1f692",
                "0x1f469",
                "0x200d",
                "0x1f692",
                "0x1f46e",
                "0x1f46e",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f46e",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f575",
                "0x1f575",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f575",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f482",
                "0x1f482",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f482",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f977",
                "0x1f477",
                "0x1f477",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f477",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1fac5",
                "0x1f934",
                "0x1f478",
                "0x1f473",
                "0x1f473",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f473",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f472",
                "0x1f9d5",
                "0x1f935",
                "0x1f935",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f935",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f470",
                "0x1f470",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f470",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f930",
                "0x1fac3",
                "0x1fac4",
                "0x1f931",
                "0x1f469",
                "0x200d",
                "0x1f37c",
                "0x1f468",
                "0x200d",
                "0x1f37c",
                "0x1f9d1",
                "0x200d",
                "0x1f37c",
                "0x1f47c",
                "0x1f385",
                "0x1f936",
                "0x1f9d1",
                "0x200d",
                "0x1f384",
                "0x1f9b8",
                "0x1f9b8",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9b8",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9b9",
                "0x1f9b9",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9b9",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d9",
                "0x1f9d9",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d9",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9da",
                "0x1f9da",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9da",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9db",
                "0x1f9db",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9db",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9dc",
                "0x1f9dc",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9dc",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9dd",
                "0x1f9dd",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9dd",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9de",
                "0x1f9de",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9de",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9df",
                "0x1f9df",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9df",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9cc",
                "0x1f486",
                "0x1f486",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f486",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f487",
                "0x1f487",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f487",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b6",
                "0x1f6b6",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9cd",
                "0x1f9cd",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9cd",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9ce",
                "0x1f9ce",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f9af",
                "0x1f9d1",
                "0x200d",
                "0x1f9af",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9af",
                "0x1f468",
                "0x200d",
                "0x1f9af",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x1f9af",
                "0x1f469",
                "0x200d",
                "0x1f9af",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f9bc",
                "0x1f9d1",
                "0x200d",
                "0x1f9bc",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9bc",
                "0x1f468",
                "0x200d",
                "0x1f9bc",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x1f9bc",
                "0x1f469",
                "0x200d",
                "0x1f9bc",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f9bd",
                "0x1f9d1",
                "0x200d",
                "0x1f9bd",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9bd",
                "0x1f468",
                "0x200d",
                "0x1f9bd",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x1f9bd",
                "0x1f469",
                "0x200d",
                "0x1f9bd",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f3c3",
                "0x1f3c3",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f483",
                "0x1f57a",
                "0x1f574",
                "0x1f46f",
                "0x1f46f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f46f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d6",
                "0x1f9d6",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d6",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d7",
                "0x1f9d7",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d7",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93a",
                "0x1f3c7",
                "0x26f7",
                "0x1f3c2",
                "0x1f3cc",
                "0x1f3cc",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3cc",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3c4",
                "0x1f3c4",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3c4",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6a3",
                "0x1f6a3",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6a3",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3ca",
                "0x1f3ca",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3ca",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x26f9",
                "0x26f9",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x26f9",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3cb",
                "0x1f3cb",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3cb",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b4",
                "0x1f6b4",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6b4",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b5",
                "0x1f6b5",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6b5",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f938",
                "0x1f938",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f938",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93c",
                "0x1f93c",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f93c",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93d",
                "0x1f93d",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f93d",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93e",
                "0x1f93e",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f93e",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f939",
                "0x1f939",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f939",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d8",
                "0x1f9d8",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d8",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6c0",
                "0x1f6cc",
                "0x1f9d1",
                "0x200d",
                "0x1f91d",
                "0x200d",
                "0x1f9d1",
                "0x1f46d",
                "0x1f46b",
                "0x1f46c",
                "0x1f48f",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f48b",
                "0x200d",
                "0x1f468",
                "0x1f468",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f48b",
                "0x200d",
                "0x1f468",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f48b",
                "0x200d",
                "0x1f469",
                "0x1f491",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f468",
                "0x1f468",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f468",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f469",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f5e3",
                "0x1f464",
                "0x1f465",
                "0x1fac2",
                "0x1f46a",
                "0x1f9d1",
                "0x200d",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x1f9d1",
                "0x200d",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x200d",
                "0x1f9d2",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x200d",
                "0x1f9d2",
                "0x1f463"
            ],
            "animals_and_nature": [
                "0x1f435",
                "0x1f412",
                "0x1f98d",
                "0x1f9a7",
                "0x1f436",
                "0x1f415",
                "0x1f9ae",
                "0x1f415",
                "0x200d",
                "0x1f9ba",
                "0x1f429",
                "0x1f43a",
                "0x1f98a",
                "0x1f99d",
                "0x1f431",
                "0x1f408",
                "0x1f408",
                "0x200d",
                "0x2b1b",
                "0x1f981",
                "0x1f42f",
                "0x1f405",
                "0x1f406",
                "0x1f434",
                "0x1face",
                "0x1facf",
                "0x1f40e",
                "0x1f984",
                "0x1f993",
                "0x1f98c",
                "0x1f9ac",
                "0x1f42e",
                "0x1f402",
                "0x1f403",
                "0x1f404",
                "0x1f437",
                "0x1f416",
                "0x1f417",
                "0x1f43d",
                "0x1f40f",
                "0x1f411",
                "0x1f410",
                "0x1f42a",
                "0x1f42b",
                "0x1f999",
                "0x1f992",
                "0x1f418",
                "0x1f9a3",
                "0x1f98f",
                "0x1f99b",
                "0x1f42d",
                "0x1f401",
                "0x1f400",
                "0x1f439",
                "0x1f430",
                "0x1f407",
                "0x1f43f",
                "0x1f9ab",
                "0x1f994",
                "0x1f987",
                "0x1f43b",
                "0x1f43b",
                "0x200d",
                "0x2744",
                "0xfe0f",
                "0x1f428",
                "0x1f43c",
                "0x1f9a5",
                "0x1f9a6",
                "0x1f9a8",
                "0x1f998",
                "0x1f9a1",
                "0x1f43e",
                "0x1f983",
                "0x1f414",
                "0x1f413",
                "0x1f423",
                "0x1f424",
                "0x1f425",
                "0x1f426",
                "0x1f427",
                "0x1f54a",
                "0x1f985",
                "0x1f986",
                "0x1f9a2",
                "0x1f989",
                "0x1f9a4",
                "0x1fab6",
                "0x1f9a9",
                "0x1f99a",
                "0x1f99c",
                "0x1fabd",
                "0x1f426",
                "0x200d",
                "0x2b1b",
                "0x1fabf",
                "0x1f426",
                "0x200d",
                "0x1f525",
                "0x1f438",
                "0x1f40a",
                "0x1f422",
                "0x1f98e",
                "0x1f40d",
                "0x1f432",
                "0x1f409",
                "0x1f995",
                "0x1f996",
                "0x1f433",
                "0x1f40b",
                "0x1f42c",
                "0x1f9ad",
                "0x1f41f",
                "0x1f420",
                "0x1f421",
                "0x1f988",
                "0x1f419",
                "0x1f41a",
                "0x1fab8",
                "0x1fabc",
                "0x1f40c",
                "0x1f98b",
                "0x1f41b",
                "0x1f41c",
                "0x1f41d",
                "0x1fab2",
                "0x1f41e",
                "0x1f997",
                "0x1fab3",
                "0x1f577",
                "0x1f578",
                "0x1f982",
                "0x1f99f",
                "0x1fab0",
                "0x1fab1",
                "0x1f9a0",
                "0x1f490",
                "0x1f338",
                "0x1f4ae",
                "0x1fab7",
                "0x1f3f5",
                "0x1f339",
                "0x1f940",
                "0x1f33a",
                "0x1f33b",
                "0x1f33c",
                "0x1f337",
                "0x1fabb",
                "0x1f331",
                "0x1fab4",
                "0x1f332",
                "0x1f333",
                "0x1f334",
                "0x1f335",
                "0x1f33e",
                "0x1f33f",
                "0x2618",
                "0x1f340",
                "0x1f341",
                "0x1f342",
                "0x1f343",
                "0x1fab9",
                "0x1faba",
                "0x1f344"
            ],
            "food_and_drink": [
                "0x1f347",
                "0x1f348",
                "0x1f349",
                "0x1f34a",
                "0x1f34b",
                "0x1f34b",
                "0x200d",
                "0x1f7e9",
                "0x1f34c",
                "0x1f34d",
                "0x1f96d",
                "0x1f34e",
                "0x1f34f",
                "0x1f350",
                "0x1f351",
                "0x1f352",
                "0x1f353",
                "0x1fad0",
                "0x1f95d",
                "0x1f345",
                "0x1fad2",
                "0x1f965",
                "0x1f951",
                "0x1f346",
                "0x1f954",
                "0x1f955",
                "0x1f33d",
                "0x1f336",
                "0x1fad1",
                "0x1f952",
                "0x1f96c",
                "0x1f966",
                "0x1f9c4",
                "0x1f9c5",
                "0x1f95c",
                "0x1fad8",
                "0x1f330",
                "0x1fada",
                "0x1fadb",
                "0x1f344",
                "0x200d",
                "0x1f7eb",
                "0x1f35e",
                "0x1f950",
                "0x1f956",
                "0x1fad3",
                "0x1f968",
                "0x1f96f",
                "0x1f95e",
                "0x1f9c7",
                "0x1f9c0",
                "0x1f356",
                "0x1f357",
                "0x1f969",
                "0x1f953",
                "0x1f354",
                "0x1f35f",
                "0x1f355",
                "0x1f32d",
                "0x1f96a",
                "0x1f32e",
                "0x1f32f",
                "0x1fad4",
                "0x1f959",
                "0x1f9c6",
                "0x1f95a",
                "0x1f373",
                "0x1f958",
                "0x1f372",
                "0x1fad5",
                "0x1f963",
                "0x1f957",
                "0x1f37f",
                "0x1f9c8",
                "0x1f9c2",
                "0x1f96b",
                "0x1f371",
                "0x1f358",
                "0x1f359",
                "0x1f35a",
                "0x1f35b",
                "0x1f35c",
                "0x1f35d",
                "0x1f360",
                "0x1f362",
                "0x1f363",
                "0x1f364",
                "0x1f365",
                "0x1f96e",
                "0x1f361",
                "0x1f95f",
                "0x1f960",
                "0x1f961",
                "0x1f980",
                "0x1f99e",
                "0x1f990",
                "0x1f991",
                "0x1f9aa",
                "0x1f366",
                "0x1f367",
                "0x1f368",
                "0x1f369",
                "0x1f36a",
                "0x1f382",
                "0x1f370",
                "0x1f9c1",
                "0x1f967",
                "0x1f36b",
                "0x1f36c",
                "0x1f36d",
                "0x1f36e",
                "0x1f36f",
                "0x1f37c",
                "0x1f95b",
                "0x2615",
                "0x1fad6",
                "0x1f375",
                "0x1f376",
                "0x1f37e",
                "0x1f377",
                "0x1f378",
                "0x1f379",
                "0x1f37a",
                "0x1f37b",
                "0x1f942",
                "0x1f943",
                "0x1fad7",
                "0x1f964",
                "0x1f9cb",
                "0x1f9c3",
                "0x1f9c9",
                "0x1f9ca",
                "0x1f962",
                "0x1f37d",
                "0x1f374",
                "0x1f944",
                "0x1f52a",
                "0x1fad9",
                "0x1f3fa"
            ],
            "travel_and_places": [
                "0x1f30d",
                "0x1f30e",
                "0x1f30f",
                "0x1f310",
                "0x1f5fa",
                "0x1f5fe",
                "0x1f9ed",
                "0x1f3d4",
                "0x26f0",
                "0x1f30b",
                "0x1f5fb",
                "0x1f3d5",
                "0x1f3d6",
                "0x1f3dc",
                "0x1f3dd",
                "0x1f3de",
                "0x1f3df",
                "0x1f3db",
                "0x1f3d7",
                "0x1f9f1",
                "0x1faa8",
                "0x1fab5",
                "0x1f6d6",
                "0x1f3d8",
                "0x1f3da",
                "0x1f3e0",
                "0x1f3e1",
                "0x1f3e2",
                "0x1f3e3",
                "0x1f3e4",
                "0x1f3e5",
                "0x1f3e6",
                "0x1f3e8",
                "0x1f3e9",
                "0x1f3ea",
                "0x1f3eb",
                "0x1f3ec",
                "0x1f3ed",
                "0x1f3ef",
                "0x1f3f0",
                "0x1f492",
                "0x1f5fc",
                "0x1f5fd",
                "0x26ea",
                "0x1f54c",
                "0x1f6d5",
                "0x1f54d",
                "0x26e9",
                "0x1f54b",
                "0x26f2",
                "0x26fa",
                "0x1f301",
                "0x1f303",
                "0x1f3d9",
                "0x1f304",
                "0x1f305",
                "0x1f306",
                "0x1f307",
                "0x1f309",
                "0x2668",
                "0x1f3a0",
                "0x1f6dd",
                "0x1f3a1",
                "0x1f3a2",
                "0x1f488",
                "0x1f3aa",
                "0x1f682",
                "0x1f683",
                "0x1f684",
                "0x1f685",
                "0x1f686",
                "0x1f687",
                "0x1f688",
                "0x1f689",
                "0x1f68a",
                "0x1f69d",
                "0x1f69e",
                "0x1f68b",
                "0x1f68c",
                "0x1f68d",
                "0x1f68e",
                "0x1f690",
                "0x1f691",
                "0x1f692",
                "0x1f693",
                "0x1f694",
                "0x1f695",
                "0x1f696",
                "0x1f697",
                "0x1f698",
                "0x1f699",
                "0x1f6fb",
                "0x1f69a",
                "0x1f69b",
                "0x1f69c",
                "0x1f3ce",
                "0x1f3cd",
                "0x1f6f5",
                "0x1f9bd",
                "0x1f9bc",
                "0x1f6fa",
                "0x1f6b2",
                "0x1f6f4",
                "0x1f6f9",
                "0x1f6fc",
                "0x1f68f",
                "0x1f6e3",
                "0x1f6e4",
                "0x1f6e2",
                "0x26fd",
                "0x1f6de",
                "0x1f6a8",
                "0x1f6a5",
                "0x1f6a6",
                "0x1f6d1",
                "0x1f6a7",
                "0x2693",
                "0x1f6df",
                "0x26f5",
                "0x1f6f6",
                "0x1f6a4",
                "0x1f6f3",
                "0x26f4",
                "0x1f6e5",
                "0x1f6a2",
                "0x2708",
                "0x1f6e9",
                "0x1f6eb",
                "0x1f6ec",
                "0x1fa82",
                "0x1f4ba",
                "0x1f681",
                "0x1f69f",
                "0x1f6a0",
                "0x1f6a1",
                "0x1f6f0",
                "0x1f680",
                "0x1f6f8",
                "0x1f6ce",
                "0x1f9f3",
                "0x231b",
                "0x23f3",
                "0x231a",
                "0x23f0",
                "0x23f1",
                "0x23f2",
                "0x1f570",
                "0x1f55b",
                "0x1f567",
                "0x1f550",
                "0x1f55c",
                "0x1f551",
                "0x1f55d",
                "0x1f552",
                "0x1f55e",
                "0x1f553",
                "0x1f55f",
                "0x1f554",
                "0x1f560",
                "0x1f555",
                "0x1f561",
                "0x1f556",
                "0x1f562",
                "0x1f557",
                "0x1f563",
                "0x1f558",
                "0x1f564",
                "0x1f559",
                "0x1f565",
                "0x1f55a",
                "0x1f566",
                "0x1f311",
                "0x1f312",
                "0x1f313",
                "0x1f314",
                "0x1f315",
                "0x1f316",
                "0x1f317",
                "0x1f318",
                "0x1f319",
                "0x1f31a",
                "0x1f31b",
                "0x1f31c",
                "0x1f321",
                "0x2600",
                "0x1f31d",
                "0x1f31e",
                "0x1fa90",
                "0x2b50",
                "0x1f31f",
                "0x1f320",
                "0x1f30c",
                "0x2601",
                "0x26c5",
                "0x26c8",
                "0x1f324",
                "0x1f325",
                "0x1f326",
                "0x1f327",
                "0x1f328",
                "0x1f329",
                "0x1f32a",
                "0x1f32b",
                "0x1f32c",
                "0x1f300",
                "0x1f308",
                "0x1f302",
                "0x2602",
                "0x2614",
                "0x26f1",
                "0x26a1",
                "0x2744",
                "0x2603",
                "0x26c4",
                "0x2604",
                "0x1f525",
                "0x1f4a7",
                "0x1f30a"
            ],
            "activities": [
                "0x1f383",
                "0x1f384",
                "0x1f386",
                "0x1f387",
                "0x1f9e8",
                "0x2728",
                "0x1f388",
                "0x1f389",
                "0x1f38a",
                "0x1f38b",
                "0x1f38d",
                "0x1f38e",
                "0x1f38f",
                "0x1f390",
                "0x1f391",
                "0x1f9e7",
                "0x1f380",
                "0x1f381",
                "0x1f397",
                "0x1f39f",
                "0x1f3ab",
                "0x1f396",
                "0x1f3c6",
                "0x1f3c5",
                "0x1f947",
                "0x1f948",
                "0x1f949",
                "0x26bd",
                "0x26be",
                "0x1f94e",
                "0x1f3c0",
                "0x1f3d0",
                "0x1f3c8",
                "0x1f3c9",
                "0x1f3be",
                "0x1f94f",
                "0x1f3b3",
                "0x1f3cf",
                "0x1f3d1",
                "0x1f3d2",
                "0x1f94d",
                "0x1f3d3",
                "0x1f3f8",
                "0x1f94a",
                "0x1f94b",
                "0x1f945",
                "0x26f3",
                "0x26f8",
                "0x1f3a3",
                "0x1f93f",
                "0x1f3bd",
                "0x1f3bf",
                "0x1f6f7",
                "0x1f94c",
                "0x1f3af",
                "0x1fa80",
                "0x1fa81",
                "0x1f52b",
                "0x1f3b1",
                "0x1f52e",
                "0x1fa84",
                "0x1f3ae",
                "0x1f579",
                "0x1f3b0",
                "0x1f3b2",
                "0x1f9e9",
                "0x1f9f8",
                "0x1fa85",
                "0x1faa9",
                "0x1fa86",
                "0x2660",
                "0x2665",
                "0x2666",
                "0x2663",
                "0x265f",
                "0x1f0cf",
                "0x1f004",
                "0x1f3b4",
                "0x1f3ad",
                "0x1f5bc",
                "0x1f3a8",
                "0x1f9f5",
                "0x1faa1",
                "0x1f9f6",
                "0x1faa2"
            ],
            "objects": [
                "0x1f453",
                "0x1f576",
                "0x1f97d",
                "0x1f97c",
                "0x1f9ba",
                "0x1f454",
                "0x1f455",
                "0x1f456",
                "0x1f9e3",
                "0x1f9e4",
                "0x1f9e5",
                "0x1f9e6",
                "0x1f457",
                "0x1f458",
                "0x1f97b",
                "0x1fa71",
                "0x1fa72",
                "0x1fa73",
                "0x1f459",
                "0x1f45a",
                "0x1faad",
                "0x1f45b",
                "0x1f45c",
                "0x1f45d",
                "0x1f6cd",
                "0x1f392",
                "0x1fa74",
                "0x1f45e",
                "0x1f45f",
                "0x1f97e",
                "0x1f97f",
                "0x1f460",
                "0x1f461",
                "0x1fa70",
                "0x1f462",
                "0x1faae",
                "0x1f451",
                "0x1f452",
                "0x1f3a9",
                "0x1f393",
                "0x1f9e2",
                "0x1fa96",
                "0x26d1",
                "0x1f4ff",
                "0x1f484",
                "0x1f48d",
                "0x1f48e",
                "0x1f507",
                "0x1f508",
                "0x1f509",
                "0x1f50a",
                "0x1f4e2",
                "0x1f4e3",
                "0x1f4ef",
                "0x1f514",
                "0x1f515",
                "0x1f3bc",
                "0x1f3b5",
                "0x1f3b6",
                "0x1f399",
                "0x1f39a",
                "0x1f39b",
                "0x1f3a4",
                "0x1f3a7",
                "0x1f4fb",
                "0x1f3b7",
                "0x1fa97",
                "0x1f3b8",
                "0x1f3b9",
                "0x1f3ba",
                "0x1f3bb",
                "0x1fa95",
                "0x1f941",
                "0x1fa98",
                "0x1fa87",
                "0x1fa88",
                "0x1f4f1",
                "0x1f4f2",
                "0x260e",
                "0x1f4de",
                "0x1f4df",
                "0x1f4e0",
                "0x1f50b",
                "0x1faab",
                "0x1f50c",
                "0x1f4bb",
                "0x1f5a5",
                "0x1f5a8",
                "0x2328",
                "0x1f5b1",
                "0x1f5b2",
                "0x1f4bd",
                "0x1f4be",
                "0x1f4bf",
                "0x1f4c0",
                "0x1f9ee",
                "0x1f3a5",
                "0x1f39e",
                "0x1f4fd",
                "0x1f3ac",
                "0x1f4fa",
                "0x1f4f7",
                "0x1f4f8",
                "0x1f4f9",
                "0x1f4fc",
                "0x1f50d",
                "0x1f50e",
                "0x1f56f",
                "0x1f4a1",
                "0x1f526",
                "0x1f3ee",
                "0x1fa94",
                "0x1f4d4",
                "0x1f4d5",
                "0x1f4d6",
                "0x1f4d7",
                "0x1f4d8",
                "0x1f4d9",
                "0x1f4da",
                "0x1f4d3",
                "0x1f4d2",
                "0x1f4c3",
                "0x1f4dc",
                "0x1f4c4",
                "0x1f4f0",
                "0x1f5de",
                "0x1f4d1",
                "0x1f516",
                "0x1f3f7",
                "0x1f4b0",
                "0x1fa99",
                "0x1f4b4",
                "0x1f4b5",
                "0x1f4b6",
                "0x1f4b7",
                "0x1f4b8",
                "0x1f4b3",
                "0x1f9fe",
                "0x1f4b9",
                "0x2709",
                "0x1f4e7",
                "0x1f4e8",
                "0x1f4e9",
                "0x1f4e4",
                "0x1f4e5",
                "0x1f4e6",
                "0x1f4eb",
                "0x1f4ea",
                "0x1f4ec",
                "0x1f4ed",
                "0x1f4ee",
                "0x1f5f3",
                "0x270f",
                "0x2712",
                "0x1f58b",
                "0x1f58a",
                "0x1f58c",
                "0x1f58d",
                "0x1f4dd",
                "0x1f4bc",
                "0x1f4c1",
                "0x1f4c2",
                "0x1f5c2",
                "0x1f4c5",
                "0x1f4c6",
                "0x1f5d2",
                "0x1f5d3",
                "0x1f4c7",
                "0x1f4c8",
                "0x1f4c9",
                "0x1f4ca",
                "0x1f4cb",
                "0x1f4cc",
                "0x1f4cd",
                "0x1f4ce",
                "0x1f587",
                "0x1f4cf",
                "0x1f4d0",
                "0x2702",
                "0x1f5c3",
                "0x1f5c4",
                "0x1f5d1",
                "0x1f512",
                "0x1f513",
                "0x1f50f",
                "0x1f510",
                "0x1f511",
                "0x1f5dd",
                "0x1f528",
                "0x1fa93",
                "0x26cf",
                "0x2692",
                "0x1f6e0",
                "0x1f5e1",
                "0x2694",
                "0x1f4a3",
                "0x1fa83",
                "0x1f3f9",
                "0x1f6e1",
                "0x1fa9a",
                "0x1f527",
                "0x1fa9b",
                "0x1f529",
                "0x2699",
                "0x1f5dc",
                "0x2696",
                "0x1f9af",
                "0x1f517",
                "0x26d3",
                "0xfe0f",
                "0x200d",
                "0x1f4a5",
                "0x26d3",
                "0x1fa9d",
                "0x1f9f0",
                "0x1f9f2",
                "0x1fa9c",
                "0x2697",
                "0x1f9ea",
                "0x1f9eb",
                "0x1f9ec",
                "0x1f52c",
                "0x1f52d",
                "0x1f4e1",
                "0x1f489",
                "0x1fa78",
                "0x1f48a",
                "0x1fa79",
                "0x1fa7c",
                "0x1fa7a",
                "0x1fa7b",
                "0x1f6aa",
                "0x1f6d7",
                "0x1fa9e",
                "0x1fa9f",
                "0x1f6cf",
                "0x1f6cb",
                "0x1fa91",
                "0x1f6bd",
                "0x1faa0",
                "0x1f6bf",
                "0x1f6c1",
                "0x1faa4",
                "0x1fa92",
                "0x1f9f4",
                "0x1f9f7",
                "0x1f9f9",
                "0x1f9fa",
                "0x1f9fb",
                "0x1faa3",
                "0x1f9fc",
                "0x1fae7",
                "0x1faa5",
                "0x1f9fd",
                "0x1f9ef",
                "0x1f6d2",
                "0x1f6ac",
                "0x26b0",
                "0x1faa6",
                "0x26b1",
                "0x1f9ff",
                "0x1faac",
                "0x1f5ff",
                "0x1faa7",
                "0x1faaa"
            ],
            "symbols": [
                "0x1f3e7",
                "0x1f6ae",
                "0x1f6b0",
                "0x267f",
                "0x1f6b9",
                "0x1f6ba",
                "0x1f6bb",
                "0x1f6bc",
                "0x1f6be",
                "0x1f6c2",
                "0x1f6c3",
                "0x1f6c4",
                "0x1f6c5",
                "0x26a0",
                "0x1f6b8",
                "0x26d4",
                "0x1f6ab",
                "0x1f6b3",
                "0x1f6ad",
                "0x1f6af",
                "0x1f6b1",
                "0x1f6b7",
                "0x1f4f5",
                "0x1f51e",
                "0x2622",
                "0x2623",
                "0x2b06",
                "0x2197",
                "0x27a1",
                "0x2198",
                "0x2b07",
                "0x2199",
                "0x2b05",
                "0x2196",
                "0x2195",
                "0x2194",
                "0x21a9",
                "0x21aa",
                "0x2934",
                "0x2935",
                "0x1f503",
                "0x1f504",
                "0x1f519",
                "0x1f51a",
                "0x1f51b",
                "0x1f51c",
                "0x1f51d",
                "0x1f6d0",
                "0x269b",
                "0x1f549",
                "0x2721",
                "0x2638",
                "0x262f",
                "0x271d",
                "0x2626",
                "0x262a",
                "0x262e",
                "0x1f54e",
                "0x1f52f",
                "0x1faaf",
                "0x2648",
                "0x2649",
                "0x264a",
                "0x264b",
                "0x264c",
                "0x264d",
                "0x264e",
                "0x264f",
                "0x2650",
                "0x2651",
                "0x2652",
                "0x2653",
                "0x26ce",
                "0x1f500",
                "0x1f501",
                "0x1f502",
                "0x25b6",
                "0x23e9",
                "0x23ed",
                "0x23ef",
                "0x25c0",
                "0x23ea",
                "0x23ee",
                "0x1f53c",
                "0x23eb",
                "0x1f53d",
                "0x23ec",
                "0x23f8",
                "0x23f9",
                "0x23fa",
                "0x23cf",
                "0x1f3a6",
                "0x1f505",
                "0x1f506",
                "0x1f4f6",
                "0x1f6dc",
                "0x1f4f3",
                "0x1f4f4",
                "0x2640",
                "0x2642",
                "0x26a7",
                "0x2716",
                "0x2795",
                "0x2796",
                "0x2797",
                "0x1f7f0",
                "0x267e",
                "0x203c",
                "0x2049",
                "0x2753",
                "0x2754",
                "0x2755",
                "0x2757",
                "0x3030",
                "0x1f4b1",
                "0x1f4b2",
                "0x2695",
                "0x267b",
                "0x269c",
                "0x1f531",
                "0x1f4db",
                "0x1f530",
                "0x2b55",
                "0x2705",
                "0x2611",
                "0x2714",
                "0x274c",
                "0x274e",
                "0x27b0",
                "0x27bf",
                "0x303d",
                "0x2733",
                "0x2734",
                "0x2747",
                "0x00a9",
                "0x00ae",
                "0x2122",
                "0x0023",
                "0xfe0f",
                "0x20e3",
                "0x002a",
                "0xfe0f",
                "0x20e3",
                "0x0030",
                "0xfe0f",
                "0x20e3",
                "0x0031",
                "0xfe0f",
                "0x20e3",
                "0x0032",
                "0xfe0f",
                "0x20e3",
                "0x0033",
                "0xfe0f",
                "0x20e3",
                "0x0034",
                "0xfe0f",
                "0x20e3",
                "0x0035",
                "0xfe0f",
                "0x20e3",
                "0x0036",
                "0xfe0f",
                "0x20e3",
                "0x0037",
                "0xfe0f",
                "0x20e3",
                "0x0038",
                "0xfe0f",
                "0x20e3",
                "0x0039",
                "0xfe0f",
                "0x20e3",
                "0x1f51f",
                "0x1f520",
                "0x1f521",
                "0x1f522",
                "0x1f523",
                "0x1f524",
                "0x1f170",
                "0x1f18e",
                "0x1f171",
                "0x1f191",
                "0x1f192",
                "0x1f193",
                "0x2139",
                "0x1f194",
                "0x24c2",
                "0x1f195",
                "0x1f196",
                "0x1f17e",
                "0x1f197",
                "0x1f17f",
                "0x1f198",
                "0x1f199",
                "0x1f19a",
                "0x1f201",
                "0x1f202",
                "0x1f237",
                "0x1f236",
                "0x1f22f",
                "0x1f250",
                "0x1f239",
                "0x1f21a",
                "0x1f232",
                "0x1f251",
                "0x1f238",
                "0x1f234",
                "0x1f233",
                "0x3297",
                "0x3299",
                "0x1f23a",
                "0x1f235",
                "0x1f534",
                "0x1f7e0",
                "0x1f7e1",
                "0x1f7e2",
                "0x1f535",
                "0x1f7e3",
                "0x1f7e4",
                "0x26ab",
                "0x26aa",
                "0x1f7e5",
                "0x1f7e7",
                "0x1f7e8",
                "0x1f7e9",
                "0x1f7e6",
                "0x1f7ea",
                "0x1f7eb",
                "0x2b1b",
                "0x2b1c",
                "0x25fc",
                "0x25fb",
                "0x25fe",
                "0x25fd",
                "0x25aa",
                "0x25ab",
                "0x1f536",
                "0x1f537",
                "0x1f538",
                "0x1f539",
                "0x1f53a",
                "0x1f53b",
                "0x1f4a0",
                "0x1f518",
                "0x1f533",
                "0x1f532"
            ],
            "flags": [
                "0x1f3c1",
                "0x1f6a9",
                "0x1f38c",
                "0x1f3f4",
                "0x1f3f3",
                "0x1f3f3",
                "0xfe0f",
                "0x200d",
                "0x1f308",
                "0x1f3f3",
                "0xfe0f",
                "0x200d",
                "0x26a7",
                "0xfe0f",
                "0x1f3f4",
                "0x200d",
                "0x2620",
                "0xfe0f",
                "0x1f1e6",
                "0x1f1e8",
                "0x1f1e6",
                "0x1f1e9",
                "0x1f1e6",
                "0x1f1ea",
                "0x1f1e6",
                "0x1f1eb",
                "0x1f1e6",
                "0x1f1ec",
                "0x1f1e6",
                "0x1f1ee",
                "0x1f1e6",
                "0x1f1f1",
                "0x1f1e6",
                "0x1f1f2",
                "0x1f1e6",
                "0x1f1f4",
                "0x1f1e6",
                "0x1f1f6",
                "0x1f1e6",
                "0x1f1f7",
                "0x1f1e6",
                "0x1f1f8",
                "0x1f1e6",
                "0x1f1f9",
                "0x1f1e6",
                "0x1f1fa",
                "0x1f1e6",
                "0x1f1fc",
                "0x1f1e6",
                "0x1f1fd",
                "0x1f1e6",
                "0x1f1ff",
                "0x1f1e7",
                "0x1f1e6",
                "0x1f1e7",
                "0x1f1e7",
                "0x1f1e7",
                "0x1f1e9",
                "0x1f1e7",
                "0x1f1ea",
                "0x1f1e7",
                "0x1f1eb",
                "0x1f1e7",
                "0x1f1ec",
                "0x1f1e7",
                "0x1f1ed",
                "0x1f1e7",
                "0x1f1ee",
                "0x1f1e7",
                "0x1f1ef",
                "0x1f1e7",
                "0x1f1f1",
                "0x1f1e7",
                "0x1f1f2",
                "0x1f1e7",
                "0x1f1f3",
                "0x1f1e7",
                "0x1f1f4",
                "0x1f1e7",
                "0x1f1f6",
                "0x1f1e7",
                "0x1f1f7",
                "0x1f1e7",
                "0x1f1f8",
                "0x1f1e7",
                "0x1f1f9",
                "0x1f1e7",
                "0x1f1fb",
                "0x1f1e7",
                "0x1f1fc",
                "0x1f1e7",
                "0x1f1fe",
                "0x1f1e7",
                "0x1f1ff",
                "0x1f1e8",
                "0x1f1e6",
                "0x1f1e8",
                "0x1f1e8",
                "0x1f1e8",
                "0x1f1e9",
                "0x1f1e8",
                "0x1f1eb",
                "0x1f1e8",
                "0x1f1ec",
                "0x1f1e8",
                "0x1f1ed",
                "0x1f1e8",
                "0x1f1ee",
                "0x1f1e8",
                "0x1f1f0",
                "0x1f1e8",
                "0x1f1f1",
                "0x1f1e8",
                "0x1f1f2",
                "0x1f1e8",
                "0x1f1f3",
                "0x1f1e8",
                "0x1f1f4",
                "0x1f1e8",
                "0x1f1f5",
                "0x1f1e8",
                "0x1f1f7",
                "0x1f1e8",
                "0x1f1fa",
                "0x1f1e8",
                "0x1f1fb",
                "0x1f1e8",
                "0x1f1fc",
                "0x1f1e8",
                "0x1f1fd",
                "0x1f1e8",
                "0x1f1fe",
                "0x1f1e8",
                "0x1f1ff",
                "0x1f1e9",
                "0x1f1ea",
                "0x1f1e9",
                "0x1f1ec",
                "0x1f1e9",
                "0x1f1ef",
                "0x1f1e9",
                "0x1f1f0",
                "0x1f1e9",
                "0x1f1f2",
                "0x1f1e9",
                "0x1f1f4",
                "0x1f1e9",
                "0x1f1ff",
                "0x1f1ea",
                "0x1f1e6",
                "0x1f1ea",
                "0x1f1e8",
                "0x1f1ea",
                "0x1f1ea",
                "0x1f1ea",
                "0x1f1ec",
                "0x1f1ea",
                "0x1f1ed",
                "0x1f1ea",
                "0x1f1f7",
                "0x1f1ea",
                "0x1f1f8",
                "0x1f1ea",
                "0x1f1f9",
                "0x1f1ea",
                "0x1f1fa",
                "0x1f1eb",
                "0x1f1ee",
                "0x1f1eb",
                "0x1f1ef",
                "0x1f1eb",
                "0x1f1f0",
                "0x1f1eb",
                "0x1f1f2",
                "0x1f1eb",
                "0x1f1f4",
                "0x1f1eb",
                "0x1f1f7",
                "0x1f1ec",
                "0x1f1e6",
                "0x1f1ec",
                "0x1f1e7",
                "0x1f1ec",
                "0x1f1e9",
                "0x1f1ec",
                "0x1f1ea",
                "0x1f1ec",
                "0x1f1eb",
                "0x1f1ec",
                "0x1f1ec",
                "0x1f1ec",
                "0x1f1ed",
                "0x1f1ec",
                "0x1f1ee",
                "0x1f1ec",
                "0x1f1f1",
                "0x1f1ec",
                "0x1f1f2",
                "0x1f1ec",
                "0x1f1f3",
                "0x1f1ec",
                "0x1f1f5",
                "0x1f1ec",
                "0x1f1f6",
                "0x1f1ec",
                "0x1f1f7",
                "0x1f1ec",
                "0x1f1f8",
                "0x1f1ec",
                "0x1f1f9",
                "0x1f1ec",
                "0x1f1fa",
                "0x1f1ec",
                "0x1f1fc",
                "0x1f1ec",
                "0x1f1fe",
                "0x1f1ed",
                "0x1f1f0",
                "0x1f1ed",
                "0x1f1f2",
                "0x1f1ed",
                "0x1f1f3",
                "0x1f1ed",
                "0x1f1f7",
                "0x1f1ed",
                "0x1f1f9",
                "0x1f1ed",
                "0x1f1fa",
                "0x1f1ee",
                "0x1f1e8",
                "0x1f1ee",
                "0x1f1e9",
                "0x1f1ee",
                "0x1f1ea",
                "0x1f1ee",
                "0x1f1f1",
                "0x1f1ee",
                "0x1f1f2",
                "0x1f1ee",
                "0x1f1f3",
                "0x1f1ee",
                "0x1f1f4",
                "0x1f1ee",
                "0x1f1f6",
                "0x1f1ee",
                "0x1f1f7",
                "0x1f1ee",
                "0x1f1f8",
                "0x1f1ee",
                "0x1f1f9",
                "0x1f1ef",
                "0x1f1ea",
                "0x1f1ef",
                "0x1f1f2",
                "0x1f1ef",
                "0x1f1f4",
                "0x1f1ef",
                "0x1f1f5",
                "0x1f1f0",
                "0x1f1ea",
                "0x1f1f0",
                "0x1f1ec",
                "0x1f1f0",
                "0x1f1ed",
                "0x1f1f0",
                "0x1f1ee",
                "0x1f1f0",
                "0x1f1f2",
                "0x1f1f0",
                "0x1f1f3",
                "0x1f1f0",
                "0x1f1f5",
                "0x1f1f0",
                "0x1f1f7",
                "0x1f1f0",
                "0x1f1fc",
                "0x1f1f0",
                "0x1f1fe",
                "0x1f1f0",
                "0x1f1ff",
                "0x1f1f1",
                "0x1f1e6",
                "0x1f1f1",
                "0x1f1e7",
                "0x1f1f1",
                "0x1f1e8",
                "0x1f1f1",
                "0x1f1ee",
                "0x1f1f1",
                "0x1f1f0",
                "0x1f1f1",
                "0x1f1f7",
                "0x1f1f1",
                "0x1f1f8",
                "0x1f1f1",
                "0x1f1f9",
                "0x1f1f1",
                "0x1f1fa",
                "0x1f1f1",
                "0x1f1fb",
                "0x1f1f1",
                "0x1f1fe",
                "0x1f1f2",
                "0x1f1e6",
                "0x1f1f2",
                "0x1f1e8",
                "0x1f1f2",
                "0x1f1e9",
                "0x1f1f2",
                "0x1f1ea",
                "0x1f1f2",
                "0x1f1eb",
                "0x1f1f2",
                "0x1f1ec",
                "0x1f1f2",
                "0x1f1ed",
                "0x1f1f2",
                "0x1f1f0",
                "0x1f1f2",
                "0x1f1f1",
                "0x1f1f2",
                "0x1f1f2",
                "0x1f1f2",
                "0x1f1f3",
                "0x1f1f2",
                "0x1f1f4",
                "0x1f1f2",
                "0x1f1f5",
                "0x1f1f2",
                "0x1f1f6",
                "0x1f1f2",
                "0x1f1f7",
                "0x1f1f2",
                "0x1f1f8",
                "0x1f1f2",
                "0x1f1f9",
                "0x1f1f2",
                "0x1f1fa",
                "0x1f1f2",
                "0x1f1fb",
                "0x1f1f2",
                "0x1f1fc",
                "0x1f1f2",
                "0x1f1fd",
                "0x1f1f2",
                "0x1f1fe",
                "0x1f1f2",
                "0x1f1ff",
                "0x1f1f3",
                "0x1f1e6",
                "0x1f1f3",
                "0x1f1e8",
                "0x1f1f3",
                "0x1f1ea",
                "0x1f1f3",
                "0x1f1eb",
                "0x1f1f3",
                "0x1f1ec",
                "0x1f1f3",
                "0x1f1ee",
                "0x1f1f3",
                "0x1f1f1",
                "0x1f1f3",
                "0x1f1f4",
                "0x1f1f3",
                "0x1f1f5",
                "0x1f1f3",
                "0x1f1f7",
                "0x1f1f3",
                "0x1f1fa",
                "0x1f1f3",
                "0x1f1ff",
                "0x1f1f4",
                "0x1f1f2",
                "0x1f1f5",
                "0x1f1e6",
                "0x1f1f5",
                "0x1f1ea",
                "0x1f1f5",
                "0x1f1eb",
                "0x1f1f5",
                "0x1f1ec",
                "0x1f1f5",
                "0x1f1ed",
                "0x1f1f5",
                "0x1f1f0",
                "0x1f1f5",
                "0x1f1f1",
                "0x1f1f5",
                "0x1f1f2",
                "0x1f1f5",
                "0x1f1f3",
                "0x1f1f5",
                "0x1f1f7",
                "0x1f1f5",
                "0x1f1f8",
                "0x1f1f5",
                "0x1f1f9",
                "0x1f1f5",
                "0x1f1fc",
                "0x1f1f5",
                "0x1f1fe",
                "0x1f1f6",
                "0x1f1e6",
                "0x1f1f7",
                "0x1f1ea",
                "0x1f1f7",
                "0x1f1f4",
                "0x1f1f7",
                "0x1f1f8",
                "0x1f1f7",
                "0x1f1fa",
                "0x1f1f7",
                "0x1f1fc",
                "0x1f1f8",
                "0x1f1e6",
                "0x1f1f8",
                "0x1f1e7",
                "0x1f1f8",
                "0x1f1e8",
                "0x1f1f8",
                "0x1f1e9",
                "0x1f1f8",
                "0x1f1ea",
                "0x1f1f8",
                "0x1f1ec",
                "0x1f1f8",
                "0x1f1ed",
                "0x1f1f8",
                "0x1f1ee",
                "0x1f1f8",
                "0x1f1ef",
                "0x1f1f8",
                "0x1f1f0",
                "0x1f1f8",
                "0x1f1f1",
                "0x1f1f8",
                "0x1f1f2",
                "0x1f1f8",
                "0x1f1f3",
                "0x1f1f8",
                "0x1f1f4",
                "0x1f1f8",
                "0x1f1f7",
                "0x1f1f8",
                "0x1f1f8",
                "0x1f1f8",
                "0x1f1f9",
                "0x1f1f8",
                "0x1f1fb",
                "0x1f1f8",
                "0x1f1fd",
                "0x1f1f8",
                "0x1f1fe",
                "0x1f1f8",
                "0x1f1ff",
                "0x1f1f9",
                "0x1f1e6",
                "0x1f1f9",
                "0x1f1e8",
                "0x1f1f9",
                "0x1f1e9",
                "0x1f1f9",
                "0x1f1eb",
                "0x1f1f9",
                "0x1f1ec",
                "0x1f1f9",
                "0x1f1ed",
                "0x1f1f9",
                "0x1f1ef",
                "0x1f1f9",
                "0x1f1f0",
                "0x1f1f9",
                "0x1f1f1",
                "0x1f1f9",
                "0x1f1f2",
                "0x1f1f9",
                "0x1f1f3",
                "0x1f1f9",
                "0x1f1f4",
                "0x1f1f9",
                "0x1f1f7",
                "0x1f1f9",
                "0x1f1f9",
                "0x1f1f9",
                "0x1f1fb",
                "0x1f1f9",
                "0x1f1fc",
                "0x1f1f9",
                "0x1f1ff",
                "0x1f1fa",
                "0x1f1e6",
                "0x1f1fa",
                "0x1f1ec",
                "0x1f1fa",
                "0x1f1f2",
                "0x1f1fa",
                "0x1f1f3",
                "0x1f1fa",
                "0x1f1f8",
                "0x1f1fa",
                "0x1f1fe",
                "0x1f1fa",
                "0x1f1ff",
                "0x1f1fb",
                "0x1f1e6",
                "0x1f1fb",
                "0x1f1e8",
                "0x1f1fb",
                "0x1f1ea",
                "0x1f1fb",
                "0x1f1ec",
                "0x1f1fb",
                "0x1f1ee",
                "0x1f1fb",
                "0x1f1f3",
                "0x1f1fb",
                "0x1f1fa",
                "0x1f1fc",
                "0x1f1eb",
                "0x1f1fc",
                "0x1f1f8",
                "0x1f1fd",
                "0x1f1f0",
                "0x1f1fe",
                "0x1f1ea",
                "0x1f1fe",
                "0x1f1f9",
                "0x1f1ff",
                "0x1f1e6",
                "0x1f1ff",
                "0x1f1f2",
                "0x1f1ff",
                "0x1f1fc",
                "0x1f3f4",
                "0xe0067",
                "0xe0062",
                "0xe0065",
                "0xe006e",
                "0xe0067",
                "0xe007f",
                "0x1f3f4",
                "0xe0067",
                "0xe0062",
                "0xe0073",
                "0xe0063",
                "0xe0074",
                "0xe007f",
                "0x1f3f4",
                "0xe0067",
                "0xe0062",
                "0xe0077",
                "0xe006c",
                "0xe0073",
                "0xe007f"
            ]
        }
    };
    var o_hasOwnProperty = Object.prototype.hasOwnProperty;
    var o_keys = Object.keys || function(obj) {
        var result = [];
        for(var key in obj)if (o_hasOwnProperty.call(obj, key)) result.push(key);
        return result;
    };
    function _copyObject(source, target) {
        var keys = o_keys(source);
        var key;
        for(var i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            target[key] = source[key] || target[key];
        }
    }
    function _copyArray(source, target) {
        for(var i = 0, l = source.length; i < l; i++)target[i] = source[i];
    }
    function copyObject(source, _target) {
        var isArray = Array.isArray(source);
        var target = _target || (isArray ? new Array(source.length) : {});
        if (isArray) _copyArray(source, target);
        else _copyObject(source, target);
        return target;
    }
    /** Get the data based on key**/ Chance.prototype.get = function(name) {
        return copyObject(data[name]);
    };
    // Mac Address
    Chance.prototype.mac_address = function(options) {
        // typically mac addresses are separated by ":"
        // however they can also be separated by "-"
        // the network variant uses a dot every fourth byte
        options = initOptions(options);
        if (!options.separator) options.separator = options.networkVersion ? "." : ":";
        var mac_pool = "ABCDEF1234567890", mac = "";
        if (!options.networkVersion) mac = this.n(this.string, 6, {
            pool: mac_pool,
            length: 2
        }).join(options.separator);
        else mac = this.n(this.string, 3, {
            pool: mac_pool,
            length: 4
        }).join(options.separator);
        return mac;
    };
    Chance.prototype.normal = function(options) {
        options = initOptions(options, {
            mean: 0,
            dev: 1,
            pool: []
        });
        testRange(options.pool.constructor !== Array, "Chance: The pool option must be a valid array.");
        testRange(typeof options.mean !== 'number', "Chance: Mean (mean) must be a number");
        testRange(typeof options.dev !== 'number', "Chance: Standard deviation (dev) must be a number");
        // If a pool has been passed, then we are returning an item from that pool,
        // using the normal distribution settings that were passed in
        if (options.pool.length > 0) return this.normal_pool(options);
        // The Marsaglia Polar method
        var s, u, v, norm, mean = options.mean, dev = options.dev;
        do {
            // U and V are from the uniform distribution on (-1, 1)
            u = this.random() * 2 - 1;
            v = this.random() * 2 - 1;
            s = u * u + v * v;
        }while (s >= 1);
        // Compute the standard normal variate
        norm = u * Math.sqrt(-2 * Math.log(s) / s);
        // Shape and scale
        return dev * norm + mean;
    };
    Chance.prototype.normal_pool = function(options) {
        var performanceCounter = 0;
        do {
            var idx = Math.round(this.normal({
                mean: options.mean,
                dev: options.dev
            }));
            if (idx < options.pool.length && idx >= 0) return options.pool[idx];
            else performanceCounter++;
        }while (performanceCounter < 100);
        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
    };
    Chance.prototype.radio = function(options) {
        // Initial Letter (Typically Designated by Side of Mississippi River)
        options = initOptions(options, {
            side: "?"
        });
        var fl = "";
        switch(options.side.toLowerCase()){
            case "east":
            case "e":
                fl = "W";
                break;
            case "west":
            case "w":
                fl = "K";
                break;
            default:
                fl = this.character({
                    pool: "KW"
                });
                break;
        }
        return fl + this.character({
            alpha: true,
            casing: "upper"
        }) + this.character({
            alpha: true,
            casing: "upper"
        }) + this.character({
            alpha: true,
            casing: "upper"
        });
    };
    // Set the data as key and data or the data map
    Chance.prototype.set = function(name, values) {
        if (typeof name === "string") data[name] = values;
        else data = copyObject(name, data);
    };
    Chance.prototype.tv = function(options) {
        return this.radio(options);
    };
    // ID number for Brazil companies
    Chance.prototype.cnpj = function() {
        var n = this.n(this.natural, 8, {
            max: 9
        });
        var d1 = 2 + n[7] * 6 + n[6] * 7 + n[5] * 8 + n[4] * 9 + n[3] * 2 + n[2] * 3 + n[1] * 4 + n[0] * 5;
        d1 = 11 - d1 % 11;
        if (d1 >= 10) d1 = 0;
        var d2 = d1 * 2 + 3 + n[7] * 7 + n[6] * 8 + n[5] * 9 + n[4] * 2 + n[3] * 3 + n[2] * 4 + n[1] * 5 + n[0] * 6;
        d2 = 11 - d2 % 11;
        if (d2 >= 10) d2 = 0;
        return '' + n[0] + n[1] + '.' + n[2] + n[3] + n[4] + '.' + n[5] + n[6] + n[7] + '/0001-' + d1 + d2;
    };
    Chance.prototype.emotion = function() {
        return this.pick(this.get("emotions"));
    };
    // -- End Miscellaneous --
    Chance.prototype.mersenne_twister = function(seed) {
        return new MersenneTwister(seed);
    };
    Chance.prototype.blueimp_md5 = function() {
        return new BlueImpMD5();
    };
    // Mersenne Twister from https://gist.github.com/banksean/300494
    /*
       A C-program for MT19937, with initialization improved 2002/1/26.
       Coded by Takuji Nishimura and Makoto Matsumoto.

       Before using, initialize the state by using init_genrand(seed)
       or init_by_array(init_key, key_length).

       Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
       All rights reserved.

       Redistribution and use in source and binary forms, with or without
       modification, are permitted provided that the following conditions
       are met:

       1. Redistributions of source code must retain the above copyright
       notice, this list of conditions and the following disclaimer.

       2. Redistributions in binary form must reproduce the above copyright
       notice, this list of conditions and the following disclaimer in the
       documentation and/or other materials provided with the distribution.

       3. The names of its contributors may not be used to endorse or promote
       products derived from this software without specific prior written
       permission.

       THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
       "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
       LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
       A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
       CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
       EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
       PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
       PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
       LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
       NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
       SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


       Any feedback is very welcome.
       http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
       email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
     */ var MersenneTwister = function(seed) {
        if (seed === undefined) // kept random number same size as time used previously to ensure no unexpected results downstream
        seed = Math.floor(Math.random() * Math.pow(10, 13));
        /* Period parameters */ this.N = 624;
        this.M = 397;
        this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
        this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
        this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
        this.mt = new Array(this.N); /* the array for the state vector */ 
        this.mti = this.N + 1; /* mti==N + 1 means mt[N] is not initialized */ 
        this.init_genrand(seed);
    };
    /* initializes mt[N] with a seed */ MersenneTwister.prototype.init_genrand = function(s) {
        this.mt[0] = s >>> 0;
        for(this.mti = 1; this.mti < this.N; this.mti++){
            s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
            this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
            /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
        /* for >32 bit machines */ }
    };
    /* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
        var i = 1, j = 0, k, s;
        this.init_genrand(19650218);
        k = this.N > key_length ? this.N : key_length;
        for(; k; k--){
            s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
            this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
            this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
            i++;
            j++;
            if (i >= this.N) {
                this.mt[0] = this.mt[this.N - 1];
                i = 1;
            }
            if (j >= key_length) j = 0;
        }
        for(k = this.N - 1; k; k--){
            s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
            this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
            this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
            i++;
            if (i >= this.N) {
                this.mt[0] = this.mt[this.N - 1];
                i = 1;
            }
        }
        this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
    };
    /* generates a random number on [0,0xffffffff]-interval */ MersenneTwister.prototype.genrand_int32 = function() {
        var y;
        var mag01 = new Array(0x0, this.MATRIX_A);
        /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
            var kk;
            if (this.mti === this.N + 1) this.init_genrand(5489); /* a default initial seed is used */ 
            for(kk = 0; kk < this.N - this.M; kk++){
                y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
                this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
            }
            for(; kk < this.N - 1; kk++){
                y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
                this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
            }
            y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
            this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
            this.mti = 0;
        }
        y = this.mt[this.mti++];
        /* Tempering */ y ^= y >>> 11;
        y ^= y << 7 & 0x9d2c5680;
        y ^= y << 15 & 0xefc60000;
        y ^= y >>> 18;
        return y >>> 0;
    };
    /* generates a random number on [0,0x7fffffff]-interval */ MersenneTwister.prototype.genrand_int31 = function() {
        return this.genrand_int32() >>> 1;
    };
    /* generates a random number on [0,1]-real-interval */ MersenneTwister.prototype.genrand_real1 = function() {
        return this.genrand_int32() * (1.0 / 4294967295.0);
    /* divided by 2^32-1 */ };
    /* generates a random number on [0,1)-real-interval */ MersenneTwister.prototype.random = function() {
        return this.genrand_int32() * (1.0 / 4294967296.0);
    /* divided by 2^32 */ };
    /* generates a random number on (0,1)-real-interval */ MersenneTwister.prototype.genrand_real3 = function() {
        return (this.genrand_int32() + 0.5) * (1.0 / 4294967296.0);
    /* divided by 2^32 */ };
    /* generates a random number on [0,1) with 53-bit resolution*/ MersenneTwister.prototype.genrand_res53 = function() {
        var a = this.genrand_int32() >>> 5, b = this.genrand_int32() >>> 6;
        return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
    };
    // BlueImp MD5 hashing algorithm from https://github.com/blueimp/JavaScript-MD5
    var BlueImpMD5 = function() {};
    BlueImpMD5.prototype.VERSION = '1.0.1';
    /*
    * Add integers, wrapping at 2^32. This uses 16-bit operations internally
    * to work around bugs in some JS interpreters.
    */ BlueImpMD5.prototype.safe_add = function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    /*
    * Bitwise rotate a 32-bit number to the left.
    */ BlueImpMD5.prototype.bit_roll = function(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    };
    /*
    * These functions implement the five basic operations the algorithm uses.
    */ BlueImpMD5.prototype.md5_cmn = function(q, a, b, x, s, t) {
        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(a, q), this.safe_add(x, t)), s), b);
    };
    BlueImpMD5.prototype.md5_ff = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(b & c | ~b & d, a, b, x, s, t);
    };
    BlueImpMD5.prototype.md5_gg = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(b & d | c & ~d, a, b, x, s, t);
    };
    BlueImpMD5.prototype.md5_hh = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(b ^ c ^ d, a, b, x, s, t);
    };
    BlueImpMD5.prototype.md5_ii = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(c ^ (b | ~d), a, b, x, s, t);
    };
    /*
    * Calculate the MD5 of an array of little-endian words, and a bit length.
    */ BlueImpMD5.prototype.binl_md5 = function(x, len) {
        /* append padding */ x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var i, olda, oldb, oldc, oldd, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        for(i = 0; i < x.length; i += 16){
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = this.md5_ff(a, b, c, d, x[i], 7, -680876936);
            d = this.md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = this.md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = this.md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = this.md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = this.md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = this.md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = this.md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = this.md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = this.md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = this.md5_ff(c, d, a, b, x[i + 10], 17, -42063);
            b = this.md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = this.md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = this.md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = this.md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = this.md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = this.md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = this.md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = this.md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = this.md5_gg(b, c, d, a, x[i], 20, -373897302);
            a = this.md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = this.md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = this.md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = this.md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = this.md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = this.md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = this.md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = this.md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = this.md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = this.md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = this.md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = this.md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = this.md5_hh(a, b, c, d, x[i + 5], 4, -378558);
            d = this.md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = this.md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = this.md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = this.md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = this.md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = this.md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = this.md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = this.md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = this.md5_hh(d, a, b, c, x[i], 11, -358537222);
            c = this.md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = this.md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = this.md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = this.md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = this.md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = this.md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = this.md5_ii(a, b, c, d, x[i], 6, -198630844);
            d = this.md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = this.md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = this.md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = this.md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = this.md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = this.md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = this.md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = this.md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = this.md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = this.md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = this.md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = this.md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = this.md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = this.md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = this.md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = this.safe_add(a, olda);
            b = this.safe_add(b, oldb);
            c = this.safe_add(c, oldc);
            d = this.safe_add(d, oldd);
        }
        return [
            a,
            b,
            c,
            d
        ];
    };
    /*
    * Convert an array of little-endian words to a string
    */ BlueImpMD5.prototype.binl2rstr = function(input) {
        var i, output = '';
        for(i = 0; i < input.length * 32; i += 8)output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
        return output;
    };
    /*
    * Convert a raw string to an array of little-endian words
    * Characters >255 have their high-byte silently ignored.
    */ BlueImpMD5.prototype.rstr2binl = function(input) {
        var i, output = [];
        output[(input.length >> 2) - 1] = undefined;
        for(i = 0; i < output.length; i += 1)output[i] = 0;
        for(i = 0; i < input.length * 8; i += 8)output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
        return output;
    };
    /*
    * Calculate the MD5 of a raw string
    */ BlueImpMD5.prototype.rstr_md5 = function(s) {
        return this.binl2rstr(this.binl_md5(this.rstr2binl(s), s.length * 8));
    };
    /*
    * Calculate the HMAC-MD5, of a key and some data (raw strings)
    */ BlueImpMD5.prototype.rstr_hmac_md5 = function(key, data) {
        var i, bkey = this.rstr2binl(key), ipad = [], opad = [], hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) bkey = this.binl_md5(bkey, key.length * 8);
        for(i = 0; i < 16; i += 1){
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }
        hash = this.binl_md5(ipad.concat(this.rstr2binl(data)), 512 + data.length * 8);
        return this.binl2rstr(this.binl_md5(opad.concat(hash), 640));
    };
    /*
    * Convert a raw string to a hex string
    */ BlueImpMD5.prototype.rstr2hex = function(input) {
        var hex_tab = '0123456789abcdef', output = '', x, i;
        for(i = 0; i < input.length; i += 1){
            x = input.charCodeAt(i);
            output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
        }
        return output;
    };
    /*
    * Encode a string as utf-8
    */ BlueImpMD5.prototype.str2rstr_utf8 = function(input) {
        return unescape(encodeURIComponent(input));
    };
    /*
    * Take string arguments and return either raw or hex encoded strings
    */ BlueImpMD5.prototype.raw_md5 = function(s) {
        return this.rstr_md5(this.str2rstr_utf8(s));
    };
    BlueImpMD5.prototype.hex_md5 = function(s) {
        return this.rstr2hex(this.raw_md5(s));
    };
    BlueImpMD5.prototype.raw_hmac_md5 = function(k, d) {
        return this.rstr_hmac_md5(this.str2rstr_utf8(k), this.str2rstr_utf8(d));
    };
    BlueImpMD5.prototype.hex_hmac_md5 = function(k, d) {
        return this.rstr2hex(this.raw_hmac_md5(k, d));
    };
    BlueImpMD5.prototype.md5 = function(string, key, raw) {
        if (!key) {
            if (!raw) return this.hex_md5(string);
            return this.raw_md5(string);
        }
        if (!raw) return this.hex_hmac_md5(key, string);
        return this.raw_hmac_md5(key, string);
    };
    if (module.exports) exports = module.exports = Chance;
    exports.Chance = Chance;
    // Register as an anonymous AMD module
    if (typeof define === 'function' && define.amd) define([], function() {
        return Chance;
    });
    // if there is a importsScrips object define chance for worker
    // allows worker to use full Chance functionality with seed
    if (typeof importScripts !== 'undefined') {
        chance = new Chance();
        self.Chance = Chance;
    }
    // If there is a window object, that at least has a document property,
    // instantiate and define chance on the window
    if (typeof window === "object" && typeof window.document === "object") {
        window.Chance = Chance;
        window.chance = new Chance();
    }
})();

});
parcelRegister("8DdNe", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $648caa49a6a38228$export$a143d493d941bafc, (v) => $648caa49a6a38228$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $648caa49a6a38228$export$f99ded8fe4b79145, (v) => $648caa49a6a38228$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $648caa49a6a38228$export$a143d493d941bafc;
var $648caa49a6a38228$export$e4cf37d7f6fb9e0a;
var $648caa49a6a38228$export$f99ded8fe4b79145;
var $648caa49a6a38228$export$599f31c3813fae4d;
'use strict';

var $hLdXZ = parcelRequire("hLdXZ");

var $5leHq = parcelRequire("5leHq");
var $648caa49a6a38228$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$648caa49a6a38228$export$a143d493d941bafc = $648caa49a6a38228$var$Buffer;
$648caa49a6a38228$export$e4cf37d7f6fb9e0a = $648caa49a6a38228$var$SlowBuffer;
$648caa49a6a38228$export$f99ded8fe4b79145 = 50;
var $648caa49a6a38228$var$K_MAX_LENGTH = 0x7fffffff;
$648caa49a6a38228$export$599f31c3813fae4d = $648caa49a6a38228$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $648caa49a6a38228$var$Buffer.TYPED_ARRAY_SUPPORT = $648caa49a6a38228$var$typedArraySupport();
if (!$648caa49a6a38228$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $648caa49a6a38228$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($648caa49a6a38228$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$648caa49a6a38228$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($648caa49a6a38228$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$648caa49a6a38228$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $648caa49a6a38228$var$createBuffer(length) {
    if (length > $648caa49a6a38228$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $648caa49a6a38228$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $648caa49a6a38228$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $648caa49a6a38228$var$allocUnsafe(arg);
    }
    return $648caa49a6a38228$var$from(arg, encodingOrOffset, length);
}
$648caa49a6a38228$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $648caa49a6a38228$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $648caa49a6a38228$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $648caa49a6a38228$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($648caa49a6a38228$var$isInstance(value, ArrayBuffer) || value && $648caa49a6a38228$var$isInstance(value.buffer, ArrayBuffer)) return $648caa49a6a38228$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($648caa49a6a38228$var$isInstance(value, SharedArrayBuffer) || value && $648caa49a6a38228$var$isInstance(value.buffer, SharedArrayBuffer))) return $648caa49a6a38228$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $648caa49a6a38228$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $648caa49a6a38228$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $648caa49a6a38228$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $648caa49a6a38228$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $648caa49a6a38228$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($648caa49a6a38228$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($648caa49a6a38228$var$Buffer, Uint8Array);
function $648caa49a6a38228$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $648caa49a6a38228$var$alloc(size, fill, encoding) {
    $648caa49a6a38228$var$assertSize(size);
    if (size <= 0) return $648caa49a6a38228$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $648caa49a6a38228$var$createBuffer(size).fill(fill, encoding) : $648caa49a6a38228$var$createBuffer(size).fill(fill);
    return $648caa49a6a38228$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $648caa49a6a38228$var$Buffer.alloc = function(size, fill, encoding) {
    return $648caa49a6a38228$var$alloc(size, fill, encoding);
};
function $648caa49a6a38228$var$allocUnsafe(size) {
    $648caa49a6a38228$var$assertSize(size);
    return $648caa49a6a38228$var$createBuffer(size < 0 ? 0 : $648caa49a6a38228$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $648caa49a6a38228$var$Buffer.allocUnsafe = function(size) {
    return $648caa49a6a38228$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $648caa49a6a38228$var$Buffer.allocUnsafeSlow = function(size) {
    return $648caa49a6a38228$var$allocUnsafe(size);
};
function $648caa49a6a38228$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$648caa49a6a38228$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $648caa49a6a38228$var$byteLength(string, encoding) | 0;
    var buf = $648caa49a6a38228$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $648caa49a6a38228$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $648caa49a6a38228$var$checked(array.length) | 0;
    var buf = $648caa49a6a38228$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $648caa49a6a38228$var$fromArrayView(arrayView) {
    if ($648caa49a6a38228$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $648caa49a6a38228$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $648caa49a6a38228$var$fromArrayLike(arrayView);
}
function $648caa49a6a38228$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $648caa49a6a38228$var$Buffer.prototype);
    return buf;
}
function $648caa49a6a38228$var$fromObject(obj) {
    if ($648caa49a6a38228$var$Buffer.isBuffer(obj)) {
        var len = $648caa49a6a38228$var$checked(obj.length) | 0;
        var buf = $648caa49a6a38228$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $648caa49a6a38228$var$numberIsNaN(obj.length)) return $648caa49a6a38228$var$createBuffer(0);
        return $648caa49a6a38228$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $648caa49a6a38228$var$fromArrayLike(obj.data);
}
function $648caa49a6a38228$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $648caa49a6a38228$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $648caa49a6a38228$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $648caa49a6a38228$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $648caa49a6a38228$var$Buffer.alloc(+length);
}
$648caa49a6a38228$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $648caa49a6a38228$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$648caa49a6a38228$var$Buffer.compare = function compare(a, b) {
    if ($648caa49a6a38228$var$isInstance(a, Uint8Array)) a = $648caa49a6a38228$var$Buffer.from(a, a.offset, a.byteLength);
    if ($648caa49a6a38228$var$isInstance(b, Uint8Array)) b = $648caa49a6a38228$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$648caa49a6a38228$var$Buffer.isBuffer(a) || !$648caa49a6a38228$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$648caa49a6a38228$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$648caa49a6a38228$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $648caa49a6a38228$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $648caa49a6a38228$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($648caa49a6a38228$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $648caa49a6a38228$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$648caa49a6a38228$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $648caa49a6a38228$var$byteLength(string, encoding) {
    if ($648caa49a6a38228$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $648caa49a6a38228$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $648caa49a6a38228$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $648caa49a6a38228$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $648caa49a6a38228$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$648caa49a6a38228$var$Buffer.byteLength = $648caa49a6a38228$var$byteLength;
function $648caa49a6a38228$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $648caa49a6a38228$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $648caa49a6a38228$var$utf8Slice(this, start, end);
        case 'ascii':
            return $648caa49a6a38228$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $648caa49a6a38228$var$latin1Slice(this, start, end);
        case 'base64':
            return $648caa49a6a38228$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $648caa49a6a38228$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$648caa49a6a38228$var$Buffer.prototype._isBuffer = true;
function $648caa49a6a38228$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$648caa49a6a38228$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$648caa49a6a38228$var$swap(this, i, i + 1);
    return this;
};
$648caa49a6a38228$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $648caa49a6a38228$var$swap(this, i, i + 3);
        $648caa49a6a38228$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$648caa49a6a38228$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $648caa49a6a38228$var$swap(this, i, i + 7);
        $648caa49a6a38228$var$swap(this, i + 1, i + 6);
        $648caa49a6a38228$var$swap(this, i + 2, i + 5);
        $648caa49a6a38228$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$648caa49a6a38228$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $648caa49a6a38228$var$utf8Slice(this, 0, length);
    return $648caa49a6a38228$var$slowToString.apply(this, arguments);
};
$648caa49a6a38228$var$Buffer.prototype.toLocaleString = $648caa49a6a38228$var$Buffer.prototype.toString;
$648caa49a6a38228$var$Buffer.prototype.equals = function equals(b) {
    if (!$648caa49a6a38228$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $648caa49a6a38228$var$Buffer.compare(this, b) === 0;
};
$648caa49a6a38228$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $648caa49a6a38228$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($648caa49a6a38228$var$customInspectSymbol) $648caa49a6a38228$var$Buffer.prototype[$648caa49a6a38228$var$customInspectSymbol] = $648caa49a6a38228$var$Buffer.prototype.inspect;
$648caa49a6a38228$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($648caa49a6a38228$var$isInstance(target, Uint8Array)) target = $648caa49a6a38228$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$648caa49a6a38228$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $648caa49a6a38228$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($648caa49a6a38228$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $648caa49a6a38228$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($648caa49a6a38228$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $648caa49a6a38228$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $648caa49a6a38228$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $648caa49a6a38228$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$648caa49a6a38228$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$648caa49a6a38228$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $648caa49a6a38228$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$648caa49a6a38228$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $648caa49a6a38228$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $648caa49a6a38228$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($648caa49a6a38228$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $648caa49a6a38228$var$utf8Write(buf, string, offset, length) {
    return $648caa49a6a38228$var$blitBuffer($648caa49a6a38228$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $648caa49a6a38228$var$asciiWrite(buf, string, offset, length) {
    return $648caa49a6a38228$var$blitBuffer($648caa49a6a38228$var$asciiToBytes(string), buf, offset, length);
}
function $648caa49a6a38228$var$base64Write(buf, string, offset, length) {
    return $648caa49a6a38228$var$blitBuffer($648caa49a6a38228$var$base64ToBytes(string), buf, offset, length);
}
function $648caa49a6a38228$var$ucs2Write(buf, string, offset, length) {
    return $648caa49a6a38228$var$blitBuffer($648caa49a6a38228$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$648caa49a6a38228$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $648caa49a6a38228$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $648caa49a6a38228$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $648caa49a6a38228$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $648caa49a6a38228$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $648caa49a6a38228$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$648caa49a6a38228$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $648caa49a6a38228$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hLdXZ.fromByteArray(buf);
    else return $hLdXZ.fromByteArray(buf.slice(start, end));
}
function $648caa49a6a38228$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $648caa49a6a38228$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $648caa49a6a38228$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $648caa49a6a38228$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $648caa49a6a38228$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $648caa49a6a38228$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $648caa49a6a38228$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $648caa49a6a38228$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $648caa49a6a38228$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $648caa49a6a38228$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $648caa49a6a38228$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$648caa49a6a38228$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $648caa49a6a38228$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $648caa49a6a38228$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$648caa49a6a38228$var$Buffer.prototype.readUintLE = $648caa49a6a38228$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$648caa49a6a38228$var$Buffer.prototype.readUintBE = $648caa49a6a38228$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$648caa49a6a38228$var$Buffer.prototype.readUint8 = $648caa49a6a38228$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$648caa49a6a38228$var$Buffer.prototype.readUint16LE = $648caa49a6a38228$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$648caa49a6a38228$var$Buffer.prototype.readUint16BE = $648caa49a6a38228$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$648caa49a6a38228$var$Buffer.prototype.readUint32LE = $648caa49a6a38228$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$648caa49a6a38228$var$Buffer.prototype.readUint32BE = $648caa49a6a38228$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$648caa49a6a38228$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$648caa49a6a38228$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$648caa49a6a38228$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$648caa49a6a38228$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$648caa49a6a38228$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$648caa49a6a38228$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$648caa49a6a38228$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$648caa49a6a38228$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 4, this.length);
    return $5leHq.read(this, offset, true, 23, 4);
};
$648caa49a6a38228$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 4, this.length);
    return $5leHq.read(this, offset, false, 23, 4);
};
$648caa49a6a38228$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 8, this.length);
    return $5leHq.read(this, offset, true, 52, 8);
};
$648caa49a6a38228$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkOffset(offset, 8, this.length);
    return $5leHq.read(this, offset, false, 52, 8);
};
function $648caa49a6a38228$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$648caa49a6a38228$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$648caa49a6a38228$var$Buffer.prototype.writeUintLE = $648caa49a6a38228$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $648caa49a6a38228$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$648caa49a6a38228$var$Buffer.prototype.writeUintBE = $648caa49a6a38228$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $648caa49a6a38228$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$648caa49a6a38228$var$Buffer.prototype.writeUint8 = $648caa49a6a38228$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$648caa49a6a38228$var$Buffer.prototype.writeUint16LE = $648caa49a6a38228$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$648caa49a6a38228$var$Buffer.prototype.writeUint16BE = $648caa49a6a38228$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$648caa49a6a38228$var$Buffer.prototype.writeUint32LE = $648caa49a6a38228$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$648caa49a6a38228$var$Buffer.prototype.writeUint32BE = $648caa49a6a38228$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$648caa49a6a38228$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $648caa49a6a38228$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$648caa49a6a38228$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $648caa49a6a38228$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$648caa49a6a38228$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$648caa49a6a38228$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$648caa49a6a38228$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$648caa49a6a38228$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$648caa49a6a38228$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $648caa49a6a38228$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $648caa49a6a38228$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5leHq.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$648caa49a6a38228$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $648caa49a6a38228$var$writeFloat(this, value, offset, true, noAssert);
};
$648caa49a6a38228$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $648caa49a6a38228$var$writeFloat(this, value, offset, false, noAssert);
};
function $648caa49a6a38228$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $648caa49a6a38228$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5leHq.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$648caa49a6a38228$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $648caa49a6a38228$var$writeDouble(this, value, offset, true, noAssert);
};
$648caa49a6a38228$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $648caa49a6a38228$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$648caa49a6a38228$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$648caa49a6a38228$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$648caa49a6a38228$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$648caa49a6a38228$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $648caa49a6a38228$var$Buffer.isBuffer(val) ? val : $648caa49a6a38228$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $648caa49a6a38228$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $648caa49a6a38228$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($648caa49a6a38228$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $648caa49a6a38228$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $648caa49a6a38228$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $648caa49a6a38228$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $648caa49a6a38228$var$base64ToBytes(str) {
    return $hLdXZ.toByteArray($648caa49a6a38228$var$base64clean(str));
}
function $648caa49a6a38228$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $648caa49a6a38228$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $648caa49a6a38228$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $648caa49a6a38228$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hLdXZ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $cee1a8e6c973996f$export$d622b2ad8d90c771, (v) => $cee1a8e6c973996f$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $cee1a8e6c973996f$export$6100ba28696e12de, (v) => $cee1a8e6c973996f$export$6100ba28696e12de = v);
var $cee1a8e6c973996f$export$a48f0734ac7c2329;
var $cee1a8e6c973996f$export$d622b2ad8d90c771;
var $cee1a8e6c973996f$export$6100ba28696e12de;
'use strict';
$cee1a8e6c973996f$export$a48f0734ac7c2329 = $cee1a8e6c973996f$var$byteLength;
$cee1a8e6c973996f$export$d622b2ad8d90c771 = $cee1a8e6c973996f$var$toByteArray;
$cee1a8e6c973996f$export$6100ba28696e12de = $cee1a8e6c973996f$var$fromByteArray;
var $cee1a8e6c973996f$var$lookup = [];
var $cee1a8e6c973996f$var$revLookup = [];
var $cee1a8e6c973996f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $cee1a8e6c973996f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $cee1a8e6c973996f$var$i = 0, $cee1a8e6c973996f$var$len = $cee1a8e6c973996f$var$code.length; $cee1a8e6c973996f$var$i < $cee1a8e6c973996f$var$len; ++$cee1a8e6c973996f$var$i){
    $cee1a8e6c973996f$var$lookup[$cee1a8e6c973996f$var$i] = $cee1a8e6c973996f$var$code[$cee1a8e6c973996f$var$i];
    $cee1a8e6c973996f$var$revLookup[$cee1a8e6c973996f$var$code.charCodeAt($cee1a8e6c973996f$var$i)] = $cee1a8e6c973996f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$cee1a8e6c973996f$var$revLookup['-'.charCodeAt(0)] = 62;
$cee1a8e6c973996f$var$revLookup['_'.charCodeAt(0)] = 63;
function $cee1a8e6c973996f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $cee1a8e6c973996f$var$byteLength(b64) {
    var lens = $cee1a8e6c973996f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $cee1a8e6c973996f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $cee1a8e6c973996f$var$toByteArray(b64) {
    var tmp;
    var lens = $cee1a8e6c973996f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $cee1a8e6c973996f$var$Arr($cee1a8e6c973996f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i)] << 18 | $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i)] << 2 | $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i)] << 10 | $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $cee1a8e6c973996f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $cee1a8e6c973996f$var$tripletToBase64(num) {
    return $cee1a8e6c973996f$var$lookup[num >> 18 & 0x3F] + $cee1a8e6c973996f$var$lookup[num >> 12 & 0x3F] + $cee1a8e6c973996f$var$lookup[num >> 6 & 0x3F] + $cee1a8e6c973996f$var$lookup[num & 0x3F];
}
function $cee1a8e6c973996f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($cee1a8e6c973996f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $cee1a8e6c973996f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($cee1a8e6c973996f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($cee1a8e6c973996f$var$lookup[tmp >> 2] + $cee1a8e6c973996f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($cee1a8e6c973996f$var$lookup[tmp >> 10] + $cee1a8e6c973996f$var$lookup[tmp >> 4 & 0x3F] + $cee1a8e6c973996f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5leHq", function(module, exports) {

$parcel$export(module.exports, "read", () => $3e3a50f018786853$export$aafa59e2e03f2942, (v) => $3e3a50f018786853$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $3e3a50f018786853$export$68d8715fc104d294, (v) => $3e3a50f018786853$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $3e3a50f018786853$export$aafa59e2e03f2942;
var $3e3a50f018786853$export$68d8715fc104d294;
$3e3a50f018786853$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$3e3a50f018786853$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("3vL3Z", function(module, exports) {
exports = module.exports = Victor;
/**
 * # Victor - A JavaScript 2D vector class with methods for common vector operations
 */ /**
 * Constructor. Will also work without the `new` keyword
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = Victor(42, 1337);
 *
 * @param {Number} x Value of the x axis
 * @param {Number} y Value of the y axis
 * @return {Victor}
 * @api public
 */ function Victor(x, y) {
    if (!(this instanceof Victor)) return new Victor(x, y);
    /**
	 * The X axis
	 *
	 * ### Examples:
	 *     var vec = new Victor.fromArray(42, 21);
	 *
	 *     vec.x;
	 *     // => 42
	 *
	 * @api public
	 */ this.x = x || 0;
    /**
	 * The Y axis
	 *
	 * ### Examples:
	 *     var vec = new Victor.fromArray(42, 21);
	 *
	 *     vec.y;
	 *     // => 21
	 *
	 * @api public
	 */ this.y = y || 0;
}
/**
 * # Static
 */ /**
 * Creates a new instance from an array
 *
 * ### Examples:
 *     var vec = Victor.fromArray([42, 21]);
 *
 *     vec.toString();
 *     // => x:42, y:21
 *
 * @name Victor.fromArray
 * @param {Array} array Array with the x and y values at index 0 and 1 respectively
 * @return {Victor} The new instance
 * @api public
 */ Victor.fromArray = function(arr) {
    return new Victor(arr[0] || 0, arr[1] || 0);
};
/**
 * Creates a new instance from an object
 *
 * ### Examples:
 *     var vec = Victor.fromObject({ x: 42, y: 21 });
 *
 *     vec.toString();
 *     // => x:42, y:21
 *
 * @name Victor.fromObject
 * @param {Object} obj Object with the values for x and y
 * @return {Victor} The new instance
 * @api public
 */ Victor.fromObject = function(obj) {
    return new Victor(obj.x || 0, obj.y || 0);
};
/**
 * # Manipulation
 *
 * These functions are chainable.
 */ /**
 * Adds another vector's X axis to this one
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.addX(vec2);
 *     vec1.toString();
 *     // => x:30, y:10
 *
 * @param {Victor} vector The other vector you want to add to this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addX = function(vec) {
    this.x += vec.x;
    return this;
};
/**
 * Adds another vector's Y axis to this one
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.addY(vec2);
 *     vec1.toString();
 *     // => x:10, y:40
 *
 * @param {Victor} vector The other vector you want to add to this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addY = function(vec) {
    this.y += vec.y;
    return this;
};
/**
 * Adds another vector to this one
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.add(vec2);
 *     vec1.toString();
 *     // => x:30, y:40
 *
 * @param {Victor} vector The other vector you want to add to this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.add = function(vec) {
    this.x += vec.x;
    this.y += vec.y;
    return this;
};
/**
 * Adds the given scalar to both vector axis
 *
 * ### Examples:
 *     var vec = new Victor(1, 2);
 *
 *     vec.addScalar(2);
 *     vec.toString();
 *     // => x: 3, y: 4
 *
 * @param {Number} scalar The scalar to add
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addScalar = function(scalar) {
    this.x += scalar;
    this.y += scalar;
    return this;
};
/**
 * Adds the given scalar to the X axis
 *
 * ### Examples:
 *     var vec = new Victor(1, 2);
 *
 *     vec.addScalarX(2);
 *     vec.toString();
 *     // => x: 3, y: 2
 *
 * @param {Number} scalar The scalar to add
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addScalarX = function(scalar) {
    this.x += scalar;
    return this;
};
/**
 * Adds the given scalar to the Y axis
 *
 * ### Examples:
 *     var vec = new Victor(1, 2);
 *
 *     vec.addScalarY(2);
 *     vec.toString();
 *     // => x: 1, y: 4
 *
 * @param {Number} scalar The scalar to add
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addScalarY = function(scalar) {
    this.y += scalar;
    return this;
};
/**
 * Subtracts the X axis of another vector from this one
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.subtractX(vec2);
 *     vec1.toString();
 *     // => x:80, y:50
 *
 * @param {Victor} vector The other vector you want subtract from this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractX = function(vec) {
    this.x -= vec.x;
    return this;
};
/**
 * Subtracts the Y axis of another vector from this one
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.subtractY(vec2);
 *     vec1.toString();
 *     // => x:100, y:20
 *
 * @param {Victor} vector The other vector you want subtract from this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractY = function(vec) {
    this.y -= vec.y;
    return this;
};
/**
 * Subtracts another vector from this one
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.subtract(vec2);
 *     vec1.toString();
 *     // => x:80, y:20
 *
 * @param {Victor} vector The other vector you want subtract from this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtract = function(vec) {
    this.x -= vec.x;
    this.y -= vec.y;
    return this;
};
/**
 * Subtracts the given scalar from both axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 200);
 *
 *     vec.subtractScalar(20);
 *     vec.toString();
 *     // => x: 80, y: 180
 *
 * @param {Number} scalar The scalar to subtract
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractScalar = function(scalar) {
    this.x -= scalar;
    this.y -= scalar;
    return this;
};
/**
 * Subtracts the given scalar from the X axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 200);
 *
 *     vec.subtractScalarX(20);
 *     vec.toString();
 *     // => x: 80, y: 200
 *
 * @param {Number} scalar The scalar to subtract
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractScalarX = function(scalar) {
    this.x -= scalar;
    return this;
};
/**
 * Subtracts the given scalar from the Y axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 200);
 *
 *     vec.subtractScalarY(20);
 *     vec.toString();
 *     // => x: 100, y: 180
 *
 * @param {Number} scalar The scalar to subtract
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractScalarY = function(scalar) {
    this.y -= scalar;
    return this;
};
/**
 * Divides the X axis by the x component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 0);
 *
 *     vec.divideX(vec2);
 *     vec.toString();
 *     // => x:50, y:50
 *
 * @param {Victor} vector The other vector you want divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideX = function(vector) {
    this.x /= vector.x;
    return this;
};
/**
 * Divides the Y axis by the y component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(0, 2);
 *
 *     vec.divideY(vec2);
 *     vec.toString();
 *     // => x:100, y:25
 *
 * @param {Victor} vector The other vector you want divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideY = function(vector) {
    this.y /= vector.y;
    return this;
};
/**
 * Divides both vector axis by a axis values of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 2);
 *
 *     vec.divide(vec2);
 *     vec.toString();
 *     // => x:50, y:25
 *
 * @param {Victor} vector The vector to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divide = function(vector) {
    this.x /= vector.x;
    this.y /= vector.y;
    return this;
};
/**
 * Divides both vector axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.divideScalar(2);
 *     vec.toString();
 *     // => x:50, y:25
 *
 * @param {Number} The scalar to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideScalar = function(scalar) {
    if (scalar !== 0) {
        this.x /= scalar;
        this.y /= scalar;
    } else {
        this.x = 0;
        this.y = 0;
    }
    return this;
};
/**
 * Divides the X axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.divideScalarX(2);
 *     vec.toString();
 *     // => x:50, y:50
 *
 * @param {Number} The scalar to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideScalarX = function(scalar) {
    if (scalar !== 0) this.x /= scalar;
    else this.x = 0;
    return this;
};
/**
 * Divides the Y axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.divideScalarY(2);
 *     vec.toString();
 *     // => x:100, y:25
 *
 * @param {Number} The scalar to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideScalarY = function(scalar) {
    if (scalar !== 0) this.y /= scalar;
    else this.y = 0;
    return this;
};
/**
 * Inverts the X axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.invertX();
 *     vec.toString();
 *     // => x:-100, y:50
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.invertX = function() {
    this.x *= -1;
    return this;
};
/**
 * Inverts the Y axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.invertY();
 *     vec.toString();
 *     // => x:100, y:-50
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.invertY = function() {
    this.y *= -1;
    return this;
};
/**
 * Inverts both axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.invert();
 *     vec.toString();
 *     // => x:-100, y:-50
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.invert = function() {
    this.invertX();
    this.invertY();
    return this;
};
/**
 * Multiplies the X axis by X component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 0);
 *
 *     vec.multiplyX(vec2);
 *     vec.toString();
 *     // => x:200, y:50
 *
 * @param {Victor} vector The vector to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyX = function(vector) {
    this.x *= vector.x;
    return this;
};
/**
 * Multiplies the Y axis by Y component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(0, 2);
 *
 *     vec.multiplyX(vec2);
 *     vec.toString();
 *     // => x:100, y:100
 *
 * @param {Victor} vector The vector to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyY = function(vector) {
    this.y *= vector.y;
    return this;
};
/**
 * Multiplies both vector axis by values from a given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 2);
 *
 *     vec.multiply(vec2);
 *     vec.toString();
 *     // => x:200, y:100
 *
 * @param {Victor} vector The vector to multiply by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiply = function(vector) {
    this.x *= vector.x;
    this.y *= vector.y;
    return this;
};
/**
 * Multiplies both vector axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.multiplyScalar(2);
 *     vec.toString();
 *     // => x:200, y:100
 *
 * @param {Number} The scalar to multiply by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyScalar = function(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
};
/**
 * Multiplies the X axis by the given scalar
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.multiplyScalarX(2);
 *     vec.toString();
 *     // => x:200, y:50
 *
 * @param {Number} The scalar to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyScalarX = function(scalar) {
    this.x *= scalar;
    return this;
};
/**
 * Multiplies the Y axis by the given scalar
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.multiplyScalarY(2);
 *     vec.toString();
 *     // => x:100, y:100
 *
 * @param {Number} The scalar to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyScalarY = function(scalar) {
    this.y *= scalar;
    return this;
};
/**
 * Normalize
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.normalize = function() {
    var length = this.length();
    if (length === 0) {
        this.x = 1;
        this.y = 0;
    } else this.divide(Victor(length, length));
    return this;
};
Victor.prototype.norm = Victor.prototype.normalize;
/**
 * If the absolute vector axis is greater than `max`, multiplies the axis by `factor`
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.limit(80, 0.9);
 *     vec.toString();
 *     // => x:90, y:50
 *
 * @param {Number} max The maximum value for both x and y axis
 * @param {Number} factor Factor by which the axis are to be multiplied with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.limit = function(max, factor) {
    if (Math.abs(this.x) > max) this.x *= factor;
    if (Math.abs(this.y) > max) this.y *= factor;
    return this;
};
/**
 * Randomizes both vector axis with a value between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomize(new Victor(50, 60), new Victor(70, 80`));
 *     vec.toString();
 *     // => x:67, y:73
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomize = function(topLeft, bottomRight) {
    this.randomizeX(topLeft, bottomRight);
    this.randomizeY(topLeft, bottomRight);
    return this;
};
/**
 * Randomizes the y axis with a value between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomizeX(new Victor(50, 60), new Victor(70, 80`));
 *     vec.toString();
 *     // => x:55, y:50
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomizeX = function(topLeft, bottomRight) {
    var min = Math.min(topLeft.x, bottomRight.x);
    var max = Math.max(topLeft.x, bottomRight.x);
    this.x = random(min, max);
    return this;
};
/**
 * Randomizes the y axis with a value between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomizeY(new Victor(50, 60), new Victor(70, 80`));
 *     vec.toString();
 *     // => x:100, y:66
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomizeY = function(topLeft, bottomRight) {
    var min = Math.min(topLeft.y, bottomRight.y);
    var max = Math.max(topLeft.y, bottomRight.y);
    this.y = random(min, max);
    return this;
};
/**
 * Randomly randomizes either axis between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomizeAny(new Victor(50, 60), new Victor(70, 80));
 *     vec.toString();
 *     // => x:100, y:77
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomizeAny = function(topLeft, bottomRight) {
    if (!!Math.round(Math.random())) this.randomizeX(topLeft, bottomRight);
    else this.randomizeY(topLeft, bottomRight);
    return this;
};
/**
 * Rounds both axis to an integer value
 *
 * ### Examples:
 *     var vec = new Victor(100.2, 50.9);
 *
 *     vec.unfloat();
 *     vec.toString();
 *     // => x:100, y:51
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.unfloat = function() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
};
/**
 * Rounds both axis to a certain precision
 *
 * ### Examples:
 *     var vec = new Victor(100.2, 50.9);
 *
 *     vec.unfloat();
 *     vec.toString();
 *     // => x:100, y:51
 *
 * @param {Number} Precision (default: 8)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.toFixed = function(precision) {
    if (typeof precision === 'undefined') precision = 8;
    this.x = this.x.toFixed(precision);
    this.y = this.y.toFixed(precision);
    return this;
};
/**
 * Performs a linear blend / interpolation of the X axis towards another vector
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 100);
 *     var vec2 = new Victor(200, 200);
 *
 *     vec1.mixX(vec2, 0.5);
 *     vec.toString();
 *     // => x:150, y:100
 *
 * @param {Victor} vector The other vector
 * @param {Number} amount The blend amount (optional, default: 0.5)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.mixX = function(vec, amount) {
    if (typeof amount === 'undefined') amount = 0.5;
    this.x = (1 - amount) * this.x + amount * vec.x;
    return this;
};
/**
 * Performs a linear blend / interpolation of the Y axis towards another vector
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 100);
 *     var vec2 = new Victor(200, 200);
 *
 *     vec1.mixY(vec2, 0.5);
 *     vec.toString();
 *     // => x:100, y:150
 *
 * @param {Victor} vector The other vector
 * @param {Number} amount The blend amount (optional, default: 0.5)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.mixY = function(vec, amount) {
    if (typeof amount === 'undefined') amount = 0.5;
    this.y = (1 - amount) * this.y + amount * vec.y;
    return this;
};
/**
 * Performs a linear blend / interpolation towards another vector
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 100);
 *     var vec2 = new Victor(200, 200);
 *
 *     vec1.mix(vec2, 0.5);
 *     vec.toString();
 *     // => x:150, y:150
 *
 * @param {Victor} vector The other vector
 * @param {Number} amount The blend amount (optional, default: 0.5)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.mix = function(vec, amount) {
    this.mixX(vec, amount);
    this.mixY(vec, amount);
    return this;
};
/**
 * # Products
 */ /**
 * Creates a clone of this vector
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = vec1.clone();
 *
 *     vec2.toString();
 *     // => x:10, y:10
 *
 * @return {Victor} A clone of the vector
 * @api public
 */ Victor.prototype.clone = function() {
    return new Victor(this.x, this.y);
};
/**
 * Copies another vector's X component in to its own
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 20);
 *     var vec2 = vec1.copyX(vec1);
 *
 *     vec2.toString();
 *     // => x:20, y:10
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.copyX = function(vec) {
    this.x = vec.x;
    return this;
};
/**
 * Copies another vector's Y component in to its own
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 20);
 *     var vec2 = vec1.copyY(vec1);
 *
 *     vec2.toString();
 *     // => x:10, y:20
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.copyY = function(vec) {
    this.y = vec.y;
    return this;
};
/**
 * Copies another vector's X and Y components in to its own
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 20);
 *     var vec2 = vec1.copy(vec1);
 *
 *     vec2.toString();
 *     // => x:20, y:20
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.copy = function(vec) {
    this.copyX(vec);
    this.copyY(vec);
    return this;
};
/**
 * Sets the vector to zero (0,0)
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *		 var1.zero();
 *     vec1.toString();
 *     // => x:0, y:0
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.zero = function() {
    this.x = this.y = 0;
    return this;
};
/**
 * Calculates the dot product of this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.dot(vec2);
 *     // => 23000
 *
 * @param {Victor} vector The second vector
 * @return {Number} Dot product
 * @api public
 */ Victor.prototype.dot = function(vec2) {
    return this.x * vec2.x + this.y * vec2.y;
};
Victor.prototype.cross = function(vec2) {
    return this.x * vec2.y - this.y * vec2.x;
};
/**
 * Projects a vector onto another vector, setting itself to the result.
 *
 * ### Examples:
 *     var vec = new Victor(100, 0);
 *     var vec2 = new Victor(100, 100);
 *
 *     vec.projectOnto(vec2);
 *     vec.toString();
 *     // => x:50, y:50
 *
 * @param {Victor} vector The other vector you want to project this vector onto
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.projectOnto = function(vec2) {
    var coeff = (this.x * vec2.x + this.y * vec2.y) / (vec2.x * vec2.x + vec2.y * vec2.y);
    this.x = coeff * vec2.x;
    this.y = coeff * vec2.y;
    return this;
};
Victor.prototype.horizontalAngle = function() {
    return Math.atan2(this.y, this.x);
};
Victor.prototype.horizontalAngleDeg = function() {
    return radian2degrees(this.horizontalAngle());
};
Victor.prototype.verticalAngle = function() {
    return Math.atan2(this.x, this.y);
};
Victor.prototype.verticalAngleDeg = function() {
    return radian2degrees(this.verticalAngle());
};
Victor.prototype.angle = Victor.prototype.horizontalAngle;
Victor.prototype.angleDeg = Victor.prototype.horizontalAngleDeg;
Victor.prototype.direction = Victor.prototype.horizontalAngle;
Victor.prototype.rotate = function(angle) {
    var nx = this.x * Math.cos(angle) - this.y * Math.sin(angle);
    var ny = this.x * Math.sin(angle) + this.y * Math.cos(angle);
    this.x = nx;
    this.y = ny;
    return this;
};
Victor.prototype.rotateDeg = function(angle) {
    angle = degrees2radian(angle);
    return this.rotate(angle);
};
Victor.prototype.rotateTo = function(rotation) {
    return this.rotate(rotation - this.angle());
};
Victor.prototype.rotateToDeg = function(rotation) {
    rotation = degrees2radian(rotation);
    return this.rotateTo(rotation);
};
Victor.prototype.rotateBy = function(rotation) {
    var angle = this.angle() + rotation;
    return this.rotate(angle);
};
Victor.prototype.rotateByDeg = function(rotation) {
    rotation = degrees2radian(rotation);
    return this.rotateBy(rotation);
};
/**
 * Calculates the distance of the X axis between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceX(vec2);
 *     // => -100
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distanceX = function(vec) {
    return this.x - vec.x;
};
/**
 * Same as `distanceX()` but always returns an absolute number
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.absDistanceX(vec2);
 *     // => 100
 *
 * @param {Victor} vector The second vector
 * @return {Number} Absolute distance
 * @api public
 */ Victor.prototype.absDistanceX = function(vec) {
    return Math.abs(this.distanceX(vec));
};
/**
 * Calculates the distance of the Y axis between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceY(vec2);
 *     // => -10
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distanceY = function(vec) {
    return this.y - vec.y;
};
/**
 * Same as `distanceY()` but always returns an absolute number
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceY(vec2);
 *     // => 10
 *
 * @param {Victor} vector The second vector
 * @return {Number} Absolute distance
 * @api public
 */ Victor.prototype.absDistanceY = function(vec) {
    return Math.abs(this.distanceY(vec));
};
/**
 * Calculates the euclidean distance between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distance(vec2);
 *     // => 100.4987562112089
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distance = function(vec) {
    return Math.sqrt(this.distanceSq(vec));
};
/**
 * Calculates the squared euclidean distance between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceSq(vec2);
 *     // => 10100
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distanceSq = function(vec) {
    var dx = this.distanceX(vec), dy = this.distanceY(vec);
    return dx * dx + dy * dy;
};
/**
 * Calculates the length or magnitude of the vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.length();
 *     // => 111.80339887498948
 *
 * @return {Number} Length / Magnitude
 * @api public
 */ Victor.prototype.length = function() {
    return Math.sqrt(this.lengthSq());
};
/**
 * Squared length / magnitude
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.lengthSq();
 *     // => 12500
 *
 * @return {Number} Length / Magnitude
 * @api public
 */ Victor.prototype.lengthSq = function() {
    return this.x * this.x + this.y * this.y;
};
Victor.prototype.magnitude = Victor.prototype.length;
/**
 * Returns a true if vector is (0, 0)
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     vec.zero();
 *
 *     // => true
 *
 * @return {Boolean}
 * @api public
 */ Victor.prototype.isZero = function() {
    return this.x === 0 && this.y === 0;
};
/**
 * Returns a true if this vector is the same as another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(100, 50);
 *     vec1.isEqualTo(vec2);
 *
 *     // => true
 *
 * @return {Boolean}
 * @api public
 */ Victor.prototype.isEqualTo = function(vec2) {
    return this.x === vec2.x && this.y === vec2.y;
};
/**
 * # Utility Methods
 */ /**
 * Returns an string representation of the vector
 *
 * ### Examples:
 *     var vec = new Victor(10, 20);
 *
 *     vec.toString();
 *     // => x:10, y:20
 *
 * @return {String}
 * @api public
 */ Victor.prototype.toString = function() {
    return 'x:' + this.x + ', y:' + this.y;
};
/**
 * Returns an array representation of the vector
 *
 * ### Examples:
 *     var vec = new Victor(10, 20);
 *
 *     vec.toArray();
 *     // => [10, 20]
 *
 * @return {Array}
 * @api public
 */ Victor.prototype.toArray = function() {
    return [
        this.x,
        this.y
    ];
};
/**
 * Returns an object representation of the vector
 *
 * ### Examples:
 *     var vec = new Victor(10, 20);
 *
 *     vec.toObject();
 *     // => { x: 10, y: 20 }
 *
 * @return {Object}
 * @api public
 */ Victor.prototype.toObject = function() {
    return {
        x: this.x,
        y: this.y
    };
};
var degrees = 180 / Math.PI;
function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function radian2degrees(rad) {
    return rad * degrees;
}
function degrees2radian(deg) {
    return deg / degrees;
}

});

parcelRegister("fmTEa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("fT7Me")).default);
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $fT7Me = parcelRequire("fT7Me");

var $cZZK1 = parcelRequire("cZZK1");
$parcel$exportWildcard(module.exports, $cZZK1);

});
parcelRegister("fT7Me", function(module, exports) {

$parcel$export(module.exports, "default", () => $b912066519bd972a$export$2e2bcd8739ae039);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("cZZK1");
var $eI42i = parcelRequire("eI42i");
var $cZZK1 = parcelRequire("cZZK1");
// Add all of the Underscore functions to the wrapper object.
var $b912066519bd972a$var$_ = (0, $eI42i.default)($cZZK1);
// Legacy Node.js API.
$b912066519bd972a$var$_._ = $b912066519bd972a$var$_;
var // Export the Underscore API.
$b912066519bd972a$export$2e2bcd8739ae039 = $b912066519bd972a$var$_;

});
parcelRegister("cZZK1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", () => (parcelRequire("dLKuc")).VERSION);
$parcel$export(module.exports, "restArguments", () => (parcelRequire("h3syS")).default);
$parcel$export(module.exports, "isObject", () => (parcelRequire("h8Zr6")).default);
$parcel$export(module.exports, "isNull", () => (parcelRequire("18kZG")).default);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("eYJ68")).default);
$parcel$export(module.exports, "isBoolean", () => (parcelRequire("cMCe8")).default);
$parcel$export(module.exports, "isElement", () => (parcelRequire("4TdqA")).default);
$parcel$export(module.exports, "isString", () => (parcelRequire("2p9gC")).default);
$parcel$export(module.exports, "isNumber", () => (parcelRequire("a1Kf4")).default);
$parcel$export(module.exports, "isDate", () => (parcelRequire("8vvky")).default);
$parcel$export(module.exports, "isRegExp", () => (parcelRequire("g8ZId")).default);
$parcel$export(module.exports, "isError", () => (parcelRequire("hwyyW")).default);
$parcel$export(module.exports, "isSymbol", () => (parcelRequire("9HqAx")).default);
$parcel$export(module.exports, "isArrayBuffer", () => (parcelRequire("8U7HM")).default);
$parcel$export(module.exports, "isDataView", () => (parcelRequire("7znjo")).default);
$parcel$export(module.exports, "isArray", () => (parcelRequire("2wtAn")).default);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("44lMV")).default);
$parcel$export(module.exports, "isArguments", () => (parcelRequire("2metK")).default);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("k8wT0")).default);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("3BXSp")).default);
$parcel$export(module.exports, "isTypedArray", () => (parcelRequire("1iw1M")).default);
$parcel$export(module.exports, "isEmpty", () => (parcelRequire("a7Lcu")).default);
$parcel$export(module.exports, "isMatch", () => (parcelRequire("lLhKI")).default);
$parcel$export(module.exports, "isEqual", () => (parcelRequire("fqtqt")).default);
$parcel$export(module.exports, "isMap", () => (parcelRequire("ioQtQ")).default);
$parcel$export(module.exports, "isWeakMap", () => (parcelRequire("gfEIF")).default);
$parcel$export(module.exports, "isSet", () => (parcelRequire("du1qT")).default);
$parcel$export(module.exports, "isWeakSet", () => (parcelRequire("cRhxP")).default);
$parcel$export(module.exports, "keys", () => (parcelRequire("jdwHQ")).default);
$parcel$export(module.exports, "allKeys", () => (parcelRequire("a958q")).default);
$parcel$export(module.exports, "values", () => (parcelRequire("3bYdr")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("6JKbF")).default);
$parcel$export(module.exports, "invert", () => (parcelRequire("9AGgi")).default);
$parcel$export(module.exports, "functions", () => (parcelRequire("c81pn")).default);
$parcel$export(module.exports, "methods", () => (parcelRequire("c81pn")).default);
$parcel$export(module.exports, "extend", () => (parcelRequire("a4yWg")).default);
$parcel$export(module.exports, "extendOwn", () => (parcelRequire("2ZWtN")).default);
$parcel$export(module.exports, "assign", () => (parcelRequire("2ZWtN")).default);
$parcel$export(module.exports, "defaults", () => (parcelRequire("aTgF3")).default);
$parcel$export(module.exports, "create", () => (parcelRequire("jNvSj")).default);
$parcel$export(module.exports, "clone", () => (parcelRequire("bgQ6c")).default);
$parcel$export(module.exports, "tap", () => (parcelRequire("91UkY")).default);
$parcel$export(module.exports, "get", () => (parcelRequire("b8o6h")).default);
$parcel$export(module.exports, "has", () => (parcelRequire("gFX6V")).default);
$parcel$export(module.exports, "mapObject", () => (parcelRequire("6LlVq")).default);
$parcel$export(module.exports, "identity", () => (parcelRequire("baXZx")).default);
$parcel$export(module.exports, "constant", () => (parcelRequire("cBCbl")).default);
$parcel$export(module.exports, "noop", () => (parcelRequire("7sjtc")).default);
$parcel$export(module.exports, "toPath", () => (parcelRequire("kj7DN")).default);
$parcel$export(module.exports, "property", () => (parcelRequire("evEHH")).default);
$parcel$export(module.exports, "propertyOf", () => (parcelRequire("3JiCT")).default);
$parcel$export(module.exports, "matcher", () => (parcelRequire("fQb5K")).default);
$parcel$export(module.exports, "matches", () => (parcelRequire("fQb5K")).default);
$parcel$export(module.exports, "times", () => (parcelRequire("6zv16")).default);
$parcel$export(module.exports, "random", () => (parcelRequire("9yGwN")).default);
$parcel$export(module.exports, "now", () => (parcelRequire("gy6Vo")).default);
$parcel$export(module.exports, "escape", () => (parcelRequire("8nGHq")).default);
$parcel$export(module.exports, "unescape", () => (parcelRequire("elsMI")).default);
$parcel$export(module.exports, "templateSettings", () => (parcelRequire("6PJ2Z")).default);
$parcel$export(module.exports, "template", () => (parcelRequire("9L3Xb")).default);
$parcel$export(module.exports, "result", () => (parcelRequire("aPopu")).default);
$parcel$export(module.exports, "uniqueId", () => (parcelRequire("7Lukp")).default);
$parcel$export(module.exports, "chain", () => (parcelRequire("b6qzH")).default);
$parcel$export(module.exports, "iteratee", () => (parcelRequire("j7ucl")).default);
$parcel$export(module.exports, "partial", () => (parcelRequire("esv10")).default);
$parcel$export(module.exports, "bind", () => (parcelRequire("kC4Di")).default);
$parcel$export(module.exports, "bindAll", () => (parcelRequire("jTntB")).default);
$parcel$export(module.exports, "memoize", () => (parcelRequire("jCdTn")).default);
$parcel$export(module.exports, "delay", () => (parcelRequire("l03hq")).default);
$parcel$export(module.exports, "defer", () => (parcelRequire("3kUNh")).default);
$parcel$export(module.exports, "throttle", () => (parcelRequire("k7L26")).default);
$parcel$export(module.exports, "debounce", () => (parcelRequire("6xVmO")).default);
$parcel$export(module.exports, "wrap", () => (parcelRequire("d9w0P")).default);
$parcel$export(module.exports, "negate", () => (parcelRequire("4i6ZQ")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("6wDn1")).default);
$parcel$export(module.exports, "after", () => (parcelRequire("3gLmM")).default);
$parcel$export(module.exports, "before", () => (parcelRequire("7VJby")).default);
$parcel$export(module.exports, "once", () => (parcelRequire("hw1dL")).default);
$parcel$export(module.exports, "findKey", () => (parcelRequire("c8gTp")).default);
$parcel$export(module.exports, "findIndex", () => (parcelRequire("aLdQR")).default);
$parcel$export(module.exports, "findLastIndex", () => (parcelRequire("4Uweu")).default);
$parcel$export(module.exports, "sortedIndex", () => (parcelRequire("7xlCj")).default);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("hmVSZ")).default);
$parcel$export(module.exports, "lastIndexOf", () => (parcelRequire("9L0nd")).default);
$parcel$export(module.exports, "find", () => (parcelRequire("4TeC4")).default);
$parcel$export(module.exports, "detect", () => (parcelRequire("4TeC4")).default);
$parcel$export(module.exports, "findWhere", () => (parcelRequire("9ZLI3")).default);
$parcel$export(module.exports, "each", () => (parcelRequire("6BCJr")).default);
$parcel$export(module.exports, "forEach", () => (parcelRequire("6BCJr")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("dCj5c")).default);
$parcel$export(module.exports, "collect", () => (parcelRequire("dCj5c")).default);
$parcel$export(module.exports, "reduce", () => (parcelRequire("cJifR")).default);
$parcel$export(module.exports, "foldl", () => (parcelRequire("cJifR")).default);
$parcel$export(module.exports, "inject", () => (parcelRequire("cJifR")).default);
$parcel$export(module.exports, "reduceRight", () => (parcelRequire("c1J1C")).default);
$parcel$export(module.exports, "foldr", () => (parcelRequire("c1J1C")).default);
$parcel$export(module.exports, "filter", () => (parcelRequire("lpWdV")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("lpWdV")).default);
$parcel$export(module.exports, "reject", () => (parcelRequire("6QtQF")).default);
$parcel$export(module.exports, "every", () => (parcelRequire("dSuIk")).default);
$parcel$export(module.exports, "all", () => (parcelRequire("dSuIk")).default);
$parcel$export(module.exports, "some", () => (parcelRequire("74eBK")).default);
$parcel$export(module.exports, "any", () => (parcelRequire("74eBK")).default);
$parcel$export(module.exports, "contains", () => (parcelRequire("liuPn")).default);
$parcel$export(module.exports, "includes", () => (parcelRequire("liuPn")).default);
$parcel$export(module.exports, "include", () => (parcelRequire("liuPn")).default);
$parcel$export(module.exports, "invoke", () => (parcelRequire("coSxW")).default);
$parcel$export(module.exports, "pluck", () => (parcelRequire("lP78i")).default);
$parcel$export(module.exports, "where", () => (parcelRequire("lEDu0")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("GIhLa")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("5s80w")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("bb8Y0")).default);
$parcel$export(module.exports, "sample", () => (parcelRequire("gq8G9")).default);
$parcel$export(module.exports, "sortBy", () => (parcelRequire("lBDMU")).default);
$parcel$export(module.exports, "groupBy", () => (parcelRequire("jVDF1")).default);
$parcel$export(module.exports, "indexBy", () => (parcelRequire("haiqc")).default);
$parcel$export(module.exports, "countBy", () => (parcelRequire("672iw")).default);
$parcel$export(module.exports, "partition", () => (parcelRequire("777nt")).default);
$parcel$export(module.exports, "toArray", () => (parcelRequire("5SVFE")).default);
$parcel$export(module.exports, "size", () => (parcelRequire("3tuwZ")).default);
$parcel$export(module.exports, "pick", () => (parcelRequire("5MYdb")).default);
$parcel$export(module.exports, "omit", () => (parcelRequire("6mL1r")).default);
$parcel$export(module.exports, "first", () => (parcelRequire("hgSYG")).default);
$parcel$export(module.exports, "head", () => (parcelRequire("hgSYG")).default);
$parcel$export(module.exports, "take", () => (parcelRequire("hgSYG")).default);
$parcel$export(module.exports, "initial", () => (parcelRequire("1c8bS")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("dzRqN")).default);
$parcel$export(module.exports, "rest", () => (parcelRequire("4xVcg")).default);
$parcel$export(module.exports, "tail", () => (parcelRequire("4xVcg")).default);
$parcel$export(module.exports, "drop", () => (parcelRequire("4xVcg")).default);
$parcel$export(module.exports, "compact", () => (parcelRequire("iuOZr")).default);
$parcel$export(module.exports, "flatten", () => (parcelRequire("24mPh")).default);
$parcel$export(module.exports, "without", () => (parcelRequire("7PadH")).default);
$parcel$export(module.exports, "uniq", () => (parcelRequire("hTqtq")).default);
$parcel$export(module.exports, "unique", () => (parcelRequire("hTqtq")).default);
$parcel$export(module.exports, "union", () => (parcelRequire("876Ln")).default);
$parcel$export(module.exports, "intersection", () => (parcelRequire("2A87p")).default);
$parcel$export(module.exports, "difference", () => (parcelRequire("hwkCa")).default);
$parcel$export(module.exports, "unzip", () => (parcelRequire("dtwWO")).default);
$parcel$export(module.exports, "transpose", () => (parcelRequire("dtwWO")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("di7s8")).default);
$parcel$export(module.exports, "object", () => (parcelRequire("5ZnU3")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("1GzEv")).default);
$parcel$export(module.exports, "chunk", () => (parcelRequire("ksicB")).default);
$parcel$export(module.exports, "mixin", () => (parcelRequire("eI42i")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("fQUMC")).default);
// Named Exports
// =============
//     Underscore.js 1.13.8
//     https://underscorejs.org
//     (c) 2009-2026 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $dLKuc = parcelRequire("dLKuc");

var $h3syS = parcelRequire("h3syS");

var $h8Zr6 = parcelRequire("h8Zr6");

var $18kZG = parcelRequire("18kZG");

var $eYJ68 = parcelRequire("eYJ68");

var $cMCe8 = parcelRequire("cMCe8");

var $4TdqA = parcelRequire("4TdqA");

var $2p9gC = parcelRequire("2p9gC");

var $a1Kf4 = parcelRequire("a1Kf4");

var $8vvky = parcelRequire("8vvky");

var $g8ZId = parcelRequire("g8ZId");

var $hwyyW = parcelRequire("hwyyW");

var $9HqAx = parcelRequire("9HqAx");

var $8U7HM = parcelRequire("8U7HM");

var $7znjo = parcelRequire("7znjo");

var $2wtAn = parcelRequire("2wtAn");

var $44lMV = parcelRequire("44lMV");

var $2metK = parcelRequire("2metK");

var $k8wT0 = parcelRequire("k8wT0");

var $3BXSp = parcelRequire("3BXSp");

var $1iw1M = parcelRequire("1iw1M");

var $a7Lcu = parcelRequire("a7Lcu");

var $lLhKI = parcelRequire("lLhKI");

var $fqtqt = parcelRequire("fqtqt");

var $ioQtQ = parcelRequire("ioQtQ");

var $gfEIF = parcelRequire("gfEIF");

var $du1qT = parcelRequire("du1qT");

var $cRhxP = parcelRequire("cRhxP");

var $jdwHQ = parcelRequire("jdwHQ");

var $a958q = parcelRequire("a958q");

var $3bYdr = parcelRequire("3bYdr");

var $6JKbF = parcelRequire("6JKbF");

var $9AGgi = parcelRequire("9AGgi");

var $c81pn = parcelRequire("c81pn");

var $a4yWg = parcelRequire("a4yWg");

var $2ZWtN = parcelRequire("2ZWtN");

var $aTgF3 = parcelRequire("aTgF3");

var $jNvSj = parcelRequire("jNvSj");

var $bgQ6c = parcelRequire("bgQ6c");

var $91UkY = parcelRequire("91UkY");

var $b8o6h = parcelRequire("b8o6h");

var $gFX6V = parcelRequire("gFX6V");

var $6LlVq = parcelRequire("6LlVq");

var $baXZx = parcelRequire("baXZx");

var $cBCbl = parcelRequire("cBCbl");

var $7sjtc = parcelRequire("7sjtc");

var $kj7DN = parcelRequire("kj7DN");

var $evEHH = parcelRequire("evEHH");

var $3JiCT = parcelRequire("3JiCT");

var $fQb5K = parcelRequire("fQb5K");

var $6zv16 = parcelRequire("6zv16");

var $9yGwN = parcelRequire("9yGwN");

var $gy6Vo = parcelRequire("gy6Vo");

var $8nGHq = parcelRequire("8nGHq");

var $elsMI = parcelRequire("elsMI");

var $6PJ2Z = parcelRequire("6PJ2Z");

var $9L3Xb = parcelRequire("9L3Xb");

var $aPopu = parcelRequire("aPopu");

var $7Lukp = parcelRequire("7Lukp");

var $b6qzH = parcelRequire("b6qzH");

var $j7ucl = parcelRequire("j7ucl");

var $esv10 = parcelRequire("esv10");

var $kC4Di = parcelRequire("kC4Di");

var $jTntB = parcelRequire("jTntB");

var $jCdTn = parcelRequire("jCdTn");

var $l03hq = parcelRequire("l03hq");

var $3kUNh = parcelRequire("3kUNh");

var $k7L26 = parcelRequire("k7L26");

var $6xVmO = parcelRequire("6xVmO");

var $d9w0P = parcelRequire("d9w0P");

var $4i6ZQ = parcelRequire("4i6ZQ");

var $6wDn1 = parcelRequire("6wDn1");

var $3gLmM = parcelRequire("3gLmM");

var $7VJby = parcelRequire("7VJby");

var $hw1dL = parcelRequire("hw1dL");

var $c8gTp = parcelRequire("c8gTp");

var $aLdQR = parcelRequire("aLdQR");

var $4Uweu = parcelRequire("4Uweu");

var $7xlCj = parcelRequire("7xlCj");

var $hmVSZ = parcelRequire("hmVSZ");

var $9L0nd = parcelRequire("9L0nd");

var $4TeC4 = parcelRequire("4TeC4");

var $9ZLI3 = parcelRequire("9ZLI3");

var $6BCJr = parcelRequire("6BCJr");

var $dCj5c = parcelRequire("dCj5c");

var $cJifR = parcelRequire("cJifR");

var $c1J1C = parcelRequire("c1J1C");

var $lpWdV = parcelRequire("lpWdV");

var $6QtQF = parcelRequire("6QtQF");

var $dSuIk = parcelRequire("dSuIk");

var $74eBK = parcelRequire("74eBK");

var $liuPn = parcelRequire("liuPn");

var $coSxW = parcelRequire("coSxW");

var $lP78i = parcelRequire("lP78i");

var $lEDu0 = parcelRequire("lEDu0");

var $GIhLa = parcelRequire("GIhLa");

var $5s80w = parcelRequire("5s80w");

var $bb8Y0 = parcelRequire("bb8Y0");

var $gq8G9 = parcelRequire("gq8G9");

var $lBDMU = parcelRequire("lBDMU");

var $jVDF1 = parcelRequire("jVDF1");

var $haiqc = parcelRequire("haiqc");

var $672iw = parcelRequire("672iw");

var $777nt = parcelRequire("777nt");

var $5SVFE = parcelRequire("5SVFE");

var $3tuwZ = parcelRequire("3tuwZ");

var $5MYdb = parcelRequire("5MYdb");

var $6mL1r = parcelRequire("6mL1r");

var $hgSYG = parcelRequire("hgSYG");

var $1c8bS = parcelRequire("1c8bS");

var $dzRqN = parcelRequire("dzRqN");

var $4xVcg = parcelRequire("4xVcg");

var $iuOZr = parcelRequire("iuOZr");

var $24mPh = parcelRequire("24mPh");

var $7PadH = parcelRequire("7PadH");

var $hTqtq = parcelRequire("hTqtq");

var $876Ln = parcelRequire("876Ln");

var $2A87p = parcelRequire("2A87p");

var $hwkCa = parcelRequire("hwkCa");

var $dtwWO = parcelRequire("dtwWO");

var $di7s8 = parcelRequire("di7s8");

var $5ZnU3 = parcelRequire("5ZnU3");

var $1GzEv = parcelRequire("1GzEv");

var $ksicB = parcelRequire("ksicB");

var $eI42i = parcelRequire("eI42i");

var $fQUMC = parcelRequire("fQUMC");

});
parcelRegister("dLKuc", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $a063b94f714ec490$export$a4ad2735b021c132);
$parcel$export(module.exports, "root", () => $a063b94f714ec490$export$e8e78c978b129247);
$parcel$export(module.exports, "ArrayProto", () => $a063b94f714ec490$export$aabeece9448a227a);
$parcel$export(module.exports, "ObjProto", () => $a063b94f714ec490$export$e77bb59b5e655b3d);
$parcel$export(module.exports, "SymbolProto", () => $a063b94f714ec490$export$e229dcb397ceea81);
$parcel$export(module.exports, "push", () => $a063b94f714ec490$export$4cbf152802aa238);
$parcel$export(module.exports, "slice", () => $a063b94f714ec490$export$58adb3bec8346d0f);
$parcel$export(module.exports, "toString", () => $a063b94f714ec490$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "hasOwnProperty", () => $a063b94f714ec490$export$5a15a386532a5ea4);
$parcel$export(module.exports, "supportsArrayBuffer", () => $a063b94f714ec490$export$20eaf89d899ede58);
$parcel$export(module.exports, "supportsDataView", () => $a063b94f714ec490$export$a2e478ad34dac33e);
$parcel$export(module.exports, "nativeIsArray", () => $a063b94f714ec490$export$552cf9b635cef256);
$parcel$export(module.exports, "nativeKeys", () => $a063b94f714ec490$export$e676cf06d7fd2114);
$parcel$export(module.exports, "nativeCreate", () => $a063b94f714ec490$export$5b53dc95b548c58c);
$parcel$export(module.exports, "nativeIsView", () => $a063b94f714ec490$export$35fc70fc5e80d5a7);
$parcel$export(module.exports, "_isNaN", () => $a063b94f714ec490$export$a739ba33a90be0a1);
$parcel$export(module.exports, "_isFinite", () => $a063b94f714ec490$export$8b48b92f6c9d5ad);
$parcel$export(module.exports, "hasEnumBug", () => $a063b94f714ec490$export$7dcea4d27900b116);
$parcel$export(module.exports, "nonEnumerableProps", () => $a063b94f714ec490$export$f8fa596d5e31cb19);
$parcel$export(module.exports, "MAX_ARRAY_INDEX", () => $a063b94f714ec490$export$63b3abc5cd28bc48);
// Current version.
var $a063b94f714ec490$export$a4ad2735b021c132 = '1.13.8';
var $a063b94f714ec490$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $a063b94f714ec490$export$aabeece9448a227a = Array.prototype, $a063b94f714ec490$export$e77bb59b5e655b3d = Object.prototype;
var $a063b94f714ec490$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $a063b94f714ec490$export$4cbf152802aa238 = $a063b94f714ec490$export$aabeece9448a227a.push, $a063b94f714ec490$export$58adb3bec8346d0f = $a063b94f714ec490$export$aabeece9448a227a.slice, $a063b94f714ec490$export$f84e8e69fd4488a5 = $a063b94f714ec490$export$e77bb59b5e655b3d.toString, $a063b94f714ec490$export$5a15a386532a5ea4 = $a063b94f714ec490$export$e77bb59b5e655b3d.hasOwnProperty;
var $a063b94f714ec490$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $a063b94f714ec490$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $a063b94f714ec490$export$552cf9b635cef256 = Array.isArray, $a063b94f714ec490$export$e676cf06d7fd2114 = Object.keys, $a063b94f714ec490$export$5b53dc95b548c58c = Object.create, $a063b94f714ec490$export$35fc70fc5e80d5a7 = $a063b94f714ec490$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $a063b94f714ec490$export$a739ba33a90be0a1 = isNaN, $a063b94f714ec490$export$8b48b92f6c9d5ad = isFinite;
var $a063b94f714ec490$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $a063b94f714ec490$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $a063b94f714ec490$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("h3syS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6a8df2f06813d5c$export$2e2bcd8739ae039);
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $c6a8df2f06813d5c$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("h8Zr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b2d6f468f8548b$export$2e2bcd8739ae039);
// Is a given variable an object?
function $c7b2d6f468f8548b$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}

});

parcelRegister("18kZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d36d2c15fbcc288$export$2e2bcd8739ae039);
// Is a given value equal to null?
function $0d36d2c15fbcc288$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("eYJ68", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae79a6cde419e1c1$export$2e2bcd8739ae039);
// Is a given variable undefined?
function $ae79a6cde419e1c1$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("cMCe8", function(module, exports) {

$parcel$export(module.exports, "default", () => $94e79ed6974bf1cc$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $94e79ed6974bf1cc$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $dLKuc.toString).call(obj) === '[object Boolean]';
}

});

parcelRegister("4TdqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $38f6b6f961e9bffd$export$2e2bcd8739ae039);
// Is a given value a DOM element?
function $38f6b6f961e9bffd$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("2p9gC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c051acb4175d16e$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $1c051acb4175d16e$export$2e2bcd8739ae039 = (0, $hvHZD.default)('String');

});
parcelRegister("hvHZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf7750c14e00ebc$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $cbf7750c14e00ebc$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $dLKuc.toString).call(obj) === tag;
    };
}

});


parcelRegister("a1Kf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $74cdde1292eda7a0$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $74cdde1292eda7a0$export$2e2bcd8739ae039 = (0, $hvHZD.default)('Number');

});

parcelRegister("8vvky", function(module, exports) {

$parcel$export(module.exports, "default", () => $6319859135e9ba5b$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $6319859135e9ba5b$export$2e2bcd8739ae039 = (0, $hvHZD.default)('Date');

});

parcelRegister("g8ZId", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0d436e74824089$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $bc0d436e74824089$export$2e2bcd8739ae039 = (0, $hvHZD.default)('RegExp');

});

parcelRegister("hwyyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc203c3c6107710f$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $cc203c3c6107710f$export$2e2bcd8739ae039 = (0, $hvHZD.default)('Error');

});

parcelRegister("9HqAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fcc1137d774650$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $70fcc1137d774650$export$2e2bcd8739ae039 = (0, $hvHZD.default)('Symbol');

});

parcelRegister("8U7HM", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b987cbb724cf39$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $67b987cbb724cf39$export$2e2bcd8739ae039 = (0, $hvHZD.default)('ArrayBuffer');

});

parcelRegister("7znjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $582de284073f3a0d$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");

var $44lMV = parcelRequire("44lMV");

var $8U7HM = parcelRequire("8U7HM");

var $5M0oh = parcelRequire("5M0oh");
var $582de284073f3a0d$var$isDataView = (0, $hvHZD.default)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $582de284073f3a0d$var$alternateIsDataView(obj) {
    return obj != null && (0, $44lMV.default)(obj.getInt8) && (0, $8U7HM.default)(obj.buffer);
}
var $582de284073f3a0d$export$2e2bcd8739ae039 = (0, $5M0oh.hasDataViewBug) ? $582de284073f3a0d$var$alternateIsDataView : $582de284073f3a0d$var$isDataView;

});
parcelRegister("44lMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f686fd38b1be4a8$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");

var $dLKuc = parcelRequire("dLKuc");
var $2f686fd38b1be4a8$var$isFunction = (0, $hvHZD.default)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $2f686fd38b1be4a8$var$nodelist = (0, $dLKuc.root).document && (0, $dLKuc.root).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $2f686fd38b1be4a8$var$nodelist != 'function') $2f686fd38b1be4a8$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $2f686fd38b1be4a8$export$2e2bcd8739ae039 = $2f686fd38b1be4a8$var$isFunction;

});

parcelRegister("5M0oh", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", () => $4341bd01c93fc84b$export$29b9ed4126fa90ab);
$parcel$export(module.exports, "isIE11", () => $4341bd01c93fc84b$export$f7bad96d83325a34);

var $dLKuc = parcelRequire("dLKuc");

var $aNNaY = parcelRequire("aNNaY");
var $4341bd01c93fc84b$export$29b9ed4126fa90ab = (0, $dLKuc.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $aNNaY.default)(new DataView(new ArrayBuffer(8)))), $4341bd01c93fc84b$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $aNNaY.default)(new Map);

});
parcelRegister("aNNaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dd4a04eb6a567a8$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $7dd4a04eb6a567a8$export$2e2bcd8739ae039 = (0, $hvHZD.default)('Object');

});



parcelRegister("2wtAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d65850ddeb5181c$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");

var $hvHZD = parcelRequire("hvHZD");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$1d65850ddeb5181c$export$2e2bcd8739ae039 = (0, $dLKuc.nativeIsArray) || (0, $hvHZD.default)('Array');

});

parcelRegister("2metK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b78de028b9f4417$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");

var $dxpIS = parcelRequire("dxpIS");
var $1b78de028b9f4417$var$isArguments = (0, $hvHZD.default)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$1b78de028b9f4417$var$isArguments(arguments)) $1b78de028b9f4417$var$isArguments = function(obj) {
        return (0, $dxpIS.default)(obj, 'callee');
    };
})();
var $1b78de028b9f4417$export$2e2bcd8739ae039 = $1b78de028b9f4417$var$isArguments;

});
parcelRegister("dxpIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db24f6d8e414393$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $9db24f6d8e414393$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $dLKuc.hasOwnProperty).call(obj, key);
}

});


parcelRegister("k8wT0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea8e107e9f3dd9a6$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");

var $9HqAx = parcelRequire("9HqAx");
function $ea8e107e9f3dd9a6$export$2e2bcd8739ae039(obj) {
    return !(0, $9HqAx.default)(obj) && (0, $dLKuc._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("3BXSp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a13461039a641ed$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");

var $a1Kf4 = parcelRequire("a1Kf4");
function $2a13461039a641ed$export$2e2bcd8739ae039(obj) {
    return (0, $a1Kf4.default)(obj) && (0, $dLKuc._isNaN)(obj);
}

});

parcelRegister("1iw1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2050ee795bb0eb$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");

var $7znjo = parcelRequire("7znjo");

var $cBCbl = parcelRequire("cBCbl");

var $dhqo4 = parcelRequire("dhqo4");
// Is a given value a typed array?
var $0f2050ee795bb0eb$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $0f2050ee795bb0eb$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $dLKuc.nativeIsView) ? (0, $dLKuc.nativeIsView)(obj) && !(0, $7znjo.default)(obj) : (0, $dhqo4.default)(obj) && $0f2050ee795bb0eb$var$typedArrayPattern.test((0, $dLKuc.toString).call(obj));
}
var $0f2050ee795bb0eb$export$2e2bcd8739ae039 = (0, $dLKuc.supportsArrayBuffer) ? $0f2050ee795bb0eb$var$isTypedArray : (0, $cBCbl.default)(false);

});
parcelRegister("cBCbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d68ede22e80d1e$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $92d68ede22e80d1e$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("dhqo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab154d4309fad29$export$2e2bcd8739ae039);

var $d26sb = parcelRequire("d26sb");

var $fmaHI = parcelRequire("fmaHI");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$9ab154d4309fad29$export$2e2bcd8739ae039 = (0, $d26sb.default)((0, $fmaHI.default));

});
parcelRegister("d26sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d077d6195c259e$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $97d077d6195c259e$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $dLKuc.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("fmaHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2e136b2d0a7ffb0$export$2e2bcd8739ae039);

var $lVJbq = parcelRequire("lVJbq");
var // Internal helper to obtain the `byteLength` property of an object.
$b2e136b2d0a7ffb0$export$2e2bcd8739ae039 = (0, $lVJbq.default)('byteLength');

});
parcelRegister("lVJbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff71f854151f8336$export$2e2bcd8739ae039);
// Internal helper to generate a function to obtain property `key` from `obj`.
function $ff71f854151f8336$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("a7Lcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ef2be0f5dc9e27$export$2e2bcd8739ae039);

var $dxz2V = parcelRequire("dxz2V");

var $2wtAn = parcelRequire("2wtAn");

var $2p9gC = parcelRequire("2p9gC");

var $2metK = parcelRequire("2metK");

var $jdwHQ = parcelRequire("jdwHQ");
function $75ef2be0f5dc9e27$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $dxz2V.default)(obj);
    if (typeof length == 'number' && ((0, $2wtAn.default)(obj) || (0, $2p9gC.default)(obj) || (0, $2metK.default)(obj))) return length === 0;
    return (0, $dxz2V.default)((0, $jdwHQ.default)(obj)) === 0;
}

});
parcelRegister("dxz2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db98ae39ae2a98a$export$2e2bcd8739ae039);

var $lVJbq = parcelRequire("lVJbq");
var // Internal helper to obtain the `length` property of an object.
$9db98ae39ae2a98a$export$2e2bcd8739ae039 = (0, $lVJbq.default)('length');

});

parcelRegister("jdwHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfd899f73619a83d$export$2e2bcd8739ae039);

var $h8Zr6 = parcelRequire("h8Zr6");

var $dLKuc = parcelRequire("dLKuc");

var $dxpIS = parcelRequire("dxpIS");

var $glJIG = parcelRequire("glJIG");
function $dfd899f73619a83d$export$2e2bcd8739ae039(obj) {
    if (!(0, $h8Zr6.default)(obj)) return [];
    if (0, $dLKuc.nativeKeys) return (0, $dLKuc.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $dxpIS.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $dLKuc.hasEnumBug) (0, $glJIG.default)(obj, keys);
    return keys;
}

});
parcelRegister("glJIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $be72127f5c7e475e$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");

var $44lMV = parcelRequire("44lMV");

var $dxpIS = parcelRequire("dxpIS");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $be72127f5c7e475e$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $be72127f5c7e475e$export$2e2bcd8739ae039(obj, keys) {
    keys = $be72127f5c7e475e$var$emulatedSet(keys);
    var nonEnumIdx = (0, $dLKuc.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $44lMV.default)(constructor) && constructor.prototype || (0, $dLKuc.ObjProto);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $dxpIS.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $dLKuc.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("lLhKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7bc20afda9126f$export$2e2bcd8739ae039);

var $jdwHQ = parcelRequire("jdwHQ");
function $fd7bc20afda9126f$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $jdwHQ.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("fqtqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b01c1ac39f9b64$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");

var $dLKuc = parcelRequire("dLKuc");

var $fmaHI = parcelRequire("fmaHI");

var $1iw1M = parcelRequire("1iw1M");

var $44lMV = parcelRequire("44lMV");

var $5M0oh = parcelRequire("5M0oh");

var $7znjo = parcelRequire("7znjo");

var $jdwHQ = parcelRequire("jdwHQ");

var $dxpIS = parcelRequire("dxpIS");

var $eZNDK = parcelRequire("eZNDK");
// We use this string twice, so give it a name for minification.
var $b3b01c1ac39f9b64$var$tagDataView = '[object DataView]';
function $b3b01c1ac39f9b64$export$2e2bcd8739ae039(a, b) {
    var todo = [
        {
            a: a,
            b: b
        }
    ];
    // Initializing stacks of traversed objects for cycle detection.
    var aStack = [], bStack = [];
    while(todo.length){
        var frame = todo.pop();
        if (frame === true) {
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            continue;
        }
        a = frame.a;
        b = frame.b;
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) {
            if (a !== 0 || 1 / a === 1 / b) continue;
            return false;
        }
        // `null` or `undefined` only equal to itself (strict comparison).
        if (a == null || b == null) return false;
        // `NaN`s are equivalent, but non-reflexive.
        if (a !== a) {
            if (b !== b) continue;
            return false;
        }
        // Exhaust primitive checks
        var type = typeof a;
        if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
        // Internal recursive comparison function for `_.isEqual`.
        // Unwrap any wrapped objects.
        if (a instanceof (0, $k7vPj.default)) a = a._wrapped;
        if (b instanceof (0, $k7vPj.default)) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = (0, $dLKuc.toString).call(a);
        if (className !== (0, $dLKuc.toString).call(b)) return false;
        // Work around a bug in IE 10 - Edge 13.
        if ((0, $5M0oh.hasDataViewBug) && className == '[object Object]' && (0, $7znjo.default)(a)) {
            if (!(0, $7znjo.default)(b)) return false;
            className = $b3b01c1ac39f9b64$var$tagDataView;
        }
        switch(className){
            // These types are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                if ('' + a === '' + b) continue;
                return false;
            case '[object Number]':
                todo.push({
                    a: +a,
                    b: +b
                });
                continue;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                if (+a === +b) continue;
                return false;
            case '[object Symbol]':
                if ((0, $dLKuc.SymbolProto).valueOf.call(a) === (0, $dLKuc.SymbolProto).valueOf.call(b)) continue;
                return false;
            case '[object ArrayBuffer]':
            case $b3b01c1ac39f9b64$var$tagDataView:
                // Coerce to typed array so we can fall through.
                todo.push({
                    a: (0, $eZNDK.default)(a),
                    b: (0, $eZNDK.default)(b)
                });
                continue;
        }
        var areArrays = className === '[object Array]';
        if (!areArrays && (0, $1iw1M.default)(a)) {
            var byteLength = (0, $fmaHI.default)(a);
            if (byteLength !== (0, $fmaHI.default)(b)) return false;
            if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) continue;
            areArrays = true;
        }
        if (!areArrays) {
            if (typeof a != 'object' || typeof b != 'object') return false;
            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !((0, $44lMV.default)(aCtor) && aCtor instanceof aCtor && (0, $44lMV.default)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
        var length = aStack.length;
        while(length--)// Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) {
            if (bStack[length] === b) break;
            return false;
        }
        if (length >= 0) continue;
        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);
        todo.push(true);
        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while(length--)todo.push({
                a: a[length],
                b: b[length]
            });
        } else {
            // Deep compare objects.
            var _keys = (0, $jdwHQ.default)(a), key;
            length = _keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if ((0, $jdwHQ.default)(b).length !== length) return false;
            while(length--){
                // Deep compare each member
                key = _keys[length];
                if (!(0, $dxpIS.default)(b, key)) return false;
                todo.push({
                    a: a[key],
                    b: b[key]
                });
            }
        }
    }
    return true;
}

});
parcelRegister("k7vPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5d262dcfa872e4$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $ea5d262dcfa872e4$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $ea5d262dcfa872e4$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $ea5d262dcfa872e4$export$2e2bcd8739ae039)) return new $ea5d262dcfa872e4$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$ea5d262dcfa872e4$export$2e2bcd8739ae039.VERSION = (0, $dLKuc.VERSION);
// Extracts the result from a wrapped and chained object.
$ea5d262dcfa872e4$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$ea5d262dcfa872e4$export$2e2bcd8739ae039.prototype.valueOf = $ea5d262dcfa872e4$export$2e2bcd8739ae039.prototype.toJSON = $ea5d262dcfa872e4$export$2e2bcd8739ae039.prototype.value;
$ea5d262dcfa872e4$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("eZNDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $aead44b4712f1e27$export$2e2bcd8739ae039);

var $fmaHI = parcelRequire("fmaHI");
function $aead44b4712f1e27$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $fmaHI.default)(bufferSource));
}

});


parcelRegister("ioQtQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6532d669957eedf$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");

var $5M0oh = parcelRequire("5M0oh");

var $7MXUM = parcelRequire("7MXUM");
var $d6532d669957eedf$export$2e2bcd8739ae039 = (0, $5M0oh.isIE11) ? (0, $7MXUM.ie11fingerprint)((0, $7MXUM.mapMethods)) : (0, $hvHZD.default)('Map');

});
parcelRegister("7MXUM", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", () => $5abb7de9bba0dce4$export$15230eca1f400e40);
$parcel$export(module.exports, "weakMapMethods", () => $5abb7de9bba0dce4$export$2f74b890a72cf48);
$parcel$export(module.exports, "mapMethods", () => $5abb7de9bba0dce4$export$de9acb94190bb764);
$parcel$export(module.exports, "setMethods", () => $5abb7de9bba0dce4$export$60e14a5e2a057f78);

var $dxz2V = parcelRequire("dxz2V");

var $44lMV = parcelRequire("44lMV");

var $a958q = parcelRequire("a958q");
function $5abb7de9bba0dce4$export$15230eca1f400e40(methods) {
    var length = (0, $dxz2V.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $a958q.default)(obj);
        if ((0, $dxz2V.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $44lMV.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $5abb7de9bba0dce4$export$2f74b890a72cf48 || !(0, $44lMV.default)(obj[$5abb7de9bba0dce4$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $5abb7de9bba0dce4$var$forEachName = 'forEach', $5abb7de9bba0dce4$var$hasName = 'has', $5abb7de9bba0dce4$var$commonInit = [
    'clear',
    'delete'
], $5abb7de9bba0dce4$var$mapTail = [
    'get',
    $5abb7de9bba0dce4$var$hasName,
    'set'
];
var $5abb7de9bba0dce4$export$de9acb94190bb764 = $5abb7de9bba0dce4$var$commonInit.concat($5abb7de9bba0dce4$var$forEachName, $5abb7de9bba0dce4$var$mapTail), $5abb7de9bba0dce4$export$2f74b890a72cf48 = $5abb7de9bba0dce4$var$commonInit.concat($5abb7de9bba0dce4$var$mapTail), $5abb7de9bba0dce4$export$60e14a5e2a057f78 = [
    'add'
].concat($5abb7de9bba0dce4$var$commonInit, $5abb7de9bba0dce4$var$forEachName, $5abb7de9bba0dce4$var$hasName);

});
parcelRegister("a958q", function(module, exports) {

$parcel$export(module.exports, "default", () => $762eba52fcc4a93f$export$2e2bcd8739ae039);

var $h8Zr6 = parcelRequire("h8Zr6");

var $dLKuc = parcelRequire("dLKuc");

var $glJIG = parcelRequire("glJIG");
function $762eba52fcc4a93f$export$2e2bcd8739ae039(obj) {
    if (!(0, $h8Zr6.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $dLKuc.hasEnumBug) (0, $glJIG.default)(obj, keys);
    return keys;
}

});



parcelRegister("gfEIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd4da216e2246270$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");

var $5M0oh = parcelRequire("5M0oh");

var $7MXUM = parcelRequire("7MXUM");
var $bd4da216e2246270$export$2e2bcd8739ae039 = (0, $5M0oh.isIE11) ? (0, $7MXUM.ie11fingerprint)((0, $7MXUM.weakMapMethods)) : (0, $hvHZD.default)('WeakMap');

});

parcelRegister("du1qT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0f3037a5a4142c$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");

var $5M0oh = parcelRequire("5M0oh");

var $7MXUM = parcelRequire("7MXUM");
var $9d0f3037a5a4142c$export$2e2bcd8739ae039 = (0, $5M0oh.isIE11) ? (0, $7MXUM.ie11fingerprint)((0, $7MXUM.setMethods)) : (0, $hvHZD.default)('Set');

});

parcelRegister("cRhxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c80b3f48c946b2$export$2e2bcd8739ae039);

var $hvHZD = parcelRequire("hvHZD");
var $95c80b3f48c946b2$export$2e2bcd8739ae039 = (0, $hvHZD.default)('WeakSet');

});

parcelRegister("3bYdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $25311bc60005b296$export$2e2bcd8739ae039);

var $jdwHQ = parcelRequire("jdwHQ");
function $25311bc60005b296$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $jdwHQ.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("6JKbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ac5dfc920482e$export$2e2bcd8739ae039);

var $jdwHQ = parcelRequire("jdwHQ");
function $4e7ac5dfc920482e$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $jdwHQ.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("9AGgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb8422f89f8c9cd$export$2e2bcd8739ae039);

var $jdwHQ = parcelRequire("jdwHQ");
function $6fb8422f89f8c9cd$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $jdwHQ.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("c81pn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d47530e05ccc5f2$export$2e2bcd8739ae039);

var $44lMV = parcelRequire("44lMV");
function $8d47530e05ccc5f2$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $44lMV.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("a4yWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7555613c59e38244$export$2e2bcd8739ae039);

var $6lpCZ = parcelRequire("6lpCZ");

var $a958q = parcelRequire("a958q");
var // Extend a given object with all the properties in passed-in object(s).
$7555613c59e38244$export$2e2bcd8739ae039 = (0, $6lpCZ.default)((0, $a958q.default));

});
parcelRegister("6lpCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e8956c1f548fc4$export$2e2bcd8739ae039);
// An internal function for creating assigner functions.
function $49e8956c1f548fc4$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("2ZWtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $22eea41b5f08f0f9$export$2e2bcd8739ae039);

var $6lpCZ = parcelRequire("6lpCZ");

var $jdwHQ = parcelRequire("jdwHQ");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$22eea41b5f08f0f9$export$2e2bcd8739ae039 = (0, $6lpCZ.default)((0, $jdwHQ.default));

});

parcelRegister("aTgF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7edbf70305dc1cbc$export$2e2bcd8739ae039);

var $6lpCZ = parcelRequire("6lpCZ");

var $a958q = parcelRequire("a958q");
var // Fill in a given object with default properties.
$7edbf70305dc1cbc$export$2e2bcd8739ae039 = (0, $6lpCZ.default)((0, $a958q.default), true);

});

parcelRegister("jNvSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69b51a91ac50a85$export$2e2bcd8739ae039);

var $j8LIA = parcelRequire("j8LIA");

var $2ZWtN = parcelRequire("2ZWtN");
function $e69b51a91ac50a85$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $j8LIA.default)(prototype);
    if (props) (0, $2ZWtN.default)(result, props);
    return result;
}

});
parcelRegister("j8LIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $def3c77c45cbce18$export$2e2bcd8739ae039);

var $h8Zr6 = parcelRequire("h8Zr6");

var $dLKuc = parcelRequire("dLKuc");
// Create a naked function reference for surrogate-prototype-swapping.
function $def3c77c45cbce18$var$ctor() {
    return function() {};
}
function $def3c77c45cbce18$export$2e2bcd8739ae039(prototype) {
    if (!(0, $h8Zr6.default)(prototype)) return {};
    if (0, $dLKuc.nativeCreate) return (0, $dLKuc.nativeCreate)(prototype);
    var Ctor = $def3c77c45cbce18$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("bgQ6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $83499a2010f98e75$export$2e2bcd8739ae039);

var $h8Zr6 = parcelRequire("h8Zr6");

var $2wtAn = parcelRequire("2wtAn");

var $a4yWg = parcelRequire("a4yWg");
function $83499a2010f98e75$export$2e2bcd8739ae039(obj) {
    if (!(0, $h8Zr6.default)(obj)) return obj;
    return (0, $2wtAn.default)(obj) ? obj.slice() : (0, $a4yWg.default)({}, obj);
}

});

parcelRegister("91UkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $692fe87cf8c7a125$export$2e2bcd8739ae039);
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $692fe87cf8c7a125$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("b8o6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b322dca6b9f097$export$2e2bcd8739ae039);

var $4oVVY = parcelRequire("4oVVY");

var $gjKa2 = parcelRequire("gjKa2");

var $eYJ68 = parcelRequire("eYJ68");
function $81b322dca6b9f097$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $gjKa2.default)(object, (0, $4oVVY.default)(path));
    return (0, $eYJ68.default)(value) ? defaultValue : value;
}

});
parcelRegister("4oVVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $334657cde63f6689$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");
parcelRequire("kj7DN");
function $334657cde63f6689$export$2e2bcd8739ae039(path) {
    return (0, $k7vPj.default).toPath(path);
}

});
parcelRegister("kj7DN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8b825309508c13$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");

var $2wtAn = parcelRequire("2wtAn");
function $ec8b825309508c13$export$2e2bcd8739ae039(path) {
    return (0, $2wtAn.default)(path) ? path : [
        path
    ];
}
(0, $k7vPj.default).toPath = $ec8b825309508c13$export$2e2bcd8739ae039;

});


parcelRegister("gjKa2", function(module, exports) {

$parcel$export(module.exports, "default", () => $be123a4ccbe4b50d$export$2e2bcd8739ae039);
// Internal function to obtain a nested property in `obj` along `path`.
function $be123a4ccbe4b50d$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("gFX6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23e53d4eeacc4cb$export$2e2bcd8739ae039);

var $dxpIS = parcelRequire("dxpIS");

var $4oVVY = parcelRequire("4oVVY");
function $c23e53d4eeacc4cb$export$2e2bcd8739ae039(obj, path) {
    path = (0, $4oVVY.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $dxpIS.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("6LlVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec823bba63104c5$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $jdwHQ = parcelRequire("jdwHQ");
function $4ec823bba63104c5$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $eKuxJ.default)(iteratee, context);
    var _keys = (0, $jdwHQ.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("eKuxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcd0dc85584de84$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");

var $8iXA5 = parcelRequire("8iXA5");

var $j7ucl = parcelRequire("j7ucl");
function $abcd0dc85584de84$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $k7vPj.default).iteratee !== (0, $j7ucl.default)) return (0, $k7vPj.default).iteratee(value, context);
    return (0, $8iXA5.default)(value, context, argCount);
}

});
parcelRegister("8iXA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $60be38bd486b1606$export$2e2bcd8739ae039);

var $baXZx = parcelRequire("baXZx");

var $44lMV = parcelRequire("44lMV");

var $h8Zr6 = parcelRequire("h8Zr6");

var $2wtAn = parcelRequire("2wtAn");

var $fQb5K = parcelRequire("fQb5K");

var $evEHH = parcelRequire("evEHH");

var $f2vFG = parcelRequire("f2vFG");
function $60be38bd486b1606$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $baXZx.default;
    if ((0, $44lMV.default)(value)) return (0, $f2vFG.default)(value, context, argCount);
    if ((0, $h8Zr6.default)(value) && !(0, $2wtAn.default)(value)) return (0, $fQb5K.default)(value);
    return (0, $evEHH.default)(value);
}

});
parcelRegister("baXZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $822f29f8ddd7f3f7$export$2e2bcd8739ae039);
// Keep the identity function around for default iteratees.
function $822f29f8ddd7f3f7$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("fQb5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88450e714aa744d$export$2e2bcd8739ae039);

var $2ZWtN = parcelRequire("2ZWtN");

var $lLhKI = parcelRequire("lLhKI");
function $b88450e714aa744d$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $2ZWtN.default)({}, attrs);
    return function(obj) {
        return (0, $lLhKI.default)(obj, attrs);
    };
}

});

parcelRegister("evEHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90388dc6d4fedfd$export$2e2bcd8739ae039);

var $gjKa2 = parcelRequire("gjKa2");

var $4oVVY = parcelRequire("4oVVY");
function $a90388dc6d4fedfd$export$2e2bcd8739ae039(path) {
    path = (0, $4oVVY.default)(path);
    return function(obj) {
        return (0, $gjKa2.default)(obj, path);
    };
}

});

parcelRegister("f2vFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af2f9c2abeabcdb9$export$2e2bcd8739ae039);
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $af2f9c2abeabcdb9$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("j7ucl", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb6187ed921705a$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");

var $8iXA5 = parcelRequire("8iXA5");
function $deb6187ed921705a$export$2e2bcd8739ae039(value, context) {
    return (0, $8iXA5.default)(value, context, Infinity);
}
(0, $k7vPj.default).iteratee = $deb6187ed921705a$export$2e2bcd8739ae039;

});



parcelRegister("7sjtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $56da404159450c9e$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $56da404159450c9e$export$2e2bcd8739ae039() {}

});

parcelRegister("3JiCT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b7405dea2cbeb89$export$2e2bcd8739ae039);

var $7sjtc = parcelRequire("7sjtc");

var $b8o6h = parcelRequire("b8o6h");
function $2b7405dea2cbeb89$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $7sjtc.default;
    return function(path) {
        return (0, $b8o6h.default)(obj, path);
    };
}

});

parcelRegister("6zv16", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8e12394413f6b0$export$2e2bcd8739ae039);

var $f2vFG = parcelRequire("f2vFG");
function $4c8e12394413f6b0$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $f2vFG.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("9yGwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f58473344c2de70$export$2e2bcd8739ae039);
// Return a random integer between `min` and `max` (inclusive).
function $6f58473344c2de70$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("gy6Vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c53165765778f8$export$2e2bcd8739ae039);
// A (possibly faster) way to get the current timestamp as an integer.
var $c0c53165765778f8$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("8nGHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a197e7b333edb9$export$2e2bcd8739ae039);

var $fHbqf = parcelRequire("fHbqf");

var $5CeZW = parcelRequire("5CeZW");
var // Function for escaping strings to HTML interpolation.
$61a197e7b333edb9$export$2e2bcd8739ae039 = (0, $fHbqf.default)((0, $5CeZW.default));

});
parcelRegister("fHbqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6d3bb6aba808a75$export$2e2bcd8739ae039);

var $jdwHQ = parcelRequire("jdwHQ");
function $b6d3bb6aba808a75$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $jdwHQ.default)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("5CeZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $416c22afc79661fd$export$2e2bcd8739ae039);
// Internal list of HTML entities for escaping.
var $416c22afc79661fd$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};

});


parcelRegister("elsMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7195ae38b90f7f1$export$2e2bcd8739ae039);

var $fHbqf = parcelRequire("fHbqf");

var $6uqxh = parcelRequire("6uqxh");
var // Function for unescaping strings from HTML interpolation.
$a7195ae38b90f7f1$export$2e2bcd8739ae039 = (0, $fHbqf.default)((0, $6uqxh.default));

});
parcelRegister("6uqxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9a20d99b60820c$export$2e2bcd8739ae039);

var $9AGgi = parcelRequire("9AGgi");

var $5CeZW = parcelRequire("5CeZW");
var // Internal list of HTML entities for unescaping.
$4b9a20d99b60820c$export$2e2bcd8739ae039 = (0, $9AGgi.default)((0, $5CeZW.default));

});


parcelRegister("6PJ2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f9a72f0a63640f8$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$4f9a72f0a63640f8$export$2e2bcd8739ae039 = (0, $k7vPj.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("9L3Xb", function(module, exports) {

$parcel$export(module.exports, "default", () => $71ab91f42fa3e857$export$2e2bcd8739ae039);

var $aTgF3 = parcelRequire("aTgF3");

var $k7vPj = parcelRequire("k7vPj");
parcelRequire("6PJ2Z");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $71ab91f42fa3e857$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $71ab91f42fa3e857$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $71ab91f42fa3e857$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $71ab91f42fa3e857$var$escapeChar(match) {
    return '\\' + $71ab91f42fa3e857$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $71ab91f42fa3e857$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $71ab91f42fa3e857$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $aTgF3.default)({}, settings, (0, $k7vPj.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $71ab91f42fa3e857$var$noMatch).source,
        (settings.interpolate || $71ab91f42fa3e857$var$noMatch).source,
        (settings.evaluate || $71ab91f42fa3e857$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($71ab91f42fa3e857$var$escapeRegExp, $71ab91f42fa3e857$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$71ab91f42fa3e857$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $k7vPj.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

});

parcelRegister("aPopu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e219a1edc680d24$export$2e2bcd8739ae039);

var $44lMV = parcelRequire("44lMV");

var $4oVVY = parcelRequire("4oVVY");
function $7e219a1edc680d24$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $4oVVY.default)(path);
    var length = path.length;
    if (!length) return (0, $44lMV.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $44lMV.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("7Lukp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a7472bcc1ff37fa$export$2e2bcd8739ae039);
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $5a7472bcc1ff37fa$var$idCounter = 0;
function $5a7472bcc1ff37fa$export$2e2bcd8739ae039(prefix) {
    var id = ++$5a7472bcc1ff37fa$var$idCounter + '';
    return prefix ? prefix + id : id;
}

});

parcelRegister("b6qzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8154de6e7394b540$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");
function $8154de6e7394b540$export$2e2bcd8739ae039(obj) {
    var instance = (0, $k7vPj.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("esv10", function(module, exports) {

$parcel$export(module.exports, "default", () => $a86bbd2aa2bc0917$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $9gtw0 = parcelRequire("9gtw0");

var $k7vPj = parcelRequire("k7vPj");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $a86bbd2aa2bc0917$var$partial = (0, $h3syS.default)(function(func, boundArgs) {
    var placeholder = $a86bbd2aa2bc0917$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $9gtw0.default)(func, bound, this, this, args);
    };
    return bound;
});
$a86bbd2aa2bc0917$var$partial.placeholder = (0, $k7vPj.default);
var $a86bbd2aa2bc0917$export$2e2bcd8739ae039 = $a86bbd2aa2bc0917$var$partial;

});
parcelRegister("9gtw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bec80c83a9060f3$export$2e2bcd8739ae039);

var $j8LIA = parcelRequire("j8LIA");

var $h8Zr6 = parcelRequire("h8Zr6");
function $6bec80c83a9060f3$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $j8LIA.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $h8Zr6.default)(result)) return result;
    return self;
}

});


parcelRegister("kC4Di", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01af33a9b2de62a$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $44lMV = parcelRequire("44lMV");

var $9gtw0 = parcelRequire("9gtw0");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$f01af33a9b2de62a$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(func, context, args) {
    if (!(0, $44lMV.default)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $h3syS.default)(function(callArgs) {
        return (0, $9gtw0.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("jTntB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b55d4d8a836ba0$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $4KizQ = parcelRequire("4KizQ");

var $kC4Di = parcelRequire("kC4Di");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$e7b55d4d8a836ba0$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(obj, keys) {
    keys = (0, $4KizQ.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $kC4Di.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("4KizQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3749de55c9a5816c$export$2e2bcd8739ae039);

var $dxz2V = parcelRequire("dxz2V");

var $lJur2 = parcelRequire("lJur2");

var $2wtAn = parcelRequire("2wtAn");

var $2metK = parcelRequire("2metK");
function $3749de55c9a5816c$export$2e2bcd8739ae039(input, depth, strict) {
    if (!depth && depth !== 0) depth = Infinity;
    var output = [], idx = 0, i = 0, length = (0, $dxz2V.default)(input) || 0, stack = [];
    while(true){
        if (i >= length) {
            if (!stack.length) break;
            var frame = stack.pop();
            i = frame.i;
            input = frame.v;
            length = (0, $dxz2V.default)(input);
            continue;
        }
        var value = input[i++];
        if (stack.length >= depth) output[idx++] = value;
        else if ((0, $lJur2.default)(value) && ((0, $2wtAn.default)(value) || (0, $2metK.default)(value))) {
            // Flatten current level of array or arguments object.
            stack.push({
                i: i,
                v: input
            });
            i = 0;
            input = value;
            length = (0, $dxz2V.default)(input);
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("lJur2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2568b3e89d025b$export$2e2bcd8739ae039);

var $d26sb = parcelRequire("d26sb");

var $dxz2V = parcelRequire("dxz2V");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$fd2568b3e89d025b$export$2e2bcd8739ae039 = (0, $d26sb.default)((0, $dxz2V.default));

});



parcelRegister("jCdTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47c57a4e285db54$export$2e2bcd8739ae039);

var $dxpIS = parcelRequire("dxpIS");
function $e47c57a4e285db54$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $dxpIS.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("l03hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f49c246eff472506$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$f49c246eff472506$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("3kUNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $26df4b69a5f11817$export$2e2bcd8739ae039);

var $esv10 = parcelRequire("esv10");

var $l03hq = parcelRequire("l03hq");

var $k7vPj = parcelRequire("k7vPj");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$26df4b69a5f11817$export$2e2bcd8739ae039 = (0, $esv10.default)((0, $l03hq.default), (0, $k7vPj.default), 1);

});

parcelRegister("k7L26", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea68f1d8adb7b329$export$2e2bcd8739ae039);

var $gy6Vo = parcelRequire("gy6Vo");
function $ea68f1d8adb7b329$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $gy6Vo.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $gy6Vo.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("6xVmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4253007fe97185$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $gy6Vo = parcelRequire("gy6Vo");
function $4c4253007fe97185$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $gy6Vo.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $h3syS.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $gy6Vo.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("d9w0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $9934f29927f01e37$export$2e2bcd8739ae039);

var $esv10 = parcelRequire("esv10");
function $9934f29927f01e37$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $esv10.default)(wrapper, func);
}

});

parcelRegister("4i6ZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31fe453bcd69c77e$export$2e2bcd8739ae039);
// Returns a negated version of the passed-in predicate.
function $31fe453bcd69c77e$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("6wDn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c044562b4d6d60f$export$2e2bcd8739ae039);
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $4c044562b4d6d60f$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("3gLmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $26179bb6f784df99$export$2e2bcd8739ae039);
// Returns a function that will only be executed on and after the Nth call.
function $26179bb6f784df99$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("7VJby", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c60e82ad85a39f7$export$2e2bcd8739ae039);
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $5c60e82ad85a39f7$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("hw1dL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc065f4c9d57c68f$export$2e2bcd8739ae039);

var $esv10 = parcelRequire("esv10");

var $7VJby = parcelRequire("7VJby");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$cc065f4c9d57c68f$export$2e2bcd8739ae039 = (0, $esv10.default)((0, $7VJby.default), 2);

});

parcelRegister("c8gTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5355f288c866ad$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $jdwHQ = parcelRequire("jdwHQ");
function $8d5355f288c866ad$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $eKuxJ.default)(predicate, context);
    var _keys = (0, $jdwHQ.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("aLdQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5909c82847ecc4$export$2e2bcd8739ae039);

var $2gjNP = parcelRequire("2gjNP");
var // Returns the first index on an array-like that passes a truth test.
$7d5909c82847ecc4$export$2e2bcd8739ae039 = (0, $2gjNP.default)(1);

});
parcelRegister("2gjNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a5c6fc83b8773c1$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $dxz2V = parcelRequire("dxz2V");
function $1a5c6fc83b8773c1$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $eKuxJ.default)(predicate, context);
        var length = (0, $dxz2V.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("4Uweu", function(module, exports) {

$parcel$export(module.exports, "default", () => $39356527e9b6afab$export$2e2bcd8739ae039);

var $2gjNP = parcelRequire("2gjNP");
var // Returns the last index on an array-like that passes a truth test.
$39356527e9b6afab$export$2e2bcd8739ae039 = (0, $2gjNP.default)(-1);

});

parcelRegister("7xlCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cc6229b2402880$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $dxz2V = parcelRequire("dxz2V");
function $57cc6229b2402880$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $eKuxJ.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $dxz2V.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("hmVSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca5164b4cc13753c$export$2e2bcd8739ae039);

var $7xlCj = parcelRequire("7xlCj");

var $aLdQR = parcelRequire("aLdQR");

var $8NMU9 = parcelRequire("8NMU9");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$ca5164b4cc13753c$export$2e2bcd8739ae039 = (0, $8NMU9.default)(1, (0, $aLdQR.default), (0, $7xlCj.default));

});
parcelRegister("8NMU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6688d5c8e3478d80$export$2e2bcd8739ae039);

var $dxz2V = parcelRequire("dxz2V");

var $dLKuc = parcelRequire("dLKuc");

var $3BXSp = parcelRequire("3BXSp");
function $6688d5c8e3478d80$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $dxz2V.default)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $dLKuc.slice).call(array, i, length), (0, $3BXSp.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("9L0nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a8cb057dc5ec97$export$2e2bcd8739ae039);

var $4Uweu = parcelRequire("4Uweu");

var $8NMU9 = parcelRequire("8NMU9");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$71a8cb057dc5ec97$export$2e2bcd8739ae039 = (0, $8NMU9.default)(-1, (0, $4Uweu.default));

});

parcelRegister("4TeC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $38f7a256058f0429$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $aLdQR = parcelRequire("aLdQR");

var $c8gTp = parcelRequire("c8gTp");
function $38f7a256058f0429$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $lJur2.default)(obj) ? (0, $aLdQR.default) : (0, $c8gTp.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("9ZLI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $746ed1b1c7fd4a46$export$2e2bcd8739ae039);

var $4TeC4 = parcelRequire("4TeC4");

var $fQb5K = parcelRequire("fQb5K");
function $746ed1b1c7fd4a46$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $4TeC4.default)(obj, (0, $fQb5K.default)(attrs));
}

});

parcelRegister("6BCJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf43e27554c030e$export$2e2bcd8739ae039);

var $f2vFG = parcelRequire("f2vFG");

var $lJur2 = parcelRequire("lJur2");

var $jdwHQ = parcelRequire("jdwHQ");
function $4cf43e27554c030e$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $f2vFG.default)(iteratee, context);
    var i, length;
    if ((0, $lJur2.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $jdwHQ.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("dCj5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9da06c3a14ac70$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $lJur2 = parcelRequire("lJur2");

var $jdwHQ = parcelRequire("jdwHQ");
function $9e9da06c3a14ac70$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $eKuxJ.default)(iteratee, context);
    var _keys = !(0, $lJur2.default)(obj) && (0, $jdwHQ.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("cJifR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9447d906406ea0af$export$2e2bcd8739ae039);

var $adl6o = parcelRequire("adl6o");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$9447d906406ea0af$export$2e2bcd8739ae039 = (0, $adl6o.default)(1);

});
parcelRegister("adl6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $76fb7cb24129cfba$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $jdwHQ = parcelRequire("jdwHQ");

var $f2vFG = parcelRequire("f2vFG");
function $76fb7cb24129cfba$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $lJur2.default)(obj) && (0, $jdwHQ.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $f2vFG.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("c1J1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c18811512862205$export$2e2bcd8739ae039);

var $adl6o = parcelRequire("adl6o");
var // The right-associative version of reduce, also known as `foldr`.
$8c18811512862205$export$2e2bcd8739ae039 = (0, $adl6o.default)(-1);

});

parcelRegister("lpWdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f97918c55eb25b5b$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $6BCJr = parcelRequire("6BCJr");
function $f97918c55eb25b5b$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $eKuxJ.default)(predicate, context);
    (0, $6BCJr.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("6QtQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbec0b00669adc8$export$2e2bcd8739ae039);

var $lpWdV = parcelRequire("lpWdV");

var $4i6ZQ = parcelRequire("4i6ZQ");

var $eKuxJ = parcelRequire("eKuxJ");
function $4fbec0b00669adc8$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $lpWdV.default)(obj, (0, $4i6ZQ.default)((0, $eKuxJ.default)(predicate)), context);
}

});

parcelRegister("dSuIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a824ae571979e1$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $lJur2 = parcelRequire("lJur2");

var $jdwHQ = parcelRequire("jdwHQ");
function $a1a824ae571979e1$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $eKuxJ.default)(predicate, context);
    var _keys = !(0, $lJur2.default)(obj) && (0, $jdwHQ.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("74eBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $52543cf0d7347e32$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $lJur2 = parcelRequire("lJur2");

var $jdwHQ = parcelRequire("jdwHQ");
function $52543cf0d7347e32$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $eKuxJ.default)(predicate, context);
    var _keys = !(0, $lJur2.default)(obj) && (0, $jdwHQ.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("liuPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8133122ab01f112$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $3bYdr = parcelRequire("3bYdr");

var $hmVSZ = parcelRequire("hmVSZ");
function $f8133122ab01f112$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $lJur2.default)(obj)) obj = (0, $3bYdr.default)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $hmVSZ.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("coSxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $907209bbc56f87d2$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $44lMV = parcelRequire("44lMV");

var $dCj5c = parcelRequire("dCj5c");

var $gjKa2 = parcelRequire("gjKa2");

var $4oVVY = parcelRequire("4oVVY");
var // Invoke a method (with arguments) on every item in a collection.
$907209bbc56f87d2$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $44lMV.default)(path)) func = path;
    else {
        path = (0, $4oVVY.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $dCj5c.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $gjKa2.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("lP78i", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe33e4d5e77e9fa9$export$2e2bcd8739ae039);

var $dCj5c = parcelRequire("dCj5c");

var $evEHH = parcelRequire("evEHH");
function $fe33e4d5e77e9fa9$export$2e2bcd8739ae039(obj, key) {
    return (0, $dCj5c.default)(obj, (0, $evEHH.default)(key));
}

});

parcelRegister("lEDu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3bf5e686cf6219$export$2e2bcd8739ae039);

var $lpWdV = parcelRequire("lpWdV");

var $fQb5K = parcelRequire("fQb5K");
function $fc3bf5e686cf6219$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $lpWdV.default)(obj, (0, $fQb5K.default)(attrs));
}

});

parcelRegister("GIhLa", function(module, exports) {

$parcel$export(module.exports, "default", () => $080646869307d765$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $3bYdr = parcelRequire("3bYdr");

var $eKuxJ = parcelRequire("eKuxJ");

var $6BCJr = parcelRequire("6BCJr");
function $080646869307d765$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $lJur2.default)(obj) ? obj : (0, $3bYdr.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $eKuxJ.default)(iteratee, context);
        (0, $6BCJr.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("5s80w", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f85c75c41c6822b$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $3bYdr = parcelRequire("3bYdr");

var $eKuxJ = parcelRequire("eKuxJ");

var $6BCJr = parcelRequire("6BCJr");
function $3f85c75c41c6822b$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $lJur2.default)(obj) ? obj : (0, $3bYdr.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $eKuxJ.default)(iteratee, context);
        (0, $6BCJr.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("bb8Y0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8237ad6e2a81b196$export$2e2bcd8739ae039);

var $gq8G9 = parcelRequire("gq8G9");
function $8237ad6e2a81b196$export$2e2bcd8739ae039(obj) {
    return (0, $gq8G9.default)(obj, Infinity);
}

});
parcelRegister("gq8G9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf45ce802d2d1826$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $3bYdr = parcelRequire("3bYdr");

var $dxz2V = parcelRequire("dxz2V");

var $9yGwN = parcelRequire("9yGwN");

var $5SVFE = parcelRequire("5SVFE");
function $bf45ce802d2d1826$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $lJur2.default)(obj)) obj = (0, $3bYdr.default)(obj);
        return obj[(0, $9yGwN.default)(obj.length - 1)];
    }
    var sample = (0, $5SVFE.default)(obj);
    var length = (0, $dxz2V.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $9yGwN.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("5SVFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $448ebb1c72c962e8$export$2e2bcd8739ae039);

var $2wtAn = parcelRequire("2wtAn");

var $dLKuc = parcelRequire("dLKuc");

var $2p9gC = parcelRequire("2p9gC");

var $lJur2 = parcelRequire("lJur2");

var $dCj5c = parcelRequire("dCj5c");

var $baXZx = parcelRequire("baXZx");

var $3bYdr = parcelRequire("3bYdr");
// Safely create a real, live array from anything iterable.
var $448ebb1c72c962e8$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $448ebb1c72c962e8$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $2wtAn.default)(obj)) return (0, $dLKuc.slice).call(obj);
    if ((0, $2p9gC.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($448ebb1c72c962e8$var$reStrSymbol);
    if ((0, $lJur2.default)(obj)) return (0, $dCj5c.default)(obj, (0, $baXZx.default));
    return (0, $3bYdr.default)(obj);
}

});



parcelRegister("lBDMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbabeab8f9aaed42$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $lP78i = parcelRequire("lP78i");

var $dCj5c = parcelRequire("dCj5c");
function $fbabeab8f9aaed42$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $eKuxJ.default)(iteratee, context);
    return (0, $lP78i.default)((0, $dCj5c.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}

});

parcelRegister("jVDF1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8221af68f48dd54$export$2e2bcd8739ae039);

var $cUbCS = parcelRequire("cUbCS");

var $dxpIS = parcelRequire("dxpIS");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$e8221af68f48dd54$export$2e2bcd8739ae039 = (0, $cUbCS.default)(function(result, value, key) {
    if ((0, $dxpIS.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("cUbCS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9653bbaa513eb67c$export$2e2bcd8739ae039);

var $eKuxJ = parcelRequire("eKuxJ");

var $6BCJr = parcelRequire("6BCJr");
function $9653bbaa513eb67c$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $eKuxJ.default)(iteratee, context);
        (0, $6BCJr.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("haiqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7f1a8fa67ebfa50$export$2e2bcd8739ae039);

var $cUbCS = parcelRequire("cUbCS");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$c7f1a8fa67ebfa50$export$2e2bcd8739ae039 = (0, $cUbCS.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("672iw", function(module, exports) {

$parcel$export(module.exports, "default", () => $47352dd1f5f00ad0$export$2e2bcd8739ae039);

var $cUbCS = parcelRequire("cUbCS");

var $dxpIS = parcelRequire("dxpIS");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$47352dd1f5f00ad0$export$2e2bcd8739ae039 = (0, $cUbCS.default)(function(result, value, key) {
    if ((0, $dxpIS.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("777nt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52dee8e2e2ea10b9$export$2e2bcd8739ae039);

var $cUbCS = parcelRequire("cUbCS");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$52dee8e2e2ea10b9$export$2e2bcd8739ae039 = (0, $cUbCS.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("3tuwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $287bc35d26977719$export$2e2bcd8739ae039);

var $lJur2 = parcelRequire("lJur2");

var $jdwHQ = parcelRequire("jdwHQ");
function $287bc35d26977719$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $lJur2.default)(obj) ? obj.length : (0, $jdwHQ.default)(obj).length;
}

});

parcelRegister("5MYdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4370243de0464082$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $44lMV = parcelRequire("44lMV");

var $f2vFG = parcelRequire("f2vFG");

var $a958q = parcelRequire("a958q");

var $lzyKU = parcelRequire("lzyKU");

var $4KizQ = parcelRequire("4KizQ");
var // Return a copy of the object only containing the allowed properties.
$4370243de0464082$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $44lMV.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $f2vFG.default)(iteratee, keys[1]);
        keys = (0, $a958q.default)(obj);
    } else {
        iteratee = (0, $lzyKU.default);
        keys = (0, $4KizQ.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("lzyKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb47d39c0c722534$export$2e2bcd8739ae039);
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $fb47d39c0c722534$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("6mL1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2945c6dd599dfb$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $44lMV = parcelRequire("44lMV");

var $4i6ZQ = parcelRequire("4i6ZQ");

var $dCj5c = parcelRequire("dCj5c");

var $4KizQ = parcelRequire("4KizQ");

var $liuPn = parcelRequire("liuPn");

var $5MYdb = parcelRequire("5MYdb");
var // Return a copy of the object without the disallowed properties.
$4a2945c6dd599dfb$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $44lMV.default)(iteratee)) {
        iteratee = (0, $4i6ZQ.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $dCj5c.default)((0, $4KizQ.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $liuPn.default)(keys, key);
        };
    }
    return (0, $5MYdb.default)(obj, iteratee, context);
});

});

parcelRegister("hgSYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92e93b8aac0d57d$export$2e2bcd8739ae039);

var $1c8bS = parcelRequire("1c8bS");
function $c92e93b8aac0d57d$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $1c8bS.default)(array, array.length - n);
}

});
parcelRegister("1c8bS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ded43e409eae558$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $0ded43e409eae558$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $dLKuc.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("dzRqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e27fd972a1eddb4$export$2e2bcd8739ae039);

var $4xVcg = parcelRequire("4xVcg");
function $9e27fd972a1eddb4$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $4xVcg.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("4xVcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $34f69c970678ae19$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $34f69c970678ae19$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $dLKuc.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("iuOZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d77294dda396b4a7$export$2e2bcd8739ae039);

var $lpWdV = parcelRequire("lpWdV");
function $d77294dda396b4a7$export$2e2bcd8739ae039(array) {
    return (0, $lpWdV.default)(array, Boolean);
}

});

parcelRegister("24mPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $181da94bba3e3204$export$2e2bcd8739ae039);

var $4KizQ = parcelRequire("4KizQ");
function $181da94bba3e3204$export$2e2bcd8739ae039(array, depth) {
    return (0, $4KizQ.default)(array, depth, false);
}

});

parcelRegister("7PadH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b253950612eb2be$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $hwkCa = parcelRequire("hwkCa");
var // Return a version of the array that does not contain the specified value(s).
$5b253950612eb2be$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(array, otherArrays) {
    return (0, $hwkCa.default)(array, otherArrays);
});

});
parcelRegister("hwkCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc156a79390c5d6b$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $4KizQ = parcelRequire("4KizQ");

var $lpWdV = parcelRequire("lpWdV");

var $liuPn = parcelRequire("liuPn");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$cc156a79390c5d6b$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(array, rest) {
    rest = (0, $4KizQ.default)(rest, true, true);
    return (0, $lpWdV.default)(array, function(value) {
        return !(0, $liuPn.default)(rest, value);
    });
});

});


parcelRegister("hTqtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06c1bd0586ac75d$export$2e2bcd8739ae039);

var $cMCe8 = parcelRequire("cMCe8");

var $eKuxJ = parcelRequire("eKuxJ");

var $dxz2V = parcelRequire("dxz2V");

var $liuPn = parcelRequire("liuPn");
function $d06c1bd0586ac75d$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $cMCe8.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $eKuxJ.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $dxz2V.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $liuPn.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $liuPn.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("876Ln", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e8439340db6207a$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $hTqtq = parcelRequire("hTqtq");

var $4KizQ = parcelRequire("4KizQ");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$5e8439340db6207a$export$2e2bcd8739ae039 = (0, $h3syS.default)(function(arrays) {
    return (0, $hTqtq.default)((0, $4KizQ.default)(arrays, true, true));
});

});

parcelRegister("2A87p", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e153dbcb70f1855$export$2e2bcd8739ae039);

var $dxz2V = parcelRequire("dxz2V");

var $liuPn = parcelRequire("liuPn");
function $1e153dbcb70f1855$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $dxz2V.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $liuPn.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $liuPn.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("dtwWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf78a8621f82414$export$2e2bcd8739ae039);

var $GIhLa = parcelRequire("GIhLa");

var $dxz2V = parcelRequire("dxz2V");

var $lP78i = parcelRequire("lP78i");
function $9cf78a8621f82414$export$2e2bcd8739ae039(array) {
    var length = array && (0, $GIhLa.default)(array, (0, $dxz2V.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $lP78i.default)(array, index);
    return result;
}

});

parcelRegister("di7s8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ad2bcc38f47e23a$export$2e2bcd8739ae039);

var $h3syS = parcelRequire("h3syS");

var $dtwWO = parcelRequire("dtwWO");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$9ad2bcc38f47e23a$export$2e2bcd8739ae039 = (0, $h3syS.default)((0, $dtwWO.default));

});

parcelRegister("5ZnU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c530e54391772a$export$2e2bcd8739ae039);

var $dxz2V = parcelRequire("dxz2V");
function $45c530e54391772a$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $dxz2V.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("1GzEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a55e85c20adc34$export$2e2bcd8739ae039);
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $13a55e85c20adc34$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("ksicB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee448ac79a94452e$export$2e2bcd8739ae039);

var $dLKuc = parcelRequire("dLKuc");
function $ee448ac79a94452e$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $dLKuc.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("eI42i", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab584e32c0561f4f$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");

var $6BCJr = parcelRequire("6BCJr");

var $c81pn = parcelRequire("c81pn");

var $dLKuc = parcelRequire("dLKuc");

var $kG8U1 = parcelRequire("kG8U1");
function $ab584e32c0561f4f$export$2e2bcd8739ae039(obj) {
    (0, $6BCJr.default)((0, $c81pn.default)(obj), function(name) {
        var func = (0, $k7vPj.default)[name] = obj[name];
        (0, $k7vPj.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $dLKuc.push).apply(args, arguments);
            return (0, $kG8U1.default)(this, func.apply((0, $k7vPj.default), args));
        };
    });
    return 0, $k7vPj.default;
}

});
parcelRegister("kG8U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0dea2bfd682a850$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");
function $f0dea2bfd682a850$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $k7vPj.default)(obj).chain() : obj;
}

});


parcelRegister("fQUMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a7c24e67acfda9$export$2e2bcd8739ae039);

var $k7vPj = parcelRequire("k7vPj");

var $6BCJr = parcelRequire("6BCJr");

var $dLKuc = parcelRequire("dLKuc");

var $kG8U1 = parcelRequire("kG8U1");
// Add all mutator `Array` functions to the wrapper.
(0, $6BCJr.default)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $dLKuc.ArrayProto)[name];
    (0, $k7vPj.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $kG8U1.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $6BCJr.default)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $dLKuc.ArrayProto)[name];
    (0, $k7vPj.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $kG8U1.default)(this, obj);
    };
});
var $b8a7c24e67acfda9$export$2e2bcd8739ae039 = (0, $k7vPj.default);

});




parcelRegister("7h8DK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $54c0d2afb04813ef$var$Room {
    constructor(x, y, width, height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    getBoundingBox() {
        return {
            top: this.y,
            right: this.x + this.width - 1,
            bottom: this.y + this.height - 1,
            left: this.x
        };
    }
    containsTile(x, y) {
        const boundingBox = this.getBoundingBox();
        return !(x < boundingBox.left || x > boundingBox.right || y < boundingBox.top || y > boundingBox.bottom);
    }
    intersects(other) {
        if (!other.getBoundingBox) throw new Error('Given entity has no method getBoundingBox');
        const r1 = this.getBoundingBox();
        const r2 = other.getBoundingBox();
        return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
    }
    toJS() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    }
}
module.exports.default = $54c0d2afb04813ef$var$Room;

});

parcelRegister("iBBZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $037edb7394220896$var$Tile {
    constructor(type, x, y){
        this.type = type;
        this.neighbours = {};
        this.x = x;
        this.y = y;
    }
    setNeighbours(neighbours) {
        this.neighbours = neighbours;
        return this;
    }
    toJS() {
        return {
            x: this.x,
            y: this.y,
            type: this.type,
            ...this.regionId !== undefined ? {
                regionId: this.regionId
            } : {},
            ...this.regionTag !== undefined ? {
                regionTag: this.regionTag
            } : {}
        };
    }
}
module.exports.default = $037edb7394220896$var$Tile;

});

parcelRegister("9C41J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $6ffac94eee6402c6$var$isCorridorTile = (tile, rooms)=>{
    if (tile.type !== 'floor') return false;
    if (rooms.find((room)=>room.containsTile(tile.x, tile.y))) return false;
    const neighbours = [
        tile.neighbours.n,
        tile.neighbours.e,
        tile.neighbours.s,
        tile.neighbours.w
    ];
    const exits = neighbours.filter((n)=>n && n.type !== 'wall');
    if (exits.length !== 2) return false;
    const a = exits[0];
    const b = exits[1];
    const horizontal = a.x !== b.x && a.y === b.y;
    const vertical = a.x === b.x && a.y !== b.y;
    return horizontal || vertical;
};
const $6ffac94eee6402c6$var$addChokePoints = (options = {})=>{
    const inverseChance = options.inverseChance ?? 8;
    const maxCount = options.maxCount ?? Number.POSITIVE_INFINITY;
    return ({ rooms: rooms, tiles: tiles, oneIn: oneIn })=>{
        let added = 0;
        for (const row of tiles)for (const tile of row){
            if (added >= maxCount) return;
            if (!$6ffac94eee6402c6$var$isCorridorTile(tile, rooms)) continue;
            if (oneIn(inverseChance)) {
                tile.type = 'door';
                added++;
            }
        }
    };
};
module.exports.default = $6ffac94eee6402c6$var$addChokePoints;

});

parcelRegister("k0phk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $e9076a86942c3ff6$var$isRoomBoundaryWall = (tile, rooms)=>{
    if (tile.type !== 'wall') return false;
    const cardinalNeighbours = [
        tile.neighbours.n,
        tile.neighbours.e,
        tile.neighbours.s,
        tile.neighbours.w
    ];
    let adjacentRoomFloor = 0;
    let adjacentCorridorFloor = 0;
    for (const neighbour of cardinalNeighbours){
        if (!neighbour || neighbour.type !== 'floor') continue;
        const inRoom = rooms.find((room)=>room.containsTile(neighbour.x, neighbour.y));
        if (inRoom) adjacentRoomFloor++;
        else adjacentCorridorFloor++;
    }
    return adjacentRoomFloor >= 1 && adjacentCorridorFloor >= 1;
};
const $e9076a86942c3ff6$var$addSecrets = (options = {})=>{
    const inverseChance = options.inverseChance ?? 12;
    const maxCount = options.maxCount ?? Number.POSITIVE_INFINITY;
    return ({ rooms: rooms, tiles: tiles, oneIn: oneIn })=>{
        let added = 0;
        for (const row of tiles)for (const tile of row){
            if (added >= maxCount) return;
            if (!$e9076a86942c3ff6$var$isRoomBoundaryWall(tile, rooms)) continue;
            if (oneIn(inverseChance)) {
                tile.type = 'door';
                added++;
            }
        }
    };
};
module.exports.default = $e9076a86942c3ff6$var$addSecrets;

});

parcelRegister("1k9h0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $0f6eda2ba14c5443$var$getCardinalPassableNeighbours = (tile)=>{
    const neighbours = [
        tile.neighbours.n,
        tile.neighbours.e,
        tile.neighbours.s,
        tile.neighbours.w
    ];
    return neighbours.filter((n)=>Boolean(n && n.type !== 'wall'));
};
const $0f6eda2ba14c5443$var$classifyCorridorFlavor = (tiles)=>{
    if (tiles.length === 0) return 'branch';
    let deadEnds = 0;
    let junctions = 0;
    for (const tile of tiles){
        const degree = $0f6eda2ba14c5443$var$getCardinalPassableNeighbours(tile).length;
        if (degree <= 1) deadEnds++;
        if (degree >= 3) junctions++;
    }
    const deadEndRatio = deadEnds / tiles.length;
    if (deadEndRatio >= 0.2) return 'dead-end-cluster';
    if (junctions > 0) return 'hub';
    return 'branch';
};
const $0f6eda2ba14c5443$var$buildRegions = (tiles, rooms)=>{
    const visited = new Set();
    const regions = [];
    let regionId = 1;
    const keyFor = (tile)=>`${tile.x},${tile.y}`;
    const isRoomTile = (tile)=>Boolean(rooms.find((room)=>room.containsTile(tile.x, tile.y)));
    for (const row of tiles)for (const tile of row){
        if (tile.type === 'wall') continue;
        const startKey = keyFor(tile);
        if (visited.has(startKey)) continue;
        const kind = isRoomTile(tile) ? 'room' : 'corridor';
        const queue = [
            tile
        ];
        const component = [];
        visited.add(startKey);
        while(queue.length > 0){
            const current = queue.shift();
            component.push(current);
            const neighbours = $0f6eda2ba14c5443$var$getCardinalPassableNeighbours(current);
            for (const neighbour of neighbours){
                if (isRoomTile(neighbour) !== (kind === 'room')) continue;
                const key = keyFor(neighbour);
                if (visited.has(key)) continue;
                visited.add(key);
                queue.push(neighbour);
            }
        }
        const region = {
            id: regionId,
            tiles: component,
            kind: kind
        };
        if (kind === 'corridor') region.flavor = $0f6eda2ba14c5443$var$classifyCorridorFlavor(component);
        regions.push(region);
        regionId++;
    }
    return regions;
};
const $0f6eda2ba14c5443$var$addRegionTags = (options = {})=>{
    const roomPrefix = options.roomPrefix ?? 'room';
    const corridorPrefix = options.corridorPrefix ?? 'corridor';
    return ({ rooms: rooms, tiles: tiles })=>{
        const regions = $0f6eda2ba14c5443$var$buildRegions(tiles, rooms);
        for (const region of regions){
            const base = region.kind === 'room' ? `${roomPrefix}:${region.id}` : `${corridorPrefix}:${region.id}`;
            const suffix = region.kind === 'corridor' && region.flavor ? `:${region.flavor}` : '';
            for (const tile of region.tiles){
                tile.regionId = region.id;
                tile.regionTag = `${base}${suffix}`;
            }
        }
    };
};
module.exports.default = $0f6eda2ba14c5443$var$addRegionTags;

});

var $3a50e14af61c7272$exports = {};
"use strict";
var $3a50e14af61c7272$var$__importDefault = $3a50e14af61c7272$exports && $3a50e14af61c7272$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3a50e14af61c7272$exports, "__esModule", {
    value: true
});

const $3a50e14af61c7272$var$chance_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("hBaMZ")));

const $3a50e14af61c7272$var$victor_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("3vL3Z")));

const $3a50e14af61c7272$var$underscore_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("fmTEa")));

const $3a50e14af61c7272$var$room_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("7h8DK")));

const $3a50e14af61c7272$var$tile_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("iBBZd")));

const $3a50e14af61c7272$var$add_choke_points_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("9C41J")));

const $3a50e14af61c7272$var$add_secrets_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("k0phk")));

const $3a50e14af61c7272$var$add_region_tags_1 = $3a50e14af61c7272$var$__importDefault((parcelRequire("1k9h0")));
const $3a50e14af61c7272$var$getTileNESW = (tile)=>{
    const tiles = [];
    if (tile.neighbours.n) tiles.push(tile.neighbours.n);
    if (tile.neighbours.e) tiles.push(tile.neighbours.e);
    if (tile.neighbours.s) tiles.push(tile.neighbours.s);
    if (tile.neighbours.w) tiles.push(tile.neighbours.w);
    return tiles;
};
const $3a50e14af61c7272$var$nameChance = new $3a50e14af61c7272$var$chance_1.default();
const $3a50e14af61c7272$var$assertInteger = (value, path)=>{
    if (!Number.isInteger(value)) throw new RangeError(`DungeoneerError: ${path} must be an integer, received ${value}`);
};
const $3a50e14af61c7272$var$validatePlugins = (plugins)=>{
    plugins.forEach((plugin, index)=>{
        if (typeof plugin !== 'function') throw new TypeError(`DungeoneerError: options.plugins[${index}] must be a function`);
    });
};
const $3a50e14af61c7272$var$validateConstraints = (constraints)=>{
    const { minRooms: minRooms, maxRooms: maxRooms, minRoomSize: minRoomSize, maxRoomSize: maxRoomSize, maxDeadEnds: maxDeadEnds } = constraints;
    const numericChecks = [
        [
            minRooms,
            'options.constraints.minRooms',
            1
        ],
        [
            maxRooms,
            'options.constraints.maxRooms',
            1
        ],
        [
            minRoomSize,
            'options.constraints.minRoomSize',
            1
        ],
        [
            maxRoomSize,
            'options.constraints.maxRoomSize',
            1
        ],
        [
            maxDeadEnds,
            'options.constraints.maxDeadEnds',
            0
        ]
    ];
    for (const [value, path, min] of numericChecks){
        if (value === undefined) continue;
        $3a50e14af61c7272$var$assertInteger(value, path);
        if (value < min) throw new RangeError(`DungeoneerError: ${path} must be greater than or equal to ${min}, received ${value}`);
    }
    if (minRooms !== undefined && maxRooms !== undefined && minRooms > maxRooms) throw new RangeError('DungeoneerError: options.constraints.minRooms must be less than or equal to options.constraints.maxRooms');
    if (minRoomSize !== undefined && maxRoomSize !== undefined && minRoomSize > maxRoomSize) throw new RangeError('DungeoneerError: options.constraints.minRoomSize must be less than or equal to options.constraints.maxRoomSize');
};
const $3a50e14af61c7272$var$Dungeon = function Dungeon() {
    const numRoomTries = 50;
    const extraConnectorChance = 50;
    const roomExtraSize = 0;
    const windingPercent = 50;
    const _rooms = [];
    let _currentRegion = -1;
    let stage;
    let rng;
    const n = new $3a50e14af61c7272$var$victor_1.default(0, 1);
    const e = new $3a50e14af61c7272$var$victor_1.default(1, 0);
    const s = new $3a50e14af61c7272$var$victor_1.default(0, -1);
    const w = new $3a50e14af61c7272$var$victor_1.default(-1, 0);
    const cardinalDirections = [
        n,
        e,
        s,
        w
    ];
    const bindStage = (givenStage)=>{
        stage = givenStage;
    };
    const _tiles = [];
    let _seed;
    const randBetween = (min, max)=>{
        return rng.integer({
            min: min,
            max: max
        });
    };
    const getTile = (x, y)=>{
        return _tiles[x][y];
    };
    const setTile = (x, y, type)=>{
        if (_tiles[x] && _tiles[x][y]) {
            _tiles[x][y].type = type;
            _tiles[x][y].region = _currentRegion;
            return _tiles[x][y];
        }
        throw new RangeError(`tile at ${x}, ${y} is unreachable`);
    };
    const fill = (type)=>{
        let neighbours = {};
        for(let x = 0; x < stage.width; x++){
            _tiles.push([]);
            for(let y = 0; y < stage.height; y++)_tiles[x].push(new $3a50e14af61c7272$var$tile_1.default(type, x, y));
        }
        for(let x = 0; x < stage.width; x++)for(let y = 0; y < stage.height; y++){
            neighbours = {};
            if (_tiles[x][y - 1]) neighbours.n = _tiles[x][y - 1];
            if (_tiles[x + 1] && _tiles[x + 1][y - 1]) neighbours.ne = _tiles[x + 1][y - 1];
            if (_tiles[x + 1] && _tiles[x + 1][y]) neighbours.e = _tiles[x + 1][y];
            if (_tiles[x + 1] && _tiles[x + 1][y + 1]) neighbours.se = _tiles[x + 1][y + 1];
            if (_tiles[x] && _tiles[x][y + 1]) neighbours.s = _tiles[x][y + 1];
            if (_tiles[x - 1] && _tiles[x - 1][y + 1]) neighbours.sw = _tiles[x - 1][y + 1];
            if (_tiles[x - 1] && _tiles[x - 1][y]) neighbours.w = _tiles[x - 1][y];
            if (_tiles[x - 1] && _tiles[x - 1][y - 1]) neighbours.nw = _tiles[x - 1][y - 1];
            _tiles[x][y].setNeighbours(neighbours);
        }
        return _tiles;
    };
    const _toJS = ()=>{
        const rooms = [];
        const tiles = [];
        for (const room of _rooms)rooms.push(room.toJS());
        for(let x = 0; x < _tiles.length; x++){
            if (!tiles[x]) tiles.push([]);
            for(let y = 0; y < _tiles[x].length; y++){
                const tile = _tiles[x][y];
                tiles[x].push(tile.toJS());
            }
        }
        return {
            tiles: tiles,
            rooms: rooms,
            seed: _seed
        };
    };
    const _startRegion = ()=>{
        _currentRegion++;
        return _currentRegion;
    };
    const _carve = (x, y, type = 'floor')=>{
        setTile(x, y, type);
    };
    const _canCarve = (cell, direction)=>{
        const end = cell.clone().add(direction).add(direction).add(direction).toObject();
        if (!_tiles[end.x] || !_tiles[end.x][end.y]) return false;
        if (getTile(end.x, end.y).type !== 'wall') return false;
        const dest = cell.clone().add(direction).add(direction).toObject();
        return getTile(dest.x, dest.y).type !== 'floor';
    };
    const _oneIn = (num)=>{
        return randBetween(1, num) === 1;
    };
    const carveArea = (x, y, width, height)=>{
        for(let i = x; i < x + width; i++)for(let j = y; j < y + height; j++)_carve(i, j);
    };
    const _growMaze = (startX, startY)=>{
        const cells = [];
        let lastDir = null;
        if (Object.values(_tiles[startX][startY].neighbours).filter((tile)=>tile.type === 'floor').length > 0) return;
        _startRegion();
        _carve(startX, startY);
        cells.push(new $3a50e14af61c7272$var$victor_1.default(startX, startY));
        let count = 0;
        while(cells.length && count < 500){
            count++;
            const cell = cells[cells.length - 1];
            const unmadeCells = [];
            for (const dir of cardinalDirections)if (_canCarve(cell, dir)) unmadeCells.push(dir);
            if (unmadeCells.length) {
                let dir;
                const stringifiedCells = unmadeCells.map((v)=>v.toString());
                if (lastDir && stringifiedCells.indexOf(lastDir.toString()) > -1 && randBetween(1, 100) > windingPercent) dir = lastDir.clone();
                else {
                    const rand = randBetween(0, unmadeCells.length - 1);
                    dir = unmadeCells[rand].clone();
                }
                const carveLoc1 = cell.clone().add(dir).toObject();
                _carve(carveLoc1.x, carveLoc1.y);
                const carveLoc2 = cell.clone().add(dir).add(dir).toObject();
                _carve(carveLoc2.x, carveLoc2.y);
                cells.push(cell.clone().add(dir).add(dir));
                lastDir = dir.clone();
            } else {
                cells.pop();
                lastDir = null;
            }
        }
    };
    const _addRooms = ()=>{
        const constraints = stage.constraints;
        const minRooms = constraints?.minRooms ?? 0;
        const maxRooms = constraints?.maxRooms ?? Number.POSITIVE_INFINITY;
        const minConfiguredRoomSize = constraints?.minRoomSize;
        const maxConfiguredRoomSize = constraints?.maxRoomSize;
        const usesRoomSizeConstraints = minConfiguredRoomSize !== undefined || maxConfiguredRoomSize !== undefined;
        const maxFeasibleRoomSize = Math.max(1, Math.min(stage.width - 4, stage.height - 4));
        const toOddCeil = (value)=>{
            return value % 2 === 0 ? value + 1 : value;
        };
        const toOddFloor = (value)=>{
            return value % 2 === 0 ? value - 1 : value;
        };
        const pickOddInRange = (min, max)=>{
            const oddMin = toOddCeil(min);
            const oddMax = toOddFloor(max);
            if (oddMin > oddMax) throw new RangeError(`DungeoneerError: room size constraints are infeasible for this stage size (${stage.width}x${stage.height})`);
            const steps = Math.floor((oddMax - oddMin) / 2);
            return oddMin + randBetween(0, steps) * 2;
        };
        const maxAttempts = Math.max(numRoomTries, minRooms * 25, Number.isFinite(maxRooms) ? maxRooms * 10 : 0);
        let attempts = 0;
        while(attempts < maxAttempts && _rooms.length < maxRooms){
            attempts++;
            let width;
            let height;
            if (usesRoomSizeConstraints) {
                const minSize = Math.min(minConfiguredRoomSize ?? 3, maxFeasibleRoomSize);
                const maxSize = Math.min(maxConfiguredRoomSize ?? maxFeasibleRoomSize, maxFeasibleRoomSize);
                width = pickOddInRange(minSize, maxSize);
                height = pickOddInRange(minSize, maxSize);
            } else {
                const size = randBetween(1, 3 + roomExtraSize) * 2 + 1;
                const rectangularity = randBetween(0, 1 + Math.floor(size / 2)) * 2;
                width = size;
                height = size;
                if (_oneIn(2)) width += rectangularity;
                else height += rectangularity;
                width = Math.min(width, stage.width - 4);
                height = Math.min(height, stage.height - 4);
            }
            let x = randBetween(0, Math.floor((stage.width - width) / 2)) * 2 + 1;
            let y = randBetween(0, Math.floor((stage.height - height) / 2)) * 2 + 1;
            if (x + width > stage.width) x = Math.max(1, stage.width - width - 1);
            if (y + height > stage.height) y = Math.max(1, stage.height - height - 1);
            const room = new $3a50e14af61c7272$var$room_1.default(x, y, width, height);
            let overlaps = false;
            for (const other of _rooms)if (room.intersects(other)) {
                overlaps = true;
                break;
            }
            if (overlaps) continue;
            _rooms.push(room);
            _startRegion();
            carveArea(x, y, width, height);
        }
        if (_rooms.length < minRooms) throw new RangeError(`DungeoneerError: unable to satisfy options.constraints.minRooms=${minRooms}; generated ${_rooms.length} room(s)`);
    };
    const _connectRegions = ()=>{
        const regionConnections = {};
        _tiles.forEach((row)=>{
            row.forEach((tile)=>{
                if (tile.type === 'floor') return;
                const tileRegions = $3a50e14af61c7272$var$underscore_1.default.uniq($3a50e14af61c7272$var$getTileNESW(tile).map((x)=>x.region).filter((x)=>!$3a50e14af61c7272$var$underscore_1.default.isUndefined(x)));
                if (tileRegions.length <= 1) return;
                const key = tileRegions.join('-');
                if (!regionConnections[key]) regionConnections[key] = [];
                regionConnections[key].push(tile);
            });
        });
        $3a50e14af61c7272$var$underscore_1.default.each(regionConnections, (connections)=>{
            const index = randBetween(0, connections.length - 1);
            connections[index].type = 'door';
            connections.splice(index, 1);
            connections.forEach((conn)=>{
                if (_oneIn(extraConnectorChance)) conn.type = 'door';
            });
        });
    };
    const _applyPlugins = (plugins, seed)=>{
        const context = {
            rooms: _rooms,
            tiles: _tiles,
            seed: seed,
            randBetween: randBetween,
            oneIn: _oneIn
        };
        for (const plugin of plugins)plugin(context);
    };
    const _removeDeadEnds = ()=>{
        const maxDeadEnds = stage.constraints?.maxDeadEnds;
        const isRemovableDeadEnd = (tile)=>{
            if (tile.type === 'wall') return false;
            if (_rooms.find((room)=>room.containsTile(tile.x, tile.y))) return false;
            return $3a50e14af61c7272$var$getTileNESW(tile).filter((t)=>t.type !== 'wall').length <= 1;
        };
        const countDeadEnds = ()=>{
            let count = 0;
            _tiles.forEach((row)=>{
                row.forEach((tile)=>{
                    if (isRemovableDeadEnd(tile)) count++;
                });
            });
            return count;
        };
        let done = false;
        const cycle = ()=>{
            let isDone = true;
            if (maxDeadEnds !== undefined && countDeadEnds() <= maxDeadEnds) return true;
            _tiles.forEach((row)=>{
                row.forEach((tile)=>{
                    if (isRemovableDeadEnd(tile)) {
                        tile.type = 'wall';
                        isDone = false;
                    }
                });
            });
            return isDone;
        };
        while(!done)done = cycle();
    };
    const build = (inputStage)=>{
        const mutableStage = {
            ...inputStage
        };
        $3a50e14af61c7272$var$assertInteger(mutableStage.width, 'options.width');
        $3a50e14af61c7272$var$assertInteger(mutableStage.height, 'options.height');
        if (mutableStage.width < 5) throw new RangeError(`DungeoneerError: options.width must not be less than 5, received ${mutableStage.width}`);
        if (mutableStage.height < 5) throw new RangeError(`DungeoneerError: options.height must not be less than 5, received ${mutableStage.height}`);
        if (mutableStage.constraints) $3a50e14af61c7272$var$validateConstraints(mutableStage.constraints);
        if (mutableStage.plugins) $3a50e14af61c7272$var$validatePlugins(mutableStage.plugins);
        if (mutableStage.width % 2 === 0) mutableStage.width += 1;
        if (mutableStage.height % 2 === 0) mutableStage.height += 1;
        const seed = mutableStage.seed === undefined || mutableStage.seed === null ? `${$3a50e14af61c7272$var$nameChance.word({
            length: 7
        })}-${$3a50e14af61c7272$var$nameChance.word({
            length: 7
        })}` : mutableStage.seed;
        rng = new $3a50e14af61c7272$var$chance_1.default(seed);
        _seed = seed;
        bindStage(mutableStage);
        fill('wall');
        _addRooms();
        for(let y = 1; y < mutableStage.height; y += 2)for(let x = 1; x < mutableStage.width; x += 2){
            if (getTile(x, y).type === 'floor') continue;
            _growMaze(x, y);
        }
        _connectRegions();
        _removeDeadEnds();
        if (mutableStage.plugins) _applyPlugins(mutableStage.plugins, seed);
        return {
            rooms: _rooms,
            tiles: _tiles,
            seed: seed,
            toJS: _toJS
        };
    };
    return {
        build: build
    };
};
const $3a50e14af61c7272$var$build = (options)=>{
    return $3a50e14af61c7272$var$Dungeon().build(options);
};
$3a50e14af61c7272$exports = {
    build: $3a50e14af61c7272$var$build,
    plugins: {
        addChokePoints: $3a50e14af61c7272$var$add_choke_points_1.default,
        addSecrets: $3a50e14af61c7272$var$add_secrets_1.default,
        addRegionTags: $3a50e14af61c7272$var$add_region_tags_1.default
    }
};


var $2cf8904c171099ce$exports = {};
$2cf8904c171099ce$exports = JSON.parse("{\"name\":\"dungeoneer\",\"version\":\"3.1.0\",\"description\":\"A procedural dungeon generator\",\"main\":\"dist/index.js\",\"types\":\"./dist/index.d.ts\",\"homepage\":\"https://github.com/LucianBuzzo/dungeoneer\",\"repository\":{\"type\":\"git\",\"url\":\"git://github.com/LucianBuzzo/dungeoneer.git\"},\"scripts\":{\"build\":\"tsc -p tsconfig.json\",\"pretest\":\"npm run build\",\"predev\":\"npm run build\",\"prebuild:demo\":\"npm run build\",\"test\":\"nyc --reporter=lcov ava -v\",\"lint\":\"standard 'test/**/*.js' 'demo/main.js'\",\"typecheck\":\"tsc -p tsconfig.json --noEmit\",\"ci\":\"npm run lint && npm run typecheck && npm run test\",\"dev\":\"parcel ./demo/index.html\",\"build:demo\":\"parcel build --public-url ./ ./demo/index.html\",\"prepublishOnly\":\"npm run build\"},\"keywords\":[\"procedural\",\"map\",\"generator\",\"dungeon\",\"games\",\"level\",\"roguelike\"],\"author\":\"Lucian Buzzo <lucian.buzzo@gmail.com>\",\"license\":\"MIT\",\"engines\":{\"node\":\">=20\"},\"dependencies\":{\"chance\":\"^1.0.18\",\"underscore\":\"^1.8.3\",\"victor\":\"^1.1.0\"},\"devDependencies\":{\"@types/chance\":\"^1.1.7\",\"@types/node\":\"^22.13.10\",\"@types/underscore\":\"^1.11.15\",\"@types/victor\":\"^1.1.5\",\"ava\":\"^3.15.0\",\"nyc\":\"^15.1.0\",\"parcel\":\"^2.0.1\",\"standard\":\"^16.0.4\",\"typescript\":\"^5.8.2\"},\"ava\":{\"files\":[\"test/**/*.spec.js\"]},\"browserslist\":[\"last 2 Chrome versions\"],\"targets\":{\"module\":false,\"main\":false,\"types\":false}}");


const $febf975bab15f8fa$var$canvas = document.querySelector('canvas');
const $febf975bab15f8fa$var$ctx = $febf975bab15f8fa$var$canvas.getContext('2d');
$febf975bab15f8fa$var$ctx.imageSmoothingEnabled = false;
const $febf975bab15f8fa$var$$seed = document.getElementById('seed');
const $febf975bab15f8fa$var$$stats = document.getElementById('stats');
const $febf975bab15f8fa$var$$seedHistory = document.getElementById('seed-history');
const $febf975bab15f8fa$var$HISTORY_KEY = 'dungeoneer-seed-history-v1';
const $febf975bab15f8fa$var$HISTORY_LIMIT = 8;
const $febf975bab15f8fa$var$PRESETS = {
    classic: {
        width: 51,
        height: 51
    },
    dense: {
        width: 51,
        height: 51,
        constraints: {
            minRooms: 24,
            maxRooms: 38,
            minRoomSize: 3,
            maxRoomSize: 7
        },
        plugins: {
            regions: true,
            chokes: true,
            chokeInverse: 7,
            chokeMax: 20
        }
    },
    sparse: {
        width: 51,
        height: 51,
        constraints: {
            minRooms: 8,
            maxRooms: 14,
            minRoomSize: 5,
            maxRoomSize: 11,
            maxDeadEnds: 12
        }
    },
    labyrinth: {
        width: 71,
        height: 71,
        constraints: {
            minRooms: 6,
            maxRooms: 12,
            minRoomSize: 3,
            maxRoomSize: 5,
            maxDeadEnds: 2
        },
        plugins: {
            chokes: true,
            chokeInverse: 5,
            chokeMax: 30
        }
    },
    'secret-heavy': {
        width: 51,
        height: 51,
        constraints: {
            minRooms: 14,
            maxRooms: 24,
            minRoomSize: 3,
            maxRoomSize: 9
        },
        plugins: {
            secrets: true,
            secretsInverse: 5,
            secretsMax: 20,
            regions: true
        }
    }
};
const $febf975bab15f8fa$var$parseBool = (value)=>value === '1' || value === 'true';
const $febf975bab15f8fa$var$getNumber = (id)=>{
    const raw = document.getElementById(id).value;
    if (raw === '') return undefined;
    const value = Number(raw);
    if (Number.isNaN(value)) return undefined;
    return value;
};
const $febf975bab15f8fa$var$setNumber = (id, value)=>{
    document.getElementById(id).value = value === undefined ? '' : String(value);
};
const $febf975bab15f8fa$var$hashColor = (text)=>{
    let hash = 0;
    for(let i = 0; i < text.length; i++){
        hash = (hash << 5) - hash + text.charCodeAt(i);
        hash |= 0;
    }
    const hue = Math.abs(hash) % 360;
    return `hsla(${hue}, 80%, 60%, 0.8)`;
};
const $febf975bab15f8fa$var$countTilesByType = (dungeon, type)=>{
    let count = 0;
    for (const row of dungeon.tiles){
        for (const tile of row)if (tile.type === type) count++;
    }
    return count;
};
const $febf975bab15f8fa$var$countDeadEnds = (dungeon)=>{
    let count = 0;
    for (const row of dungeon.tiles)for (const tile of row){
        if (tile.type === 'wall') continue;
        const inRoom = dungeon.rooms.find((room)=>room.containsTile(tile.x, tile.y));
        if (inRoom) continue;
        const neighbours = [
            tile.neighbours.n,
            tile.neighbours.e,
            tile.neighbours.s,
            tile.neighbours.w
        ];
        const exits = neighbours.filter((n)=>n && n.type !== 'wall').length;
        if (exits <= 1) count++;
    }
    return count;
};
const $febf975bab15f8fa$var$buildOptionsFromControls = ()=>{
    const width = $febf975bab15f8fa$var$getNumber('width') || 51;
    const height = $febf975bab15f8fa$var$getNumber('height') || 51;
    const options = {
        width: width,
        height: height
    };
    if (document.getElementById('use-seed').checked) {
        const seed = document.getElementById('seed-input').value;
        if (seed !== '') options.seed = seed;
    }
    const constraints = {
        minRooms: $febf975bab15f8fa$var$getNumber('minRooms'),
        maxRooms: $febf975bab15f8fa$var$getNumber('maxRooms'),
        minRoomSize: $febf975bab15f8fa$var$getNumber('minRoomSize'),
        maxRoomSize: $febf975bab15f8fa$var$getNumber('maxRoomSize'),
        maxDeadEnds: $febf975bab15f8fa$var$getNumber('maxDeadEnds')
    };
    const hasConstraints = Object.values(constraints).some((value)=>value !== undefined);
    if (hasConstraints) options.constraints = constraints;
    const plugins = [];
    if (document.getElementById('plugin-chokes').checked) plugins.push($3a50e14af61c7272$exports.plugins.addChokePoints({
        inverseChance: $febf975bab15f8fa$var$getNumber('chokeInverse') || 8,
        maxCount: $febf975bab15f8fa$var$getNumber('chokeMax') || 12
    }));
    if (document.getElementById('plugin-secrets').checked) plugins.push($3a50e14af61c7272$exports.plugins.addSecrets({
        inverseChance: $febf975bab15f8fa$var$getNumber('secretsInverse') || 12,
        maxCount: $febf975bab15f8fa$var$getNumber('secretsMax') || 8
    }));
    if (document.getElementById('plugin-regions').checked) plugins.push($3a50e14af61c7272$exports.plugins.addRegionTags());
    if (plugins.length > 0) options.plugins = plugins;
    return options;
};
const $febf975bab15f8fa$var$applyUrlState = ()=>{
    const params = new URLSearchParams(window.location.search);
    $febf975bab15f8fa$var$setNumber('width', Number(params.get('w')) || 51);
    $febf975bab15f8fa$var$setNumber('height', Number(params.get('h')) || 51);
    const useSeed = $febf975bab15f8fa$var$parseBool(params.get('us'));
    document.getElementById('use-seed').checked = useSeed;
    document.getElementById('seed-input').value = params.get('seed') || '';
    document.getElementById('show-region-colors').checked = $febf975bab15f8fa$var$parseBool(params.get('rc'));
    document.getElementById('plugin-chokes').checked = $febf975bab15f8fa$var$parseBool(params.get('pc'));
    document.getElementById('plugin-secrets').checked = $febf975bab15f8fa$var$parseBool(params.get('ps'));
    document.getElementById('plugin-regions').checked = $febf975bab15f8fa$var$parseBool(params.get('pr'));
    $febf975bab15f8fa$var$setNumber('minRooms', params.get('minRooms') ? Number(params.get('minRooms')) : undefined);
    $febf975bab15f8fa$var$setNumber('maxRooms', params.get('maxRooms') ? Number(params.get('maxRooms')) : undefined);
    $febf975bab15f8fa$var$setNumber('minRoomSize', params.get('minRoomSize') ? Number(params.get('minRoomSize')) : undefined);
    $febf975bab15f8fa$var$setNumber('maxRoomSize', params.get('maxRoomSize') ? Number(params.get('maxRoomSize')) : undefined);
    $febf975bab15f8fa$var$setNumber('maxDeadEnds', params.get('maxDeadEnds') ? Number(params.get('maxDeadEnds')) : undefined);
    $febf975bab15f8fa$var$setNumber('chokeInverse', params.get('chokeInverse') ? Number(params.get('chokeInverse')) : 8);
    $febf975bab15f8fa$var$setNumber('chokeMax', params.get('chokeMax') ? Number(params.get('chokeMax')) : 12);
    $febf975bab15f8fa$var$setNumber('secretsInverse', params.get('secretsInverse') ? Number(params.get('secretsInverse')) : 12);
    $febf975bab15f8fa$var$setNumber('secretsMax', params.get('secretsMax') ? Number(params.get('secretsMax')) : 8);
};
const $febf975bab15f8fa$var$writeUrlState = ()=>{
    const params = new URLSearchParams();
    const options = $febf975bab15f8fa$var$buildOptionsFromControls();
    params.set('w', String(options.width));
    params.set('h', String(options.height));
    if (document.getElementById('use-seed').checked) {
        params.set('us', '1');
        const seed = document.getElementById('seed-input').value;
        if (seed) params.set('seed', seed);
    }
    if (document.getElementById('show-region-colors').checked) params.set('rc', '1');
    if (document.getElementById('plugin-chokes').checked) params.set('pc', '1');
    if (document.getElementById('plugin-secrets').checked) params.set('ps', '1');
    if (document.getElementById('plugin-regions').checked) params.set('pr', '1');
    for (const key of [
        'minRooms',
        'maxRooms',
        'minRoomSize',
        'maxRoomSize',
        'maxDeadEnds',
        'chokeInverse',
        'chokeMax',
        'secretsInverse',
        'secretsMax'
    ]){
        const value = $febf975bab15f8fa$var$getNumber(key);
        if (value !== undefined) params.set(key, String(value));
    }
    const query = params.toString();
    window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
};
const $febf975bab15f8fa$var$loadSeedHistory = ()=>{
    try {
        const parsed = JSON.parse(window.localStorage.getItem($febf975bab15f8fa$var$HISTORY_KEY) || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((seed)=>typeof seed === 'string').slice(0, $febf975bab15f8fa$var$HISTORY_LIMIT);
    } catch (_) {
        return [];
    }
};
let $febf975bab15f8fa$var$seedHistory = $febf975bab15f8fa$var$loadSeedHistory();
const $febf975bab15f8fa$var$saveSeedHistory = ()=>{
    window.localStorage.setItem($febf975bab15f8fa$var$HISTORY_KEY, JSON.stringify($febf975bab15f8fa$var$seedHistory));
};
const $febf975bab15f8fa$var$renderSeedHistory = ()=>{
    $febf975bab15f8fa$var$$seedHistory.innerHTML = '';
    if ($febf975bab15f8fa$var$seedHistory.length === 0) return;
    const label = document.createElement('span');
    label.innerText = 'Recent seeds:';
    $febf975bab15f8fa$var$$seedHistory.appendChild(label);
    for (const seed of $febf975bab15f8fa$var$seedHistory){
        const button = document.createElement('button');
        button.type = 'button';
        button.innerText = seed;
        button.addEventListener('click', ()=>{
            document.getElementById('use-seed').checked = true;
            document.getElementById('seed-input').value = seed;
            $febf975bab15f8fa$var$create();
        });
        $febf975bab15f8fa$var$$seedHistory.appendChild(button);
    }
};
const $febf975bab15f8fa$var$addSeedToHistory = (seed)=>{
    if (!seed) return;
    $febf975bab15f8fa$var$seedHistory = [
        seed,
        ...$febf975bab15f8fa$var$seedHistory.filter((item)=>item !== seed)
    ].slice(0, $febf975bab15f8fa$var$HISTORY_LIMIT);
    $febf975bab15f8fa$var$saveSeedHistory();
    $febf975bab15f8fa$var$renderSeedHistory();
};
const $febf975bab15f8fa$var$applyPreset = (name)=>{
    const preset = $febf975bab15f8fa$var$PRESETS[name];
    if (!preset) return;
    $febf975bab15f8fa$var$setNumber('width', preset.width);
    $febf975bab15f8fa$var$setNumber('height', preset.height);
    $febf975bab15f8fa$var$setNumber('minRooms', preset.constraints ? preset.constraints.minRooms : undefined);
    $febf975bab15f8fa$var$setNumber('maxRooms', preset.constraints ? preset.constraints.maxRooms : undefined);
    $febf975bab15f8fa$var$setNumber('minRoomSize', preset.constraints ? preset.constraints.minRoomSize : undefined);
    $febf975bab15f8fa$var$setNumber('maxRoomSize', preset.constraints ? preset.constraints.maxRoomSize : undefined);
    $febf975bab15f8fa$var$setNumber('maxDeadEnds', preset.constraints ? preset.constraints.maxDeadEnds : undefined);
    document.getElementById('plugin-chokes').checked = !!(preset.plugins && preset.plugins.chokes);
    document.getElementById('plugin-secrets').checked = !!(preset.plugins && preset.plugins.secrets);
    document.getElementById('plugin-regions').checked = !!(preset.plugins && preset.plugins.regions);
    $febf975bab15f8fa$var$setNumber('chokeInverse', preset.plugins && preset.plugins.chokeInverse ? preset.plugins.chokeInverse : 8);
    $febf975bab15f8fa$var$setNumber('chokeMax', preset.plugins && preset.plugins.chokeMax ? preset.plugins.chokeMax : 12);
    $febf975bab15f8fa$var$setNumber('secretsInverse', preset.plugins && preset.plugins.secretsInverse ? preset.plugins.secretsInverse : 12);
    $febf975bab15f8fa$var$setNumber('secretsMax', preset.plugins && preset.plugins.secretsMax ? preset.plugins.secretsMax : 8);
    $febf975bab15f8fa$var$create();
};
const $febf975bab15f8fa$var$renderDungeon = (dungeon, width, height)=>{
    const cellSize = 4;
    const colorByRegion = document.getElementById('show-region-colors').checked;
    $febf975bab15f8fa$var$canvas.width = width * cellSize;
    $febf975bab15f8fa$var$canvas.height = height * cellSize;
    $febf975bab15f8fa$var$canvas.style.width = width * cellSize + 'px';
    $febf975bab15f8fa$var$canvas.style.height = height * cellSize + 'px';
    $febf975bab15f8fa$var$ctx.fillStyle = 'black';
    $febf975bab15f8fa$var$ctx.fillRect(0, 0, $febf975bab15f8fa$var$ctx.canvas.width, $febf975bab15f8fa$var$ctx.canvas.height);
    for (const room of dungeon.rooms){
        $febf975bab15f8fa$var$ctx.fillStyle = '#912f2f';
        $febf975bab15f8fa$var$ctx.fillRect(room.x * cellSize, room.y * cellSize, room.width * cellSize, room.height * cellSize);
    }
    for(let x = 0; x < dungeon.tiles.length; x++)for(let y = 0; y < dungeon.tiles[x].length; y++){
        const tile = dungeon.tiles[x][y];
        if (tile.type === 'wall') continue;
        if (tile.type === 'door') $febf975bab15f8fa$var$ctx.fillStyle = '#ffd43b';
        else if (colorByRegion && tile.regionTag) $febf975bab15f8fa$var$ctx.fillStyle = $febf975bab15f8fa$var$hashColor(tile.regionTag);
        else $febf975bab15f8fa$var$ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
        $febf975bab15f8fa$var$ctx.fillRect(x * cellSize, y * cellSize, cellSize, cellSize);
    }
};
const $febf975bab15f8fa$var$create = ()=>{
    try {
        const options = $febf975bab15f8fa$var$buildOptionsFromControls();
        const dungeon = $3a50e14af61c7272$exports.build(options);
        $febf975bab15f8fa$var$renderDungeon(dungeon, options.width, options.height);
        $febf975bab15f8fa$var$$seed.innerText = dungeon.seed;
        const doors = $febf975bab15f8fa$var$countTilesByType(dungeon, 'door');
        const floors = $febf975bab15f8fa$var$countTilesByType(dungeon, 'floor');
        const deadEnds = $febf975bab15f8fa$var$countDeadEnds(dungeon);
        $febf975bab15f8fa$var$$stats.innerText = `rooms=${dungeon.rooms.length} floors=${floors} doors=${doors} deadEnds=${deadEnds}`;
        $febf975bab15f8fa$var$addSeedToHistory(String(dungeon.seed));
        $febf975bab15f8fa$var$writeUrlState();
        window.ctx = $febf975bab15f8fa$var$ctx;
        window.dungeon = dungeon;
    } catch (error) {
        $febf975bab15f8fa$var$$stats.innerText = error.message;
        console.error(error);
    }
};
document.querySelector('#dice-svg svg').addEventListener('mousedown', function() {
    document.querySelector('#dice-svg svg').classList.add('mousedown');
}, false);
document.querySelector('#dice-svg svg').addEventListener('mouseup', function() {
    document.querySelector('#dice-svg svg').classList.remove('mousedown');
    if (!document.getElementById('use-seed').checked) document.getElementById('seed-input').value = '';
    $febf975bab15f8fa$var$create();
}, false);
for (const el of document.querySelectorAll('#controls input'))el.addEventListener('change', ()=>$febf975bab15f8fa$var$create());
for (const button of document.querySelectorAll('#presets button'))button.addEventListener('click', ()=>$febf975bab15f8fa$var$applyPreset(button.dataset.preset));
$febf975bab15f8fa$var$applyUrlState();
$febf975bab15f8fa$var$renderSeedHistory();
$febf975bab15f8fa$var$create();
window.create = $febf975bab15f8fa$var$create;
const $febf975bab15f8fa$var$$version = document.createElement('div');
const $febf975bab15f8fa$var$shortSha = "dd150a188ccbe254508ee7d5afeff749d24ff007".slice(0, 7);
$febf975bab15f8fa$var$$version.innerText = `v${$2cf8904c171099ce$exports.version} (${$febf975bab15f8fa$var$shortSha})`;
$febf975bab15f8fa$var$$version.style = `
  color: white;
  position: absolute;
  top: 16px;
  left: 16px;
  font-family: monospace;
`;
document.body.appendChild($febf975bab15f8fa$var$$version);


//# sourceMappingURL=demo.72f2fa01.js.map
